const pl: Record<string, string> = {
    // Common
    back: "Wstecz",
    home: "Strona główna",
    admin: "Administrator",
    login: "Zaloguj",
    logout: "Wyloguj",
    submit: "Wyślij",
    yes: "Tak",
    no: "Nie",
    close: "Zamknij",
    reset: "Resetuj",
    search: "Szukaj",
    loading: "Ładowanie...",
    submitting: "Wysyłanie...",
    searching: "Szukanie...",
    save: "Zapisz",
    saving: "Zapisywanie...",
    refresh: "Odśwież",
    confirm: "Potwierdź",
    cancel: "Anuluj",
    error: "Błąd",
    success: "Sukces",
    info: "Info",
    export: "Eksport",

    // Home
    hello_user: "Cześć {name}!",
    goods_in: "Przyjęcie Towaru",

    // Wipe module
    wipe: "Czyszczenie",
    wipe_settings: "Czyszczenie",
    wipe_settings_hint: "Każdy przedmiot jest kierowany na paletę według wartości netto. Urządzenia przechowujące dane są zawsze ponownie etykietowane: przy wartości równej lub wyższej od progu czyszczenia są czyszczone, ponownie etykietowane i umieszczane na różowej palecie; powyżej progu utylizacji są ponownie etykietowane i umieszczane na różowej palecie; przy wartości równej progowi utylizacji lub niższej są ponownie etykietowane i umieszczane na żółtej palecie. Przedmioty nieprzechowujące danych nie otrzymują etykiety i trafiają na różową paletę, lub na żółtą paletę przy wartości równej progowi utylizacji lub niższej.",
    wipe_scan_prompt: "Zeskanuj",
    wipe_scan_lpn_prompt: "Zeskanuj LPN",
    wipe_individual_items: "Pojedyncze przedmioty",
    wipe_individual_items_hint: "Pojedyncze przedmioty: skanuj jeden kod LPN na raz. Przedmioty z pudełka wpisanego na manifest jako całość są dopasowywane do produktu przez tygodniowy manifest LPN. Każdy znaleziony LPN otrzymuje nowy SKU, niezależnie od tego, czy przechowuje dane, więc każdy wiersz trafia do eksportu Jobalots. Kody pudełek są odrzucane; niedopasowany LPN trafia na paletę Unmanifested.",
    wipe_individual_not_lpn: "Tryb pojedynczych przedmiotów: zeskanuj kod LPN.",
    wipe_mode_on: "WŁ.",
    wipe_mode_off: "WYŁ.",
    wipe_not_found: "Nie znaleziono przedmiotu",
    wipe_scan_lpns_prompt: "To pudełko zawiera {count} urządzeń z danymi i zostanie sprzedane pojedynczo jako RÓŻOWE. Zeskanuj pierwszy kod LPN.",
    wipe_scan_lpns_not_lpn: "Zeskanuj kod LPN z tego pudełka.",
    wipe_scan_lpns_cover: "Pudełko uszkodzone lub brak kodów LPN? Zakryj zamiast tego ({count} etykiet)",
    wipe_unmanifested_title: "Kod LPN nie jest na żadnym manifeście",
    wipe_unmanifested_prompt: "{lpn} nie znajduje się na żadnym manifeście. Wydrukować etykietę zakrywającą i umieścić przedmiot na palecie Unmanifested?",
    wipe_unmanifested_confirm: "Wydrukuj etykietę zakrywającą",
    wipe_outcome_cover_unmanifested: "Unmanifested",
    wipe_rates_button: "Kursy walut",
    wipe_rates_title: "Kursy walut (HMRC, miesięczne)",
    wipe_rates_hint: "Używane do przeliczania cen towaru z UE na GBP, gdy etykieta Wipe staje się produktem. Kursy są pobierane z HMRC automatycznie co miesiąc; wpisz wartość i zapisz, aby nadpisać miesiąc.",
    wipe_rates_refresh: "Pobierz ten miesiąc z HMRC",
    wipe_rates_refreshed: "Kursy zaktualizowane z HMRC",
    wipe_rates_refresh_failed: "Nie udało się pobrać kursów z HMRC",
    wipe_rates_saved: "Kurs zapisany",
    wipe_rates_invalid: "Wpisz dodatni kurs (jednostki waluty za 1 £)",
    wipe_rates_empty: "Brak zapisanych kursów. Pobierz ten miesiąc z HMRC.",
    wipe_rates_col_month: "Miesiąc",
    wipe_rates_col_currency: "Waluta",
    wipe_rates_col_rate: "Jednostki za 1 £",
    wipe_rates_col_source: "Źródło",
    wipe_rates_source_override: "Nadpisane",
    wipe_quantity: "Ilość",
    wipe_data_sensitive_q: "Czy to urządzenie przechowujące dane?",
    wipe_data_sensitive_yes: "Tak — urządzenie z danymi",
    wipe_data_sensitive_no: "Nie — bez danych",
    wipe_yes: "Tak",
    wipe_no: "Nie",
    wipe_ai_suggests: "AI sugeruje",
    wipe_human_suggests: "Ludzie sugerują",
    wipe_instructions_title: "Kroki czyszczenia danych",
    wipe_outcome_auto_list: "Różowy",
    wipe_outcome_auto_dispose: "Żółty",
    wipe_outcome_data_wipe_relabel: "Czyszczenie Etykieta Różowy",
    wipe_outcome_relabel: "Etykieta Różowy",
    wipe_outcome_relabel_dispose: "Etykieta Żółty",
    wipe_outcome_cover_relabel: "Etykiety zakrywające",
    wipe_outcome_box_blue: "Niebieski",
    wipe_outcome_box_pink: "Różowy",
    wipe_outcome_reprint: "Wydrukowano",
    wipe_print_all: "Wydrukuj wszystkie {count} szt.",
    wipe_cover_title: "Pudełko z danymi",
    wipe_cover_prompt: "To pudełko zawiera {count} urządzeń z danymi i zostanie sprzedane jako NIEBIESKIE. Wszystkie kody LPN muszą zostać zakryte nowymi kodami kreskowymi.",
    wipe_cover_confirm: "Wydrukuj {count} etykiet",
    wipe_cover_cancel: "Anuluj",
    wipe_record: "Potwierdź",
    wipe_recorded: "Zapisano",
    wipe_labels: "etykiety",
    wipe_items: "szt.",
    wipe_undo: "Cofnij",
    wipe_go_back: "Wróć",
    wipe_undone: "Cofnięto",
    wipe_next_item: "Następny przedmiot",
    wipe_today: "Dzisiaj",
    wipe_per_hour: "Na godzinę",
    wipe_target: "Cel",
    wipe_print_failed: "Błąd drukowania",
    wipe_done_dispose: "Zutylizuj ten przedmiot",
    wipe_threshold_label: "Próg czyszczenia danych (£ netto)",
    wipe_threshold_hint: "Przedmioty z danymi o wartości netto równej lub wyższej są czyszczone, ponownie etykietowane i sprzedawane na Jobalots.",
    wipe_dispose_threshold_label: "Próg utylizacji (£ netto)",
    wipe_dispose_threshold_hint: "Przedmioty o wartości netto równej tej lub niższej trafiają na żółtą paletę — te z danymi są najpierw ponownie etykietowane; droższe trafiają na różową paletę.",
    wipe_box_threshold_label: "Próg pudełka (£ śr. netto)",
    wipe_box_threshold_hint: "Zeskanowane pudełko z różnymi produktami jest oceniane według średniej wartości przedmiotu. Bez urządzeń z danymi trafia w całości na paletę: powyżej tego progu na różową, w przeciwnym razie na niebieską. Z urządzeniem z danymi, jeśli każdy przedmiot ma własny kod LPN na manifeście i średnia jest powyżej progu, pracownik skanuje każdy kod LPN i oznacza przedmioty pojedynczo, a każdy przedmiot trafia na różową paletę niezależnie od własnej wartości; w przeciwnym razie przedmioty są zakrywane nowymi kodami, a pudełko trafia w całości na niebieską paletę.",
    wipe_label_width_label: "Szerokość etykiety (mm)",
    wipe_label_height_label: "Wysokość etykiety (mm)",
    wipe_label_orientation_label: "Orientacja etykiety",
    wipe_label_orientation_hint: "Jak etykieta jest obracana podczas drukowania. Zmień, jeśli etykiety wychodzą bokiem lub do góry nogami.",
    wipe_orientation_normal: "Normalna",
    wipe_orientation_cw: "90° w prawo",
    wipe_orientation_ccw: "90° w lewo",
    wipe_orientation_flip: "180° (do góry nogami)",
    wipe_auto_process_no_label: "Automatyczne przetwarzanie bez użycia rąk",
    wipe_auto_process_no_hint: "Gdy włączone, przedmioty, które portal już widział, są przetwarzane bez dotknięć: przedmioty bez danych są wystawiane na Jobalots (bez etykiety), a urządzenia z danymi, które wymagają tylko nowej etykiety, drukują ją automatycznie — następnie ekran wraca do skanowania. Przy pierwszym skanie produktu ekran Tak/Nie zawsze się zatrzymuje z zaznaczoną odpowiedzią AI, abyś mógł ją poprawić, zanim cokolwiek się wydrukuje; Twoje potwierdzenie decyduje o kolejnych skanach. Urządzenia wymagające wyczyszczenia danych nadal się zatrzymują, abyś mógł je wyczyścić i potwierdzić. Jeśli AI się pomyli, naciśnij „Wróć” na potwierdzeniu, aby ponownie otworzyć przedmiot.",

    scan_sheet: "Arkusz Skanowania",
    book_in: "Rejestracja",

    // Relabel — moduł Goods In (skanuj i drukuj) + panel administracyjny magazynu.
    // (klucz tytułu modułu `relabel` zdefiniowany poniżej.)
    relabel_scan_original: "Zeskanuj Kod",
    relabel_remaining: "Pozostało nowych kodów dla tego artykułu: {count}",
    relabel_all_used: "Wszystkie nowe kody dla tego artykułu zostały użyte",
    relabel_not_found: "Brak wpisu etykietowania dla tego kodu",
    relabel_dispense_failed: "Nie udało się pobrać nowego kodu — spróbuj ponownie",
    relabel_settings: "Etykietowanie",
    relabel_settings_hint: "Powiązania PO / oryginalny kod / nowy kod dla stanowiska Etykietowania w Goods In. Zeskanowanie oryginalnego kodu drukuje kolejny dostępny nowy kod i oznacza go jako użyty. Każdy nowy kod można użyć tylko raz; ten sam oryginalny kod może mieć wiele nowych kodów, wydawanych w kolejności wgrania.",
    warehouse_tile_relabel_desc: "Powiązania kodów — wgrywaj i śledź",
    relabel_status_available: "Dostępny",
    relabel_status_used: "Użyty",
    relabel_toggle_hint: "Kliknij, aby przełączyć dostępny / użyty",
    relabel_download_template: "Pobierz Szablon",
    relabel_download_current: "Pobierz Bieżące",
    relabel_upload_xlsx: "Wgraj XLSX",
    relabel_upload_parse_error: "Nie udało się odczytać pliku — czy to prawidłowy .xlsx?",
    relabel_upload_empty: "Ten plik nie ma wierszy z danymi",
    relabel_upload_bad_header: "Plik musi mieć kolumny Original Barcode i New Barcode",
    relabel_bulk_summary: "Dodano {added}, zaktualizowano {updated}",
    relabel_filter_search_hint: "Szukaj PO, oryginalnego lub nowego kodu (naciśnij Enter)",
    relabel_col_id: "ID",
    relabel_col_po: "PO",
    relabel_col_original: "Oryginalny Kod",
    relabel_col_new: "Nowy Kod",
    relabel_col_status: "Status",
    relabel_no_rows: "Brak wpisów etykietowania dla wybranych filtrów.",
    wipe_admin_hint: "Przetworzone artykuły ze stanowiska Wipe / czyszczenia danych. Każdy wiersz to jedna zarejestrowana sztuka — nowy kod etykiety, zeskanowany kod, rozpoznany produkt, wynik routingu i wartość odzysku.",
    warehouse_tile_wipe_desc: "Przetworzone artykuły Wipe i wartości odzysku",
    // ── Magazyn > Punkty ────────────────────────────────────────────────
    points_settings_title: "Punkty",
    warehouse_tile_points_desc: "Cele czasowe i tabela wyników",
    points_flow_large: "Duże",
    points_tab_targets: "Cele",
    points_tab_leaderboard: "Tabela wyników",
    points_targets_hint: "Cel określa wartość punktu: pobij go na jednej jednostce pracy, a operator zdobywa zaoszczędzone sekundy. Pusty cel oznacza, że dany proces nie jest punktowany.",
    points_target_put_away_hint: "Jeden artykuł odłożony do lokalizacji lub jeden pojemnik odłożony w całości — zależnie od trybu magazynu.",
    points_target_picking_hint: "Jedna pozycja skompletowana: od zaakceptowanego skanu artykułu do następnego. Single zapisywane jest jako typ 'light'.",
    points_target_dispatch_hint: "Jedno zamówienie spakowane i zamknięte na stanowisku, mierzone celem dla typu kompletacji, z którego pochodzi.",
    points_target_wipe_hint: "Jeden artykuł zeskanowany, oceniony i zarejestrowany.",
    points_celebrations: "Świętowanie",
    points_celebration_sound: "Dźwięk kamienia milowego",
    points_celebration_sound_hint: "Dzwonek od 1000 punktów i fanfara od 5000 wzwyż — mniej więcej co dziesiąty dzień. Wyłącz tam, gdzie hałas przeszkadza; animacje pozostaną.",
    targets_moved_to_points: "Cele czasowe znajdują się teraz w",
    points_range: "Okres",
    points_range_today: "Dzisiaj",
    points_range_yesterday: "Wczoraj",
    points_range_this_week: "Ten tydzień",
    points_range_last_week: "Poprzedni tydzień",
    points_range_this_month: "Ten miesiąc",
    points_range_last_month: "Poprzedni miesiąc",
    points_range_this_year: "Ten rok",
    points_range_all: "Cały okres",
    points_range_custom: "Zakres niestandardowy",
    points_col_rank: "Miejsce",
    points_col_name: "Imię i nazwisko",
    points_col_time_saved: "Zaoszczędzony czas",
    points_col_days: "Dni",
    points_col_best_day: "Najlepszy dzień",
    points_no_scores: "Nikt nie zdobył punktów w tym okresie",
    points_unstamped_hidden: "{count} dni pracy w tym zakresie nie ma zapisanego magazynu, więc nie są tu pokazane. Wybierz Wszystkie magazyny, aby je uwzględnić.",
    points_leaderboard_lag: "Wyniki wysyłane są partiami, więc ostatnia minuta może być niewidoczna",
    wipe_filter_search_hint: "Szukaj nowego/starego SKU, pkg id, ASIN, tytułu lub magazynu (naciśnij Enter)",
    wipe_clear_filters: "Wyczyść filtry",
    wipe_export_table: "Tabela",
    wipe_ppd_export: "PPD",
    wipe_jobalots_export: "Jobalots",
    wipe_filter_all_warehouses: "Wszystkie magazyny",
    wipe_filter_all_outcomes: "Wszystkie wyniki",
    wipe_outcome_box_prefixed: "Pudełko {label}",
    wipe_filter_from: "Od",
    wipe_filter_to: "Do",
    wipe_col_id: "ID",
    wipe_col_date: "Data",
    wipe_col_warehouse: "Magazyn",
    wipe_col_new_sku: "Nowy SKU",
    wipe_col_old_sku: "Stary SKU",
    wipe_col_jli_pkg_id: "jli_pkg_id",
    wipe_col_asin: "Asin",
    wipe_col_title: "Tytuł",
    wipe_col_data_sensitive: "Dane Wrażliwe",
    wipe_col_outcome: "Wynik",
    wipe_col_unit_cost: "Koszt Jedn.",
    wipe_col_weight: "Waga (g)",
    wipe_no_rows: "Brak produktów Wipe dla wybranych filtrów.",
    wipe_col_jobalots: "Jobalots",
    wipe_jobalots_listed: "Wystawiony",
    wipe_jobalots_not_listed: "Niewystawiony",
    wipe_jobalots_not_checked: "Niesprawdzony",
    wipe_jobalots_checked_at: "Ostatnia synchronizacja stanu {date}",
    wipe_filter_all_listing: "Wystawione i nie",
    wipe_filter_listed: "Wystawione na Jobalots",
    wipe_filter_not_listed: "Niewystawione na Jobalots",
    wipe_jobalots_queue: "Zleć eksport Jobalots",
    wipe_jobalots_queued: "Eksport zlecony — pojawi się w Raporty › Eksporty w kolejce, gdy będzie gotowy.",
    wipe_jobalots_queue_failed: "Nie udało się zlecić eksportu — spróbuj ponownie",
    wipe_jobalots_sync: "Synchronizuj Jobalots",
    wipe_jobalots_sync_hint: "Wyślij ponownie stan dla każdego SKU w widoku oznaczonego jako Niewystawiony na Jobalots. Odpowiedzi Jobalots aktualizują kolumnę Jobalots w ciągu kilku minut.",
    wipe_jobalots_sync_started: "Sprawdzanie {count} SKU w Jobalots — kolumna Jobalots aktualizuje się wraz z odpowiedziami. Odśwież za kilka minut.",
    wipe_jobalots_sync_none: "Żadne SKU w widoku nie jest oznaczone jako Niewystawione na Jobalots.",
    wipe_jobalots_sync_failed: "Nie udało się uruchomić synchronizacji Jobalots — spróbuj ponownie",
    zone_storage: "Sortowanie",
    conveyor: "Przenośnik",

    // Login
    portal_login: "Logowanie do portalu",
    logging_in: "Logowanie...",
    password: "Hasło",
    select_colour: "Wybierz",
    colour_blue: "Niebieski",
    colour_black: "Czarny",
    colour_green: "Zielony",
    colour_grey: "Szary",
    colour_pink: "Różowy",
    colour_purple: "Fioletowy",
    colour_red: "Czerwony",
    colour_yellow: "Żółty",
    colour_dsd: "Nośniki danych",
    colour_white: "Biały",
    version_text: "v0.22.2",

    // Scan Sheet
    scan_here: "Skanuj tutaj...",
    scan: "Skanuj",
    server_error: "Błąd serwera — spróbuj ponownie",
    label_size_forbidden: "Nie możesz zmienić zapisanego rozmiaru etykiety — poproś administratora albo drukuj w obecnym rozmiarze",
    not_in_manifest: "Przedmiot nie znajduje się w manifestcie",
    bulk_upload_too_large: "Partia importu jest za duża dla serwera (limit 5MB). Niektóre wiersze mogą zawierać wyjątkowo długie wartości (opisy, notatki). Spróbuj skrócić te pola lub poproś administratora o zwiększenie limitu. Wcześniejsze partie w tym imporcie zostały już zapisane.",
    ppd_sync_failed: "Synchronizacja z PPd nie powiodła się — zeskanuj pojemnik ponownie",
    unsellable_location_title: "Lokalizacja niesprzedażowa",
    unsellable_location_body: "Towar tutaj umieszczony nie będzie pobierany do zamówień. Kontynuować?",
    unsellable_location_confirm: "Umieść mimo to",
    put_away_confirm_title: "Odłożyć wszystkie przedmioty?",
    put_away_confirm_hint: "Zeskanuj ponownie {location} lub naciśnij Potwierdź, aby przenieść tam wszystkie przedmioty ({units})",
    put_away_confirm_rescan_mismatch: "Zeskanuj ponownie tę samą lokalizację, aby potwierdzić, lub anuluj",
    put_away_confirm_button: "Potwierdź odłożenie",
    put_away_item_already_done: "Ta sztuka została już odłożona z tego pojemnika",
    label_size_aria: "Zmień rozmiar etykiety",
    label_size_button: "Etykieta: {size}",
    nothing_scanned: "Nic nie zeskanowano",
    oversize: "Ponadwymiarowy",
    scan_location_to_begin: "Zeskanuj lokalizację",
    scan_location_sub: "Strefa · Paczki · Palety",
    unknown_location_barcode: "Nieznany kod lokalizacji",
    location_check_failed: "Nie udało się zweryfikować lokalizacji — spróbuj ponownie",
    last_scanned: "Ostatni: {value}",
    blue: "Niebieski",
    green_hot: "Zielony Gorący",
    green_cold: "Zielony Zimny",
    green: "Zielony",
    pink: "Różowy",
    orange: "Pomarańczowy",
    grey: "Szary",
    red: "Czerwony",
    yellow: "Żółty",
    relabel: "Przetaguj",
    banned: "Zakazany",
    special: "Specjalny",
    storage_device: "Urządzenie magazynowe",
    pricing_dispute: "Spor o cenę",

    // Book In
    book_in_category_title: "Wybierz Kolor",
    book_in_category_sub: "Wybierz kategorię, aby rozpocząć",
    colour_orange: "Pomarańczowy",
    category_misc: "Różne",
    category_supplier: "Dostawca",
    category_supplier_action: "Wybierz Dostawcę",
    category_label: "Kategoria: {category}",
    change_category: "Zmień",
    tote_colour_mismatch: "Pojemnik zarejestrowany jako {colour} — zeskanuj inny pojemnik",
    scan_tote: "Skanuj Pojemnik",
    invalid_tote: "Nieprawidłowy pojemnik",
    tote_status_open: "Pojemnik w użyciu",
    tote_status_closed: "Pojemnik zamknięty",
    tote_status_stored: "Pojemnik w magazynie",
    tote_status_available: "Pojemnik jest pusty",
    tote_not_awaiting_put_away: "Pojemnik zawiera pobrany towar — nic do odłożenia",
    close_tote: "Zamknij pojemnik",
    scan_to_close: "Skanuj, aby zamknąć",
    scan_tote_sub: "Zeskanuj pojemnik, aby rozpocząć",
    scan_item_sub: "Zeskanuj pojemnik ponownie, aby zamknąć",
    remove_item_sub: "Dotknij ikony kosza, aby wyjść",
    resume_tote_hint: "Wznów {tote} ({count}) — zeskanuj, aby otworzyć",
    complete: "Zakończ",
    complete_and_putaway: "Zakończ i odłóż",
    items_count: "{count} szt.",
    tote_label: "Pojemnik: {tote}",
    close_tote_confirm: "Zeskanuj pojemnik ponownie lub naciśnij Zakończ, aby zarejestrować wszystkie przedmioty.",
    remove_item: "Usuń Przedmiot",
    item_not_in_tote: "Nie ma takiego przedmiotu",
    enter_remove_mode: "Tryb usuwania",
    exit_remove_mode: "Wyjdź z trybu usuwania",
    tote_empty_cant_close: "Zeskanuj przedmioty przed zamknięciem pojemnika",
    abandon_tote_title: "Zamknąć pusty pojemnik?",
    abandon_tote_body: "Do tego pojemnika nie zeskanowano żadnych przedmiotów. Zamknięcie go teraz zwróci pojemnik do puli dostępnych, aby można było go ponownie użyć.",
    abandon_tote_yes: "Tak, porzuć",
    already_in_tote: "Już w pojemniku",
    already_in_stock: "SKU jest już na stanie w lokalizacji {location} ({qty} szt.), przekaż ten produkt liderowi",
    already_in_stock_multi: "SKU jest już na stanie w lokalizacji {location} ({qty} szt.) i w {more} innych lokalizacjach, przekaż ten produkt liderowi",
    tote_in_use_by: "Pojemnik używany przez {name}",
    tote_resumed: "Wznowiono pojemnik rozpoczęty przez {name}",
    reopen_tote_title: "Otwórz pojemnik ponownie",
    reopen_tote_intro: "Ten pojemnik został już zaksięgowany. Kontynuować z bieżącą zawartością czy opróżnić i zacząć od nowa?",
    reopen_tote_intro_named: "Zaksięgowany przez {name}. Kontynuować z bieżącą zawartością czy opróżnić i zacząć od nowa?",
    reopen_continue: "Kontynuuj",
    reopen_empty: "Opróżnij",
    reopen_empty_confirm_title: "Opróżnić pojemnik?",
    reopen_empty_confirm_body: "Wszystkie przedmioty w tym pojemniku zostaną usunięte i zaczniesz od nowa. Tej operacji nie można cofnąć.",
    reopen_empty_confirm_yes: "Tak, opróżnij",
    join_tote_title: "Dołączyć do pojemnika?",
    join_tote_intro: "Inny operator ma ten pojemnik otwarty. Dołączyć i dopisać się do bieżącej zawartości?",
    join_tote_intro_named: "{name} ma ten pojemnik otwarty. Dołączyć i dopisać się do bieżącej zawartości?",
    join_tote_join: "Dołącz",
    must_close_tote_first: "Zamknij pojemnik {tote}, zanim otworzysz nowy",
    tote_closed_externally: "Pojemnik {tote} został zamknięty przez innego operatora",
    no_open_manifest: "Brak manifestu dla tego SKU w tym magazynie — dodaj manifest przed rejestracją",
    // Book In — supplier / PO flow
    book_in_select_supplier_title: "Wybierz dostawcę",
    book_in_select_supplier_sub: "Dostawcy z otwartymi PO",
    book_in_select_po_title: "Wybierz PO",
    book_in_select_po_sub: "Otwarte PO dla {supplier}",
    book_in_no_suppliers: "Brak dostawców z otwartymi PO. Włącz dostawców w Admin → Magazyn → Dostawcy.",
    book_in_no_pos: "Brak otwartych PO dla tego dostawcy",
    book_in_po_meta: "{done} / {total} wierszy · {received} / {expected} szt.",
    book_in_supplier_meta: "Otwarte PO: {pos} · otwarte wiersze: {lines}",
    book_in_back: "Wstecz",
    po_chip: "{supplier} · {po}",
    tote_po_mismatch: "Kosz zarejestrowany na PO {po} — zeskanuj inny kosz",
    tote_po_mismatch_none: "Kosz zarejestrowany bez PO — zeskanuj inny kosz",
    item_not_on_po_title: "Brak na tym PO",
    item_not_on_po_body: "{sku} nie ma na PO {po}. Dodać do PO?",
    item_not_on_po_add: "Dodaj do PO",
    item_po_progress: "PO {received} / {expected}",
    manifest_short: "Manifest niewystarczający dla: {skus}",
    items_missing_sku: "Nie rozpoznano tych pozycji: {barcodes}. Sprawdź konfigurację w produktach / manifestach.",
    book_in_tote_not_in_progress: "Kuweta {tote} nie ma otwartego przyjęcia — nic nie zostało przyjęte. Zeskanuj kuwetę ponownie, aby rozpocząć.",

    // Pallet Receiving
    pallet_receiving: "Przyjęcie palet",
    pallet_receiving_short: "Przyjęcia",
    how_many_labels: "Ile etykiet?",
    printing_label_n_of_m: "Drukowanie {n} z {m}",
    print_partial_failed: "Nie udało się wydrukować {failed} z {total} etykiet",
    scan_pallet: "Zeskanuj paletę",
    scan_loading_bay: "Zeskanuj lokalizację",
    pallet_loading_bay_only: "Zeskanuj pas lub lokalizację magazynową, nie strefę skanu",
    pallet_already_placed: "Paleta już rozmieszczona",
    pallet_unknown: "Nieznana paleta",
    pallet_wrong_warehouse: "Paleta z innego magazynu",
    void_label_mode: "Usuń etykietę",
    scan_label_to_void: "Zeskanuj do usunięcia",
    pallet_voided: "Etykieta usunięta",
    cannot_void_placed: "Już rozmieszczona — nie można usunąć",
    pallets_pending_count: "{count} do rozmieszczenia",
    pallets_today_count: "Dziś: {count}",
    pallets_all_placed: "Wszystkie palety rozmieszczone",
    receive_more: "Przyjmij więcej",
    scan_to_place: "Zeskanuj, aby rozmieścić",
    printed_n_labels: "Wydrukowano {count} etykiet",
    inbound_stock_type_prompt: "Jaki rodzaj towaru?",
    inbound_stock_type_required: "Najpierw wybierz rodzaj towaru",
    inbound_stock_type_unknown: "Ten rodzaj towaru już nie istnieje — odśwież stronę",
    inbound_print_prompt: "Drukuj {count} etykiet",
    inbound_supplier: "Dostawca",
    inbound_supplier_required: "Najpierw wybierz dostawcę",

    // Goods In > Inbound settings (stock types printed on inbound labels)
    inbound_settings: "Ustawienia przyjęć",
    inbound_stock_types: "Rodzaje towaru",
    inbound_stock_types_hint: "Rodzaje, z których operator wybiera przy drukowaniu etykiet przyjęcia, np. Koperty, Paczki, Palety. Kod staje się prefiksem kodu kreskowego (ENV-NP-20260915-001), a nazwa jest drukowana na etykiecie. Bez rodzajów nie ma pytania, a etykiety mają prefiks P.",
    inbound_stock_types_none: "Brak rodzajów — etykiety drukują się z prefiksem P bez pytania",
    inbound_stock_type_name: "Nazwa",
    inbound_stock_type_name_placeholder: "np. Koperty",
    inbound_stock_type_code: "Kod",
    inbound_stock_type_code_placeholder: "np. KOP",
    inbound_stock_type_add: "Dodaj rodzaj",
    inbound_stock_type_remove: "Usuń {name}",
    inbound_stock_type_code_invalid: "Kod: 1–4 litery lub cyfry",
    inbound_stock_type_duplicate: "Ta nazwa lub kod są już użyte",
    inbound_pallet_age_thresholds: "Ostrzeżenia wiekowe",
    inbound_pallet_age_thresholds_hint: "Na panelu Przyjęć rozmieszczona paleta zmienia kolor na pomarańczowy po pierwszej liczbie dni, a na czerwony po drugiej. Puste pole wyłącza ostrzeżenie.",
    inbound_pallet_age_warn_days: "Pomarańczowy po",
    inbound_pallet_age_alert_days: "Czerwony po",

    // Stock check — inbound pallets parked at the location
    stock_check_location_rescan: "To lokalizacja, którą sprawdzasz — zeskanuj produkt",
    stock_check_pallet: "Paleta przyjęcia",
    stock_check_pallet_was_missing: "była zaginiona",
    stock_check_pallet_rehomed: "{pallet} przeniesiona tutaj z {from}",
    stock_check_pallet_not_placed: "{pallet} nie została jeszcze rozmieszczona — nie ma czego sprawdzać",
    stock_check_pallet_processed: "{pallet} trafiła już do strefy skanu",
    stock_check_pallets_flagged_missing: "Oznaczono {count} palet jako zaginione",
    stock_check_pallets_unseen_body: "{count} palet przyjęcia zapisanych tutaj nie zostało zeskanowanych. Zostaną oznaczone jako zaginione, nie spisane.",

    // Stock check — pallet crates stored inside the location (2026-10-26)
    stock_check_crate: "Skrzynia",
    stock_check_crate_units: "{count} szt.",
    stock_check_crate_in: "w {location}",
    stock_check_crate_rehomed: "Skrzynia {crate} przeniesiona tutaj z {from}",
    stock_check_crate_wrong_warehouse: "Skrzynia {crate} należy do innego magazynu",
    stock_check_crate_other: "To skrzynia {crate} — najpierw dokończ tę skrzynię",
    stock_check_crate_blocked: "Skrzyni {crate} nie można teraz tu przenieść",
    stock_check_not_a_crate: "Ten pojemnik nie ma odłożonego towaru",
    stock_check_crates_flagged_missing: "Oznaczono {count} skrzyń jako zaginione",
    stock_check_crates_unseen_body: "{count} skrzyń zapisanych tutaj nie zostało zeskanowanych. Zostaną oznaczone jako zaginione, nie spisane.",

    // Admin > Warehouse > Inbound (pallet dashboard)
    inbound_admin_title: "Przyjęcia",
    inbound_admin_hint: "Każda etykieta palety przyjęcia: gdzie jest, jak długo czeka i kto ją ostatnio skanował. Palety nie są stanem magazynowym — pojawiają się tylko tutaj, w Przenieś i w kontroli stanu lokalizacji, w której stoją.",
    warehouse_tile_inbound_desc: "Palety przyjęcia — status i lokalizacja",
    inbound_admin_status_pending: "Wydrukowana",
    inbound_admin_status_placed: "Rozmieszczona",
    inbound_admin_status_missing: "Zaginiona",
    inbound_admin_status_processed: "Przetworzona",
    inbound_admin_status_voided: "Usunięta",
    inbound_admin_tile_pending: "Etykiety do rozmieszczenia",
    inbound_admin_tile_in_lanes: "W zatokach",
    inbound_admin_tile_in_storage: "W magazynie",
    inbound_admin_tile_missing: "Zaginione",
    inbound_admin_tile_processed_today: "Do strefy skanu dziś",
    inbound_admin_tile_oldest: "Najdłużej czeka",
    inbound_admin_col_pallet: "Paleta",
    inbound_admin_col_type: "Rodzaj",
    inbound_admin_col_supplier: "Dostawca",
    inbound_admin_col_status: "Status",
    inbound_admin_col_location: "Lokalizacja",
    inbound_admin_col_printed: "Wydrukowano",
    inbound_admin_col_age: "Wiek",
    inbound_admin_col_at_location: "W lokalizacji",
    inbound_admin_col_last_seen: "Ostatnio widziana",
    inbound_admin_col_by: "Przez",
    inbound_admin_group_by_location: "Grupuj wg lokalizacji",
    inbound_admin_export: "Eksport CSV",
    inbound_admin_search_hint: "Szukaj ID palety, lokalizacji lub dostawcy",
    inbound_admin_none: "Brak pasujących palet",
    inbound_admin_no_location: "Brak lokalizacji",
    inbound_admin_pallets_here: "{count} palet",
    inbound_admin_history_title: "Historia palety",
    inbound_admin_event_printed: "Wydrukowano etykietę",
    inbound_admin_event_placed: "Rozmieszczono w {location}",
    inbound_admin_event_moved: "Przeniesiono {from} → {to}",
    inbound_admin_event_missing: "Oznaczono jako zaginioną w {location}",
    inbound_admin_event_processed: "Dostarczono do strefy skanu",
    inbound_admin_event_voided: "Etykieta usunięta",
    inbound_admin_source_place: "Przyjęcia",
    inbound_admin_source_move: "Przenieś",
    inbound_admin_source_stock_check: "Kontrola stanu",
    inbound_admin_source_admin: "Admin",
    inbound_admin_action_reprint: "Drukuj etykietę ponownie",
    inbound_admin_action_void: "Usuń etykietę",
    inbound_admin_action_found: "Oznacz jako znalezioną w…",
    inbound_admin_action_force_process: "Oznacz jako przetworzoną",
    inbound_admin_found_prompt: "Zeskanuj lub wpisz kod lokalizacji, w której znaleziono {pallet}",
    inbound_admin_found_done: "{pallet} jest teraz w {location}",
    inbound_admin_force_process_confirm: "Oznaczyć {pallet} jako przetworzoną? Zniknie z kolejki Przenieś.",
    inbound_admin_void_confirm: "Usunąć etykietę {pallet}? Można usuwać tylko wydrukowane, nierozmieszczone etykiety.",
    inbound_admin_reprinted: "Etykieta wydrukowana ponownie",
    inbound_admin_age_days: "{days}d",
    inbound_admin_age_hours: "{hours}h",

    // Move (inbound pallet → scansheet handoff)
    move: "Przenieś",
    move_go_to_lane: "Idź do pasa",
    move_pallets_in_bay: "Palety w tym pasie: {count}",
    move_choose_another_bay: "Wybierz inną zatokę",
    move_scan_pallet: "Zeskanuj paletę",
    move_scan_scansheet: "Zeskanuj lokalizację docelową",
    move_inbound_processing_only: "Ta lokalizacja nie może przyjąć palety",
    move_stored_at: "Przeniesiono do {location} — nadal do zrobienia",
    move_pallet_was_missing: "Ta paleta była oznaczona jako zaginiona — dostarczenie to usuwa",
    move_all_caught_up: "Wszystko zrobione",
    move_pallets_to_move: "{count} do przeniesienia",
    move_no_inbound_location: "Brak lokalizacji skanu — wydrukuj etykietę w Ustawieniach Przyjęcia",
    pallet_already_processed: "Paleta już przetworzona",
    pallet_not_placed: "Paleta nie znajduje się w zatoce",

    locations_col_type: "Typ",

    // Developer / Demo
    developer_settings: "Programista",
    demo_mode: "Tryb demo",
    demo_mode_hint: "Pokazuj demonstracyjne kody kreskowe na stronach skanowania (Rejestracja, Przyjęcie, Przenieś, Odłożenie, Wysyłka). Ustawienie zapisywane lokalnie na urządzeniu.",
    demo_mode_super_admin_only: "Tylko SuperAdmin",
    demo_mode_super_admin_only_hint: "Gdy włączone, demonstracyjne kody kreskowe widzą tylko użytkownicy SuperAdmin. Gdy wyłączone — zarówno Admin, jak i SuperAdmin. Użytkownicy podstawowi nigdy nie widzą trybu demo. Ustawienie zapisywane lokalnie na urządzeniu.",
    label_batch_position: "{n} / {total} w partii",
    label_today_position: "#{n} dziś",
    decrease: "Zmniejsz",
    increase: "Zwiększ",

    // Admin Settings
    settings: "Ustawienia",
    warehouses_settings: "Magazyny",
    warehouses_settings_hint: "Dodaj lub przejrzyj magazyny skonfigurowane w tym Portalu. Każdy magazyn jest pogrupowany według kraju (używane przez piguły UK / EU na stronie Inwentaryzacji). Ukryj nieużywany magazyn, aby usunąć go ze wszystkich wyborów, filtrów i raportów bez naruszania danych; usunięcie działa tylko dla magazynu, do którego nic się nie odwołuje.",
    country_col: "Kraj",
    warehouse_add: "Dodaj magazyn",
    warehouse_name_placeholder: "np. Manchester",
    country_placeholder: "np. UK",
    warehouse_added: "Dodano magazyn {name}",
    warehouse_already_exists: "Magazyn o tej nazwie już istnieje",
    warehouse_edit: "Edytuj magazyn",
    warehouse_updated: "Zaktualizowano magazyn {name}",
    warehouse_rename_warning_title: "Zmiana nazwy magazynu",
    warehouse_rename_warning_body: "Nazwa magazynu jest kanonicznym ID, do którego odwołują się rekordy użytkowników, pojemników, rejestracji, dzienników skanowania i inwentaryzacji. Zmiana nazwy kaskadowo aktualizuje wszystkie tabele i kolekcje — ale jeśli jakieś odniesienie zostanie pominięte (np. przyszła tabela jeszcze niepodłączona), będzie wskazywać starą nazwę. Zmieniaj tylko, gdy jesteś pewien.",
    warehouse_rename_confirm_label: "Wpisz {name}, aby potwierdzić",
    warehouse_rename_confirm_mismatch: "Tekst potwierdzenia nie pasuje do aktualnej nazwy magazynu",
    warehouse_renamed: "Zmieniono nazwę {from} → {to}",
    warehouse_renamed_partial: "Zmieniono nazwę na {name}, ale te kolekcje wymagają ręcznej poprawki: {failures}",
    warehouse_hide: "Ukryj magazyn",
    warehouse_show: "Pokaż magazyn",
    warehouse_hide_hint: "Ukryj — usuwa go z każdego wyboru magazynu, filtra i raportu. Dane pozostają.",
    warehouse_show_hint: "Pokaż — przywróć go do wyborów magazynu, filtrów i raportów.",
    warehouse_hidden_pill: "Ukryty",
    warehouse_hidden: "Ukryto {name} — nie pojawia się już w wyborach, filtrach ani raportach",
    warehouse_shown: "{name} jest ponownie widoczny",
    warehouse_delete: "Usuń magazyn",
    warehouse_delete_checking: "Sprawdzanie, co używa tego magazynu…",
    warehouse_delete_unused: "Nic nie odwołuje się do {name}. Usunięcie skasuje go z listy magazynów.",
    warehouse_delete_in_use: "Nie można usunąć {name} — nadal odwołują się do niego:",
    warehouse_delete_in_use_hint: "Najpierw wyczyść lub przenieś te dane, potem spróbuj ponownie. Usunięcie magazynu nigdy nie usuwa jego danych.",
    warehouse_delete_unchecked: "Nie udało się sprawdzić: {sources}. Spróbuj ponownie, gdy będą dostępne.",
    warehouse_delete_confirm_label: "Wpisz {name}, aby potwierdzić usunięcie",
    warehouse_delete_history_note: "Historyczne dzienniki skanowania, sortowania i przenośnika wspominające ten magazyn są zachowywane i nie blokują usunięcia.",
    warehouse_deleted: "Usunięto magazyn {name}",
    warehouse_delete_failed: "Nie udało się usunąć magazynu",
    rows_count: "{count} wierszy",
    rows_count_capped: "{count}+ wierszy",
    goods_in_settings: "Przyjęcie Towaru",
    scan_sheet_settings: "Arkusz Skanowania",
    sorting_settings: "Sortowanie",
    sorter_1_settings: "Sorter 1",
    sorter_2_settings: "Sorter 2",
    default_timer_target: "Domyślny cel czasu",
    default_timer_target_hint: "Domyślny cel paska postępu w milisekundach. Puste = wartość domyślna aplikacji. Niższe wartości = większa presja.",
    location_timer_targets: "Cele czasowe lokalizacji",
    location_timer_targets_hint: "Ustawia cel paska postępu (w milisekundach) dla każdego prefiksu lokalizacji (pierwsze 6 znaków zeskanowanego kodu). Puste = wartość domyślna aplikacji.",
    sorting_shared_lighting: "Oświetlenie (wszystkie sortery)",
    sorting_lighting_hint: "Konfiguracja świateł ruchomych wspólna dla Sortera 1, Sortera 2 i Pick & Sort. Kolory i agenci są globalne; jasność i auto-wyłączenie są per magazyn.",
    sorter_bays_grid: "Zatoki i siatka świateł",
    sorter_bay_no_label: "Numer regału Sortera 2",
    sorter_no_locations: "Nie znaleziono istniejących lokalizacji dla tego regału. Sprawdź, czy numer regału pasuje do kodów lokalizacji (np. 01 w NPS201A1).",
    home_modules_settings: "Moduły aplikacji",
    home_modules_settings_hint: "Dla każdego magazynu wybierz, które moduły aplikacji — oraz ich podstrony — są widoczne dla każdej roli użytkownika. Rozwiń wiersz nadrzędny, aby skonfigurować jego elementy podrzędne.",
    module_col: "Moduł",
    role_super_admin: "SuperAdmin",
    // Warstwa zgodności stanowisk (9 stanowisk zastępujących 3 dawne
    // rangi) — etykiety dla selektora/listy/filtra stanowisk.
    position_admin: "Administrator",
    position_manager: "Kierownik",
    position_supervisor: "Kierownik zmiany",
    position_team_leader: "Lider zespołu",
    position_assistant_team_leader: "Asystent lidera zespołu",
    position_site_assistant: "Asystent obiektu",
    position_operative: "Operator",
    position_marketing: "Marketing",
    position_customer_service: "Obsługa klienta",
    legacy_value: "starsza wartość",
    // Edytor kontroli dostępu (Ustawienia > Kontrola dostępu) — macierz
    // uprawnień stanowisk/użytkowników, zastępująca Moduły aplikacji jako
    // źródło prawdy, gdy tryb magazynu to "active".
    access_control_settings_note: "Szukasz nowej macierzy uprawnień stanowisk/użytkowników?",
    access_control_settings_link: "Otwórz Kontrolę dostępu",
    access_control_settings_title: "Kontrola dostępu",
    ac_title: "Kontrola dostępu",
    ac_tables_missing: "Tabele kontroli dostępu nie zostały jeszcze skonfigurowane (migracja 193 nie została uruchomiona). Zapisywanie jest wyłączone do czasu naprawienia tego.",
    ac_preview_only_banner: "Tylko podgląd — Moduły aplikacji nadal decydują. Zmiany tutaj zaczną obowiązywać po włączeniu kontroli dostępu.",
    ac_revision_conflict: "Ktoś inny zapisał zmiany, gdy edytowałeś. Wczytaj najnowsze reguły i spróbuj ponownie.",
    ac_reload_and_retry: "Wczytaj ponownie i spróbuj",
    ac_view_matrix: "Macierz",
    ac_view_users: "Użytkownicy",
    ac_view_preview: "Podgląd jako…",
    ac_view_changelog: "Dziennik zmian",
    ac_view_parity: "Zgodność",
    ac_view_snapshots: "Migawki",
    ac_pending_changes: "Niezapisane zmiany: {count}",
    ac_no_pending_changes: "Brak niezapisanych zmian",
    ac_gated_by_area: "Nieaktywne: obszar {area} jest ustawiony na brak dla tego stanowiska, więc ta komórka nie działa, dopóki obszar nie zostanie nadany.",
    ac_saved_revision: "Zapisano — reguły są teraz w wersji {revision}",
    ac_discard: "Odrzuć",
    ac_defaults_tab: "Domyślne",
    ac_filter_placeholder: "Filtruj po etykiecie lub kluczu...",
    ac_key_col: "Uprawnienie",
    ac_menu_tag: "Menu",
    ac_floor_note: "Wymuszony próg: {floor}",
    ac_admin_locked: "Administrator zawsze ma pełny dostęp — nie można tego tutaj zmienić.",
    ac_inherited_from_default: "Dziedziczone z zakładki Domyślne",
    ac_inherited_from_code_default: "Dziedziczone z wbudowanej wartości domyślnej",
    ac_inherited_from_position: "Dziedziczone ze stanowiska",
    ac_user_override_beats_position: "Nadpisanie użytkownika ma pierwszeństwo przed regułą stanowiska",
    ac_group_goods_in: "Przyjęcie towaru",
    ac_group_conveyor: "Przenośnik",
    ac_group_handheld: "Skaner ręczny",
    ac_group_dispatch: "Wysyłka",
    ac_group_admin_overview: "Panel administracyjny — przegląd",
    ac_group_admin_warehouse: "Panel administracyjny — magazyn",
    ac_group_admin_catalogue: "Panel administracyjny — katalog",
    ac_group_admin_people: "Panel administracyjny — pracownicy",
    ac_group_admin_settings: "Panel administracyjny — ustawienia",
    ac_group_company: "Cała firma",
    users_action_not_granted: "Nie masz uprawnień do tej czynności. Poproś Administratora o nadanie w Kontroli dostępu.",
    ac_view_fixed: "Stałe reguły",
    ac_fixed_intro: "Te reguły obowiązują niezależnie od macierzy. Komórka w macierzy nie może nadać uprawnienia ponad nie.",
    ac_fixed_floors_title: "Czynności ograniczone do stanowiska",
    ac_fixed_floors_hint: "Sprawdzane przed macierzą. Poniżej wskazanego stanowiska odpowiedź zawsze brzmi nie; od tego stanowiska wzwyż wiersz macierzy nadal musi nadawać uprawnienie.",
    ac_fixed_guards_title: "Reguły kont i systemu",
    ac_fixed_col_action: "Czynność",
    ac_fixed_col_who: "Kto",
    ac_fixed_col_row: "Wiersz macierzy",
    ac_fixed_col_why: "Dlaczego jest stała",
    ac_fixed_admin_only: "Tylko Administrator",
    ac_fixed_manager_admin: "Kierownik i Administrator",
    ac_fixed_none: "Serwer nie zgłosił stałych reguł.",
    ac_floor_access_control: "Zmiana reguł dostępu, tworzenie i przywracanie migawek",
    ac_floor_warehouses: "Tworzenie, zmiana nazwy, ukrywanie i usuwanie magazynu",
    ac_floor_maintenance: "Czynności serwisowe (czyszczenie kolejki odkładania, reset pojemników, demo kompletacji)",
    ac_floor_remove_batch_data: "Usuwanie danych partii",
    ac_floor_network_access: "Podgląd i edycja listy dozwolonych adresów IP, aktywności logowania i zablokowanych prób",
    ac_floor_saved_logins: "Zezwalanie urządzeniom na zapisywanie danych logowania do Portalu (Ustawienia › Ekran logowania)",
    ac_floor_why_saved_logins: "Na współdzielonych urządzeniach zapisane dane logowania logują następną osobę jako kogoś innego; włączenie dotyczy każdego urządzenia we wszystkich lokalizacjach.",
    ac_floor_integrations_config: "Konfiguracja kanałów sprzedaży (tworzenie, edycja, sekrety, webhooki, synchronizacja katalogu, testy, dostawcy)",
    ac_floor_carriers_config: "Konfiguracja kont i usług przewoźników, generowanie sekretu webhooka",
    ac_floor_legacy_maintenance: "Starsze trasy serwisowe (usuwanie pozycji skanów, oranges, pozycje palet, importy testowe LaaS)",
    ac_floor_layout_delete: "Usunięcie układu magazynu",
    ac_floor_channel_rules: "Godziny graniczne kanałów i metryki pulpitu (Ustawienia › Wysyłka)",
    ac_floor_integrations_live: "Ruch na żywo w integracjach (odpytanie Amazon, wysłanie całego stanu, przesyłka testowa)",
    ac_floor_lockout_unlock: "Odblokowanie zablokowanego koloru (po wielokrotnym błędnym PIN-ie)",
    ac_floor_carrier_environment: "Przełączenie przewoźnika między trybem testowym a produkcyjnym",
    ac_floor_carrier_claims: "Natychmiastowe wysłanie reklamacji do przewoźnika",
    ac_floor_carrier_test_booking: "Nadanie testowe u przewoźnika (DPD / Cargus)",
    ac_floor_why_access_control: "Kto mógłby zmieniać reguły, mógłby nadać sobie dowolne uprawnienie.",
    ac_floor_why_warehouses: "Zmienia strukturę, na której opierają się wszystkie reguły.",
    ac_floor_why_maintenance: "Destrukcyjne i trudne do cofnięcia.",
    ac_floor_why_remove_batch_data: "Destrukcyjne i trudne do cofnięcia.",
    ac_floor_why_layout_delete: "Destrukcyjne i trudne do cofnięcia.",
    ac_floor_why_integrations_live: "Komunikacja z partnerami na prawdziwym stanie i pieniądzach.",
    ac_floor_why_lockout_unlock: "Czynność bezpieczeństwa.",
    ac_floor_why_carrier_environment: "Tryb produkcyjny tworzy prawdziwe listy przewozowe.",
    ac_floor_why_carrier_claims: "Wysyła prawdziwe reklamacje do przewoźnika.",
    ac_floor_why_carrier_test_booking: "Wywołuje przewoźnika z prawdziwymi danymi dostępowymi (próba bez nadania, ale połączenie zewnętrzne).",
    ac_guard_admin_always: "Administrator zawsze ma wszystkie uprawnienia we wszystkich magazynach i nie można go ograniczyć.",
    ac_guard_downstream: "Uprawnienia działają w dół: administrator zarządza każdym kontem poniżej administratora, menedżer każdym kontem poniżej menedżera, a nikt nie edytuje, nie zawiesza, nie dezaktywuje ani nie resetuje hasła osoby na równym stanowisku. Tylko administrator tworzy administratora.",
    ac_guard_own_details: "Własne imię i nazwisko, e-mail, nazwę użytkownika i magazyn zmieniasz sam; nikt inny nie edytuje danych administratora.",
    ac_guard_own_position: "Nikt nie zmienia własnego stanowiska.",
    ac_guard_self_actions: "Nikt nie dezaktywuje, nie zawiesza ani nie wymusza zmiany hasła na własnym koncie.",
    ac_guard_concurrent_sessions: "Tylko Administrator może zezwolić na logowanie jednego konta na kilku urządzeniach jednocześnie.",
    ac_guard_location_barcode: "Tylko Administrator może zmienić kod kreskowy lokalizacji.",
    ac_guard_legacy_levels: "W trybie legacy i shadow każda ścieżka zachowuje też dawny poziom rangi (basic, admin, superAdmin). W trybie active decyduje macierz.",
    ac_no_access: "Nie masz dostępu do Kontroli dostępu. Poproś Administratora o nadanie uprawnienia w macierzy.",
    ac_users_search_placeholder: "Szukaj po imieniu, magazynie lub UID...",
    ac_users_none_found: "Nie znaleziono użytkowników",
    ac_users_select_hint: "Wybierz użytkownika, aby zobaczyć i edytować jego nadpisania.",
    ac_users_unknown_position: "Nie udało się ustalić stanowiska tego użytkownika.",
    ac_users_override_hint: "Nadpisania tylko dla tego użytkownika — mają pierwszeństwo przed regułą stanowiska {position}.",
    ac_preview_position: "Stanowisko",
    ac_preview_uid: "ID użytkownika (opcjonalnie)",
    ac_preview_uid_placeholder: "np. 42",
    ac_preview_resolved: "Wynik",
    ac_preview_source: "Źródło",
    ac_preview_legacy: "Starsze",
    ac_audit_when: "Kiedy",
    ac_audit_who: "Kto",
    ac_audit_subject: "Podmiot",
    ac_audit_change: "Zmiana",
    ac_audit_empty: "Nie zarejestrowano jeszcze żadnych zmian.",
    ac_audit_load_older: "Wczytaj starsze",
    ac_parity_warehouses: "Magazyny",
    ac_parity_cells: "Porównane komórki",
    ac_parity_differences: "Różnice",
    ac_parity_reductions: "Ograniczenia",
    ac_parity_widenings: "Rozszerzenia",
    ac_parity_migrated_ok: "Stanowiska migrowane: każda różnica podjęta decyzją (test przełączenia zaliczony)",
    ac_parity_migrated_undecided: "Stanowiska migrowane: różnice bez decyzji",
    ac_parity_new_positions: "Nowe stanowiska (bez odpowiednika, informacyjnie)",
    ac_parity_kind: "Rodzaj",
    ac_parity_rules_col: "Kontrola dostępu",
    ac_parity_none: "Nie znaleziono różnic.",
    ac_snapshot_reason_placeholder: "Powód tej migawki (opcjonalnie)",
    ac_snapshot_take: "Utwórz migawkę",
    ac_snapshot_when: "Utworzono",
    ac_snapshot_reason: "Powód",
    ac_snapshot_revision: "Wersja",
    ac_snapshot_rule_count: "Reguły",
    ac_snapshot_restore: "Przywróć",
    ac_snapshot_empty: "Brak migawek.",
    ac_snapshot_restore_title: "Przywrócić tę migawkę?",
    ac_snapshot_restore_body: "Spowoduje to zastąpienie bieżących reguł tymi zapisanymi w tej migawce. Tej operacji nie można tu cofnąć — jeśli chcesz zachować bieżący stan, najpierw utwórz nową migawkę.",
    warehouse_menu_title: "Magazyn",
    search_admin_placeholder: "Szukaj stron admina...",
    search_no_results: "Brak wyników",
    search_min_chars: "Wpisz co najmniej {n} znaki",
    search_view_all_in: "Zobacz wszystko w {section} →",
    search_in_placeholder: "Szukaj w {section}...",
    admin_search_section_pages: "Strony",
    book_in_settings: "Rejestracja",
    warehouse_col: "Magazyn",
    allow_duplicate_barcodes: "Pozwól na duplikaty",
    allow_duplicate_barcodes_hint: "Tylko własny pojemnik. Gdy wyłączone, tego samego kodu nie można zeskanować dwukrotnie do pojemnika otwartego przez operatora. Nie sprawdza stanu, który jest już na półkach — za to odpowiada „Sprawdzaj duplikaty”. Włącz dla magazynów, w których towar rejestruje się masowo po wadze, a nie pojedynczo.",
    send_to_ppd: "Wysyłaj do PPd",
    send_to_ppd_hint: "Gdy włączone, zamknięte pojemniki są wysyłane do API PPd (ten sam kanał, z którego korzysta przenośnik).",
    zone_dispatch_via_portal: "Sorter 2 → wysyłka w Portalu",
    zone_dispatch_via_portal_hint: "Gdy włączone, zamknięcie tagu na rozładunku Sortera 2 przypisuje pojemnik do zamówienia w Portalu, przydziela stan i wysyła zamówienie do kolejki wysyłki Portalu zamiast do PPd. Skan otwierający tag sprawdza wtedy, czy pojemnik jest wolny, a zamówienie gotowe.",
    zone_singles_dispatch_via_portal: "Pas pojedynczych → wysyłka w Portalu",
    zone_singles_dispatch_via_portal_hint: "Gdy włączone, skan pasa pojedynczych Sortera 1 przypisuje każde jednosztukowe zamówienie z tagu do pojemnika, przydziela stan i wysyła je do kolejki wysyłki Portalu zamiast do PPd. Cały tag jest odrzucany, jeśli którykolwiek produkt nie przejdzie, a skan otwierający tag sprawdza, czy pojemnik jest wolny.",
    zone_reauction_via_portal: "Unsold Reauction → przeniesienie stanu w Portalu",
    zone_reauction_via_portal_hint: "Gdy włączone, załadunek Sortera 1 przenosi produkty Unsold Reauction z ich lokalizacji w Portalu do pojemnika reaukcyjnego przypisanego do stanowiska (zeskanuj pojemnik, aby go otworzyć; zeskanuj go ponownie przy SKANUJ PRODUKT, aby zamknąć go do kolejki odkładania), a produkty z palety reaukcyjnej przenośnika trafiają na pojemnik palety w Portalu (zsyp sortera: przeniesione ze stanu; przyjęcie BLUE: zarejestrowane jako nowy stan). Skan dodawania palety na przenośniku jest wtedy sprawdzany względem pojemników Portalu. PPd nie jest już wywoływane dla palet reaukcyjnych, gdy to jest włączone.",
    zone_grey_write_off_via_portal: "Unsold Grey → odpis stanu w Portalu",
    zone_grey_write_off_via_portal_hint: "Gdy włączone, potwierdzenie miejsca na Sorterze 1 dla produktu Unsold Grey odpisuje jedną sztukę tego SKU ze stanu Portalu, a komunikat przenośnika dla zsypu Unsold Grey odpisuje po jednej sztuce każdego SKU z palety (najstarsza nieprzydzielona sztuka w lokalizacji magazynowej; powód Niesprzedane grey w Kontrola stanu › Odpis › Historia). Brak stanu = nic nie jest odpisywane; operator dostaje ostrzeżenie, a przenośnik zapisuje to w logu.",
    allocate_on_ingest: "Alokuj stan przy przyjęciu zamówienia",
    allocate_on_ingest_hint: "Gdy włączone, każde zamówienie trafiające do tego magazynu od razu rezerwuje swój stan (najpierw najstarszy) i jest ukryte w kolejkach kompletacji — do wysyłki trafia przez zamknięcie Sortera 2 / pojedynczych. Jeśli brakuje stanu, zamówienie czeka w statusie Wstrzymane i jest zwalniane po dostawie towaru. Gdy wyłączone, stan jest przydzielany przy tworzeniu fali lub zamknięciu Sortera, jak dotychczas.",
    zone_portal_dispatch_settings: "Wysyłka w Portalu",
    zone_portal_dispatch_hint: "Przełączenie magazynu z PPd na wysyłkę w Portalu. Wyłączone = dotychczasowe działanie: skan zamykający tylko zapisuje tag, a poller PPd go pobiera.",
    allow_multi_user_book_in: "Wieloosobowa rejestracja",
    allow_multi_user_book_in_hint: "Gdy włączone, każdy operator może dołączać do trwającej rejestracji pojemnika otwartego przez kogoś innego. Gdy wyłączone (domyślnie) tylko pierwotny operator może wznowić — pozostali widzą komunikat „pojemnik w użyciu”.",
    allow_tote_reopen: "Ponowne otwieranie",
    allow_tote_reopen_hint: "Gdy włączone, zamknięty pojemnik można ponownie otworzyć w rejestracji, aby dodać kolejne pozycje. Gdy wyłączone (domyślnie dla magazynów PPd) zamknięcie jest ostateczne — operatorzy muszą zeskanować następny pojemnik.",
    bulk_qty_book_in: "Ilość zbiorcza",
    bulk_qty_book_in_hint: "Gdy włączone, po każdym zeskanowaniu pojawia się małe okno, w którym operator wpisuje liczbę sztuk danego SKU. Jedno skanowanie może wtedy reprezentować wiele sztuk.",
    manifest_required_book_in: "Wymagany manifest",
    manifest_required_book_in_hint: "Gdy włączone (domyślnie), produkt można przyjąć tylko wtedy, gdy jego SKU znajduje się w manifeście, a zamknięcie pojemnika nie powiedzie się, jeśli ilość w manifeście nie pokrywa przyjęcia. Gdy wyłączone, można przyjąć dowolny produkt z katalogu Portalu — ilość nieobjęta manifestem zostanie przyjęta z zerowym kosztem.",
    book_in_duplicate_stock_check: "Sprawdzaj duplikaty",
    book_in_duplicate_stock_check_hint: "Cały magazyn. Gdy włączone, skan zostaje odrzucony, jeśli jego SKU ma już stan w lokalizacji w tranzycie lub sprzedażnej gdziekolwiek w tym magazynie, a operator ma przekazać produkt liderowi. Sprawdzane są tylko produkty dostawców z wyłączonym „Zezwalaj na duplikaty” (Magazyn › Dostawcy). Pojemniki czerwone i żółte nie są sprawdzane. W odróżnieniu od „Pozwól na duplikaty”, które dotyczy tylko własnego pojemnika operatora.",
    bulk_qty_title: "Ustaw ilość",
    bulk_qty_open: "Edytuj ilość",
    bulk_qty_qty_label: "Ilość",
    toggle_blocked_by_ppd: "Send to PPd jest włączone — ponowne otwieranie i wieloosobowa rejestracja muszą pozostać wyłączone",
    cannot_reopen: "Pojemnik zamknął {name} — ponowne otwieranie nie jest dozwolone w tym magazynie",
    tote_holds_picked_stock: "Pojemnik zawiera pobrany towar z Drop lub Pickingu — odłóż go tam, nie tutaj",
    warehouse_toggles: "Przełączniki magazynów",
    warehouse_toggles_hint: "Ustawienia funkcji Rejestracji w podziale na magazyny.",
    no_warehouses: "Brak skonfigurowanych magazynów",
    po_timer_targets: "Cele czasowe",
    po_timer_targets_hint: "Ustawia cel paska postępu (w milisekundach) dla każdego PO. Puste = domyślne 4000 ms. Niższe wartości = większa presja.",
    custom_short: "własne",

    // Totes admin
    totes_settings: "Pojemniki",
    totes_settings_hint: "Zarządzaj listą pojemników przez import arkusza XLSX. Każdy wiersz: action (add/update/remove), tote_id i type (box lub pallet).",
    totes_download_template: "Pobierz szablon",
    totes_download_current: "Pobierz aktualne",
    totes_print_labels_n: "Drukuj etykiety ({count})",
    totes_print_label: "Drukuj etykietę",
    totes_print_labels_title: "Drukuj etykiety pojemników",
    totes_print_labels_hint: "Pojemniki z bieżących filtrów: {count}. Odznacz niepotrzebne. Rozmiar etykiety jest zapamiętywany na tym urządzeniu.",
    totes_print_label_hint: "Pojemnik {tote}. Rozmiar etykiety jest zapamiętywany na tym urządzeniu.",
    totes_upload_csv: "Wgraj CSV",
    orders_bulk_actions: "Akcje zbiorcze",
    totes_upload_xlsx: "Wgraj XLSX",
    totes_upload_empty: "Arkusz jest pusty",
    totes_upload_bad_header: "Arkusz musi mieć kolumny action i tote_id",
    totes_upload_parse_error: "Nie można odczytać arkusza — upewnij się, że to prawidłowy plik .xlsx",
    totes_bulk_summary: "Dodano {added}, zaktualizowano {updated}, usunięto {removed}",
    totes_row_label: "Wiersz {row}",
    totes_count: "{count} pojemników",
    totes_col_tote_id: "ID pojemnika",
    totes_col_type: "Typ",
    totes_col_status: "Status",
    totes_col_warehouse: "Magazyn",
    totes_col_last_user: "Ostatni użytkownik",
    totes_col_updated_at: "Zaktualizowano",
    totes_col_totes: "Pojemniki",
    totes_total_label: "Pojemniki łącznie",
    totes_upload_progress: "Przetwarzanie {done} z {total} wierszy",

    // Administracyjna kolejka odkładania
    putaway_queue_title: "Kolejka odkładania",
    putaway_queue_hint: "Wszystkie pojemniki oczekujące obecnie na odłożenie we wszystkich widocznych magazynach. Użyj przełączników magazynu, aby zawęzić widok do jednego. Kolejka odświeża się automatycznie, gdy ta strona jest widoczna.",
    putaway_queue_tile_desc: "Pojemniki oczekujące na odłożenie",
    putaway_queue_download_current: "Pobierz bieżące",
    putaway_queue_search_hint: "Szukaj ID pojemnika",
    putaway_queue_filter_source: "Źródło",
    putaway_queue_filter_category: "Kategoria",
    putaway_queue_filter_type: "Typ",
    putaway_queue_total_totes: "Pojemniki łącznie",
    putaway_queue_units_remaining: "Pozostałe sztuki",
    putaway_queue_oldest_waiting: "Najdłuższy czas oczekiwania",
    putaway_queue_col_tote: "Pojemnik",
    putaway_queue_col_warehouse: "Magazyn",
    putaway_queue_col_type: "Typ",
    putaway_queue_col_closed: "Zamknięto",
    putaway_queue_col_closed_by: "Zamknięte przez",
    putaway_queue_col_age: "Czas oczekiwania",
    putaway_queue_col_units: "Sztuki",
    putaway_queue_col_category: "Kategoria",
    putaway_queue_col_source: "Źródło",
    putaway_queue_units_of: "{remaining} z {total}",
    putaway_queue_category_none: "Brak",
    putaway_queue_source_drop: "Uzupełnianie",
    putaway_queue_type_box: "Pudełko",
    putaway_queue_type_pallet: "Paleta",
    putaway_queue_no_rows: "Brak pojemników pasujących do bieżących filtrów.",
    putaway_queue_age_minutes: "{minutes} min",
    putaway_queue_age_hours: "{hours} godz.",
    putaway_queue_age_hours_minutes: "{hours} godz. {minutes} min",
    putaway_queue_age_days: "{days} d",
    putaway_queue_age_days_hours: "{days} d {hours} godz.",

    // Put Away
    put_away: "Odłożenie",
    invalid_location: "Nieprawidłowa lokalizacja",
    not_a_tote: "Nieprawidłowy pojemnik",
    put_away_awaiting_location: "Czeka na lokalizację",
    put_away_tote_closed: "Pojemnik zamknięty",
    // Skrzynie paletowe: kod kreskowy skrzyni jest też jej lokalizacją.
    put_away_crate_sub: "Skrzynia — zeskanuj ją ponownie, aby odłożyć całą zawartość do {tote}",
    put_away_crate_close: "Zamknij skrzynię {tote}",
    put_away_sub_tote: "Tylko zamknięte pojemniki",
    put_away_category_mode: "Kategoria pojemnika",
    put_away_mode_toggle: "Odkładanie / Kategoria pojemnika / Puste wysokie lokalizacje",
    put_away_category_sub: "Zeskanuj pojemnik, aby zobaczyć jego kategorię",
    put_away_category_none: "Brak kategorii",
    put_away_category_never_booked_in: "Pojemnik nigdy nie był przyjęty",
    put_away_high_mode: "Puste wysokie lokalizacje",
    put_away_high_sub_anchor: "Zeskanuj wysoką lokalizację, przy której jesteś",
    put_away_high_go_to: "Idź do",
    put_away_high_sub_arrive: "Zeskanuj ją po dotarciu",
    put_away_high_sub_none: "Zeskanuj inną wysoką lokalizację",
    put_away_high_none: "Brak pustych wysokich lokalizacji",
    put_away_high_from: "Od {location}",
    put_away_high_change: "Zmień lokalizację",
    put_away_high_missing: "Lokalizacja nie istnieje",
    put_away_high_missing_title: "Lokalizacja nie istnieje?",
    put_away_high_missing_body: "Ta lokalizacja zostanie oznaczona jako niesprzedażowa i nie będzie już proponowana. Potwierdź, że fizycznie jej nie ma.",
    put_away_high_missing_confirm: "Nie istnieje",
    put_away_high_missing_done: "{location} oznaczono jako niesprzedażową",
    put_away_high_not_high: "To nie jest wysoka lokalizacja",
    put_away_high_wrong_location: "Zeskanuj wskazaną lokalizację: {location}",
    put_away_high_zones_title: "Puste wysokie lokalizacje",
    put_away_high_zones_hint: "Puste lokalizacje wg strefy, w kolejności trasy.",
    // Konsolidacja — drugi widok pigułki Puste wysokie lokalizacje (tylko Pembroke)
    put_away_high_view_toggle: "Pustki / Konsolidacja",
    put_away_high_view_empty: "Pustki",
    put_away_high_view_consolidate: "Konsolidacja",
    put_away_consolidate_sub_tote: "Zeskanuj pusty pojemnik, do którego będziesz zbierać",
    put_away_consolidate_sub_anchor: "Zeskanuj wysoką lokalizację, przy której jesteś",
    put_away_consolidate_sub_arrive: "Zeskanuj ją po dotarciu — lub dotknij pinezki, aby pójść gdzie indziej",
    put_away_consolidate_sub_items: "Zeskanuj każdy towar do swojego pojemnika",
    put_away_consolidate_units: "{count} do przeniesienia",
    put_away_consolidate_on_tote: "{count} w pojemniku",
    put_away_consolidate_none: "Nie ma już nic do konsolidacji",
    put_away_consolidate_location_empty: "Nic tu nie zostało — idziemy dalej",
    put_away_consolidate_change_body: "Zeskanuj lokalizację, do której idziesz. Ta pozostaje na liście.",
    put_away_consolidate_skipped: "Pominięto {location}",
    put_away_consolidate_tote_full: "Pojemnik pełny",
    put_away_consolidate_tote_full_title: "Pojemnik pełny — zostawić tę lokalizację?",
    put_away_consolidate_tote_full_body: "{location} nie będzie już proponowana, dopóki coś z niej nie zostanie pobrane.",
    put_away_consolidate_tote_full_confirm: "Potwierdź - pojemnik pełny",
    put_away_consolidate_reopen_title: "Otworzyć pojemnik ponownie?",
    put_away_consolidate_reopen_body: "Pojemnik {tote} został zamknięty z {units} szt. Otworzyć go ponownie, aby dalej go napełniać?",
    put_away_consolidate_reopen_confirm: "Otwórz ponownie",
    put_away_consolidate_close_title: "Zamknij pojemnik",
    put_away_consolidate_close_body: "Zamknij go i wyślij do odkładania albo zamknij i odłóż od razu. Ponowne zeskanowanie pojemnika zamyka go do odkładania. To kończy Twoją trasę.",
    put_away_consolidate_close_confirm: "Zamknij",
    put_away_consolidate_close_put_away: "Zamknij i odłóż",
    put_away_consolidate_next_location: "Następna lokalizacja",
    put_away_consolidate_not_here_btn: "Nie ma",
    put_away_consolidate_not_here_btn_aria: "Nie ma: {title}",
    put_away_consolidate_write_off_title: "Odpisać towar?",
    put_away_consolidate_write_off_body: "{qty} × {title} jest zapisane w {location}, ale go tam nie ma. Zostanie odpisane.",
    put_away_consolidate_write_off_confirm: "Odpisz",
    put_away_consolidate_written_off: "{title} odpisano",
    put_away_consolidate_write_off_allocated: "Zarezerwowane dla zamówienia — nie można tu odpisać",
    put_away_consolidate_swap_title: "Zmienić pojemnik?",
    put_away_consolidate_swap_body: "Zeskanuj pojemnik {tote} ponownie lub dotknij Potwierdź, aby kontynuować do niego. Wszystko, co już przeniesiono, zostaje w pojemniku {current} i trafia do odkładania.",
    put_away_consolidate_swap_confirm: "Potwierdź",
    put_away_consolidate_closed_toast: "Pojemnik {tote} został wysłany do odkładania.",
    put_away_consolidate_closed_empty_toast: "Pojemnik {tote} był pusty — zwolniono.",
    put_away_consolidate_take_tote: "Zabierz pusty pojemnik: {totes}",
    put_away_consolidate_not_here: "Ten towar nie jest zapisany w tej lokalizacji",
    put_away_consolidate_on_wave: "Zostaw — picker już po to idzie",
    put_away_consolidate_reserved: "Zostaw — zamówienie tego potrzebuje, a nie ma go nigdzie indziej",
    put_away_consolidate_book_in_title: "Nie zapisano tutaj",
    put_away_consolidate_book_in_body: "{title} nie jest zapisany w {location}. Przyjąć jedną sztukę tutaj i przenieść ją do pojemnika?",
    put_away_consolidate_book_in_confirm: "Przyjmij i przenieś",
    put_away_consolidate_booked_in: "{title} przyjęto i przeniesiono",
    put_away_consolidate_none_left: "Nie ma już tego tutaj",
    put_away_consolidate_tote_in_move_stock: "Pojemnik {tote} jest otwarty w Przenoszeniu towaru — zakończ go tam",
    put_away_consolidate_resumed: "Wracasz do pojemnika {tote}",
    put_away_consolidate_resume_title: "Niedokończona konsolidacja",
    put_away_consolidate_resume_body: "Pojemnik {tote} ma {units} szt. Wznów lub zamknij pojemnik i wyślij go do odkładania.",
    put_away_consolidate_resume_confirm: "Wznów",
    put_away_consolidate_resume_close: "Zamknij pojemnik",
    put_away_consolidate_zones_title: "Lokalizacje do konsolidacji",
    put_away_consolidate_zones_hint: "Lokalizacje z 1–2 szt. wg strefy, w kolejności trasy.",
    put_away_consolidate_not_available: "Konsolidacja nie jest dostępna w tym magazynie",
    move_stock_tote_in_consolidate: "Pojemnik {tote} jest otwarty w Odkładanie → Konsolidacja — zakończ go tam",
    put_away_temp_cold: "Odkładanie na zimno",
    put_away_cold_sub_anchor: "Zeskanuj, gdzie jesteś",
    put_away_cold_sub_tote: "Zeskanuj pojemnik — tylko zamknięte pojemniki Cold",
    put_away_cold_sub_location: "Zeskanuj lokalizację, aby potwierdzić",
    put_away_cold_wrong_category: "Ten pojemnik nie jest oznaczony jako Cold",
    put_away_cold_now_occupied: "Ktoś Cię wyprzedził — oto następna lokalizacja",
    put_away_cold_occupied_btn: "Towar już tu jest",
    put_away_cold_cancel: "Anuluj",
    put_away_found_sub_location: "Zeskanuj tę lokalizację, aby potwierdzić, że przy niej jesteś",
    put_away_found_sub_tote: "Zeskanuj pojemnik, który już tu stoi",
    put_away_found_release_cmd: "Znaleziono pojemnik",
    put_away_found_sub_release: "Ten pojemnik nadal czeka na odłożenie",
    put_away_found_release: "Odłóż do tej lokalizacji",
    put_away_found_count_cmd: "Skanuj towary",
    put_away_found_sub_count: "Zeskanuj każdy towar, który tu jest, a potem Zakończ",
    put_away_found_count_empty: "Nic tu jeszcze nie zapisano — każdy zeskanowany towar można przyjąć",
    put_away_found_finish: "Zakończ",
    put_away_found_finish_title: "Zakończyć liczenie?",
    put_away_found_finish_body: "Wszystko, czego nie zeskanowano, nie zostanie tu zapisane.",
    put_away_found_add_yes: "Przyjmij",
    put_away_found_released: "{tote} odłożono do {location}",
    put_away_found_finished: "{count} przyjęto do {location}",
    put_away_found_sub_dest: "Zeskanuj lokalizację, do której odłożyć te {count} szt.",
    put_away_found_moved: "{count} przeniesiono do {location}",
    put_away_found_dest_on_wave: "Towar stąd jest na fali kompletacji — musi tu zostać",
    put_away_sub_loc: "Kod dowolnej lokalizacji",
    put_away_sub_item_or_loc: "Przedmiot lub lokalizacja",
    put_away_sub_item_location: "Lokalizacja dla {item}",
    put_away_item_location_title: "Lokalizacja dla",
    scan_item_or_location: "Skanuj Przedmiot/Lok",
    scan_not_recognised: "Nieznany przedmiot ani lokalizacja",

    // Put Away admin settings
    put_away_settings: "Odłożenie",
    put_away_warehouse_toggles: "Przełączniki magazynów",
    put_away_warehouse_toggles_hint: "Ustawienia funkcji Odłożenie w podziale na magazyny.",
    allow_item_level_put_away: "Pojedyncze przedmioty",
    allow_item_level_put_away_hint: "Gdy włączone, operatorzy mogą odkładać jeden przedmiot naraz (skan pojemnika → przedmiot → lokalizacja). Po ostatnim przedmiocie pojemnik wraca do puli. Odkładanie całego pojemnika nadal działa.",
    allow_out_of_tote_put_away: "Przedmioty spoza pojemnika",
    allow_out_of_tote_put_away_hint: "Gdy włączone, zeskanowanie przedmiotu, którego nie ma w pojemniku, ale znajduje się w bazie skanu, pozwala go odłożyć. W przeciwnym razie pojawia się błąd. Wymaga opcji Pojedyncze przedmioty.",

    // Picking admin settings
    picking_settings: "Kompletacja",
    picking_settings_hint: "Sposób tworzenia fal, alokacji zapasów oraz kryteria kwalifikujące zamówienie jako Duże.",
    picking_alloc_method: "Alokacja zapasów",
    picking_alloc_method_hint: "Sposób rezerwowania zapasów przy tworzeniu fal. FIFO bierze najstarsze przyjęcia jako pierwsze; Najszybsze ocenia kandydujące lokalizacje wg bliskości i temperatury (zob. wagi poniżej).",
    picking_alloc_fifo: "FIFO (najstarsze)",
    picking_alloc_fastest: "Najszybsze",
    picking_wave_shaping: "Kształt fali",
    picking_wave_shaping_hint: "Liczba zamówień w fali oraz liczba zamówień o najwyższym priorytecie zakotwiczających falę Pick & Sort. Priorytet: najpierw do wysyłki dzisiaj, potem wcześniejsza data zamówienia, następnie ekspres przed standardem z tego samego dnia, potem najstarsze najpierw.",
    picking_pick_type_settings: "Ustawienia typu kompletacji",
    picking_pick_type_settings_hint: "Ustawienia dotyczące tylko jednego typu kompletacji. Rozwiń typ, aby zobaczyć reguły kształtu fali i progi.",
    picking_pick_and_sort_settings: "Pick & Sort",
    picking_light_settings: "Pojedyncze",
    picking_max_wave_orders: "Wielkość fali Pick & Sort",
    picking_pas_large_wave_enabled: "Duże fale Pick & Sort (dwa regały)",
    picking_pas_large_wave_enabled_hint: "Zbieraj do dwóch razy więcej zamówień w jednym przejściu i sortuj je jednocześnie na obu regałach Pick & Sort. Po włączeniu wielkość fali dobierana jest automatycznie: kolejka z pełną małą falą zbierana jest jako Duża; mniejsza końcówka jako Mała.",
    picking_pas_large_wave_orders: "Wielkość dużej fali",
    picking_pas_large_wave_orders_hint: "Górny limit dużej fali. Rzeczywista wielkość jest ograniczona liczbą aktywnych miejsc na obu regałach (np. 24 + 24 = 48).",
    picking_pas_large_max_items: "Duża fala: maks. pozycji na zamówienie",
    picking_pas_large_max_items_hint: "Zamówienia z większą liczbą pozycji pozostają w Pick & Sort, ale trafiają do Małych fal. 0 = brak limitu.",
    picking_pas_large_max_order_kg: "Duża fala: maks. waga zamówienia",
    picking_pas_large_max_order_kg_hint: "Cięższe zamówienia pozostają w Pick & Sort, ale trafiają do Małych fal. 0 = brak limitu.",

    // Putwall (Pembroke) — Ustawienia > Kompletacja > Putwall
    picking_put_wall: "Putwall",
    picking_put_wall_hint: "Wariant fali Pick & Sort sortowany na ścianie Putwall (72 miejsca) zamiast na regale. Na Putwall trafiają tylko zamówienia mieszczące się w całości w jednym pojemniku; zwykła kolejka Pick & Sort pomija je, chyba że kompletujący zaznaczy „Uwzględnij zamówienia Putwall”. Samą ścianę dodaje się jako regał w Sortowanie > Kompletacja i sortowanie z przełącznikiem „Putwall”.",
    picking_put_wall_enabled: "Fale Putwall",
    picking_put_wall_enabled_hint: "Pokazuj Putwall jako wybór po dotknięciu Pick & Sort. Wymaga też regału Putwall w Sortowanie > Kompletacja i sortowanie (Dodaj regał z przełącznikiem „Putwall”).",
    picking_put_wall_wave_orders: "Wielkość fali Putwall",
    picking_put_wall_wave_orders_hint: "Górny limit fali Putwall. Rzeczywista wielkość jest ograniczona liczbą aktywnych miejsc na ścianie (np. 72).",
    picking_put_wall_tote: "Pojemnik",
    picking_put_wall_tote_hint: "Wymiary wewnętrzne pojemnika, w którym zamówienie Putwall musi zmieścić się w całości. Razem z procentem wypełnienia poniżej decyduje, które zamówienia się kwalifikują.",
    picking_put_wall_tote_l_cm: "Długość pojemnika (cm)",
    picking_put_wall_tote_w_cm: "Szerokość pojemnika (cm)",
    picking_put_wall_tote_h_cm: "Głębokość pojemnika (cm)",
    picking_put_wall_fill_pct: "Wypełnienie pojemnika",
    picking_put_wall_fill_pct_hint: "Jaką część objętości pojemnika może zająć zamówienie, by nadal się mieściło. Nic nie pakuje się w 100% — 75% zostawia miejsce na nietypowe kształty.",
    picking_put_wall_min_orders: "Minimalna liczba zamówień Putwall",
    picking_put_wall_min_orders_hint: "Gdy oczekuje mniej kwalifikujących się zamówień Putwall niż ta liczba, pole „Uwzględnij zamówienia Putwall” w wyborze fali Pick & Sort jest domyślnie zaznaczone, więc mała pula Putwall zostaje zebrana przez zwykłą falę zamiast czekać, aż urośnie. 0 = nigdy nie zaznaczaj automatycznie.",
    picking_put_wall_max_totes: "Pojemniki na zamówienie",
    picking_put_wall_max_totes_hint: "Ile pojemników może potrzebować zamówienie, by nadal trafić na Putwall. Regał ma głębokość jednego pojemnika, więc zamówienie na dwa pojemniki dostaje dwie sąsiednie przegródki i liczy się jako dwa miejsca na ścianie; sorter przechodzi do drugiej przegródki, gdy pierwsza jest pełna, a każda przegródka wyjeżdża w osobnym pojemniku. 1 = tylko zamówienia mieszczące się w jednym pojemniku.",
    picking_unit_totes: "poj.",
    // Fale Pick & Sort w parach (migracja 223).
    picking_pairing_settings: "Fale w parach",
    picking_pairing_hint: "Dwóch kompletatorów na jednej fali Sortowania lub Putwall, każdy w swoich alejkach, więc fala dociera do regału mniej więcej dwa razy szybciej. Fala jest budowana jak dziś i cięta raz na granicy alejek; druga połowa czeka na Pick Face jako karta „Dołącz”. Jeśli nikt nie dołączy, pierwszy kompletator po prostu kontynuuje ją z tym samym wózkiem. Duże (dwuregałowe) fale nigdy nie są dzielone.",
    picking_ps_pairing_enabled: "Zezwól na fale w parach",
    picking_ps_pairing_enabled_hint: "Pokazuje przełącznik „Zbieraj w parze” w Kolejce kompletacji i pozwala Doradcy sugerować pary od cut-offu zamówień (i wcześniej, gdy pojedyncza fala nie zdążyłaby na cut-off wysyłki).",
    picking_ps_segment_split_pct: "Udział pierwszego kompletatora",
    picking_ps_segment_split_pct_hint: "Jaka część przystanków fali przypada pierwszemu kompletatorowi, 20-80%. Cięcie przeskakuje do najbliższej zmiany alejki, więc nigdy nie dzielą alejki.",
    picking_ps_pair_min_units: "Minimalna wielkość fali dla pary",
    picking_ps_pair_min_units_hint: "Fala jest dzielona tylko, gdy ma WIĘCEJ niż tyle sztuk; mniejsze fale startują jako zwykła fala nawet przy wybranej parze, a Doradca sugeruje parę tylko powyżej tej wartości. 0 = brak minimum.",
    picking_ps_sort_on_first_segment: "Sortuj od pierwszej połowy",
    picking_ps_sort_on_first_segment_hint: "Wł.: regał może wejść w falę w parze, gdy tylko jedna połowa jest zebrana; sztuki drugiej połowy są policzone i dopełniane, gdy dotrą. Wył.: regał czeka na obie połowy.",

    // Putwall — strona „Która fala?” (/picking/choose) za kartą
    // Pick & Sort w kolejce kompletacji
    picking_wave_chooser_title: "Która fala?",
    picking_wave_chooser_sorting: "Sortowanie",
    picking_wave_chooser_put_wall: "Putwall",
    picking_include_put_wall: "Uwzględnij zamówienia Putwall",
    picking_put_wall_empty: "Żadne zamówienie nie pasuje teraz do Putwall",
    picking_put_wall_unavailable: "Fale Putwall wymagają włączonej funkcji i skonfigurowanego regału Putwall",
    picking_put_wall_too_few: "Brak zamówień oczekujących na Putwall",
    picking_wave_size: "Wielkość fali",
    picking_wave_size_small: "Mała",
    picking_wave_size_large: "Duża",
    picking_large_wave_unavailable: "Duże fale wymagają włączonej funkcji i dwóch skonfigurowanych regałów Pick & Sort",
    picking_small_blocked: "Kolejka zawiera pełną falę — zbierana będzie Duża fala",
    picking_large_too_few: "Za mało zamówień na Dużą falę — zbierana będzie Mała fala",
    picking_light_max_wave_orders: "Wielkość fali Pojedynczych",
    picking_anchor_count: "Liczba kotwic",
    picking_anchor_count_hint: "Liczba niezrealizowanych zamówień o najwyższym priorytecie zakotwiczających każdą falę Pick & Sort (najpierw do wysyłki dzisiaj, potem wcześniejsza data zamówienia, następnie ekspres przed standardem z tego samego dnia, potem najstarsze najpierw). Pozostałe miejsca zapełniane są zamówieniami współdzielącymi SKU z kotwicami.",
    picking_auto_pause: "Auto-pauza",
    picking_auto_pause_hint: "Liczba minut bezczynności po której aktywna fala zostanie wstrzymana, aby inny kompletator mógł ją przejąć.",
    picking_lookahead: "Załaduj lokalizacje z wyprzedzeniem",
    picking_lookahead_hint: "Ile kolejnych lokalizacji jest ładowanych z wyprzedzeniem na ekranie Uzupełniania półek oraz Uzupełniania prognozowanego, aby kompletator od razu widział kolejny cel — bez oczekiwania na odpowiedź serwera. Kompletacja (Pojedyncze, Pick & Sort, Duże) już tego nie używa: cała fala jest ładowana raz przy starcie, a urządzenie pokazuje kolejną kompletację lokalnie — Duże nadal kolejkują kolejne zamówienie dopiero po pełnym skompletowaniu bieżącego. Zalecane 2-3.",
    picking_large_settings: "Duże",
    picking_large_settings_hint: "Typ kompletacji jednozamówieniowej: jedno zamówienie na falę, jeden pojemnik naraz. Co kwalifikuje zamówienie jako Duże i co kompletator wtedy widzi.",
    picking_large_thresholds: "Progi",
    picking_large_thresholds_hint: "Zamówienie traktowane jest jako Duże (osobna fala, jeden pojemnik naraz), jeśli przekroczy dowolny próg. Trzy limity wymiarów są niezależne od orientacji: boki przedmiotu są sortowane od najdłuższego do najkrótszego i porównywane z limitami posortowanymi tak samo, więc nie ma znaczenia, w którym polu (długość/szerokość/wysokość) produkt ma zapisany najdłuższy bok. Puste pole pomija ten warunek — ale uwaga: pozostawienie pustego tylko jednego lub dwóch z trzech limitów wymiarów oznacza brak ograniczenia dla najdłuższego boku, a pozostałe limity dotyczą wtedy mniejszych boków; pozostaw wszystkie trzy puste, aby całkowicie pominąć warunek wymiarów.",
    picking_large_max_items: "Maks. przedmiotów w zamówieniu",
    picking_large_max_order_kg: "Maks. waga zamówienia (kg)",
    picking_large_max_order_cbm: "Maks. objętość zamówienia (CBM)",
    picking_large_max_order_cbm_hint: "Łączna objętość całego zamówienia w metrach sześciennych — długość × szerokość × wysokość × ilość każdej linii, zsumowane (1 CBM = 1 000 000 cm³, więc karton 40 × 30 × 25 cm to 0,03 CBM). Przedmioty bez zapisanych wymiarów liczone są jako zero, więc zamówienie może przekroczyć ten limit na liniach, które mają wymiary. Przydatne do wyłapywania zamówień objętościowych, które nie są ciężkie ani nie zawierają pojedynczego wielkogabarytowego przedmiotu. W odróżnieniu od pozostałych progów dla Dużych ten domyślnie wynosi 0,15 CBM, a nie pusty — wyczyść pole, aby wyłączyć ten warunek dla magazynu.",
    picking_large_max_item_grams: "Maks. waga przedmiotu (g)",
    picking_large_max_item_l_cm: "Maks. najdłuższy bok przedmiotu (cm)",
    picking_large_max_item_w_cm: "Maks. drugi najdłuższy bok przedmiotu (cm)",
    picking_large_max_item_h_cm: "Maks. najkrótszy bok przedmiotu (cm)",
    picking_large_roll_cages: "Wózki klatkowe",
    picking_large_roll_cages_hint: "Te dwa ustawienia niczego nie klasyfikują — określają liczbę wózków klatkowych pokazywaną kompletatorowi przy otwarciu Dużego zamówienia. Mnożą się: pojemność × wykorzystanie to planowana zawartość jednego wózka.",
    picking_roll_cage_cbm: "Pojemność wózka klatkowego (CBM)",
    picking_roll_cage_cbm_hint: "Wewnętrzna objętość jednego wózka klatkowego w tym magazynie, w metrach sześciennych. Poszczególne lokalizacje kupują różne wózki, więc zmierz swój, zamiast zakładać — standardowy wózek to około 0,72 CBM (mniej więcej 120 × 80 × 75 cm użytecznej przestrzeni). To pojemność surowa; kompletator planuje według tej wartości pomnożonej przez wykorzystanie poniżej. Pozostaw puste, aby użyć standardowego wózka 0,72 CBM — wyczyszczenie tego pola NIE wyłącza szacunku, robi to wyczyszczenie wykorzystania.",
    picking_roll_cage_utilisation_pct: "Wykorzystanie wózka klatkowego",
    picking_roll_cage_utilisation_pct_hint: "To nie jest próg — na tej podstawie kompletator dowiaduje się, ile wózków klatkowych zabrać, gdy otwiera Duże zamówienie. Nic nie pakuje się w 100%: kartony nie układają się idealnie, nietypowe kształty marnują narożniki i nikt nie układa pod samą belkę. Ten procent pojemności powyżej stanowi planowaną zawartość wózka — przy 70% z wózka 0,72 CBM to 0,504 CBM, więc zamówienie o łącznej objętości 0,6 CBM daje 1,2 wózka. Wartość podawana jest z dokładnością do jednej dziesiątej wózka, a nie zaokrąglana w górę do pełnego: większość Dużych zamówień to ułamek wózka, a „0,3” i „1,2” to różne wskazówki, podczas gdy „1 wózek” i „1 wózek” nie. Przedmioty bez zapisanych wymiarów nie dodają objętości, dlatego ekran kompletacji podaje też, ile ich jest — szacunek to wartość minimalna, nie gwarancja. Obniż tę wartość, jeśli kompletatorzy ciągle wracają po kolejny wózek; podnieś, jeśli wożą pusty. Wyczyść pole, aby ukryć szacunek dla magazynu.",
    picking_require_location_scan: "Wymagaj skanu lokalizacji",
    picking_require_location_scan_hint: "Dotyczy Single, Pick & Sort, Large, Shelf Drop i Forecast Drop. Gdy wyłączone, kompletatorzy chodzą według walk_order bez potwierdzania każdej lokalizacji skanem. Skan lokalizacji startowej kotwiczący pozycję kompletatora jest zawsze wymagany dla Large, Shelf Drop i Forecast Drop niezależnie od tego ustawienia (Pojedyncze są przydzielane z góry i nie wymagają skanu lokalizacji startowej). Skanowanie jest bezpieczniejszą wartością domyślną.",
    auto_release_short: "Automatyczne zwolnienie z brakami",
    auto_release_short_hint: "Gdy włączone, zamówienie zablokowane brakiem stanu przez 30 minut jest zwalniane automatycznie z brakami, jeśli choć jedna linia może zostać skompletowana: brakujące sztuki są oznaczane na zamówieniu, trafia ono do fali z tym, co jest dostępne, a wysyłka pokazuje oznaczone sztuki jako brakujące do zwrotu. Zamówienia bez żadnej dostępnej sztuki zawsze czekają na decyzję ręczną. Gdy wyłączone, zablokowane zamówienia czekają w sekcji Zablokowane stanem, aż ktoś użyje Zwolnij z brakami.",
    picking_local_first_enabled: "Kompletacja lokalna (Beta)",
    picking_local_first_enabled_hint: "Gdy włączone, cała fala + rejestr pojemników + mapa kodów kreskowych są wysyłane na urządzenie kompletatora przy starcie fali. Skany są walidowane lokalnie dla natychmiastowej informacji zwrotnej i zapisywane w BE w tle. Domyślnie wyłączone — włączaj per magazyn po weryfikacji.",
    picking_location_grouping_enabled: "Grupowanie wg lokalizacji",
    picking_location_grouping_enabled_hint: "Gdy włączone, fala Pick & Sort jest wypełniana zamówieniami, które dodają najmniej nowych lokalizacji do fali — grupując zamówienia korzystające z tych samych pudeł, aby kompletator odwiedzał mniej lokalizacji i pokonywał krótszą trasę. Zamówienia bez wspólnego pudła lub SKU są dodawane według najbliższej kolejności trasy (walk_order). Domyślnie włączone; wyłącz, aby wrócić do grupowania tylko wg wspólnych SKU.",
    picking_unit_minutes: "min",
    picking_unit_orders: "zam.",
    picking_unit_items: "szt.",
    picking_unit_days: "dni",

    // Ustawienia kompletacji — nagłówki nowych sekcji
    picking_queues_section: "Kolejki kompletacji",
    picking_wave_building_section: "Budowanie fali",
    picking_wave_building_toggles: "Grupowanie lokalizacji i lokalne najpierw",
    picking_wave_building_section_hint: "Jak powstaje fala: który zapas jest przydzielany, które zamówienia są grupowane razem i kiedy bezczynna fala wraca do puli.",
    picking_picker_screen_section: "Ekran kompletatora",
    picking_picker_screen_toggles: "Skanowanie lokalizacji i zdjęcie produktu",
    picking_picker_screen_section_hint: "Co kompletator widzi na terminalu i jak długo wyświetlają się komunikaty o zmianie lokalizacji.",
    picking_experiments_section: "Eksperymenty",
    picking_experiments_section_hint: "Testy A/B na żywych falach. Każdy dzieli fale po równo między obecne i proponowane zachowanie, mierzy oba i pozwala wdrożyć zwycięzcę dla wszystkich.",

    // Eksperyment A/B — kolejność trasy
    walk_pattern_standard: "Naprzemienna (obecna)",
    walk_pattern_corridor: "Korytarzowa 1 regał",
    walk_pattern_dynamic: "Dynamiczna (trasa na falę)",
    walk_pattern_aligned: "Wyrównana (strony wg pozycji)",
    walk_experiment_title: "Eksperymenty kolejności obchodu",
    walk_experiment_intro: "Porównuj kolejności obchodu na hali. Pobierz obecną, przenumeruj ją dowolnie, wgraj z powrotem jako A, B, C… i uruchom dwie lub więcej równolegle. Fale rotują równomiernie przez warianty, per kompletator i per typ kompletacji, więc porównanie jest jak za jak, a umiejętności kompletatora się znoszą.",
    walk_experiment_running: "Trwa",
    walk_experiment_running_until: "Trwa do {date}",
    walk_experiment_finished: "Zakończony",
    walk_experiment_off: "Wył. · {pattern}",
    walk_experiment_pick_types: "Typy kompletacji",
    walk_experiment_need_one_pick_type: "Co najmniej jeden typ kompletacji musi pozostać włączony.",
    walk_experiment_ends_at: "Data zakończenia",
    walk_experiment_ends_at_hint: "Zostaw puste, aby działał do ręcznego zatrzymania.",
    walk_experiment_no_data: "Brak ukończonych fal",
    walk_experiment_delta_caption: "{pattern} jest szybsza na przejście",
    walk_experiment_confidence_insufficient: "Za mało fal",
    walk_experiment_confidence_indicative: "Tylko orientacyjnie",
    walk_experiment_confidence_clear: "Wynik jednoznaczny",
    walk_experiment_need_moves: "potrzeba {n}+ przejść na wariant",
    walk_experiment_ci: "zakres 95%: od {low}% do {high}%",
    walk_experiment_col_arm: "Wariant",
    walk_experiment_col_wave: "Fala",
    walk_experiment_col_waves: "Fale",
    walk_experiment_col_units: "Sztuki",
    walk_experiment_col_move: "s / przejście",
    walk_experiment_col_move_hint: "Mediana sekund między dwoma pobraniami w RÓŻNYCH lokalizacjach. To główna miara — izoluje czas przejścia, czyli jedyne, co zmienia kolejność trasy.",
    walk_experiment_col_same: "s / to samo miejsce",
    walk_experiment_col_same_hint: "Mediana sekund między dwoma pobraniami w TEJ SAMEJ lokalizacji. Miara kontrolna: powinna być taka sama w obu wariantach. Jeśli nie jest, warianty różnią się czymś innym niż trasa i głównego wyniku nie można jeszcze ufać.",
    walk_experiment_col_uph: "Szt./godz.",
    walk_experiment_recent_waves: "Ostatnie fale",
    walk_experiment_preview: "Podejrzyj trasę",
    walk_experiment_preview_hint: "Nigdzie nie zapisano, które dwa regały stoją naprzeciw siebie — jest to wywnioskowane z regałów, których kolejności trasy się przeplatają. Sprawdź, czy te pary wyglądają poprawnie, zanim włączysz eksperyment.",
    walk_experiment_preview_none: "Nie znaleziono par regałów w tym magazynie — wzorzec korytarzowy niczego by tu nie zmienił.",
    walk_experiment_coverage: "{pct}% dolnych lokalizacji zostałoby przestawionych ({reordered} z {total}).",
    walk_experiment_coverage_ambiguous: "{n} pominięto, bo nakładają się tam więcej niż dwa regały — sprawdź te kolejności trasy.",
    walk_experiment_large_hint: "Fale Large są kompletowane po jednym zamówieniu, więc kolejność obchodu zmienia tylko sekwencję w obrębie jednego zamówienia. Sygnał będzie tu znacznie słabszy niż przy Pick & Sort.",
    walk_experiment_adopt_no_data: "Brak danych porównawczych — zmiana nie opierałaby się na dowodach.",
    walk_experiment_adopt_confirm: "Każda nowa fala będzie używać: {pattern}. Fale już rozpoczęte zachowują swój wzorzec. To kończy eksperyment.",
    walk_experiment_adopt_confirm_measured: "Zmierzono dotychczas: {winner} jest szybsza o {pct}% na przejście ({confidence}).",
    walk_experiment_adopt_confirm_nodata: "Nie zebrano jeszcze danych porównawczych.",
    walk_experiment_arms_running: "{n} wariantów",
    walk_experiment_vs_baseline: "wzgl. {arm}",
    walk_experiment_baseline: "odniesienie",
    walk_experiment_multiple_note: "Działają więcej niż dwa warianty, więc te przedziały nie są skorygowane o wielokrotne porównania — przy czterech wariantach są cztery szanse na odczytanie \"wyraźnego\" wyniku z szumu. Pojedynczy zaskakujący zwycięzca to powód, by kontynuować test, a nie by go wdrażać.",
    walk_experiment_adopt_label: "Używaj dla każdej fali",
    walk_variant_section: "Kolejności obchodu",
    walk_variant_hint: "Pobierz obecną kolejność obchodu, przenumeruj ją w arkuszu i wgraj z powrotem jako A, B, C… Zaznacz dwie lub więcej, aby porównać je ze sobą. Wariant nigdy nie nadpisuje aktywnej kolejności — usunięcie go przywraca stan poprzedni.",
    walk_variant_col_arm: "Kolejność obchodu",
    walk_variant_col_coverage: "Obejmuje",
    walk_variant_col_in_test: "W teście",
    walk_variant_col_actions: "Akcje",
    walk_variant_builtin_standard: "Aktywna kolejność obchodu dla tego magazynu",
    walk_variant_builtin_corridor: "Wyliczana — kończy jeden regał przed przejściem przez korytarz",
    walk_variant_builtin_dynamic: "Wyliczana dla każdej fali — najkrótsza trasa po narysowanym planie magazynu; bez planu działa jak Naprzemienna",
    walk_variant_builtin_aligned: "Wyprowadzana z narysowanego planu — ta sama serpentyna, ale strony korytarza łączone wg fizycznej pozycji zamiast numeru regału; aktualizuje się sama po zmianie planu",
    walk_exp_sec_arms: "Warianty i wgrywanie",
    walk_exp_sec_arms_meta: "zapisane: {n}",
    walk_exp_sec_controls: "Typy kompletacji i harmonogram",
    walk_exp_sec_analysis: "Która kolejność obchodu jest szybsza",
    walk_exp_sec_detail: "Szczegóły wariantów i metryka kontrolna",
    walk_exp_col_estimated: "Szacowana Δ",
    walk_exp_col_measured: "Zmierzona Δ",
    walk_exp_col_confidence: "Pewność",
    walk_exp_fastest: "Najszybsza",
    walk_exp_estimates_stale: "Plan magazynu zmienił się od czasu pomiaru szacowanych delt — warianty, mapa i odległości podążają za nowym planem automatycznie, ale te szacunki są migawką i należy je zmierzyć ponownie.",
    walk_exp_estimates_only_hint: "Szacunki pochodzą z odtworzenia prawdziwych fal w każdej kolejności na narysowanym planie. Zmierzone wartości pojawią się wraz z kończonymi falami eksperymentu.",
    walk_exp_map_title: "Mapa trasy",
    walk_exp_map_meta: "Obchód narysowany na planie magazynu",
    walk_exp_map_arm: "Kolejność obchodu",
    walk_exp_map_sample: "Fala P&S #{id} w tej kolejności · {m} m między pobraniami — ta sama fala dla każdego wariantu, więc trasy można porównywać wprost",
    walk_exp_map_arrows: "Kierunek",
    walk_exp_tiers: "Poziomy",
    walk_exp_tiers_hint: "Które poziomy fal biorą udział. Wyniki raportują Niski i Wysoki osobno — inne regały, inna praca.",
    walk_experiment_need_one_tier: "Co najmniej jeden poziom musi pozostać włączony",
    walk_exp_map_view_wave: "Przykładowa fala P&S",
    walk_exp_map_view_full: "Cały magazyn",
    walk_exp_map_full: "Pełny obchód każdego regału: {m} m",
    walk_exp_map_full_hint: "Rysunek pokazuje obchód odwiedzający każdy regał, więc wyolbrzymia różnice, których rzadsza prawdziwa fala nie płaci. Porównuj szacowane i zmierzone Δ powyżej.",
    walk_exp_map_no_layout: "Dla tego magazynu nie narysowano jeszcze planu — narysuj go w Eksperymenty › Plan magazynu, aby zobaczyć trasę.",
    walk_exp_map_start: "Start",
    walk_exp_map_end: "Koniec",
    walk_exp_map_point_distance: "{m} m od {bay}",
    walk_variant_coverage: "{n} z {total} lokalizacji ({pct}%)",
    walk_variant_adopted: "aktywna",
    walk_variant_in_test: "W teście",
    walk_variant_download: "Pobierz tę kolejność obchodu",
    walk_variant_download_current: "Pobierz obecną kolejność obchodu",
    walk_variant_delete: "Usuń ten wariant",
    walk_variant_delete_confirm: "Usunąć kolejność obchodu {code}? Fale, które już na niej działały, zachowują swoje wyniki.",
    walk_variant_delete_enrolled: "{code} jest obecnie w teście. Usunięcie wyłączy go z trwającego eksperymentu; fale, które już na nim działały, zachowują wyniki. Usunąć?",
    walk_variant_upload: "Wgraj wariant",
    walk_variant_uploading: "Wgrywanie {done} / {total}…",
    walk_variant_upload_hint: "Wgrywany arkusz musi mieć kolumnę location i kolumnę walk_order; reszta jest ignorowana. Wgranie istniejącego kodu zastępuje go. Pominięte lokalizacje zachowują swoją aktywną kolejność.",

    // ── Ustawienia › Kompletacja › Eksperymenty › Układ magazynu ─────────
    wlayout_title: "Układ magazynu",
    wlayout_intro: "Regały w metrach, żeby trasę kompletacji dało się wycenić przed jej uruchomieniem. Zaczytywany z tabeli lokalizacji — alejki, regały, powiązanie korytarzy i kierunek obchodu pochodzą z danych, które już prowadzisz — a następnie poprawiany tutaj o to, czego dane nie wiedzą: szerokości regałów, słupki, przesunięcia, tunele oraz miejsca startu i końca trasy.",
    wlayout_none: "Ten magazyn nie ma jeszcze układu. Zacznij od zaczytania go z tabeli lokalizacji.",
    wlayout_seed: "Zaczytaj z lokalizacji",
    wlayout_saved: "Układ zapisany — rozmieszczono {n} regałów.",
    wlayout_unsaved: "Niezapisane zmiany",
    wlayout_calibrate: "Porównaj z pomiarami",
    wlayout_fit: "Dopasuj widok",
    wlayout_scale: "{n} m szerokości",
    wlayout_drag_corridor: "przeciągnij, aby przesunąć ten korytarz",
    wlayout_drag_column: "przeciągnij wzdłuż alejki, aby ustawić początek tej kolumny",
    wlayout_drag_tunnel: "przeciągnij, aby przenieść ten tunel na inną półkę",
    wlayout_stat_corridors: "korytarze: {n}",
    wlayout_stat_aisles: "alejki: {n}",
    wlayout_stat_bays: "rozmieszczone regały: {n}",
    wlayout_select_hint: "Wybierz alejkę lub regał na planie, aby go edytować.",
    wlayout_movement: "Ruch",
    wlayout_walk_speed: "Prędkość chodu (m/s)",
    wlayout_cage_mode: "Wózek klatkowy",
    wlayout_cage_with_picker: "Jedzie korytarzem",
    wlayout_cage_staged_at_end: "Zostaje na końcu korytarza",
    wlayout_cage_none: "Bez wózka",
    wlayout_cage_hint: "W korytarzu o szerokości 1,1 m to decyduje, czy kompletator w ogóle może obsłużyć jedną stronę i wrócić drugą — zmienia to, które kolejności obchodu są fizycznie możliwe, a nie tylko ich koszt.",
    wlayout_aisle: "Alejka {a}",
    wlayout_racking: "Regały",
    wlayout_shelving: "Półkowe",
    wlayout_pallet: "Paletowe",
    wlayout_rack_depth: "Głębokość regału (m)",
    wlayout_offset: "Przesunięcie początku (m)",
    wlayout_offset_hint: "Gdzie zaczyna się pierwszy regał tej alejki względem wejścia do korytarza. Dwie strony zaczynające się w różnych miejscach nigdy nie pokryją się regał w regał — właśnie dlatego G i H się nie pokrywają.",
    wlayout_bay_one: "Regał 1 znajduje się",
    wlayout_bay_one_origin: "Przy wejściu do korytarza",
    wlayout_bay_one_far: "Na drugim końcu",
    wlayout_runs: "Ciągi regałowe",
    wlayout_runs_hint: "Ciąg to nieprzerwany odcinek regałów o jednej szerokości regału. Podziel ciąg tam, gdzie zmienia się rozstaw — ciąg 4, 6 lub 7 regałów to powód, dla którego dwie strony korytarza się różnią.",
    wlayout_undo: "Cofnij",
    wlayout_undo_hint: "Cofnij o jedną zmianę. Nic nie zostanie zapisane, dopóki nie klikniesz Zapisz.",
    wlayout_routes: "Tunele",
    wlayout_routes_hint: "Pokaż lub ukryj tunele i przejścia poprzeczne.",
    wlayout_walk: "Kolejność obchodu",
    wlayout_walk_hint: "Pokaż trasę, którą kierowany jest kompletator. Widok 3D pokazuje też poziom.",
    wlayout_nothing_selected: "nic nie wybrano",
    wlayout_show_people: "Osoby na hali",
    wlayout_people_count: "{n} zeskanowało w ciągu 90 s",
    wlayout_bulk_all_shelves: "Wszystkie półki: {n}",
    wlayout_bulk_hint: "Zmiany dotyczą każdej półki w alejce. Puste pole oznacza, że półki się różnią.",
    wlayout_mixed: "różne",
    wlayout_shelf_n: "Półka {n}",
    wlayout_run_summary: "{w} m, {n} na półkę",
    wlayout_run_tunnel: "Tunel — brak lokalizacji",
    wlayout_point_x: "X, metry",
    wlayout_point_y: "Y, metry",
    wlayout_refresh: "Odśwież z lokalizacji",
    wlayout_refresh_hint: "Pobiera aktualne alejki, regały i poziomy z tabeli lokalizacji, zachowując rysunek.",
    wlayout_rebuild: "Zbuduj od nowa",
    wlayout_rebuild_hint: "Wylicza cały model ponownie. Usuwa rysunek.",
    wlayout_rebuild_confirm: "Zbudować układ od nowa z lokalizacji? Wszystkie naniesione pomiary zostaną zastąpione. Nic nie zapisuje się do momentu naciśnięcia Zapisz.",
    wlayout_tier_both: "Oba",
    wlayout_tier_low: "Niskie",
    wlayout_tier_high: "Wysokie",
    wlayout_shelf_count: "Półek w tej alejce",
    wlayout_bays_per_shelf: "Regałów na półkę (z lokalizacji)",
    wlayout_shelf_width: "Szerokość półki (m)",
    wlayout_locations_per_shelf: "Lokalizacji na półce (regały)",
    wlayout_upright: "Słupek (m)",
    wlayout_shelves_derived: "Półki (z tabeli lokalizacji)",
    wlayout_shelves_split: "{low} niskich · {high} wysokich",
    wlayout_shelf_height: "Wysokość półki (m)",
    wlayout_shelf_gap: "Odstęp półek (m)",
    wlayout_split_run: "Podziel",
    wlayout_run_total: "Ciągi obejmują {covered} z {total} regałów · {len} m regałów",
    wlayout_crossings: "Przejścia",
    wlayout_crossings_hint: "Miejsca, w których kompletator może przejść między korytarzami — przejścia na końcach oraz tunele. Tunele są już w danych lokalizacji jako regał „TUN”, ale nigdy nie były modelowane, więc do tej pory każdy model kosztu wyceniał przejście nimi jako długi marsz.",
    wlayout_tunnel: "Tunel",
    wlayout_end_crossaisle: "Przejście na końcu",
    wlayout_add_tunnel: "Dodaj tunel",
    wlayout_points: "Start i koniec trasy",
    wlayout_points_hint: "Gdzie fala się zaczyna i kończy. Dziś start to pojedyncza zeskanowana lokalizacja, a koniec nie jest zapisywany wcale, więc każda zaoszczędzona odległość mierzona jest tylko w środku zadania.",
    wlayout_point_distance: "{m} m od {bay}",
    wlayout_point_cage_pickup: "Odbiór wózka",
    wlayout_point_pack_desk: "Stanowisko pakowania",
    wlayout_point_conveyor: "Przenośnik",
    wlayout_point_drop_zone: "Strefa zrzutu",
    wlayout_problems: "Do sprawdzenia: {n}",
    wlayout_problems_more: "…oraz {n} więcej.",
    wlayout_calibration: "Porównanie z rzeczywistymi pobraniami",
    wlayout_calibration_hint: "Czasy przejść z rzeczywistych zdarzeń kompletacji, pogrupowane według odległości wynikającej z układu. Jeśli rysunek jest poprawny, czasy rosną z odległością; jeśli któryś przedział mocno odstaje, geometria w tym przedziale jest błędna.",
    wlayout_fit_summary: "Dopasowano: {speed} m/s chodu, {step} s na samo ruszenie się, {handling} s obsługi na pobranie (R² {r2}, przejść: {n}).",
    wlayout_no_fit: "Za mały rozrzut danych, aby dopasować prędkość.",
    wlayout_coverage: "{pct}% przejść udało się umieścić na układzie — {unmapped} nie.",
    wlayout_band: "Odległość",
    wlayout_moves: "Przejścia",
    wlayout_median_m: "Mediana m",
    wlayout_median_s: "Mediana s",
    wlayout_residual: "Reszta s",
    wlayout_band_same_spot: "To samo miejsce",
    wlayout_band_under_2m: "Poniżej 2 m",
    wlayout_band_2_to_5m: "2–5 m",
    wlayout_band_5_to_10m: "5–10 m",
    wlayout_band_10_to_20m: "10–20 m",
    wlayout_band_20_to_40m: "20–40 m",
    wlayout_band_over_40m: "Powyżej 40 m",
    wlayout_view_2d: "Plan",
    wlayout_view_3d: "3D",
    wlayout_3d_loading: "Wczytywanie widoku 3D…",
    wlayout_3d_failed: "Nie udało się wczytać widoku 3D.",
    wlayout_3d_hint: "Przeciągnij, aby obrócić, przewiń, aby przybliżyć. Tylko do podglądu — trasowanie korzysta z geometrii planu, a wysokości wpływają tylko na czas pobrania, nie na przebytą odległość. Ten widok służy do wychwycenia regału o złym kształcie.",
    walk_variant_code_placeholder: "Kod (A)",
    walk_variant_name_placeholder: "Nazwa (np. Najszybciej rotujące najpierw)",
    walk_variant_need_code: "Najpierw nadaj wariantowi kod — A, B, C…",
    walk_variant_need_two_arms: "Eksperyment wymaga co najmniej dwóch kolejności obchodu do porównania.",
    walk_variant_bad_header: "Ten arkusz nie ma kolumn location i walk_order. Pobierz obecną kolejność obchodu i edytuj ją.",
    walk_variant_empty: "Ten arkusz nie ma wierszy.",
    walk_variant_uploaded: "Kolejność obchodu {code} zapisana — {n} lokalizacji ({pct}% magazynu).",
    walk_variant_rejects: "{unknown} wierszy nie pasowało do żadnej lokalizacji, a {invalid} nie miało poprawnego walk_order. Te lokalizacje zachowują swoją aktywną kolejność.",
    walk_variant_download_failed: "Nie udało się pobrać kolejności obchodu.",

    // Shelf Drop & Forecast Drop — Ustawienia
    picking_shelf_drop_settings: "Uzupełnianie półek",
    picking_shelf_drop_settings_hint: "Uzupełnianie z wysokich lokalizacji shelf_drop do niskich miejsc kompletacji, na podstawie niezrealizowanych zamówień.",
    picking_forecast_drop_settings: "Uzupełnianie prognozowane",
    picking_forecast_drop_settings_hint: "Uzupełnianie sterowane celem Hot BargainFox — dopełnij każdą niską lokalizację do tej samej liczby, względem której arkusz skanowania przyjęć klasyfikuje Hot. Sztuki w kolejce odkładania Hot liczą się jako już na dole; sprzedane, ale jeszcze nie pobrane — nie. Shelf Drop sprowadza to, czego potrzebują otwarte zamówienia — prognoza tylko dopełnia ponad to i nigdy nie zabiera sztuk, na które one czekają.",
    drop_claim_ttl_minutes: "Czas rezerwacji",
    drop_claim_ttl_minutes_hint: "Jak długo rezerwacja kompletatora pozostaje aktywna, zanim wygaśnie automatycznie.",
    forecast_drop_target_source_hint: "Cel na SKU = 30-dniowa sprzedaż z tabeli produktów BF ÷ 30 × dni pokrycia Hot BF (patrz ustawienia arkusza skanowania BargainFox), odświeżany codziennie o 05:30. Brak osobnego ustawienia Forecast Drop.",
    require_location_scan_shelf_drop: "Wymagaj skanu lokalizacji (Shelf Drop)",
    require_location_scan_shelf_drop_hint: "Gdy włączone, kompletator musi zeskanować bieżącą lokalizację, zanim Shelf Drop pokaże najbliższy cel.",
    require_location_scan_forecast_drop: "Wymagaj skanu lokalizacji (Forecast Drop)",
    require_location_scan_forecast_drop_hint: "Gdy włączone, kompletator musi zeskanować bieżącą lokalizację, zanim Forecast Drop pokaże najbliższy cel.",

    // Shelf/Forecast Drop — UI kompletatora
    drop_scan_current_location: "SKANUJ LOKALIZACJĘ",
    drop_scan_empty_tote: "SKANUJ POJEMNIK",
    drop_scan_target_location: "SKANUJ LOKALIZACJĘ",
    drop_scan_items: "SKANUJ SZTUKĘ",
    drop_scan_items_one: "SKANUJ SZTUKĘ",
    drop_all_caught_up: "Wszystko gotowe",
    drop_finding_next_location: "Szukam kolejnej lokalizacji...",
    drop_put_away_toggle: "Odkładanie",
    drop_view_toggle: "Widok",
    drop_view_pick: "Kompletacja",
    drop_view_put_away: "Odkładanie",
    drop_put_away_view_title: "Odkładanie",
    drop_put_away_queue_empty: "Wszystko gotowe",
    drop_back_to_picking: "Wróć do kompletacji",
    drop_aisles_title: "Sztuki wg alejki",
    drop_aisles_hint: "Skąd będą pobierane zaległe sztuki.",
    drop_aisles_empty: "Obecnie nie ma nic do zrzutu.",
    drop_aisles_aisle: "Alejka {aisle}",
    drop_aisles_other: "Bez alejki",
    drop_aisles_total: "Razem",
    drop_invalid_starting_location: "Nie znaleziono lokalizacji.",
    scan_wrong_warehouse: "Ta lokalizacja znajduje się w magazynie {warehouse}. Zmień swój magazyn, aby jej użyć.",
    drop_move_location_title: "Przejdź do nowej lokalizacji",
    drop_move_location_hint: "Zeskanuj lokalizację, do której przechodzisz. Nieskompletowane tutaj sztuki pozostaną w kolejce.",
    drop_move_invalid_location: "To nie jest prawidłowa lokalizacja magazynowa.",
    picking_location_tap_label: "Zmień lokalizację",
    picking_skip_title: "Pomiń lokalizację",
    picking_skip_body: "Zeskanuj lokalizację, do której przechodzisz. Pominięte lokalizacje wrócą na koniec trasy.",
    picking_skip_unknown_location: "Nieznana lokalizacja — zeskanuj kod lokalizacji.",
    drop_not_a_tote: "To nie jest pojemnik.",
    drop_tote_in_use_elsewhere: "Pojemnik jest używany gdzie indziej.",
    drop_tote_unavailable: "Pojemnik niedostępny.",
    drop_reopen_tote_title: "Otwórz pojemnik ponownie",
    drop_reopen_tote_intro: "Ten pojemnik jest zamknięty i czeka na odłożenie. Otwórz go ponownie, aby dalej dodawać — jego bieżąca zawartość zostanie zachowana.",
    drop_reopen_confirm: "Otwórz ponownie",
    drop_swap_tote_title: "Zmienić pojemnik?",
    drop_swap_tote_intro: "Zeskanuj pojemnik {tote} ponownie lub naciśnij Potwierdź, aby dalej pakować do niego. To, co już zeskanowano, zostaje w pojemniku {current} i trafia do odłożenia.",
    drop_swap_confirm: "Potwierdź",
    drop_close_tote_title: "Zamknij pojemnik",
    drop_close_tote_intro: "Zeskanuj pojemnik ponownie lub potwierdź, aby go zamknąć i wysłać do odkładania. Spowoduje to zakończenie sesji Drop.",
    drop_close_confirm: "Zamknij pojemnik",
    drop_close_last_location: "Ostatni przedmiot pobrany z {location}",
    drop_tote_closed_toast: "Pojemnik {tote} wysłano do odkładania.",
    drop_tote_closed_empty_toast: "Pojemnik {tote} był pusty — został zwolniony.",
    drop_close_failed: "Nie udało się zamknąć pojemnika ({reason}) — spróbuj ponownie.",
    drop_resume_title: "Niedokończona sesja Drop",
    drop_resume_intro: "Pojemnik {tote} zawiera {items} szt. Bieżąca lokalizacja: {location}. Wznów lub zamknij pojemnik i wyślij go do odkładania.",
    drop_resume_intro_no_location: "Pojemnik {tote} zawiera {items} szt. Wznów, aby znaleźć kolejną lokalizację, lub zamknij pojemnik i wyślij go do odkładania.",
    drop_resume_intro_no_tote: "W tej niedokończonej sesji Drop zapisano {items} szt. Wznów i zeskanuj pojemnik, aby kontynuować.",
    drop_resume_no_tote: "Brak pojemnika",
    drop_resume_confirm: "Wznów",
    drop_resume_close_tote: "Zamknij pojemnik",
    drop_resume_discard: "Odrzuć",
    drop_resumed_toast: "Wznowiono Drop z pojemnikiem {tote}.",
    drop_resuming: "Wznawianie Drop…",
    drop_start_blocked_by_tote: "Pojemnik {tote} jest nadal otwarty w Twoim Drop — najpierw wznów go lub zamknij.",
    drop_resumed_no_tote_toast: "Wznowiono Drop — zeskanuj pojemnik, aby kontynuować.",
    drop_session_lost: "Ta sesja Drop została zakończona w innym miejscu — zacznij od nowa.",
    drop_takeover_title: "Pojemnik w niedokończonej sesji Drop",
    drop_takeover_intro: "Pojemnik {tote} należy do niedokończonej sesji Drop użytkownika {picker}. Potwierdzenie wyśle znajdujący się w nim towar do odkładania.",
    drop_takeover_confirm: "Wyślij do odkładania",
    drop_takeover_done: "Pojemnik {tote} wysłano do odkładania.",
    drop_takeover_unknown_picker: "innego kompletatora",
    drop_wrong_location: "Zła lokalizacja — udaj się do wskazanej.",
    drop_wrong_item: "Tego produktu nie ma w tym zrzucie.",
    drop_already_picked_qty: "Ilość dla tego SKU została już osiągnięta.",
    drop_partial_claim_race: "Inny kompletator zarezerwował część — przenieś to, co masz w pojemniku.",
    drop_pick_complete_failed: "Nie udało się zakończyć kompletacji.",
    drop_pa_scan_tote: "SKANUJ POJEMNIK",
    drop_pa_scan_target_location: "SKANUJ LOKALIZACJĘ",
    drop_pa_scan_item_or_location: "SKANUJ PRODUKT LUB LOKALIZACJĘ",
    drop_pa_item_gone: "Tego produktu nie ma już w tym pojemniku.",
    drop_pa_picked_by: "Skompletowane przez: {name}",
    drop_pa_tote_item_count: "{n} szt.",
    drop_pa_tote_not_in_queue: "Ten pojemnik nie oczekuje tu na odłożenie.",
    // Wrong-queue prompt (shared by Put Away / Shelf Drop / Forecast Drop put-away)
    wrong_queue_title: "Zła kolejka",
    wrong_queue_drop: "Pojemnik {tote} oczekuje na odłożenie w {queue} — {units} szt. pobrał(a) {name}.",
    wrong_queue_put_away: "Pojemnik {tote} to pojemnik z przyjęcia towaru — należy do Put Away.",
    wrong_queue_picking: "Pojemnik {tote} jest na fali kompletacji — trafia do sortowania i wysyłki, nie do odłożenia.",
    wrong_queue_go: "Przejdź do {queue}",
    wrong_queue_stay: "Zostań tutaj",
    drop_pa_unknown_location: "Nie znaleziono lokalizacji.",
    drop_pa_not_low: "Cel musi być niską lokalizacją.",
    drop_pa_target_is_source: "Cel nie może być źródłem shelf-drop.",
    drop_pa_not_storage: "Cel musi być lokalizacją magazynową.",
    drop_pa_failed: "Odłożenie nie powiodło się.",
    drop_filter_channel: "Kanał",
    drop_filter_express: "Express",
    drop_filter_standard: "Standard",
    drop_filter_age: "Wiek zamówienia",
    drop_filter_age_2plus: "2+ dni",
    drop_filter_age_1to2: "1–2 dni",
    drop_filter_age_lt1: "< 1 dzień",
    drop_filter_older_than: "Starsze niż",

    // Picking admin (top-level page)
    dashboard_admin_title: "Pulpit",
    dashboard_admin_hint: "Postęp zadań magazynowych na żywo — kto nad czym pracuje, jak daleko jest i kiedy powinien skończyć.",
    tile_dashboard_desc: "Postęp zadań na żywo i szacowany czas ukończenia",
    dashboard_col_user: "Użytkownik",
    dashboard_col_bay: "Regał",
    dashboard_col_wave_order: "Fala / Zamówienie",
    dashboard_wave_order_more: "+{n} więcej",
    dashboard_col_progress: "Postęp",
    dashboard_col_speed: "Tempo",
    dashboard_col_eta: "Szac. ukończenie",
    dashboard_speed_iph: "{n} szt./godz.",
    dashboard_eta_in: "~{mins} min ({time})",
    dashboard_idle: "Bezczynny",
    dashboard_paused: "Wstrzymane",
    dashboard_no_picks: "Brak aktywnych kompletacji.",
    dashboard_no_sorts: "Brak aktywnego sortowania.",
    dashboard_col_start: "Początek",
    dashboard_col_end: "Koniec",
    dashboard_completed_today: "Ukończone dzisiaj",
    dashboard_passed_on: "Przekazane",
    dashboard_taken_over: "Przejęte",
    dashboard_no_completed: "Nic jeszcze nie ukończono dzisiaj.",
    dashboard_col_source: "Źródło",
    dashboard_col_ref: "Pojemnik / Sesja",
    dashboard_col_units: "Sztuki",
    dashboard_col_last_activity: "Ostatnia aktywność",
    dashboard_col_orders: "Zamówienia",
    dashboard_col_parcels: "Paczki",
    dashboard_col_orders_ph: "Zam./godz.",
    dashboard_col_units_ph: "Szt./godz.",
    dashboard_col_parcels_ph: "Paczki/godz.",
    dashboard_rate_ph: "{n}/godz.",
    dashboard_source_book_in: "Przyjęcie",
    dashboard_source_bf_scan: "Skan BF",
    dashboard_source_bf_scan_big: "Skan BF BIG",
    dashboard_no_goods_in: "Brak aktywnych sesji przyjęcia towaru.",
    dashboard_no_dispatch: "Brak aktywnych sesji wysyłki.",
    dashboard_no_putaway: "Brak aktywnych sesji odkładania.",
    dashboard_col_type: "Typ",
    dashboard_col_totes_short: "Pojemniki",
    dashboard_col_misslotted: "Błędna lokalizacja",
    dashboard_rate_totes_ph: "{n} poj./godz.",
    dashboard_putaway_type_hot: "Gorące",
    dashboard_putaway_type_cold: "Zimne",
    dashboard_putaway_type_other: "Inne",
    dashboard_no_shelf_drops: "Nikt obecnie nie uzupełnia półek.",
    dashboard_no_forecast_drops: "Nikt obecnie nie wykonuje uzupełniania prognozowanego.",
    dashboard_phase_putaway: "Odkłada",
    dashboard_scope_toggle: "Widok pulpitu",
    dashboard_scope_individual: "Podsumowanie",
    dashboard_pick_type_other: "Inne",
    dashboard_sort_hint: "Sortuj według tej kolumny",
    dashboard_scope_waves: "Fale",
    dashboard_scope_team: "Zespół",
    dashboard_scope_planner: "Planer",
    dashboard_planner_hint: "Potrzebne osoby na każdym zadaniu, od teraz, aby zdążyć z celem wysyłki.",
    dashboard_planner_footer: "Stan na {time} · {scope} · Tempo: średnia z {days} dni ({from} – {to}) · Pominięte oflagowane / wstrzymane: {n}",
    dashboard_planner_scope_label: "Zamówienia do planu",
    dashboard_planner_scope_due: "Na dzisiaj",
    dashboard_planner_scope_all: "Wszystkie otwarte",
    dashboard_planner_refresh: "Odśwież dane",
    dashboard_planner_reset: "Resetuj",
    dashboard_planner_reset_hint: "Czyści poprawione liczby i przywraca domyślny cel.",
    dashboard_planner_error: "Nie udało się pobrać dzisiejszych danych — wpisz je ręcznie lub odśwież.",
    dashboard_planner_target: "Cel wysyłki",
    dashboard_planner_target_sub: "Cut-off {cutoff} minus {buffer} min",
    dashboard_planner_time_left: "Pozostały czas",
    dashboard_planner_past_target: "Po celu",
    dashboard_planner_now: "Teraz {time}",
    dashboard_planner_people: "Osoby",
    dashboard_planner_people_summary: "potrzeba {needed} · jest {active}",
    dashboard_planner_projected: "Prognozowany koniec wysyłki",
    dashboard_planner_projected_none: "Nic do planowania",
    dashboard_planner_projected_unknown: "Brakuje tempa na zadaniu",
    dashboard_planner_projected_blocked: "Nikogo na zadaniu z pracą",
    dashboard_planner_projected_on_track: "{time} — na czas",
    dashboard_planner_projected_late: "{time} — opóźnienie {late}",
    dashboard_planner_col_job: "Zadanie",
    dashboard_planner_col_work: "Praca do wykonania",
    dashboard_planner_col_rate: "Tempo na osobę / godz.",
    dashboard_planner_col_needed: "Potrzebne osoby",
    dashboard_planner_col_active: "Teraz na zadaniu",
    dashboard_planner_active_hint: "Osoby, które Portal widzi na tym zadaniu, z sesji na żywo",
    dashboard_planner_col_finish: "Prognozowany koniec",
    dashboard_planner_dept_by: "Koniec do {time}",
    dashboard_planner_row_by: "do {time}",
    dashboard_planner_dept_hours: "zostało {time}",
    dashboard_planner_dept_passed: "Termin minął",
    dashboard_planner_unit_items: "szt.",
    dashboard_planner_unit_orders: "zamówień",
    dashboard_planner_revert: "Dane na żywo: {n}",
    dashboard_planner_revert_none: "Dane na żywo: brak",
    dashboard_planner_revert_hint: "Wróć do danych na żywo",
    dashboard_planner_no_history: "Brak historii — wpisz tempo",
    dashboard_planner_short: "brakuje {n}",
    dashboard_planner_status_nothing: "Nic do zrobienia",
    dashboard_planner_status_no_rate: "Wpisz tempo",
    dashboard_planner_status_no_time: "Termin minął",
    dashboard_planner_status_nobody: "Nikogo na zadaniu",
    dashboard_planner_status_on_track: "Na czas",
    dashboard_planner_status_late: "Opóźnienie {time}",
    dashboard_planner_tomorrow: "Jutro",
    dashboard_advisor_pembroke_only: "Doradca pickingu działa tylko w Pembroke Dock.",
    dashboard_planner_views: "Widok planera",
    dashboard_planner_view_staffing: "Obsada",
    dashboard_planner_view_advisor: "Doradca pickingu",
    dashboard_advisor_hint: "Co kolejka pickingu podpowiada teraz wolnemu pickerowi, dlaczego i na jakiej podstawie. Pickerzy nigdy nie widzą powodu.",
    dashboard_advisor_load_error: "Nie udało się wczytać doradcy pickingu — odśwież.",
    dashboard_advisor_off_banner: "Doradca pickingu jest wyłączony na serwerze (PICK_ADVISOR_ENABLED) — każdy skaner pokazuje pełną kolejkę.",
    dashboard_advisor_off: "Doradca wyłączony",
    dashboard_advisor_off_hint: "Pickerzy nie widzą żadnej podpowiedzi.",
    dashboard_advisor_error: "Nie udało się odczytać podpowiedzi kolejki",
    dashboard_advisor_none: "Brak podpowiedzi",
    dashboard_advisor_no_warehouses: "Brak magazynu w zakresie.",
    dashboard_advisor_state_at: "Stan na {time}",
    dashboard_advisor_recommending: "Podpowiada teraz",
    dashboard_advisor_pick_none: "Nic — zapytaj lidera",
    dashboard_advisor_pick_with_orders: "{pick} · {n} zamówień",
    dashboard_advisor_sort_load: "Obciążenie sortowania",
    dashboard_advisor_sort_load_sub: "minuty sortowania na sortera: czekające, w toku i nadchodzące",
    dashboard_advisor_pack_runway: "Zapas pakowania",
    dashboard_advisor_pack_runway_sub: "zanim pakowaczom skończy się gotowa praca",
    dashboard_advisor_no_packers: "brak pakowaczy",
    dashboard_advisor_sorters: "Sorterzy",
    dashboard_advisor_now_expected: "{now} teraz · {expected} oczekiwanych",
    dashboard_advisor_sorters_sub: "zwykle {n} przed południem",
    dashboard_advisor_packers: "Pakowacze",
    dashboard_advisor_packers_sub: "spakowali coś w ostatnich 15 min",
    dashboard_advisor_lands_at: "Dotrze do sortowania",
    dashboard_advisor_lands_at_sub: "jeśli sugerowana fala ruszy teraz",
    dashboard_advisor_packed_by: "Spakowane do",
    dashboard_advisor_packed_by_sub: "do {cutoff}",
    dashboard_advisor_pools: "Pule: Pick & Sort {ps} · Putwall {wall} · Duże {large} · Pojedyncze {light} zamówień",
    dashboard_advisor_wall_off: "wył.",
    dashboard_advisor_after_cutoff: "Po cut-offie — picking na jutro",
    dashboard_advisor_tile_sort: "Na etapie sortowania",
    dashboard_advisor_tile_sort_value: "{waiting} czeka · {busy} w sortowaniu",
    dashboard_advisor_tile_sort_sub: "{items} szt. do posortowania · {slots} wolnych slotów ściany",
    dashboard_advisor_tile_inflight: "Fale w toku",
    dashboard_advisor_tile_pack: "Gotowe do pakowania",
    dashboard_advisor_tile_people: "Aktywni teraz",
    dashboard_advisor_tile_people_value: "{pickers} · {sorters} · {packers}",
    dashboard_advisor_tile_people_sub: "pickerzy · sorterzy · pakowacze, ostatnie 15 min",
    dashboard_advisor_tile_none: "brak",
    dashboard_advisor_waiting_title: "Kolejka sortowania",
    dashboard_advisor_waiting_none: "Nic zebranego nie czeka na sortowanie.",
    dashboard_advisor_inflight_title: "Fale w toku",
    dashboard_advisor_inflight_none: "Żadna fala nie jest kompletowana.",
    dashboard_advisor_col_wave: "Fala",
    dashboard_advisor_col_station: "Stanowisko",
    dashboard_advisor_col_orders: "Zamówienia",
    dashboard_advisor_col_items: "Sztuki",
    dashboard_advisor_col_status: "Status",
    dashboard_advisor_col_type: "Typ",
    dashboard_advisor_col_picked: "Zebrane",
    dashboard_advisor_col_lands: "Dotrze o",
    dashboard_advisor_status_sorting: "Sortowanie",
    dashboard_advisor_status_waiting: "Czeka",
    dashboard_advisor_status_waiting_for: "Czeka {time}",
    dashboard_advisor_status_paused: "Wstrzymana",
    dashboard_advisor_today_title: "Dzisiejsze starty a podpowiedzi",
    dashboard_advisor_today_summary: "{starts} fal rozpoczętych · {advised} z podpowiedzią · {followed} zgodnych ({pct}) · {suggested} z widoku Sugerowane",
    dashboard_advisor_today_none: "Dziś nie rozpoczęto jeszcze żadnej fali.",
    dashboard_advisor_rule_followed: "{followed} z {advised} zgodnych",
    dashboard_advisor_col_time: "Czas",
    dashboard_advisor_col_picker: "Kompletator",
    dashboard_advisor_col_picked_wave: "Zebrano",
    dashboard_advisor_col_suggested: "Sugerowane",
    dashboard_advisor_col_followed: "Zgodnie",
    dashboard_advisor_followed_yes: "Zgodnie",
    dashboard_advisor_followed_no: "Niezgodnie",
    dashboard_advisor_followed_na: "Bez podpowiedzi",
    dashboard_advisor_toggle_off: "Widok Sugerowane wył.",
    dashboard_advisor_high_tier: "Wysoki poziom",
    dashboard_advisor_reason_orders: "zamówień w fali",
    dashboard_advisor_reason_lands_at: "dotrze do sortowania",
    dashboard_advisor_reason_packed_by: "spakowane do",
    dashboard_advisor_reason_latest_start: "najpóźniejszy start",
    dashboard_advisor_reason_last_start: "ostatni możliwy start",
    dashboard_advisor_reason_sort_load: "obciążenie sortowania",
    dashboard_advisor_reason_pack_runway: "zapas pakowania",
    dashboard_advisor_reason_large_due: "Duże na dziś",
    dashboard_advisor_reason_due: "zamówień na dziś",
    dashboard_advisor_reason_include: "zamówienia ściany dołączone",
    dashboard_advisor_reason_ps: "pula Pick & Sort",
    dashboard_advisor_reason_put_wall: "pula Putwall",
    dashboard_advisor_reason_large: "pula Dużych",
    dashboard_advisor_reason_light: "pula Pojedynczych",
    dashboard_advisor_rule_high_tier: "Wysoki poziom — nigdy nie podpowiadany",
    dashboard_advisor_rule_morning_wall: "Rano — pełna fala Putwall",
    dashboard_advisor_rule_morning_wall_why: "Przed startem sortowania pula samych Pick & Sort jest poniżej minimum, więc prowadzi ściana.",
    dashboard_advisor_rule_morning_ps: "Rano — najpierw Pick & Sort",
    dashboard_advisor_rule_morning_ps_why: "Przed startem sortowania: pełna fala większych zamówień zapełnia kolejkę pakowania; ściana jako druga.",
    dashboard_advisor_rule_single_full: "Pula Pojedynczych osiągnęła 40",
    dashboard_advisor_rule_single_full_why: "Fala Pojedynczych jest podpowiadana zawsze, gdy czeka 40 zamówień Pojedynczych, o każdej porze dnia.",
    dashboard_advisor_rule_single_sweep: "Zebranie Pojedynczych o cut-offie zamówień",
    dashboard_advisor_rule_single_sweep_why: "Od 13:00 każde czekające Pojedyncze jest zbierane od razu.",
    dashboard_advisor_rule_pack_dry_large: "Pakowaniu kończy się praca — Duże",
    dashboard_advisor_rule_pack_dry_large_why: "Mało gotowej pracy na stole pakowania i nic Dużego w toku; Duże zasilają pakowanie bezpośrednio.",
    dashboard_advisor_rule_pack_dry_single: "Pakowaniu kończy się praca — Pojedyncze",
    dashboard_advisor_rule_pack_dry_single_why: "Nie ma już Dużych; fala Pojedynczych zasila pakowanie bezpośrednio.",
    dashboard_advisor_rule_cutoff_large: "Cut-off — Duże",
    dashboard_advisor_rule_cutoff_large_why: "Fala sortowania rozpoczęta teraz nie zostałaby spakowana przed cut-offem, a Duże na dziś czekają.",
    dashboard_advisor_rule_sort_spare_wall: "Sorterzy mają zapas — Putwall",
    dashboard_advisor_rule_sort_spare_wall_why: "Pula ściany jest dość duża i zostanie spakowana przed cut-offem.",
    dashboard_advisor_rule_sort_spare_ps: "Sorterzy mają zapas — Pick & Sort",
    dashboard_advisor_rule_sort_spare_ps_why: "Obciążenie sortowania poniżej horyzontu, więc kolejne Pick & Sort utrzymuje sorterów w pracy.",
    dashboard_advisor_rule_sort_loaded_large: "Sorterzy obciążeni — Duże",
    dashboard_advisor_rule_sort_loaded_large_why: "Kolejne Pick & Sort tylko czekałoby przy regałach; Duże zasilają pakowanie bezpośrednio.",
    dashboard_advisor_rule_ps_queue: "Pick & Sort do kolejki",
    dashboard_advisor_rule_ps_queue_why: "Nie ma już Dużych; utrzymuje falę gotową dla sorterów.",
    dashboard_advisor_rule_drop_done_wall: "Popołudniowe zrzuty zakończone — ostatnia Ściana",
    dashboard_advisor_rule_drop_done_wall_why: "Drugie zrzuty z półek się skończyły, więc nic więcej nie zjedzie i pula na dziś jest ostateczna: zamówienia na Ścianę, które są jeszcze na dziś, idą teraz jako Ściana.",
    dashboard_advisor_rule_drop_done_ps: "Popołudniowe zrzuty zakończone — ostatnie Sortowanie",
    dashboard_advisor_rule_drop_done_ps_why: "Drugie zrzuty z półek się skończyły, więc nic więcej nie zjedzie i pula na dziś jest ostateczna: każde zamówienie do Sortowania na dziś idzie teraz, nawet poniżej minimum, jeśli tylko tyle zostało.",
    dashboard_advisor_rule_override_1530: "Nadpisanie cut-offu",
    dashboard_advisor_rule_override_1530_why: "Zamówienia na dziś poniżej minimalnej fali, rozpoczęte od ostatniego możliwego startu, by jeszcze dziś wyszły.",
    dashboard_advisor_rule_ask_leader: "Nic nie spełnia reguł — zapytaj lidera",
    dashboard_advisor_rule_ask_leader_why: "Żaden picking nie spełnia teraz reguł; picker ma zapytać lidera zespołu.",
    dashboard_advisor_rule_ps_join_urgent: "Dołącz do otwartej połowy — potrzeba dwóch",
    dashboard_advisor_rule_ps_join_urgent_why: "Połowa fali w parze czeka na kompletatora, a jej zamówienia zdążą na 15:30 tylko we dwóch.",
    dashboard_advisor_rule_ps_join_fallback: "Dołącz do otwartej połowy",
    dashboard_advisor_rule_ps_join_fallback_why: "Nic innego nie spełnia reguł, a połowa fali w parze czeka na kompletatora.",
    dashboard_updated_secs: "Zaktualizowano {n} s temu",
    dashboard_updated_mins: "Zaktualizowano {n} min temu",
    dashboard_col_sessions: "Sesje",
    dashboard_col_waves: "Fale",
    dashboard_col_time_spent: "Czas",
    dashboard_col_totes: "Ukończone pojemniki",
    dashboard_no_individual: "Brak zapisanej pracy w tym dziale dzisiaj.",
    dashboard_team_race_title: "Wyścig do godziny granicznej",
    dashboard_team_race_orders_count: "{done} / {due} zamówień",
    dashboard_team_race_items_count: "{done} / {due} sztuk",
    dashboard_team_race_projected: "Prognozowany koniec",
    dashboard_team_race_finish_time: "Czas zakończenia",
    dashboard_team_race_not_today: "Nie dzisiaj",
    dashboard_team_race_rate: "Obecne tempo {n} szt./godz.",
    dashboard_team_race_clock: "Pora dnia (06:00 → godzina graniczna)",
    dashboard_team_race_finished: "Ukończono!",
    dashboard_team_race_no_estimate: "Brak prognozy",
    dashboard_team_race_frozen: "Po godzinie granicznej",
    dashboard_team_race_status_flying: "Pełna prędkość",
    dashboard_team_race_status_on_track: "Na czas",
    dashboard_team_race_status_behind: "Opóźnienie",
    dashboard_team_race_status_danger: "Strefa zagrożenia",
    dashboard_team_orders_out_today: "Zamówienia wysłane dzisiaj",
    dashboard_team_dispatch_cutoff: "Godzina graniczna wysyłki {time}",
    dashboard_team_of_due: "z {n} do wysłania",
    dashboard_team_progress_count: "{done} / {due}",
    dashboard_team_kpis: "KPI magazynu",
    dashboard_team_daily_kpis: "Dzienne KPI",
    dashboard_team_weekly_kpis: "Tygodniowe KPI",
    dashboard_team_week_range: "{from} – {to}",
    dashboard_team_orders_out_week: "Zamówienia wysłane w tym tygodniu",
    dashboard_team_on_time_pct: "{pct}% na czas",
    dashboard_team_on_time_short: "{on_time} / {total} na czas",
    dashboard_team_on_time_word: "na czas",
    dashboard_team_late_word: "spóźnione",
    dashboard_team_vs_last_week: "{pct} vs zeszły tydzień",
    dashboard_team_week_dept_help: "Tempo to średnia z tego tygodnia. Porównanie z tym samym momentem zeszłego tygodnia.",

    dashboard_team_range_label: "Zakres dat",
    dashboard_team_range_from: "Od",
    dashboard_team_range_to: "Do",
    dashboard_team_range_this_week: "Ten tydzień",
    dashboard_team_target: "Cel {pct}%",
    dashboard_team_tip_on_time: "{shipped} / {due} wysłanych na czas · {pct}%",
    dashboard_team_tip_early: "{early} wysłanych wcześniej",
    dashboard_team_range_wtd: "Bieżący tydzień",
    dashboard_team_range_last_week: "Poprzedni tydzień",
    dashboard_team_range_mtd: "Bieżący miesiąc",
    dashboard_team_range_custom: "Własny",
    dashboard_team_range_today: "Dzisiaj",
    dashboard_team_range_yesterday: "Wczoraj",
    dashboard_completed_range: "Ukończone {range}",
    dashboard_no_completed_range: "Nic nie ukończono w tym okresie.",
    // Leaders Bonus (Alex, 2026-09-28) — ustawienia + widok pulpitu
    dashboard_scope_leaders_bonus: "Premia liderów",
    leaders_bonus_settings: "Premia liderów",
    leaders_bonus_settings_hint: "Okresy rozliczeniowe i cele KPI dla premii liderów zespołu. Cele dzienne są mnożone przez liczbę dni roboczych okresu (pon.–pt., bez brytyjskich dni wolnych), co daje cel okresu pokazywany na pulpicie Premia liderów.",
    leaders_bonus_add_period: "Dodaj okres rozliczeniowy",
    leaders_bonus_no_periods: "Brak okresów rozliczeniowych.",
    leaders_bonus_col_period: "Okres rozliczeniowy",
    leaders_bonus_col_working_days: "Dni robocze",
    leaders_bonus_col_on_time: "Cel terminowości",
    leaders_bonus_col_booked_in: "Przyjęte / dzień",
    leaders_bonus_col_put_away: "Odłożone / dzień",
    leaders_bonus_col_period_targets: "Cele okresu",
    leaders_bonus_period_targets: "{booked} przyjętych · {put_away} odłożonych",
    leaders_bonus_starts_on: "Początek",
    leaders_bonus_ends_on: "Koniec",
    leaders_bonus_on_time_target: "Cel wysyłek na czas",
    leaders_bonus_booked_in_target: "Sztuki przyjęte na dzień roboczy",
    leaders_bonus_put_away_target: "Sztuki odłożone na dzień roboczy",
    leaders_bonus_form_hint: "Dni robocze i cele okresu zostaną obliczone po zapisaniu.",
    leaders_bonus_overlap: "Ten okres nakłada się na inny okres tego magazynu ({from} – {to}).",
    leaders_bonus_saved: "Okres rozliczeniowy zapisany",
    leaders_bonus_deleted: "Okres rozliczeniowy usunięty",
    leaders_bonus_current: "Bieżący",
    leaders_bonus_upcoming: "Nadchodzący",
    leaders_bonus_ended: "Zakończony",
    dashboard_lb_select_warehouse: "Brak okresów rozliczeniowych. Dodaj okres w Ustawienia › Premia liderów.",
    dashboard_lb_no_periods: "Brak okresów rozliczeniowych dla {warehouse}. Dodaj okres w Ustawienia › Premia liderów.",
    dashboard_lb_period_label: "Okres rozliczeniowy",
    dashboard_lb_period_meta: "{from} – {to} · {days} dni roboczych · {elapsed} minęło",
    dashboard_lb_fail_days: "Dni poniżej celu",
    dashboard_lb_fail_days_unit: "dni",
    dashboard_lb_fail_days_of: "z {n} ocenionych dni · cel {pct}%",
    dashboard_lb_fail_day_line: "{late} opóźnionych z {due} należnych",
    dashboard_lb_no_fail_days: "Każdy oceniony dzień osiągnął cel",
    dashboard_lb_no_scored_days: "Brak ocenionych dni",
    dashboard_lb_booked_in: "Sztuki przyjęte",
    dashboard_lb_put_away: "Sztuki odłożone",
    dashboard_lb_of_target: "z {target}",
    dashboard_lb_progress_pct: "{pct}% celu",
    dashboard_lb_daily_target: "Cel {n}/dzień",
    dashboard_lb_tip_units: "{n} szt.",
    dashboard_lb_non_working: "Dzień wolny · liczy się, bez celu",
    dashboard_lb_points: "Prognozowane punkty premii",
    dashboard_lb_daily_avg: "Cel dzienny {n}",
    dashboard_lb_need_per_day: "Potrzeba {n}/dzień do 100%",
    dashboard_lb_target_reached: "Osiągnięto 100%",
    dashboard_lb_no_days_left: "Brak dni roboczych",
    dashboard_lb_points_of: "z {max} punktów",
    dashboard_lb_pts: "{n} pkt",
    dashboard_lb_next_step: "Następny próg: {from} za {points} pkt",
    dashboard_lb_max_reached: "Osiągnięto najwyższy próg",
    dashboard_lb_no_value: "Brak danych do oceny",
    dashboard_lb_pct_of_target_value: "{pct}% celu",
    dashboard_lb_pace_value: "Na kursie do {pct}% celu",
    leaders_bonus_points_title: "Punkty premii",
    leaders_bonus_points_hint: "Ile punktów daje każdy KPI w tym okresie. Poniżej pierwszego progu 0 punktów; w przeciwnym razie najwyższy osiągnięty próg. Progi terminowości to sam wskaźnik; progi dla sztuk to % celu okresu.",
    leaders_bonus_ladder_from: "Od",
    leaders_bonus_ladder_points: "Punkty",
    leaders_bonus_ladder_add_step: "Dodaj próg",
    leaders_bonus_ladder_reset: "Przywróć domyślne",
    leaders_bonus_ladder_remove_step: "Usuń próg",
    leaders_bonus_ladder_unit_rate: "% na czas",
    leaders_bonus_ladder_unit_target: "% celu",
    dashboard_lb_booked_in_hint: "Arkusze BF + Big · Hot, Cold, Measure, Red",
    dashboard_lb_put_away_hint: "Tylko pojemniki Hot i Cold",
    dashboard_team_on_time_rate: "Wysyłki na czas",
    dashboard_team_on_time_count: "{on_time} / {total} zamówień wysłanych na czas",
    dashboard_team_time_to_ship: "Czas do wysyłki",
    dashboard_team_hours_unit: "godz.",
    dashboard_team_orders_shipped_count: "{n} zamówień wysłanych",
    dashboard_team_no_orders_in_range: "Brak zamówień w zakresie",
    dashboard_team_shipped_by_date: "Zamówienia wysłane wg daty",
    dashboard_team_shipped_by_date_help: "Zamówienia {channel} złożone danego dnia i ile z nich zostało wysłanych",
    dashboard_team_shipped_of_total: "z {total}",
    dashboard_team_shipped_by_date_total: "Razem w zakresie",
    dashboard_team_range_last_days: "Ostatnie {n} dni",
    dashboard_col_shipped: "Wysłane",
    dashboard_team_same_time_yesterday: "Wczoraj o tej porze",
    dashboard_team_by_department: "Według działu",
    dashboard_team_dept_help: "Tempo to średnia z dzisiejszego dnia. Porównanie z tą samą porą wczoraj.",
    dashboard_team_units_hr: "szt./godz.",
    dashboard_team_totes: "pojemniki",
    dashboard_team_units_count: "{n} szt.",
    dashboard_team_vs_yesterday: "{pct} vs wczoraj",
    dashboard_team_no_activity: "Brak aktywności",
    dashboard_team_booked_in: "Przyjęte",
    dashboard_team_units_picked: "Sztuki pobrane",
    dashboard_team_awaiting_putaway: "Do odłożenia",
    dashboard_team_shelf_queue_title: "Kolejka Shelf Drop",
    dashboard_team_forecast_queue_title: "Kolejka Forecast Drop",
    dashboard_team_units_to_drop_due_today: "szt. do zrzutu · na dziś",
    dashboard_team_units_to_drop: "szt. do zrzutu",
    dashboard_team_totes_to_put_away: "Pojemniki do odłożenia",
    dashboard_team_picking_due_today: "Kompletacja na dzisiaj",
    dashboard_team_of_items: "z {n} sztuk",
    dashboard_team_ready_to_pick: "Gotowe do kompletacji",
    dashboard_team_ready_word: "gotowe",
    dashboard_team_not_ready_word: "niegotowe",
    dashboard_team_low_waiting_word: "na dole",
    dashboard_team_high_word: "na górze",
    dashboard_team_ready_caption: "{pct}% szt. · {ready} z {total} zamówień",
    dashboard_team_ready_help: "Sztuki w oczekujących zamówieniach z terminem na dziś (zaległe zamówienia nie są liczone). Zielony = sztuki w zamówieniach, które można teraz w całości skompletować na dole. Bursztynowy = sztuki już na dole, których zamówienie czeka jeszcze na inne pozycje. Czerwony = sztuki, które wymagają jeszcze zrzutu z półek lub których brakuje w zapasie. Liczba zamówień to zamówienia, które można w całości skompletować na dole.",
    dashboard_team_items_picked: "Sztuki skompletowane",
    dashboard_team_items_sorted: "Sztuki posortowane",
    dashboard_team_orders_sorted: "Posortowane zamówienia",
    pallets_created: "Utworzone palety",
    dashboard_team_sorter_batch: "{date} · Partia {n}",
    dashboard_team_sorter_no_batch: "Dziś nie zeskanowano jeszcze żadnej partii",
    dashboard_team_sorter_items_count: "{done} / {total} sztuk",
    dashboard_team_sorter_people: "{n} osób",
    dashboard_team_sorter_people_now: "{n} skanuje teraz",
    dashboard_team_sorter_other_batches: "Również na stacji",
    dashboard_team_sorter_target: "Docelowy koniec {time}",
    dashboard_team_sorter_no_target: "Brak celu (potrzeba 30 dni historii)",
    dashboard_team_sorter_average: "Średnia z {days} dni {n} szt./godz.",
    dashboard_team_sorter_average_person: "Średnia z {days} dni {n} szt./godz. na osobę × {bays} stanowisk",
    dashboard_team_sorter_help: "Docelowy koniec = pierwszy dzisiejszy skan partii + pozostałe wtedy sztuki, przy średniej z 30 dni na osobę pomnożonej przez liczbę stanowisk sortowania — tyle powinien zrobić pełny zespół przez cały sort. Pełna prędkość / Na czas / Opóźnienie / Strefa zagrożenia to prognozowany koniec względem tego celu, 30 minut w obie strony. Sorter 1 w Newport to przenośnik, więc używa własnej średniej stacji z 30 dni.",
    dashboard_team_people_on_station: "Skanują teraz",
    dashboard_team_batches_finished: "Ukończone partie",
    dashboard_team_pallets: "palet",
    dashboard_team_orders_shipped_word: "wysłanych zamówień",
    dashboard_team_orders_shipped_week: "wysłanych zamówień w tym tygodniu",
    dashboard_col_date: "Data",
    dashboard_col_batch: "Partia",
    dashboard_col_people: "Osoby",
    dashboard_col_pallet: "Paleta",
    dashboard_col_colour: "Kolor",
    dashboard_col_status: "Status",
    dashboard_col_created: "Utworzono",
    dashboard_col_pallets: "Palety",
    dashboard_no_sorter_batches: "Na stacji nie ma teraz żadnej partii.",
    dashboard_no_pallets: "Nie utworzono palet.",
    dashboard_team_units_dispatched: "Sztuki wysłane",
    dashboard_team_orders_dispatched: "Zamówienia wysłane",
    dashboard_team_hot: "Gorące",
    dashboard_team_cold: "Zimne",
    dashboard_team_skus: "SKU",
    dashboard_team_new_skus: "Nowe",
    picking_admin_title: "Kompletacja",
    picking_admin_hint: "Aktywne i historyczne fale kompletacji we wszystkich magazynach. Kliknij wiersz, aby zobaczyć szczegóły.",
    picking_admin_active: "Aktywne",
    picking_admin_paused: "Wstrzymane",
    picking_admin_history: "Historia",
    picking_admin_no_active: "Brak aktywnych fal",
    picking_admin_no_paused: "Brak wstrzymanych fal",
    picking_admin_no_history: "Brak ukończonych fal",
    picking_admin_all_warehouses: "Wszystkie magazyny",
    picking_admin_pick_type_col: "Typ",
    picking_admin_status_col: "Status",
    picking_admin_orders_col: "Zamówienia",
    picking_admin_lines_col: "Linie",
    picking_admin_events_col: "Zdarzenia",
    picking_admin_location_col: "Lokalizacja",
    picking_admin_walk_order_col: "Nr trasy",
    picking_admin_qty_col: "Ilość",
    picking_admin_distribution_col: "Rozkład",
    picking_admin_when_col: "Kiedy",
    picking_admin_action_col: "Akcja",
    picking_admin_anchor: "Kotwica",
    picking_admin_status_building: "Budowanie",
    picking_admin_status_active: "Aktywna",
    picking_admin_status_paused: "Wstrzymana",
    picking_admin_status_completed: "Ukończona",
    picking_admin_status_released: "Zwolniona",
    picking_admin_generate: "Wygeneruj testową falę:",
    picking_admin_generate_btn: "Wygeneruj",
    picking_admin_generate_ok: "Wygenerowano falę #{waveId} · {orders} zam. · {lines} linii",
    picking_admin_generate_failed: "Generowanie nie powiodło się: {reason}",
    picking_admin_pick_warehouse: "Najpierw wybierz magazyn",
    picking_admin_force_release_btn: "Wymuszone zwolnienie",
    picking_admin_force_release_confirm: "Zwolnić falę #{waveId}? Rezerwacje wrócą do magazynu, a zamówienia z powrotem do statusu niezrealizowane.",
    picking_admin_force_release_ok: "Fala #{waveId} zwolniona · zwrócono {n} rezerwacji",
    picking_admin_force_release_failed: "Zwolnienie nie powiodło się: {reason}",
    picking_admin_filter_all_types: "Wszystkie typy",
    picking_admin_filter_all_tiers: "Wszystkie poziomy",
    picking_pick_type_light: "Pojedyncze",
    picking_pick_type_pick_and_sort: "Pick & Sort",
    picking_pick_type_put_wall: "Putwall",
    picking_pick_type_large: "Duże",
    picking_pick_type_pick_and_sort_large: "Pick & Sort · Duża fala",
    picking_pick_type_strip_label: "Typ kompletacji: {type}",
    picking_tier: "Poziom",
    picking_tier_high: "Wysoki",
    picking_tier_low: "Niski",
    picking_wave_id_col: "Fala",
    picking_wave_picker_col: "Kompletator",
    picking_wave_remaining_col: "Pobrane",
    picking_wave_started_col: "Rozpoczęto",
    coming_soon: "wkrótce",

    // Stock Control — warehouse stock maintenance hub
    stock_control: "Kontrola zapasów",
    stock_check: "Sprawdzenie zapasów",
    move_stock: "Przeniesienie zapasów",
    sku_check: "Sprawdzenie SKU",
    stock_check_scan_prompt: "Zeskanuj lokalizację do policzenia",
    move_stock_scan_prompt: "Zeskanuj SKU do przeniesienia",
    sku_check_scan_prompt: "Zeskanuj SKU lub kod kreskowy",
    stock_control_coming_soon: "Wkrótce",
    // Stock Check workflow
    stock_check_scan_location: "Zeskanuj lokalizację",
    stock_check_scan_products: "Skanuj produkty do sprawdzenia",
    stock_check_empty_location: "Brak oczekiwanego stanu — skanuj, aby dodać",
    stock_check_unknown_location: "Nie rozpoznano lokalizacji",
    stock_check_wrong_warehouse: "Lokalizacja jest w innym magazynie",
    stock_check_being_checked: "Sprawdzane przez {name}",
    stock_check_locked_title: "Lokalizacja w użyciu",
    stock_check_take_over: "Przejmij",
    stock_check_resumed: "Wznowiono sprawdzanie",
    stock_check_session_ended: "To sprawdzanie zostało zakończone",
    stock_check_barcode_not_recognised: "Nie rozpoznano kodu kreskowego",
    stock_check_added: "dodano",
    stock_check_allocated: "zarezerwowane",
    stock_check_complete: "Zakończ kontrolę zapasów",
    stock_check_complete_confirm: "Wszystkie pozycje policzone. Zakończyć kontrolę zapasów?",
    stock_check_complete_summary: "Gotowe — {matched} zgodnych, {surplus} dodanych, {writtenOff} spisanych",
    stock_check_add_title: "Dodać do lokalizacji?",
    stock_check_add_body: "Zaksięgować ten produkt w {location}?",
    stock_check_writeoff_title: "Nie znaleziono zapasów",
    stock_check_writeoff_body: "Te oczekiwane pozycje nie zostały zeskanowane. Spisać brakujące zapasy?",
    stock_check_writeoff_confirm: "Spisz i zakończ",
    stock_check_complete_no_writeoff: "Zakończ bez spisywania",
    stock_check_keep_scanning: "Wróć do kontroli zapasów",
    stock_check_resume_title: "Wznowić kontrolę zapasów?",
    stock_check_resume_body: "Masz trwającą kontrolę w {location} — policzono {counted}/{total}. Kontynuować od miejsca przerwania czy zacząć od nowa?",
    stock_check_continue: "Kontynuuj",
    stock_check_start_over: "Zacznij od nowa",
    stock_check_recheck_title: "Już dziś sprawdzono",
    stock_check_recheck_last: "Ostatnia kontrola",
    stock_check_recheck_by: "Przez",
    stock_check_recheck_again: "Sprawdź ponownie",
    stock_check_recheck_new: "Zeskanuj nową lokalizację",
    // Move Stock workflow
    move_stock_scan_tote: "Zeskanuj pojemnik",
    move_stock_scan_location: "Zeskanuj lokalizację",
    move_stock_scan_products: "Skanuj produkty do przeniesienia",
    move_stock_moved: "przeniesiono",
    move_stock_left: "pozostało",
    move_stock_at_location: "tutaj",
    move_stock_switch_location: "Zmień lokalizację",
    move_stock_complete: "Zakończ pojemnik",
    move_stock_complete_title: "Zakończyć pojemnik?",
    move_stock_complete_confirm: "Wysłać ten pojemnik do odkładania z {count} szt.?",
    move_stock_complete_empty_confirm: "Nic nie przeniesiono. Zwolnić ten pojemnik?",
    move_stock_sent_title: "Pojemnik wysłany do odkładania",
    move_stock_sent_body: "{count} szt. jest w drodze do odkładania. Otworzyć nowy pojemnik czy wyjść?",
    move_stock_released_title: "Pojemnik zwolniony",
    move_stock_released_body: "Nic nie przeniesiono — pojemnik jest wolny do ponownego użycia.",
    move_stock_open_new: "Otwórz nowy pojemnik",
    move_stock_leave: "Wyjdź",
    move_stock_auto_sent: "Pojemnik {tote} zamknięty — {count} szt. wysłano do odkładania",
    move_stock_auto_released: "Pojemnik {tote} zwolniony — nic nie przeniesiono",
    move_stock_reopen_title: "Ponownie otworzyć pojemnik?",
    move_stock_reopen_body: "Pojemnik {tote} jest zamknięty i zawiera {count} szt. Otworzyć go ponownie, aby dodać więcej towaru?",
    move_stock_manual_title: "Przenieś ilość",
    move_stock_manual_max: "Dostępne do {max}",
    move_stock_manual_confirm: "Przenieś",
    move_stock_move_all: "Przenieś wszystko",
    move_stock_move_all_title: "Przenieść wszystkie pozycje?",
    move_stock_move_all_confirm: "Próbujesz przenieść wszystkie pozycje z tej lokalizacji do swojego pojemnika. Kontynuować?",
    move_stock_all_short: "WSZ",
    move_stock_empty_location: "Brak zapasów w tej lokalizacji",
    move_stock_location_empty_hint: "Lokalizacja pusta — zeskanuj inną lokalizację lub zakończ pojemnik",
    move_stock_not_a_tote: "Ten kod kreskowy to nie pojemnik",
    move_stock_tote_open: "Pojemnik jest w użyciu",
    move_stock_tote_closed: "Pojemnik już czeka na odkładanie",
    move_stock_closed_goods_in: "Zamknięty w Goods In — otwórz go ponownie w Book In",
    move_stock_tote_stored: "Pojemnik jest już odłożony",
    // Move Stock — move a whole pallet crate (2026-10-26)
    move_stock_crate_title: "Przenieś skrzynię",
    move_stock_crate_scan_location: "Zeskanuj nową lokalizację",
    move_stock_crate_units: "{count} szt.",
    move_stock_crate_at: "Obecnie w {location}",
    move_stock_crate_confirm_title: "Przenieść skrzynię?",
    move_stock_crate_confirm_body: "Przenieść skrzynię {crate} z {count} szt. z {from} do {to}?",
    move_stock_crate_moved: "Skrzynia {crate} przeniesiona do {to} — {count} szt.",
    move_stock_crate_same_location: "Skrzynia już jest w tej lokalizacji",
    move_stock_crate_not_a_destination: "Nie można przenieść skrzyni w to miejsce",
    move_stock_crate_on_wave: "Zbieracz jest w drodze po {title} — przenieś skrzynię po fali",
    move_stock_crate_gone: "Ta skrzynia nie jest już odłożona z towarem",
    move_stock_crate_cancel: "Anuluj",
    move_stock_tote_locked: "Pojemnik używany przez {name}",
    move_stock_user_has_open_tote: "Najpierw zakończ swój otwarty pojemnik {tote}",
    move_stock_unknown_location: "Nie rozpoznano lokalizacji",
    move_stock_wrong_warehouse: "Lokalizacja jest w innym magazynie",
    move_stock_not_a_source: "Nie można przenieść zapasu z tej lokalizacji",
    move_stock_not_here: "Tego produktu nie ma w tej lokalizacji",
    move_stock_none_left: "Nie ma już tego produktu tutaj",
    move_stock_book_in_title: "Nie zapisano tutaj",
    move_stock_book_in_body: "Ten produkt nie jest zapisany w {location}. Przyjąć jedną sztukę tutaj i przenieść ją do pojemnika?",
    move_stock_book_in_confirm: "Przyjmij i przenieś",
    move_stock_booked_in: "przyjęto",
    move_stock_barcode_not_recognised: "Nie rozpoznano kodu kreskowego",
    move_stock_session_ended: "Ta sesja przenoszenia została zakończona",
    // Move Stock — Move / Consolidate pills
    move_stock_mode_toggle: "Tryb przenoszenia zapasów",
    move_stock_mode_move: "Przenieś",
    move_stock_mode_consolidate: "Konsoliduj",
    move_stock_cons_scan_location: "Zeskanuj lokalizację do opróżnienia",
    move_stock_cons_moving: "Przenoszenie",
    move_stock_cons_units: "szt.",
    move_stock_cons_emptied: "Opróżniono",
    move_stock_cons_blocked_title: "Zostaw tę lokalizację",
    move_stock_cons_blocked_on_wave: "Kompletator już idzie do {location} po {title}. Nic nie przeniesiono — wróć, gdy zostanie pobrane.",
    move_stock_cons_blocked_reserved: "Zamówienie potrzebuje {title}, a nie ma go nigdzie indziej na półce. Nic nie przeniesiono z {location}.",
    move_stock_cons_blocked_held: "{title} w {location} jest wstrzymane i nie można go przenieść. Nic nie przeniesiono.",
    move_stock_cons_blocked_empty: "Brak zapasów zarejestrowanych w {location}. Nie ma czego przenosić.",
    move_stock_cons_blocked_ok: "OK",
    move_stock_cons_released_totes: "Zwolniono pusty pojemnik {totes} — zabierz go ze sobą",
    move_stock_complete_only: "Zakończ",
    move_stock_complete_put_away: "Zakończ i odłóż",
    // Move Stock — Tote to tote pill (2026-10-26)
    move_stock_mode_transfer: "Pojemnik do pojemnika",
    move_stock_xfer_scan_source: "Zeskanuj pojemnik źródłowy",
    move_stock_xfer_scan_items: "Zeskanuj produkty",
    move_stock_xfer_then_tote: "następnie zeskanuj pojemnik docelowy",
    move_stock_xfer_in_hand: "w ręku",
    move_stock_xfer_on_tote: "w pojemniku",
    move_stock_xfer_all_in_hand: "Wszystko w ręku — zeskanuj pojemnik docelowy",
    move_stock_xfer_nothing_in_hand: "Najpierw zeskanuj produkty do przeniesienia",
    move_stock_xfer_moved_toast: "Przeniesiono {count} szt. z {from} do {to}",
    move_stock_xfer_emptied_toast: "{from} jest pusty i zwolniony — zabierz go ze sobą",
    move_stock_xfer_cancel_title: "Anulować przenoszenie?",
    move_stock_xfer_cancel_body: "Nic nie przeniesiono. Odłożyć {count} szt. z powrotem do {from}?",
    move_stock_xfer_move_all_confirm: "Zabrać wszystko, co zostało w {from}?",
    move_stock_xfer_not_here: "Tego produktu nie ma w tym pojemniku",
    move_stock_xfer_same_tote: "To ten sam pojemnik",
    move_stock_xfer_not_awaiting: "Pojemnik nie czeka na odłożenie",
    move_stock_xfer_picked: "Pojemnik zawiera pobrane zamówienia — nie można go dzielić",
    move_stock_xfer_empty: "W tym pojemniku nie ma zarejestrowanych zapasów",
    move_stock_xfer_wrong_warehouse: "Pojemnik należy do innego magazynu",
    move_stock_xfer_category: "Pojemnik przyjęto jako {category} — kolorów nie można mieszać",
    move_stock_xfer_no_category: "bez koloru",
    move_stock_xfer_crate: "Ta skrzynia jest składowana z zapasem — użyj Przenieś, aby ją przestawić",
    move_stock_xfer_not_destination: "Ten pojemnik nie może przyjąć zapasów",
    // SKU Check workflow
    sku_check_not_found: "Nie rozpoznano kodu kreskowego",
    sku_check_sku: "SKU",
    sku_check_barcode: "Kod kreskowy",
    sku_check_supplier: "Dostawca",
    sku_check_weight: "Waga",
    sku_check_sellable: "Na sprzedaż",
    sku_check_unsellable: "Nie na sprzedaż",
    sku_check_totals: "Na sprzedaż {sellable} · Nie na sprzedaż {unsellable}",
    sku_check_no_stock: "Brak zapasów w tym magazynie",
    sku_check_no_image: "Brak zdjęcia",
    sku_check_scan_another: "Zeskanuj inny kod kreskowy",

    // Goods In › Wyszukiwarka SKU — znajdź JliPkgID dla jednego produktu w jednej ilości
    sku_finder: "Wyszukiwarka SKU",
    sku_finder_code_label: "EAN / ASIN / FNSKU",
    sku_finder_code_placeholder: "Zeskanuj lub wpisz kod",
    sku_finder_qty_label: "Posiadana ilość",
    sku_finder_search: "Szukaj",
    sku_finder_searching: "Szukanie…",
    sku_finder_result_title: "Pasująca paczka",
    sku_finder_units: "{count} szt. — nic więcej w tej paczce",
    sku_finder_print: "Drukuj kod",
    sku_finder_search_again: "Nowe wyszukiwanie",
    sku_finder_not_found: "Tego kodu nie ma w manifestach",
    sku_finder_no_package: "Żadna paczka nie zawiera dokładnie {qty} szt. tego produktu i nic więcej",
    sku_finder_failed: "Wyszukiwanie nie powiodło się — spróbuj ponownie",
    sku_finder_printer: "Drukarka",
    sku_finder_printer_online: "Drukarka połączona — dotknij, aby zmienić",
    sku_finder_printer_offline: "Brak drukarki — dotknij, aby wybrać",
    sku_finder_printed: "Etykieta wysłana do drukarki",
    sku_finder_choose_printer: "Najpierw wybierz drukarkę",
    sku_finder_asin: "ASIN",
    sku_finder_fnsku: "FNSKU",
    sku_finder_ean: "EAN",
    sku_finder_region: "Region",
    sku_finder_mode_package: "Paczka",
    sku_finder_mode_manual: "Produkty ręczne",
    // ---- Wyszukiwarka SKU › Produkty ręczne (produkty bez kodów kreskowych) ----
    manual_products: "Produkty ręczne",
    manual_products_list_label: "Lista",
    manual_products_select_list: "Wybierz listę",
    manual_products_no_lists: "Brak list — administrator tworzy je w Admin › Magazyn › Produkty ręczne",
    manual_products_search_label: "Identyfikator, kod kreskowy lub tytuł",
    manual_products_search_placeholder: "Zacznij pisać…",
    manual_products_min_chars: "Wpisz co najmniej 2 znaki",
    manual_products_no_matches: "Nic na tej liście nie pasuje",
    manual_products_more_results: "Pokazano pierwsze {count} wyników — pisz dalej, aby zawęzić",
    manual_products_supplier: "Dostawca",
    manual_products_identifier: "Identyfikator produktu",
    manual_products_barcode: "Kod kreskowy",
    manual_products_title: "Tytuł",
    manual_products_cost: "Koszt",
    manual_products_rrp: "Cena RRP",
    manual_products_weight: "Waga (g)",
    manual_products_confirm_title: "Czy to ten produkt?",
    manual_products_confirm: "Potwierdź i drukuj",
    manual_products_creating: "Tworzenie…",
    manual_products_back: "Wróć do wyników",
    manual_products_enlarge_image: "Powiększ zdjęcie",
    manual_products_created_title: "Utworzono nowe SKU",
    manual_products_print_again: "Drukuj ponownie",
    manual_products_next: "Następny produkt",
    manual_products_create_failed: "Nie udało się utworzyć SKU — spróbuj ponownie",
    manual_products_load_failed: "Nie udało się wczytać — spróbuj ponownie",
    manual_products_print_failed: "Etykieta nie została wydrukowana — użyj Drukuj ponownie",
    // ---- Admin › Magazyn › Zestawy (plan feat-bundles.md) ----
    bundles_settings: "Zestawy",
    warehouse_tile_bundles_desc: "Jedno SKU kanału rozwijane w SKU składowe na zamówieniach",
    bundles_admin_hint: "Zestaw to jedno SKU kanału (np. oferta Jobalots), które oznacza określoną liczbę sztuk jednego lub więcej SKU portalu. Zestawy to tylko definicje — SKU zestawu nigdy nie jest produktem i nie ma stanu. Gdy SKU zestawu pojawi się na zamówieniu, zamówienie otrzymuje zamiast niego SKU składowe, a zestaw jest pokazany jako oryginalne SKU każdej linii. Kompletne zestawy to liczba całych zestawów, jaką można złożyć z dostępnego stanu.",
    bundles_new: "Nowy zestaw",
    bundles_upload: "Wgraj XLSX",
    bundles_template: "Szablon",
    bundles_export: "Eksport tabeli",
    bundles_show_archived: "Pokaż zarchiwizowane",
    bundles_filter_search_hint: "Szukaj po SKU zestawu, tytule lub SKU składowym — Enter, aby zastosować",
    bundles_filter_all_warehouses: "Wszystkie magazyny",
    bundles_col_sku: "SKU zestawu",
    bundles_col_title: "Tytuł",
    bundles_col_components: "Składniki",
    bundles_col_complete: "Kompletne zestawy",
    bundles_complete_hint: "Najmniejsza wartość: dostępne ÷ ilość, dla wszystkich składników (dostępne = na stanie minus zarezerwowane, dla wybranego magazynu lub wszystkich)",
    bundles_col_jobalots: "Synchronizacja Jobalots",
    bundles_col_bargainfox: "Synchronizacja BargainFox",
    bundles_col_updated: "Zaktualizowano",
    bundles_col_by: "Utworzył",
    bundles_comp_available: "{available} dostępnych",
    bundles_edit: "Edytuj",
    bundles_archive: "Archiwizuj",
    bundles_archived: "Zarchiwizowany",
    bundles_archive_confirm: "Zarchiwizować zestaw {sku}? Zamówienia nie będą go już rozwijać. Już przyjęte zamówienia zachowują linie składowe.",
    bundles_archived_done: "Zestaw zarchiwizowany",
    bundles_no_rows: "Brak zestawów — dodaj jeden lub wgraj arkusz",
    bundles_modal_new: "Nowy zestaw",
    bundles_modal_edit: "Edytuj zestaw",
    bundles_field_sku: "SKU zestawu",
    bundles_field_sku_required: "SKU zestawu jest wymagane",
    bundles_sku_immutable_hint: "SKU zestawu nie można zmienić — zarchiwizuj ten zestaw i utwórz nowy, aby zmienić nazwę",
    bundles_field_title: "Tytuł",
    bundles_sync_jobalots: "Wysyłaj stan kompletnych zestawów do Jobalots",
    bundles_sync_bargainfox: "Wysyłaj stan kompletnych zestawów do BargainFox",
    bundles_components_title: "Składniki",
    bundles_components_required: "Dodaj co najmniej jeden składnik",
    bundles_comp_sku: "SKU portalu",
    bundles_comp_qty: "Ilość",
    bundles_comp_product: "Produkt",
    bundles_add_component: "Dodaj składnik",
    bundles_remove_component: "Usuń składnik",
    bundles_lookup: "Wyszukaj produkt",
    bundles_lookup_not_found: "To nie jest aktywny produkt",
    bundles_lookup_unavailable: "Wyszukiwanie niedostępne — sprawdzone przy zapisie",
    bundles_save: "Zapisz zestaw",
    bundles_saved: "Zestaw zapisany",
    bundles_upload_missing_columns: "W arkuszu brakuje wymaganych kolumn: {columns}",
    bundles_upload_empty: "Arkusz nie ma wierszy danych",
    bundles_upload_too_many: "Arkusz ma więcej niż {max} wierszy — podziel go na mniejsze pliki",
    bundles_upload_done: "Wgrywanie zakończone — utworzono {created} zestaw(ów), zaktualizowano {updated}",
    bundles_upload_errors: "Odrzucono {count} zestaw(ów) — pierwszy: {sku} (wiersz {row}): {message}",
    bundles_upload_failed: "Wgrywanie nie powiodło się — sprawdź plik i spróbuj ponownie",
    // ---- Admin › Magazyn › Produkty ręczne ----
    manual_products_settings: "Produkty ręczne",
    warehouse_tile_manual_products_desc: "Listy bez kodów, wydruki SKU, eksporty",
    manual_products_admin_hint: "Każda lista to arkusz produktów bez kodów kreskowych (dostawca, identyfikator produktu, kod kreskowy, tytuł, URL obrazu, koszt, RRP, waga). Wyszukiwarka SKU › Produkty ręczne przeszukuje listę i drukuje nowe unikalne SKU dla produktu w ręku; każdy wydruk to jeden wiersz poniżej i jeden produkt w portalu.",
    manual_products_lists_title: "Listy",
    manual_products_new_list: "Nowa lista",
    manual_products_list_name_placeholder: "Nazwa listy",
    manual_products_create_list: "Utwórz",
    manual_products_upload: "Wgraj XLSX",
    manual_products_template: "Szablon",
    manual_products_archive: "Archiwizuj",
    manual_products_archived: "Zarchiwizowana",
    manual_products_rows: "{count} wierszy",
    manual_products_skus: "{count} SKU",
    manual_products_upload_done: "{inserted} dodano, {updated} zaktualizowano",
    manual_products_upload_errors: "{count} wierszy odrzucono (pierwszy: wiersz {row} — {message})",
    manual_products_upload_missing_columns: "Brak kolumn: {columns}",
    manual_products_upload_empty: "Plik nie zawiera wierszy",
    manual_products_upload_failed: "Wgrywanie nie powiodło się",
    manual_products_list_created: "Lista utworzona",
    manual_products_list_exists: "Lista o tej nazwie już istnieje",
    manual_products_list_archived_done: "Lista zarchiwizowana",
    manual_products_archive_confirm: "Zarchiwizować tę listę? Zniknie z Wyszukiwarki SKU; jej wiersze i wydrukowane SKU zostaną zachowane.",
    manual_products_view_rows: "Pokaż wiersze",
    manual_products_rows_title: "Wiersze listy {name}",
    manual_products_rows_search: "Szukaj wierszy",
    manual_products_rows_empty: "Nie wgrano jeszcze wierszy",
    manual_products_col_id: "ID",
    manual_products_col_date: "Data",
    manual_products_col_warehouse: "Magazyn",
    manual_products_col_sku: "SKU",
    manual_products_col_list: "Lista",
    manual_products_col_supplier: "Dostawca",
    manual_products_col_identifier: "ID produktu",
    manual_products_col_barcode: "Kod kreskowy",
    manual_products_col_title: "Tytuł",
    manual_products_col_image: "Obraz",
    manual_products_col_cost: "Koszt",
    manual_products_col_rrp: "RRP",
    manual_products_col_weight: "Waga (g)",
    manual_products_col_by: "Przez",
    manual_products_filter_search_hint: "Szukaj SKU, identyfikatora, kodu, tytułu, dostawcy…",
    manual_products_filter_all_warehouses: "Wszystkie magazyny",
    manual_products_filter_all_suppliers: "Wszyscy dostawcy",
    manual_products_filter_all_lists: "Wszystkie listy",
    manual_products_no_rows: "Brak produktów ręcznych",

    // Pick face — pre-picker shelf-replenishment hub
    pick_face: "Strefa kompletacji",
    shelf_drop: "Uzupełnianie półek",
    forecast_drop: "Uzupełnianie prognozowane",
    pick_queue: "Kolejka kompletacji",

    // Picking — picker-facing UI
    picking_count_ready: "{count} gotowych",
    picking_card_items: "Sztuk",
    picking_card_orders: "Zamówień",
    picking_card_next_wave: "Następna fala",
    picking_card_ready: "Gotowe:",
    picking_card_suggested: "Sugerowane",
    // Pick Advisor (2026-10-02): przełącznik Sugerowane + widok jednej karty
    picking_suggested_toggle: "Sugerowane",
    picking_suggested_toggle_hint: "Pokaż tylko kompletację zalecaną przez Portal. Wyłącz, aby wybrać coś innego.",
    picking_suggested_badge: "Sugerowane dla Ciebie",
    picking_suggested_includes_put_wall: "Zawiera zamówienia Putwall",
    picking_suggested_none_title: "Teraz nie ma nic do kompletacji",
    picking_suggested_none_body: "Zapytaj lidera zespołu, co robić dalej.",
    picking_suggested_show_all: "Pokaż wszystkie",
    picking_suggested_fallback: "Nie udało się uruchomić sugerowanej kompletacji — pokazuję wszystkie",
    picking_filter_age_aria: "Wiek zamówienia",
    picking_filter_delivery_aria: "Rodzaj dostawy",
    filter_shipping_state_aria: "Stan wysyłki",
    filter_unshipped: "Niewysłane",
    filter_due_today: "Do wysłania dziś",
    picking_filter_channel_label: "Kanał sprzedaży",
    picking_filter_channel_all: "Wszystkie kanały",
    picking_filter_all: "Wszystko",
    picking_filter_express_label: "Zamówienia ekspresowe i priorytetowe",
    picking_filter_standard_label: "Zamówienia standardowe",
    picking_filter_lt1: "<1",
    picking_filter_1to2: "1–2",
    picking_filter_2_plus: "2+",
    picking_filter_custom: "Własny",
    picking_filter_custom_from: "Od",
    picking_filter_custom_to: "Do",
    picking_filter_custom_from_time: "Godzina od",
    picking_filter_custom_to_time: "Godzina do",
    picking_filter_custom_done: "Gotowe",
    picking_filter_custom_clear: "Wyczyść",
    picking_filter_due_today: "Do wysłania dziś",
    picking_pick_disabled: "Wkrótce",
    picking_starting: "Uruchamianie fali…",
    picking_no_orders_to_pick: "Brak zamówień do kompletacji",
    picking_already_active_wave: "Najpierw zakończ aktywną falę",
    picking_start_failed: "Nie można uruchomić fali",
    picking_start_conflict: "Nie można uruchomić — poprzednia fala pozostawiła sprzeczne dane. Zwolnij zablokowane/wstrzymane fale i spróbuj ponownie.",
    picking_label_location: "Lokalizacja",
    picking_label_sku: "SKU",
    picking_label_qty: "Ilość",
    picking_sub_scan_location: "ZESKANUJ LOKALIZACJĘ",
    picking_sub_scan_items: "ZESKANUJ PRZEDMIOT",
    picking_sub_scan_items_one: "ZESKANUJ PRZEDMIOT",
    picking_sub_scan_tote: "ZESKANUJ POJEMNIK",
    picking_sub_scan_york: "ZESKANUJ YORK",
    picking_sub_scan_tote_next_order: "NOWE ZAMÓWIENIE SKANUJ POJEMNIK",
    picking_sub_scan_resume_tote: "ZESKANUJ POJEMNIK {tote}, ABY WZNOWIĆ",
    picking_scan_resume_tote_first: "Zeskanuj pojemnik {tote}, aby wznowić falę",
    picking_sub_scan_first_tote: "ZESKANUJ POJEMNIK",
    picking_wrong_location: "Zła lokalizacja",
    picking_wrong_item: "Przedmiotu nie ma w tej lokalizacji",
    picking_unknown_barcode: "Nierozpoznany kod kreskowy",
    picking_scan_rejected: "Skan odrzucony",
    picking_sync_wait: "Synchronizacja — zeskanuj ponownie za chwilę",
    picking_sync_pending_banner: "{count} skanów niezsynchronizowanych — zapisane na urządzeniu. Skanuj dalej, wyślą się automatycznie.",
    picking_sync_offline_banner: "Brak połączenia — skany będą zapisywane na urządzeniu.",
    picking_wave_interrupted: "Ta fala nie jest już aktywna — mogła zostać wstrzymana. Powrót do listy kompletacji.",
    picking_unknown_tote: "Nieznany pojemnik",
    picking_tote_unavailable: "Pojemnik niedostępny",
    picking_tote_in_use_elsewhere: "Pojemnik już otwarty w innej fali",
    picking_tote_held_by_picker: "Pojemnik trzymany przez {picker} w fali #{wave}",
    picking_tote_held_by_drop_picker: "Pojemnik trzymany przez {picker} w sesji Drop",
    picking_tote_held_by_drop: "Pojemnik trzymany przez trwającą sesję Drop",
    picking_tote_swapped: "Pakowanie do pojemnika {tote}",
    picking_tote_already_open: "Pojemnik {tote} jest już w użyciu",
    picking_open_tote_label: "Aktualnie otwarty pojemnik",
    // Szacowana liczba wózków klatkowych (kompletacja Duża).
    picking_roll_cages_count: "Wózki klatkowe: {count}",
    picking_roll_cages_unknown: "Nieznana liczba wózków",
    picking_roll_cages_missing_one: "1 przedmiot bez wymiarów",
    picking_roll_cages_missing: "Przedmioty bez wymiarów: {count}",
    picking_orders_added: "Do twojej fali dodano {count} nowych zamówień",
    picking_sub_scan_starting_location: "ZESKANUJ LOKALIZACJĘ",
    picking_next_order_scan_location: "NOWE ZAMÓWIENIE SKANUJ LOKALIZACJĘ",
    picking_anchor_done: "Gotowe",
    picking_york_order_complete: "Zamówienie gotowe",
    picking_york_fill_question: "Jak pełny jest Twój york?",
    picking_york_fill_empty: "Pusty",
    picking_york_fill_quarter: "1/4 pełny",
    picking_york_fill_half: "1/2 pełny",
    picking_york_fill_three_quarters: "3/4 pełny",
    picking_york_fill_full: "4/4 pełny",
    picking_york_nothing_fits: "Nic już się nie zmieści",
    picking_york_drop_off: "Odstaw york",
    picking_york_drop_zone: "Strefa odstawiania",
    picking_york_bring_empty: "Przywieź pusty york",
    picking_york_dropped: "York odstawiony",
    picking_anchor_back: "Wstecz",
    picking_anchor_no_orders: "Brak kolejnych zamówień do kompletacji",
    picking_invalid_starting_location: "Ten kod kreskowy to nie lokalizacja magazynowa",
    picking_scan_starting_location_first: "Zeskanuj swoją aktualną lokalizację, aby rozpocząć",
    picking_scan_location_first: "Najpierw zeskanuj lokalizację",
    picking_scan_tote_first: "Najpierw zeskanuj pojemnik",
    picking_scan_york_first: "Najpierw zeskanuj york",
    picking_wave_complete: "Fala ukończona",
    picking_tote_open: "Pojemnik otwarty",
    picking_tote_closed: "Pojemnik zamknięty",
    picking_tote_reopen: "Pojemnik ponownie otwarty",
    picking_progress: "{picked}/{total} skompletowane",

    // Missing-item flow
    picking_missing_btn: "Brak przedmiotu",
    picking_missing_title: "Inwentaryzacja",
    picking_missing_cmd_scan_loc: "ZESKANUJ LOKALIZACJĘ",
    picking_missing_cmd_scan_items: "ZESKANUJ PRZEDMIOT",
    picking_missing_done: "Zakończ liczenie",
    picking_missing_done_found: "Znaleziono — zakończ liczenie",
    picking_missing_cancel: "Anuluj",
    picking_missing_surplus_title: "Nieoczekiwane w tej lokalizacji",
    picking_missing_surplus_body: "{sku} nie jest zarejestrowane w tej lokalizacji. Dodać do stanu tej lokalizacji?",
    picking_missing_extra_unit_title: "Znaleziono dodatkową sztukę",
    picking_missing_extra_unit_body: "Policzono więcej {sku}, niż jest zarejestrowane w tej lokalizacji. Dodać kolejną sztukę do stanu?",
    picking_missing_wrong_location: "Zła lokalizacja do liczenia",
    picking_missing_unknown_barcode: "Nieznany przedmiot",
    picking_missing_section_target: "Szukamy",
    picking_missing_section_others: "Inne w tej lokalizacji",
    picking_missing_took_over: "Przejęto kontrolę stanu tej lokalizacji od {name}",
    picking_missing_pick_relevant: "{sku} jest na Twojej liście zbiórki — {location}",
    picking_missing_relevant_heading: "Na Twojej liście zbiórki",
    picking_missing_relevant_at: "Potrzebne {count} w {location}",
    picking_missing_count_label: "{count}",
    picking_missing_starting: "Rozpoczynanie…",
    picking_missing_finishing: "Rozwiązywanie…",
    picking_missing_loc_required_pre: "ZESKANUJ LOKALIZACJĘ",

    // Bramka lokalizacji (krok 1)
    picking_missing_gate_looking_for: "Szukamy {count} x {sku}",
    picking_missing_gate_why: "Zeskanuj etykietę lokalizacji, aby rozpocząć liczenie",

    // Potwierdzenie zakończenia (krok 3)
    picking_missing_confirm_title: "Zakończ liczenie",
    picking_missing_confirm_found: "Znaleziono {count} x {sku}",
    picking_missing_confirm_found_next: "Przedmiot wraca na Twoją listę zbiórki — zeskanuj go teraz do pojemnika.",
    picking_missing_confirm_not_found: "Znaleziono {count} z {required} x {sku}",
    picking_missing_confirm_not_found_next: "Poszukamy stanu w innej lokalizacji. Jeśli go nie ma, przedmiot zostanie oznaczony jako brakujący dla wysyłki.",
    picking_missing_confirm_others_body: "Nie znaleziono {count} innych przedmiotów w {location}. Usunąć je z tej lokalizacji?",
    picking_missing_confirm_keep_counting: "Licz dalej",
    picking_missing_confirm_keep_others: "Zostaw resztę bez zmian",
    picking_missing_confirm_remove_others: "Usuń {count} z lokalizacji",
    picking_missing_confirm_finish: "Zakończ liczenie",

    // Ekran wyniku (krok 4)
    picking_missing_res_found_title: "Znaleziono",
    picking_missing_res_found_body: "Zbierz teraz {count} x {sku} z {location}.",
    picking_missing_res_elsewhere_title: "Nie ma w tym pudełku",
    picking_missing_res_elsewhere_next: "Idź do {location} — to Twój następny przystanek.",
    picking_missing_res_elsewhere_later: "Dodano do Twojej trasy w {location}.",
    picking_missing_res_elsewhere_note: "Stan znaleziono w innej lokalizacji, więc nic nie brakuje.",
    picking_missing_res_kept_here: "Znaleziono tu {count} x {sku} — zbierz je, zanim pójdziesz dalej.",
    picking_missing_res_notfound_title: "Brak stanu w magazynie",
    picking_missing_res_notfound_body: "{sku} nie jest dostępne w tym magazynie — kontynuuj zbiórkę.",
    picking_missing_res_notfound_dispatch: "Oznaczono {count} szt. w {orders} zamówieniach jako brakujące dla wysyłki.",
    picking_missing_res_notfound_dispatch_none: "Oznaczono jako brakujące dla wysyłki.",
    picking_missing_res_notfound_review: "{count} zamówień nie ma nic do wysłania — oznaczono dla kierownika.",
    picking_missing_res_continue: "Kontynuuj zbiórkę",
    picking_missing_res_finish_wave: "Zakończ falę",

    // Przepływ brakującego przedmiotu w Drop (przycisk flagi w shelf/forecast
    // drop). Bramka, lista liczenia i potwierdzenie używają kluczy
    // picking_missing_* — różni się tylko karta wyniku.
    drop_missing_res_found_title: "Znaleziono",
    drop_missing_res_found_body: "Policzono {count} x {sku} — stany się zgadzają. Lokalizacja pozostaje na trasie.",
    drop_missing_res_short_title: "Brak w lokalizacji",
    drop_missing_res_short_body: "Znaleziono {count} z {required} x {sku}. Stany magazynowe zostały poprawione.",
    drop_missing_res_written_off: "Usunięto {count} szt. z ewidencji tej lokalizacji.",
    drop_missing_res_continue: "Kontynuuj",

    // Ujednolicony ekran zbierania (redesign 054)
    priority_high: "WYS",
    priority_medium: "ŚR",
    priority_low: "NISKI",
    picking_items_unit: "szt.",
    picking_scan_location_label: "Zeskanuj lokalizację",
    picking_scan_item_label: "Zeskanuj przedmiot",
    picking_pick_speed_label: "Tempo",
    picking_qty_remaining: "Pozostała ilość",
    picking_show_product_image: "Pokaż zdjęcie produktu",
    picking_show_product_image_hint: "Pokazuje miniaturę zdjęcia obok SKU i ilości. Wyłącz, aby uzyskać gęstszy nagłówek bez zdjęcia.",
    picking_other_skus_count: "Wierszy „Sztuki w tej lokalizacji”",
    picking_other_skus_count_hint: "Ile innych SKU pokazać, gdy więcej niż jedna otwarta linia znajduje się w tej samej lokalizacji. 0 ukrywa panel; maks. 10. Pozostałe są łączone w „+N więcej”.",
    picking_location_change_ms: "Ekran zmiany lokalizacji",
    picking_location_change_ms_hint: "Jak długo (w milisekundach) pełnoekranowy komunikat „nowa lokalizacja” pozostaje widoczny, gdy picker kończy lokalizację, a następna pozycja jest gdzie indziej. Domyślnie 2000 ms; 0 wyłącza komunikat (pomarańczowe podświetlenie na ekranie kompletacji nadal się pokazuje).",
    picking_new_location_highlight_ms: "Podświetlenie nowej lokalizacji",
    picking_new_location_highlight_ms_hint: "Jak długo pomarańczowe podświetlenie „nowa lokalizacja” (wstążka i przebarwiony kod lokalizacji) pozostaje na ekranie kompletacji po zniknięciu komunikatu pełnoekranowego. Domyślnie 6000 ms; 0 wyłącza podświetlenie (komunikat pełnoekranowy nadal się pokazuje).",
    picking_new_location_title: "Nowa lokalizacja",
    picking_new_location_ribbon: "Nowa lokalizacja — zmiana miejsca",
    picking_new_location_was: "poprzednio {location}",
    picking_units_at_location: "Sztuki w tej lokalizacji",
    picking_also_more: "+{n} więcej",
    picking_aisle_units_title: "Sztuki do pobrania wg alejki",
    picking_aisle_units_total: "Pozostało: {n}",
    picking_aisle_units_chip: "Alejka {aisle}: pozostało {n} szt.",
    picking_aisle_units_here: "tutaj",
    picking_aisle_units_btn: "Sztuki do pobrania wg alejki",
    picking_aisle_units_hint: "Do pobrania",
    picking_aisle_location_units: "{location}: pozostało {n} szt.",
    picking_aisle_tap_hint: "Dotknij lokalizacji, aby pobierać z niej jako następnej",
    picking_aisle_jump_label: "Pobieraj z {location} jako następnej",
    picking_last_picked_label: "Ostatnio pobrane",
    drop_last_dropped_label: "Ostatnio zrzucone",
    put_away_last_put_away: "Ostatnio odłożone",
    picking_unit_skus: "SKU",

    // Manual pick — awaryjne pobranie, gdy kod kreskowy nie daje się
    // zeskanować (fale pobrań + shelf/forecast drop).
    picking_manual_btn: "Kod kreskowy nie działa?",
    picking_manual_title: "Ręczne pobranie",
    picking_manual_hint: "Potwierdź ilość, którą pobierasz. Używaj tylko wtedy, gdy kodu kreskowego nie da się zeskanować.",
    picking_manual_qty_label: "Ilość do pobrania",
    picking_manual_max: "Maks. {max}",
    picking_manual_confirm: "Potwierdź pobranie",
    picking_manual_stale: "Ten produkt nie jest już bieżącym pobraniem — sprawdź ekran i spróbuj ponownie.",
    picking_manual_qty_invalid: "Ilość przekracza pozostałą do pobrania.",

    // Inne kody kreskowe — żółty "+" na ciemnym pasku, gdy produkt ma
    // więcej kodów niż ten wyświetlany; dotknięcie otwiera pełną listę.
    picking_alt_barcodes_btn: "Pokaż inne kody kreskowe",
    picking_alt_barcodes_title: "Inne kody kreskowe",
    picking_alt_barcodes_hint: "Ten produkt można też zeskanować dowolnym z tych kodów kreskowych.",

    // Pause / resume
    picking_pause_btn: "Pauza",
    picking_paused_section: "Wstrzymane fale",
    picking_paused_meta: "{picked}/{total} pobrane",
    picking_paused_by: "wstrzymane przez {name}",
    picking_paused_unknown_by: "wstrzymane {ago}",
    picking_paused_resume: "Wznów",
    // Fale w parach (Alex, 2026-10-16): dwóch kompletatorów na jednej fali.
    picking_segment_badge: "Segment {no} z {of}",
    picking_segment_sibling_on: "{name} na {no}",
    picking_segment_sibling_waiting: "druga połowa czeka na kompletatora",
    picking_join_title: "Dołącz: {type}",
    picking_join_meta: "{lines} linii · {items} szt.",
    picking_join_started_by: "zaczął {name} {ago}",
    picking_join_started_by_short: "z {name}",
    picking_join_started: "zaczęta {ago}",
    picking_join_cta: "Dołącz",
    picking_join_lines: "linii",
    picking_pair_toggle: "Kompletuj w parze",
    picking_pair_toggle_hint: "Podziel następną falę Sortowania lub Putwall między dwóch kompletatorów: Ty bierzesz pierwszą połowę, druga trafia na kartę „Dołącz” dla każdego.",
    picking_pair_single_aisle: "Ta fala to jedna alejka, więc wystartowała jako zwykła fala",
    picking_pair_too_small: "Ta fala ma {units} sztuk lub mniej, więc wystartowała jako zwykła fala",
    picking_suggested_as_pair: "W parze — druga połowa trafi na kartę „Dołącz”",
    picking_pause_failed: "Nie można wstrzymać",
    picking_resume_failed: "Nie można wznowić",
    picking_resume_already_active: "Najpierw zakończ aktywną falę",
    picking_resume_already_claimed: "Przejęte przez innego kompletatora",
    picking_auto_paused_toast: "Fala wstrzymana po {minutes} min bezczynności",

    // Close wave (Singles only) — Pause tap opens the choice
    picking_pause_or_close_title: "Wstrzymać czy zamknąć falę?",
    picking_pause_or_close_hint: "Pauza zachowuje wszystkie zamówienia na tej fali do późniejszego wznowienia. Zamknij falę kończy tutaj: pobrane zamówienia idą do wysyłki, a pozostałe wracają do kolejki kompletacji dla każdego.",
    picking_pause_choice_sub: "Zachowaj wszystkie zamówienia na tej fali",
    picking_close_wave_btn: "Zamknij falę",
    picking_close_choice_sub: "Odeślij niepobrane zamówienia do kolejki",
    picking_close_loading: "Sprawdzanie zamówień…",
    picking_close_title: "Zamknąć tę falę?",
    picking_close_done_line: "{count} pobranych zamówień idzie do wysyłki",
    picking_close_untouched_line: "{count} nierozpoczętych zamówień wraca do kolejki kompletacji",
    picking_close_confirm: "Zamknij falę",
    picking_close_keep: "Kontynuuj kompletację",
    picking_close_blocked_title: "Najpierw dokończ te zamówienia",
    picking_close_blocked_body: "Te zamówienia są częściowo pobrane — ich pozycje są już w Twoim pojemniku. Pobierz resztę każdego z nich, a potem zamknij falę.",
    picking_close_blocked_row: "{picked}/{total} pobrane",
    picking_close_done_toast: "Fala zamknięta — {count} zamówień wróciło do kolejki kompletacji",
    picking_close_released_toast: "Fala zamknięta — nic nie pobrano, wszystkie {count} zamówień wróciło do kolejki kompletacji",
    picking_close_failed: "Nie można zamknąć fali",
    picking_ago_minutes: "{m} min temu",
    picking_ago_hours: "{h} h temu",
    picking_ago_just_now: "przed chwilą",

    // Lanes admin
    lanes_settings: "Pasy",
    lanes_warehouse_filter: "Magazyn",
    lanes_refresh: "Odśwież",
    lanes_empty: "Brak pasów w tym magazynie",
    lanes_col_zone: "Strefa",
    lanes_col_lane: "Pas",
    lanes_col_status: "Status",
    lanes_col_num_totes: "Liczba pojemników",
    lanes_col_num_auctions: "Liczba aukcji",
    lanes_col_auction_end_date: "Data zakończenia aukcji",
    lanes_col_totes: "Pojemniki",
    lanes_col_auctions: "Aukcje",
    lanes_col_end: "Data zakończenia aukcji",
    lanes_view_table: "Tabela",
    lanes_view_floor: "Plan",
    lanes_view_floor_coming_soon: "Widok planu — wkrótce",
    lanes_stale: "Nieaktualne",
    lanes_demo_data: "Dane testowe",
    lanes_filter_chip_prefix: "Filtr",
    lanes_clear_filter: "Wyczyść filtr",
    lanes_kpi_total: "Wszystkie pasy",
    lanes_kpi_on_auction: "Na aukcji",
    lanes_kpi_closing_today: "Kończą się dziś",
    lanes_kpi_outbound: "Wychodzące",
    lanes_kpi_idle: "Puste",
    lanes_kpi_unprocessed: "Nieprzetworzone",
    lanes_status_lane_empty: "Pas pusty",
    lanes_status_greens: "Zielone",
    lanes_status_oranges: "Pomarańczowe",
    lanes_status_pinks: "Różowe",
    lanes_status_greys: "Szare",
    lanes_status_greens_outbound: "Zielone — wysyłka",
    lanes_status_oranges_outbound: "Pomarańczowe — wysyłka",
    lanes_status_apc: "APC",
    lanes_status_auction_pallets_outbound: "Palety aukcyjne — wysyłka",
    lanes_status_ready_for_auction: "Gotowe do aukcji",
    lanes_status_auctions_filling: "Aukcje – napełnianie",
    lanes_status_on_auction: "Na aukcji",
    lanes_status_auctions_ended: "Aukcje zakończone",
    lanes_status_unprocessed_stock: "Towar nieprzetworzony",
    lanes_zone_label: "Strefa",
    lanes_zone_lanes_suffix: "pasów",
    lanes_zone_busy: "zajęte",
    lanes_zone_idle: "puste",
    lanes_zone_unprocessed: "nieprzetworzone",
    lanes_drawer_close: "Zamknij",
    lanes_drawer_closes_prefix: "Kończy się",
    lanes_status_locked: "Status zablokowany",
    lanes_status_locked_hint: "Pasa z pojemnikami lub aukcjami nie można zmienić ręcznie. Status odblokuje się, gdy pas będzie pusty.",
    lanes_drawer_stat_totes: "Pojemniki",
    lanes_drawer_stat_auctions: "Aukcje",
    lanes_drawer_stat_walk: "Nr trasy",
    lanes_drawer_active_auctions: "Aktywne aukcje",
    lanes_drawer_totes_on_lane: "Pojemniki na pasie",
    lanes_drawer_no_auctions: "Brak aktywnych aukcji na tym pasie.",
    lanes_drawer_no_totes: "Brak zaparkowanych pojemników.",
    lanes_drawer_lots_suffix: "loty",
    lanes_drawer_print: "Drukuj etykietę pasa",
    lanes_drawer_open_in_locations: "Otwórz w Lokalizacjach",

    // Ustawienia pasów (edytor palety w /admin/settings)
    lanes_colours_section: "Pasy",
    lanes_colours_hint: "Wybierz kolor podstawowy dla każdego statusu pasa. Tło, obramowanie i kolor tekstu pigułki są wyznaczane automatycznie. Zmiany pojawią się na każdym urządzeniu przy następnym wczytaniu.",
    lanes_colours_reset_all: "Przywróć wszystko do domyślnych",
    lanes_colours_reset: "Przywróć",
    lanes_colours_col_status: "Status",
    lanes_colours_col_colour: "Kolor",
    lanes_cfg_hint: "Skonfiguruj każdy status pasa: jego etykietę, kafelek podsumowania, do którego się wlicza, pola, które przenosi, oraz kolor pigułki. Zmiany pojawią się na każdym urządzeniu przy następnym wczytaniu.",
    lanes_cfg_label_en: "Etykieta (angielski)",
    lanes_cfg_label_pl: "Etykieta (polski)",
    lanes_cfg_category: "Kategoria",
    lanes_cfg_applies: "Dotyczy",
    lanes_cfg_flag_totes: "Pojemniki",
    lanes_cfg_flag_auctions: "Aukcje",
    lanes_cfg_flag_end_date: "Data zakończenia aukcji",
    lanes_cfg_cat_auction: "Na aukcji",
    lanes_cfg_cat_outbound: "Wychodzące",
    lanes_cfg_cat_stock: "Towar",
    lanes_cfg_cat_idle: "Pusty",
    lanes_cfg_cat_unprocessed: "Nieprzetworzone",
    lanes_cfg_cat_none: "Brak",

    // Locations admin
    locations_settings: "Lokalizacje",
    locations_settings_panel: "Lokalizacje",
    locations_settings_hint: "Wgraj arkusz XLSX z kolumnami: action, warehouse, zone, aisle, bay, level, walk_order, size, high_low, temperature, barcode, name, sellable. Barcode jest wartością skanowaną. Temperature to 1–10 (1=zimno, 10=gorąco). Sellable decyduje, czy stan w tej lokalizacji jest synchronizowany z kanałami sprzedaży.",
    locations_total_label: "Liczba lokalizacji",
    locations_upload_xlsx: "Wgraj XLSX",
    locations_upload_empty: "Arkusz jest pusty",
    locations_upload_bad_header: "Arkusz musi mieć kolumny action i barcode",
    locations_upload_parse_error: "Nie można odczytać arkusza — upewnij się, że to prawidłowy plik .xlsx",
    locations_col_zone: "Strefa",
    locations_col_barcode: "Kod kreskowy",
    locations_col_aisle: "Aleja",
    locations_col_bay: "Boks",
    locations_col_level: "Poziom",
    locations_col_name: "Nazwa",
    locations_col_walk_order: "Kol. #",
    locations_col_size: "Rozmiar",
    locations_col_high_low: "Góra/Dół",
    locations_col_temperature: "Temp.",
    locations_col_sellable: "Sprzedawalne",
    locations_col_shelf_drop: "Uzupełnianie półek",
    locations_value_sellable: "Sprzedawalne",
    locations_value_unsellable: "Niesprzedawalne",
    locations_value_high: "Góra",
    locations_value_low: "Dół",
    locations_search_placeholder: "Szukaj lokalizacji…",
    locations_search_hint: "Szukaj lokalizacji (Enter; dodaj * dla dokładnego dopasowania)",
    locations_filter_all_warehouses: "Wszystkie magazyny",
    locations_filter_all_types: "Wszystkie typy",
    locations_filter_all_sizes: "Wszystkie rozmiary",
    locations_filter_all_high_low: "Wszystkie góra/dół",
    locations_download_filtered: "Pobierz filtrowane ({n})",
    locations_print_labels: "Drukuj etykiety ({n})",
    locations_print_labels_aria: "Drukuj etykiety regałów dla przefiltrowanych lokalizacji",
    locations_print_pick_warehouse: "Aby drukować etykiety regałów, przefiltruj do jednego magazynu",
    locations_print_labels_title: "Drukuj etykiety regałów — {warehouse}",
    locations_print_labels_hint: "Lista {count} lokalizacji regałowych (wysokie/niskie) z bieżącego filtra — zaznacz te do wydruku. Etykiety drukują się na etykietach ustawionych dla {warehouse}. Wzór regałowy drukuje alejkę, zatokę na czarnym tle, poziom i kod kreskowy — jak na etykietach już naklejonych na regałach. Wzory sortowania drukują zamiast tego miejsce w zatoce.",

    // Location types admin (Settings > Locations)
    locations_types_settings: "Typy lokalizacji",
    locations_types_settings_hint: "Zarządzaj wartościami typów dostępnymi w rozwijanej liście Typ w panelu Lokalizacje oraz akceptowanymi przy zbiorczym imporcie. Typ można usunąć tylko, gdy nie korzystają z niego żadne aktywne lokalizacje ani zapasy.",
    locations_type_in_use: "{locations} lokalizacji · {inventory} pozycji zapasów",
    locations_no_types_yet: "Nie zdefiniowano jeszcze typów — dodaj poniżej.",
    locations_type_name_placeholder: "np. storage, lane, area, pallet",
    locations_type_add: "Dodaj typ",
    locations_type_exists: "Typ o tej nazwie już istnieje",
    locations_type_invalid: "Nazwa typu może zawierać tylko małe litery, cyfry, '-' lub '_'",
    locations_type_remove_title: "Usunąć typ?",
    locations_type_remove_body: "Usuń „{name}” z katalogu typów.",
    locations_type_remove_blocked: "{locations} lokalizacji i {inventory} pozycji zapasów nadal używa tego typu — usuń je najpierw.",
    locations_type_remove_blocked_title: "Typ jest używany — wyczyść lokalizacje i zapasy przed usunięciem.",
    locations_type_remove_in_use_block: "Typ jest nadal używany — odśwież i spróbuj ponownie.",
    locations_type_remove_hint: "Typ możesz dodać ponownie w dowolnym momencie.",

    // Location sizes admin (Settings > Locations)
    locations_sizes_settings: "Rozmiary lokalizacji",
    locations_sizes_settings_hint: "Zarządzaj etykietami rozmiarów dostępnymi w rozwijanej liście Rozmiar w panelu Lokalizacje. Usunięcie rozmiaru pozostawia istniejące lokalizacje bez zmian, ale wartość nie będzie już do wyboru.",
    locations_size_in_use: "Używane przez {count} lokalizacji",
    locations_no_sizes_yet: "Nie zdefiniowano jeszcze żadnych rozmiarów — dodaj poniżej.",
    locations_size_name_placeholder: "np. Mały, Średni, Duży",
    locations_size_add: "Dodaj rozmiar",
    locations_size_exists: "Rozmiar o tej nazwie już istnieje",
    locations_size_remove_title: "Usunąć rozmiar?",
    locations_size_remove_body: "Usuń „{name}” z katalogu rozmiarów.",
    locations_size_remove_in_use: "{count} lokalizacji obecnie używa tego rozmiaru — zachowają wartość, ale nie będzie ona dostępna do wyboru.",
    locations_size_remove_blocked_title: "Rozmiar jest używany — usuń go z lokalizacji przed usunięciem.",
    locations_size_remove_hint: "Możesz dodać rozmiar ponownie w dowolnym momencie.",
    locations_no_matches: "Brak lokalizacji pasujących do filtrów",
    locations_showing_n_of_total: "Pokazano {n} z {total}",
    locations_showing_range: "Pokazano {from}–{to} z {total}",
    locations_show_more: "Pokaż więcej",
    pagination_previous: "Poprzednia",
    pagination_next: "Następna",
    pagination_page_x_of_y: "Strona {page} z {total}",
    per_page: "Na stronę",
    filter_country_all: "Wszystkie {country}",
    select_all_visible: "Zaznacz wszystkie na tej stronie",
    select_row: "Zaznacz wiersz",
    selected_count: "Zaznaczono: {n}",
    change_status_to: "Zmień status na…",
    apply: "Zastosuj",
    bulk_status_summary: "Zaktualizowano {n} zamówień do statusu {status}",
    bulk_release_consolidated: "{n} zwolnionych połączono w skonsolidowaną przesyłkę {masters}",

    // Ręczna realizacja — potwierdzenie (Zamówienia → Zmień status na → Zrealizowane)
    manual_fulfil_title_one: "Oznaczyć to zamówienie jako zrealizowane?",
    manual_fulfil_title: "Oznaczyć zamówienia ({n}) jako zrealizowane?",
    manual_fulfil_body: "Spowoduje to zużycie rezerwacji stanu i poinformowanie kanału sprzedaży o wysyłce. Można to cofnąć, zmieniając status z powrotem, ale tylko przed wysłaniem powiadomienia do kanału.",
    manual_fulfil_add_tracking: "Dodaj dane śledzenia",
    manual_fulfil_filled_count: "wypełniono: {n}",
    manual_fulfil_tracking_hint: "Opcjonalne. Wprowadzone dane zostaną zapisane na zamówieniu i wysłane do kanału sprzedaży razem z realizacją.",
    manual_fulfil_tracking_link: "Link do śledzenia",
    manual_fulfil_carrier_placeholder: "np. Royal Mail",
    manual_fulfil_code_placeholder: "np. AB123456789GB",
    manual_fulfil_bad_link: "Link do śledzenia musi zaczynać się od http:// lub https://.",
    manual_fulfil_confirm: "Oznacz jako zrealizowane",

    // Lokalizacje — usuwanie miękkie
    delete: "Usuń",
    deleting: "Usuwanie…",
    locations_delete_title: "Usunąć lokalizację?",
    locations_delete_body: "Ukryj „{barcode}” z listy lokalizacji i skanów operacyjnych.",
    locations_delete_hint: "Wiersz pozostaje w bazie danych — przywrócenie wymaga ręcznej akcji.",
    locations_deleted_toast: "Usunięto {barcode}",

    // Lokalizacje — okno edycji (kliknięcie wiersza)
    locations_edit_title: "Edytuj lokalizację",
    locations_row_click_hint: "Kliknij, aby edytować",
    locations_col_bay_position: "Pozycja w regale",
    locations_bay_position_none: "Bez schematu",
    locations_edit_hint: "Pozostaw pole puste, aby wyczyścić tę wartość.",
    locations_edit_barcode_superadmin: "Tylko super administrator może zmienić kod kreskowy.",
    locations_edit_barcode_rename_warning: "Zmiana kodu kreskowego przenosi cały zapas, pojemniki, kompletacje i historię tej lokalizacji na nowy kod. Wydrukuj potem nową etykietę.",
    locations_renamed_toast: "Zmieniono {from} na {to}",
    locations_add_button: "Dodaj lokalizację",
    locations_add_title: "Nowa lokalizacja",
    locations_add_barcode_placeholder: "Zostaw puste, aby wygenerować",
    locations_add_hint: "Zostaw kod kreskowy pusty, aby wygenerować go automatycznie. Wymagane są tylko magazyn i typ.",
    locations_add_submit: "Dodaj",
    locations_added_toast: "Dodano {barcode}",
    locations_edit_required: "Pole „{field}” jest wymagane",
    locations_updated_toast: "Zapisano {barcode}",

    // Conveyor
    collect: "Zbierz",
    add: "Dodaj",
    holding_pallets: "Oczekujące",
    manual_sorter_scan: "Ręczne sortowanie",
    add_pallet: "Dodaj paletę",
    scan_pallet_id: "Skanuj ID palety",
    scan_chute: "Skanuj zsyp",
    pallet_label: "Paleta: {id}",
    chutes_needing_pallets: "Zsypy wymagające palet",
    no_chutes_needing_pallets: "Wszystkie zsypy mają palety",
    pallet_added: "Paleta dodana",
    add_failed: "Dodawanie nie powiodło się — spróbuj ponownie",
    collect_chute: "Zbierz zsyp",
    scan_chute_number: "Skanuj zsyp",
    scan_pallet_tag: "Skanuj paletę",
    take_to_location: "Zabierz do: {location}",
    scan_location_confirm: "Skanuj lokalizację, aby potwierdzić",
    add_pallet_back: "Dodać paletę z powrotem?",
    wrong_chute: "Zły zsyp",
    wrong_pallet: "Zła paleta",
    wrong_location: "Zła lokalizacja",
    invalid_pallet: "Nieprawidłowy identyfikator palety",
    invalid_chute: "Nieprawidłowy zsyp",
    chute_collected: "Zsyp zebrany",
    collect_failed: "Zbieranie nie powiodło się — spróbuj ponownie",
    no_chutes: "Brak gotowych zsypów",
    complete_chutes: "Gotowe zsypy",
    chute_label: "Zsyp: {chute}",
    type_label: "Typ: {type}",
    system_label: "System: {system}",
    fetch_chutes_failed: "Pobieranie nie powiodło się — spróbuj ponownie",
    scan_item: "Skanuj przedmiot",
    scan_location_with_name: "Skanuj lokalizację: {location}",
    item_label: "Przedmiot: {sku}",
    item_scanned: "Przedmiot zeskanowany",
    scan_failed: "Skan nie powiódł się — spróbuj ponownie",
    mark_failed: "Oznaczanie nie powiodło się — spróbuj ponownie",
    pallet_collected: "Paleta zebrana",
    pallet_details_failed: "Błąd szczegółów — spróbuj ponownie",
    pallet_collect_failed: "Zbieranie nie powiodło się — spróbuj ponownie",
    pallet_no_zones_left: "Brak wolnych stref — skontaktuj się z kierownikiem zespołu",
    pallet_validator: "Walidacja palet",
    scan_conveyor: "Skanuj przenośnik",
    scan_conveyor_confirm: "Skanuj kod przenośnika, aby potwierdzić",
    pallet_not_in_batch: "Paleta nie należy do bieżącej daty i partii",
    pallet_already_collected: "Paleta została już zebrana",
    wrong_barcode: "Zły kod kreskowy",

    // Zone Storage
    scan_location_barcode: "Skanuj lokalizację",
    invalid_barcode: "Nieprawidłowy kod",
    invalid_warehouse: "Nieprawidłowy magazyn",
    invalid_sorter: "Nieprawidłowy sorter",
    invalid_bay: "Nieprawidłowa zatoka",
    rescan_product: "Skanuj ponownie",
    tap_to_close: "dotknij, aby zamknąć",
    wrong_location_scanned: "Zła lokalizacja: {location}",
    invalid_barcode_size: "Nieprawidłowy kod",
    warehouse_label: "Magazyn: {warehouse}",
    bay_label: "Zatoka: {bay}",
    scanned_label: "Zeskanowano: {item}",
    location_label: "Lokalizacja: {location}",
    sorter_1_unloader: "Rozładunek sortera 1",
    scan_location: "Skanuj lokalizację",
    invalid_scan: "Nieprawidłowy skan",
    location_to_lane: "Lokalizacja {location} do pasa 02",
    single_item_orders: "Zamówienia pojedyncze",
    scan_tag: "Skanuj tag:",
    tag_label: "Tag: {tag}",
    scanned_items: "Zeskanowane",
    scan_lane_close: "Skanuj pas, aby zamknąć",
    invalid_tag: "Nieprawidłowy tag",

    // Zone Storage Settings
    zone_storage_settings: "Ustawienia magazynu strefowego",
    current_settings: "Bieżące ustawienia",
    change_settings: "Zmień ustawienia",
    active_batch: "Aktywna partia",
    active_date: "Aktywna data",
    sorter_1: "Sorter 1",
    sorter_2: "Sorter 2",
    change_batch: "Zmień partię:",
    change_date: "Zmień datę:",
    set_new_values: "Ustaw nowe wartości",
    newport: "Newport",
    poland: "Polska",
    test: "Test",
    pembroke_dock: "Pembroke",

    // Zone Storage Settings — Batch Info
    sorter_batch_info: "Info partii sortera {sorter}",
    complete_pct: "Ukończono: {pct}%",
    scanned_of_total: "{scanned}/{total} zeskanowano",
    pallets_scanned_of_total: "Palety: {scanned}/{total}",
    batch_pallets_title: "Palety partii {batch}",
    pallet_zone_label: "Strefa: {zone}",
    pallet_status_collected: "Zebrano",
    pallet_status_pending: "Oczekuje",
    no_data: "Brak danych",

    // Zone Storage Settings — Bays
    sorter_2_bay_info: "Info regałów sortera 2",
    bay_title: "Zatoka {number} - {type}",
    lane_label: "Pas: {lane}",
    date_label: "Data: {date}",
    batch_label: "Partia: {batch}",
    zone_label: "Sorter 2 Strefa: {zone}",
    unassigned: "Nieprzypisany",

    // Zone Storage Settings — Lanes
    sorter_lanes: "Pasy sortera:",
    lane_complete: "ZAKOŃCZONY",
    lane_ready: "GOTOWY",
    lane_not_ready: "NIEGOTOWY",

    // Zone Storage Settings — Search
    item_search: "Szukaj przedmiotu:",
    search_label: "Szukaj:",
    item_not_found: "Nie znaleziono",
    order_details: "Szczegóły zamówienia:",
    order_not_ready: "Zamówienie niegotowe.",
    number_items: "Ilość przedmiotów: {count}",
    collected_label: "Zebrano: {value}",
    sent_to_ppd: "Wysłano do PPd: {value}",
    sorter_1_scanned: "Sorter 1 zeskanowano: {value}",
    sorter_1_lane: "Sorter 1 pas: {lane}",
    sorter_2_scanned: "Sorter 2 zeskanowano: {value}",
    sorter_2_locations_needed: "Sorter 2 potrzebne lokalizacje: {count}",
    sorter_2_locations: "Sorter 2 lokalizacje: {locations}",

    // Zone Storage Settings — Change Confirmation
    change_s1_settings: "Zmień ustawienia S1",
    warehouse_name: "Magazyn {warehouse}",
    new_date_label: "Nowa data: {date}",
    new_batch_label: "Nowa partia: {batch}",
    reauction_tag: "Tag reaukcji: {tag}",
    confirm_change: "Czy na pewno chcesz zmienić ustawienia?",
    sorter_finished_question: "Czy sorter skończył, czy szybka zmiana?",
    finished: "Zakończony",
    quick_switch: "Szybka zmiana",
    enter_new_date: "Wprowadź nową datę",
    set_date: "Ustaw datę",
    enter_new_batch: "Wprowadź nową partię",
    set_batch: "Ustaw partię",
    confirm_proceed: "Potwierdź i kontynuuj?",
    change_success: "Zmieniono pomyślnie. Zamykanie za 3 sekundy...",

    // Zone Storage Settings — Edit Lane
    total_items: "Łącznie: {count}",
    scanned_items_count: "Zeskanowano: {count}",
    unscanned_items: "Niezeskanowane",
    mark_ready: "Oznacz jako gotowy",
    mark_complete: "Oznacz jako zakończony",
    confirm_ready: "Czy na pewno chcesz oznaczyć pas jako gotowy?",
    confirm_force_close: "Czy na pewno chcesz wymusić zamknięcie pasa?",
    order: "Zamówienie",
    item: "Przedmiot",
    status: "Status",
    lane_marked_ready: "Pas {lane} gotowy!",
    lane_marked_complete: "Pas {lane} zakończony",

    // Sorter 2
    select_lane: "Wybierz pas",
    no_lanes: "Brak dostępnych pasów",
    lane_in_use: "Pas w użyciu - odświeżanie",
    select_bay: "Wybierz zatokę",
    no_orders_ready: "Brak gotowych zamówień",
    orders_count: "{count} zamówień",
    orders: "Zamówienia",
    no_orders: "Brak zamówień",
    no_order_in_location: "Brak zamówienia w lokalizacji {location}",
    order_number: "Zamówienie #",
    locations: "Lokalizacje",
    items: "Przedmioty",
    order_title: "Zamówienie {number}",
    priority: "PRIORYTET",
    scan_tag_suffix: "Skanuj tag {suffix}",
    scan_all_locations: "Skanuj wszystkie lokalizacje",
    to_scan: "Do skanowania",
    scanned: "Zeskanowane",
    tags_dont_match: "Tagi nie pasują",
    // Sorter 2 → wysyłka w Portalu — odmowy (powody z BE zoneDispatch)
    zone_tag_not_a_tote: "To nie jest pojemnik — zeskanuj pojemnik Portalu",
    zone_tag_unavailable: "Pojemnik w użyciu ({status}) — użyj dostępnego pojemnika",
    zone_tag_bound: "Pojemnik zawiera już inne zamówienie do wysyłki",
    zone_order_not_in_portal: "Zamówienia {order} nie znaleziono w Portalu",
    zone_order_ambiguous: "Zamówienie {order} pasuje do więcej niż jednego zamówienia w Portalu — zapytaj przełożonego",
    zone_order_not_ready: "Zamówienie {order} ma w Portalu status {status} — nie jest gotowe do wysyłki",
    zone_items_mismatch: "Posortowane produkty nie zgadzają się z zamówieniem w Portalu — zapytaj przełożonego",
    zone_allocation_failed: "Portal nie mógł przydzielić stanu dla zamówienia {order}",
    zone_order_no_items: "Zamówienie {order} w Portalu nie ma pozycji",
    zone_order_flagged_missing: "Zamówienie {order}: przy sortowaniu nie znaleziono żadnych produktów — oflagowane w Portalu dla lidera, nic nie wysłano do wysyłki",
    zone_singles_refused: "{count} produkt(ów) nie może trafić do wysyłki w Portalu — usuń oznaczone produkty i zamknij tag ponownie",
    zone_singles_no_items: "Brak produktów na tym tagu",
    // Unsold Reauction → przeniesienie stanu w Portalu (pojemnik reaukcyjny Sortera 1)
    zone_tag_in_use: "Pojemnik jest używany gdzie indziej — najpierw go tam zamknij",
    zone_tote_locked: "Pojemnik jest otwarty na innym ekranie — najpierw go tam zamknij",
    scan_reauction_tote: "Skanuj pojemnik reaukcyjny",
    scan_tote_id: "Skanuj pojemnik {tote}",
    reauction_tote_label: "Pojemnik reaukcyjny: {tote}",
    zone_reauction_wrong_tote: "Zły pojemnik — zeskanuj pojemnik {tote}",
    zone_reauction_tote_not_mapped: "Pojemnik został zamknięty przez inne stanowisko — zeskanuj nowy pojemnik reaukcyjny",
    zone_reauction_not_portal_item: "Produktu nie znaleziono w stanie Portalu — przekaż przełożonemu",
    zone_reauction_bay_mapped: "To stanowisko jest już na pojemniku {tote}",
    zone_reauction_disabled: "Przeniesienie reaukcji w Portalu jest wyłączone dla tego magazynu",
    zone_reauction_close_title: "Zamknąć pojemnik reaukcyjny?",
    zone_reauction_close_body: "Przeniesione produkty zostają w pojemniku. Następny produkt reaukcyjny poprosi o nowy pojemnik.",
    zone_reauction_tote_closed: "Pojemnik {tote} zamknięty — przeniesiono {count} szt.",
    zone_reauction_tote_closed_empty: "Pojemnik {tote} zamknięty — był pusty",
    // Unsold Grey → odpis stanu w Portalu przy potwierdzeniu miejsca (BE migracja 247).
    zone_grey_not_written_off: "{item}: brak stanu w Portalu — nic nie odpisano, powiadom przełożonego",
    zone_grey_write_off_failed: "{item}: odpis w Portalu nie powiódł się — powiadom przełożonego",
    location_not_in_order: "Lokalizacja nie w zamówieniu",
    mega_order: "Mega zamówienie",
    scan_tag_prompt: "Skanuj tag:",
    details_correct: "Czy dane są poprawne?",
    product_not_in_lane: "Produkt nie jest na Twoim pasie, przekaż przełożonemu",
    product_in_wrong_batch: "Produkt jest w złej partii, przekaż przełożonemu",
    product_on_wrong_date: "Produkt jest w złej dacie, przekaż przełożonemu",
    item_marked_as_missing: "Przedmiot oznaczony jako brakujący",
    locations_not_free: "Lokalizacje nie są wolne",
    item_has_no_location: "Przedmiot nie ma przypisanej lokalizacji, przekaż przełożonemu.",

    // Admin
    admin_panel: "Panel administracyjny",
    users: "Użytkownicy",
    devices: "Urządzenia",
    displays: "Wyświetlacze",
    hardware: "Sprzęt",
    manage: "Zarządzaj",
    enter_fullscreen: "Pełny ekran",
    exit_fullscreen: "Zamknij pełny ekran",
    chute: "Zsyp",
    no_complete_chutes: "Brak gotowych zsypów",
    more_chutes: "więcej gotowych zsypów",

    // Nawigacja boczna + przełącznik trybu
    app: "Aplikacja",
    nav_primary: "Nawigacja główna",
    sidenav_expand: "Rozwiń nawigację",
    sidenav_collapse: "Zwiń nawigację",
    sidenav_open: "Otwórz nawigację",
    sidenav_close: "Zamknij nawigację",
    header_env_staging: "Staging",

    // Strona główna admina — karty KPI + opisy kafelków
    kpi_unfulfilled: "Sztuki niezrealizowane",
    kpi_in_picking: "Sztuki w kompletacji",
    kpi_in_sorting: "Sztuki w sortowaniu",
    kpi_awaiting_dispatch: "Sztuki do wysyłki",
    kpi_fulfilled_today: "Sztuki zrealizowane dziś",
    kpi_orders_sub: "{count} zamówień",
    kpi_stock_blocked_sub: "{units} szt. bez zapasu",
    kpi_sorters_breakdown: "Sorter 1: {s1} · Sorter 2: {s2}",
    kpi_active_today: "Aktywni dziś",
    kpi_totes_to_put_away: "Pojemniki do odłożenia",
    tile_orders_desc: "Zarządzaj i szukaj zamówień",
    tile_warehouse_desc: "Zapasy, pojemniki, lokalizacje, produkty",
    tile_sorting_desc: "Konfiguruj sortery stref",
    tile_users_desc: "Personel, role, uprawnienia",
    tile_displays_desc: "Monitory zsypów i ekrany",
    tile_complete_chutes_desc: "Tablica statusu gotowych zsypów na żywo",
    tile_hardware_desc: "Urządzenia i drukarki",
    tile_settings_desc: "Ustawienia operacyjne i wysyłki",

    // Opisy kafelków podstron magazynu
    warehouse_tile_totes_desc: "Pojemniki do rejestracji i odkładania",
    warehouse_tile_locations_desc: "Miejsca, pasy, strefy przyjęć",
    warehouse_tile_lanes_desc: "Pasy na żywo — pojemniki, aukcje, daty",
    warehouse_tile_products_desc: "Katalog SKU, wagi, wymiary, kody",
    warehouse_tile_suppliers_desc: "Lista dostawców dla produktów i manifestów",
    warehouse_tile_boxes_desc: "Rozmiary i zasady pakowania",
    warehouse_tile_inventory_desc: "Stany wg SKU i magazynu",
    warehouse_tile_manifest_desc: "Oczekiwany zapas — PO i preordery",
    warehouse_tile_pos_desc: "PO wg dostawcy — oczekiwane a przyjęte",
    warehouse_tile_picking_desc: "Fale — aktywne, wstrzymane, historia",

    // Users
    users_panel: "Panel użytkowników",
    add_user: "Dodaj użytkownika",
    users_filter_search: "Szukaj nazwy, nazwy użytkownika, RFID, uprawnień",
    users_no_matches: "Brak użytkowników pasujących do filtrów",
    users_col_name: "Imię i nazwisko",
    users_col_warehouse: "Magazyn",
    users_col_permissions: "Uprawnienia",
    users_col_created: "Utworzono",
    users_col_last_active: "Ost. logowanie",
    users_col_password_changed: "Hasło ustawione",
    user_added: "Dodano {name}",
    user_deleted: "{name} usunięty",
    user_force_change_done: "{name} zostanie poproszony o ustawienie nowego hasła przy następnym logowaniu",
    user_suspended: "{name} zawieszony",
    user_unsuspended: "{name} przywrócony",

    // Akcje wiersza na stronie Użytkownicy
    users_status_suspended: "Zawieszony",
    users_rotation_pending: "Wymagana rotacja",
    users_rotation_pending_hint: "Użytkownik zostanie poproszony o ustawienie nowego hasła przy następnym logowaniu",
    users_password_expired: "Hasło wygasło",
    users_password_expired_hint: "Hasło ma ponad {days} dni — użytkownik zostanie poproszony o ustawienie nowego przy następnym logowaniu",
    users_force_change: "Wymuś zmianę hasła",
    users_suspend: "Zawieś",
    users_unsuspend: "Przywróć",
    users_quick_actions: "Szybkie akcje",
    users_allow_concurrent: "Zezwól na wiele urządzeń",
    users_allow_concurrent_hint: "Domyślnie wyłączone: zalogowanie na nowym urządzeniu wylogowuje to konto wszędzie indziej. Włączaj tylko dla stanowisk współdzielonych lub klientów automatycznych.",
    users_force_change_title: "Wymusić zmianę hasła?",
    users_force_change_body: "{name} zostanie poproszony o ustawienie nowego hasła przy następnym logowaniu. Można to cofnąć tylko poprzez wykonanie rotacji.",
    users_force_change_confirm: "Wymuś zmianę",
    users_suspend_title: "Zawiesić użytkownika?",
    users_suspend_body: "{name} nie będzie mógł się zalogować, dopóki administrator go nie przywróci.",
    users_suspend_confirm: "Zawieś",
    users_unsuspend_title: "Przywrócić użytkownika?",
    users_unsuspend_body: "{name} będzie mógł się ponownie zalogować.",
    users_unsuspend_confirm: "Przywróć",
    edit_user: "Edytuj użytkownika",
    delete_user: "Usuń użytkownika",
    delete_confirm: "Czy na pewno chcesz usunąć tego użytkownika?",
    name: "Imię",
    rfid_optional: "Tag RFID (opcjonalnie)",
    basic: "Podstawowy",
    adding_user: "Dodawanie...",

    // Devices
    device_management: "Zarządzanie urządzeniami",
    device_subtitle: "Monitoruj i zarządzaj urządzeniami",
    device_overview: "Przegląd urządzeń",
    all_warehouses: "Wszystkie magazyny",
    clear: "Wyczyść",
    total_devices: "Łącznie urządzeń",
    checked_in: "Zameldowane",
    checked_out: "Wymeldowane",
    maintenance: "Konserwacja",
    scanners: "Skanery",
    handhelds: "Terminale",
    search_devices: "Szukaj urządzeń...",
    all_types: "Wszystkie typy",
    all_statuses: "Wszystkie statusy",
    phones: "Telefony",
    zebras: "Zebry",
    clear_filters: "Wyczyść filtry",
    device: "Urządzenie",
    warehouse: "Magazyn",
    switch_warehouse: "Zmień magazyn",
    type: "Typ",
    last_updated: "Ostatnia aktualizacja",
    updated_by: "Zaktualizowane przez",
    no_devices: "Brak urządzeń",
    adjust_filters: "Zmień filtry",
    showing_devices: "Pokazano {count} z {total}",
    current_status: "Bieżący status",
    notes: "Notatki:",
    no_notes: "Brak notatek",
    save_notes: "Zapisz notatki",
    usage_history: "Historia użycia",
    no_history: "Brak historii",
    sort_updated_desc: "Ostatnio zmienione (najnowsze)",
    sort_updated_asc: "Ostatnio zmienione (najstarsze)",
    sort_name_asc: "Nazwa (A–Z)",
    sort_name_desc: "Nazwa (Z–A)",
    sort_status: "Status",
    sort_warehouse: "Magazyn",

    // Language
    language: "Język",
    english: "English",
    polish: "Polski",

    // Camera
    camera_denied: "Brak dostępu do kamery",
    camera_unavailable: "Kamera niedostępna",

    // PWA
    pwa_install_title: "Zainstaluj Portal",
    pwa_install_description: "Dodaj do ekranu głównego",
    pwa_install_button: "Zainstaluj",
    pwa_ios_install_title: "Dodaj do ekranu głównego",
    pwa_ios_install_step1: "Naciśnij przycisk Udostępnij poniżej",
    pwa_ios_install_step2: "Następnie naciśnij 'Dodaj do ekranu głównego'",
    network_offline: "Jesteś offline",
    streak: "SERIA",
    score_label: "PUNKTY",
    best_time: "NAJLEPSZY",
    achievement_label: "OSIĄGNIĘCIE",
    achievement_items: "{count} ARTYKUŁÓW",
    chute_info: "Zsyp: {chute}",
    zone_info: "Strefa: {zone}",
    no_zone: "Brak strefy",
    product_not_found: "Nie znaleziono produktu",
    scan_zone: "Skanuj strefę",
    item_details: "Szczegóły produktu",
    order_type: "Typ zamówienia",
    chute_location: "Zsyp",
    sorter_1_location: "Lokalizacja Sorter 1",
    sorter_2_location: "Lokalizacja Sorter 2",
    weight_label: "Waga",
    bay: "Zatoka",
    day: "Dzień",
    sent_to_ppd_label: "Wysłano do PPd",

    // Dispatch
    dispatch: "Wysyłka",
    scan_desk: "Skanuj Stanowisko",
    scan_desk_prompt: "Zeskanuj kod kreskowy stanowiska pakowania",
    scan_item_dispatch: "Skanuj Przedmiot",
    no_order_found: "Nie znaleziono zamówienia dla tego przedmiotu",
    order_already_shipped: "Zamówienie już przetworzone",
    already_scanned: "Już zeskanowano",
    unscan: "Cofnij skan",
    item_not_in_order: "Przedmiot nie należy do tego zamówienia",
    item_not_in_order_number: "\"{value}\" nie należy do zamówienia #{order}. Jeśli to zamówienie nie powinno być otwarte, użyj strzałki wstecz, aby je opuścić.",
    leave_order: "Opuść zamówienie",
    leave_order_warning: "Opuścić zamówienie #{order}? Zeskanowane przedmioty i pudełka pozostają zapisane przy zamówieniu — kto otworzy je następny, kontynuuje od tego miejsca. Aby je wyczyścić, użyj opcji Zresetuj zamówienie.",
    item_missing: "Brakujący",
    dispatch_item_missing_chip: "{count} brakuje",
    dispatch_item_refund_chip: "{count} do zwrotu",
    dispatch_added_to_consignment: "Dodano do istniejącej przesyłki {waybill} — wydrukowano tylko etykiety nowych paczek poniżej.",
    item_damaged: "Uszkodzony",
    item_wrong: "Zły przedmiot",
    item_barcode_damaged: "Ręcznie",
    confirm_missing: "Dotknij ponownie, aby potwierdzić brak",
    confirm_damaged: "Dotknij ponownie, aby potwierdzić uszkodzenie",
    all_items_scanned: "Zakończ",
    confirm_shipment: "Potwierdź Wysyłkę",
    how_many_boxes: "Ile pudełek?",
    total_weight: "Łączna waga",
    items_to_ship: "przedmiotów do wysłania",
    book_and_print: "Zarezerwuj i Drukuj Etykiety",
    print_label: "Drukuj Etykietę",
    print_labels: "Drukuj Etykiety",
    scan_to_print: "Skanuj aby drukować",
    printing: "Drukowanie...",
    print_failed: "Drukowanie nie powiodło się — spróbuj ponownie",
    label_printed: "Etykieta wydrukowana",
    checking_printer: "Sprawdzanie drukarki...",
    print_agent_required: "Wymagany Agent Druku",
    print_agent_not_installed: "Agent Druku nie zainstalowany",
    print_agent_update_available: "Dostępna aktualizacja Agenta Druku",
    print_agent_update_desc: "Dostępna jest nowsza wersja Agenta Druku. Pobierz i zainstaluj, aby uzyskać najnowsze funkcje.",
    download_latest: "Pobierz najnowszą wersję",
    print_agent_desc: "Pobierz i zainstaluj Agenta Druku, aby umożliwić ciche drukowanie etykiet na tym urządzeniu.",
    download_print_agent: "Pobierz Agenta Druku",
    install_on_any_pc: "Zainstaluj na dowolnym komputerze",
    agent_version: "Agent",
    agent_update_required: "Wymagana aktualizacja",
    agent_network: "Sieć i urządzenie",
    agent_network_title: "Urządzenie — {id}",
    agent_printer: "Drukarka",
    agent_restart: "Restartuj agenta",
    agent_reboot: "Uruchom ponownie urządzenie",
    agent_test_print: "Drukuj etykietę testową",
    agent_rediscover: "Znajdź drukarkę",
    agent_confirm_restart: "Zrestartować agenta drukowania na \"{id}\"? Drukowanie zatrzyma się na kilka sekund.",
    agent_confirm_reboot: "Uruchomić ponownie \"{id}\"? Urządzenie będzie niedostępne przez około minutę.",
    agent_command_done: "Gotowe: {detail}",
    agent_command_failed: "Błąd: {detail}",
    agents_needing_update: "Agenty wymagające aktualizacji",
    agent_devices: "Urządzenia agenta",
    last_seen: "Ostatnio widziano",
    print_agent_installed: "Agent Druku zainstalowany",
    retry_connection: "Ponów Połączenie",
    connect_printer: "Połącz Drukarkę",
    select_printer: "Wybierz Drukarkę",
    network_printers: "Drukarki Sieciowe",
    no_printers_available: "Brak dostępnych drukarek",
    printer_offline: "Offline",
    print_job_queued: "Zadanie druku wysłane",
    print_job_failed: "Zadanie druku nie powiodło się",
    change_printer: "Zmień Drukarkę",
    selected_printer: "Wybrana Drukarka",
    printers: "Drukarki",
    friendly_name: "Nazwa",
    system_name: "Nazwa Systemowa",
    hostname: "Nazwa Komputera",
    status_online: "Online",
    mobile_enabled: "Druk Mobilny",
    rename_printer: "Zmień nazwę",
    printer_updated: "Drukarka zaktualizowana",
    no_printers_registered: "Brak zarejestrowanych drukarek",
    search_printers: "Szukaj drukarki, skrótu lub komputera...",
    search_this_computer: "Szukaj tego komputera",
    set_my_computer: "Ustaw mój komputer",
    enter_computer_name: "Podaj nazwę tego komputera.\n\nWskazówka: otwórz Start i wpisz 'About' — nazwa PC jest u góry. Albo naciśnij Win+R, wpisz 'cmd', potem 'hostname'.",
    edit: "Edytuj",
    show_hidden: "Pokaż Ukryte",
    hide_hidden: "Ukryj Ukryte",
    hide_printer: "Ukryj",
    unhide_printer: "Pokaż",
    all: "Wszystkie",
    select: "Wybierz",
    select_warehouse_first: "Najpierw wybierz magazyn",
    enter_warehouse: "Wpisz magazyn",
    chutes: "ZSYPÓW",
    tap_to_enable_sound: "Dotknij aby włączyć dźwięk",
    waiting_for_chutes: "Oczekiwanie na zsypy...",
    local: "To Urządzenie",
    local_printer: "Drukarka Lokalna",
    this_device: "Podłączona bezpośrednio",
    print_agent_not_found: "Agent Druku nie wykryty — upewnij się, że jest uruchomiony",
    auto_print: "Automatyczny Druk",
    print: "Druk",
    fetching_label: "Pobieranie etykiety...",
    label_fetch_failed: "Nie udało się pobrać etykiety od kuriera",
    own_label_shipment: "Wysyłka na przesłanej etykiecie — brak rezerwacji kuriera",
    print_attached_label: "Drukuj załączoną etykietę",
    attached_label_fetch_failed: "Nie udało się wczytać załączonej etykiety",
    reopen_order: "Otwórz",
    reopen_warning: "Etykiety wysyłkowe zostaną anulowane i nowe etykiety muszą zostać wydrukowane. Przedmioty pozostaną w swoich pudełkach.",
    reopen_confirm: "Otwórz i Anuluj Etykiety",
    reopen_failed: "Nie udało się ponownie otworzyć zamówienia — spróbuj ponownie",
    reopen_busy: "To zamówienie jest już ponownie otwierane — poczekaj kilka sekund i zeskanuj je ponownie",
    reopen_partner_notified: "Kanał sprzedaży został już powiadomiony o tej wysyłce. Zaktualizowane dane paczek zostaną wysłane przy ponownej wysyłce.",
    print_all: "Drukuj wszystkie",
    download: "Pobierz",
    download_all: "Pobierz wszystkie",
    download_failed: "Pobieranie nie powiodło się",
    continue_label: "Kontynuuj",
    order_shipped: "Zamówienie Wysłane!",
    ship_order: "Wyślij Zamówienie",
    ship_failed: "Wysyłka nie powiodła się — spróbuj ponownie",
    ship_failed_title: "Wysyłka nie powiodła się",
    refund_queued: "Zwrot w kolejce dla",
    items_flagged: "Przedmioty oznaczone",
    cancel_order_all_unavailable: "Wszystkie przedmioty niedostępne — anulować zamówienie?",
    add_box: "Dodaj Pudełko",
    retry: "Ponów",
    label_error_title: "Błąd Etykiety",
    label_generation_failed: "Nie udało się wygenerować etykiet. Sprawdź szczegóły zamówienia poniżej i spróbuj ponownie.",
    delivery_address: "Adres Dostawy",
    billing_address: "Adres Rozliczeniowy",
    address_line_1: "Linia adresu 1",
    address_line_2: "Linia adresu 2",
    city: "Miasto",
    company: "Firma",
    company_optional: "Firma (opcjonalnie)",
    county: "Województwo",
    postcode: "Kod pocztowy",
    country: "Kraj",
    phone: "Telefon",
    phone_country_code: "Kierunkowy kraju",
    phone_invalid_for_country: "Numer telefonu nie pasuje do oczekiwanej długości dla tego kraju.",
    billing_phone_invalid_for_country: "Numer telefonu w adresie rozliczeniowym nie pasuje do oczekiwanej długości dla tego kraju.",
    email: "E-mail",
    placed_at: "Złożono",

    // Ustawienia > Wysyłka > Harmonogram powiadomień o wysyłce
    // Ustawienia › Wysyłka › Godziny graniczne kanałów i metryki pulpitu (2026-10-13)
    channel_rules_settings: "Godziny graniczne kanałów i metryki pulpitu",
    channel_rules_hint: "Dla każdego kanału sprzedaży: czy jego zamówienia liczą się do metryk sprzedaży na pulpicie oraz tygodniowa siatka godzin granicznych i dni wysyłki (standard i ekspres), która decyduje, kiedy zamówienie jest wymagalne — na pulpicie, w filtrze zegara kolejki kompletacji i w zamówieniach administratora. Zmiana obowiązuje od dziś; wcześniejsze dni zachowują poprzednią regułę.",
    channel_rules_default_title: "Domyślne dla magazynu",
    channel_rules_default_hint: "Siatka używana przez każdy kanał bez własnej oraz godzina graniczna wysyłki: wymagalne zamówienia muszą być wysłane do tej godziny w dniu wymagalności (meta wyścigu i wynik terminowości).",
    channel_rules_ship_cutoff: "Godzina graniczna wysyłki",
    channel_rules_day_col: "Dzień",
    channel_rules_standard: "Standard",
    channel_rules_express: "Ekspres / priorytet",
    channel_rules_cutoff_col: "Godzina graniczna zamówień",
    channel_rules_ships_col: "Wysyłka",
    channel_rules_no_cutoff: "bez godziny granicznej",
    channel_rules_same_day: "tego samego dnia",
    channel_rules_channels_title: "Kanały",
    channel_rules_channel_col: "Kanał",
    channel_rules_orders_col: "Zamówienia (90 dni)",
    channel_rules_metrics_col: "W metrykach pulpitu",
    channel_rules_grid_col: "Godziny graniczne",
    channel_rules_uses_default: "Domyślne magazynu",
    channel_rules_custom: "Własna siatka",
    channel_rules_edit_grid: "Edytuj siatkę",
    channel_rules_use_default: "Użyj domyślnych magazynu",
    channel_rules_since: "od {date}",
    channel_rules_by: "przez {name}",
    channel_rules_builtin: "wbudowane wartości domyślne (nic nie zapisano)",
    channel_rules_not_saved: "domyślne",
    channel_rules_saved: "Zapisano — obowiązuje od dziś",
    channel_rules_applies_from: "Zapis obowiązuje od dziś ({date}); wcześniejsze dni zachowują poprzednią regułę.",
    channel_rules_history: "Historia",
    channel_rules_no_channels: "Brak zamówień w ostatnich 90 dniach",
    channel_rules_bad_time: "{day}: godzina graniczna musi być w formacie GG:MM lub pusta",
    channel_rules_midnight_cutoff: "{day}: godzina 00:00 — zostaw puste, aby nie było godziny granicznej",
    channel_rules_bad_ship_days: "{day}: wysyłka musi nastąpić w ciągu 6 dni",
    channel_rules_not_monotone: "Zamówienia z {next} byłyby wysłane przed zamówieniami z {day}",
    dispatch_shipments_release: "Wysyłanie powiadomień o wysyłce",
    dispatch_shipments_release_hint: "Kontroluje, kiedy powiadomienie /shipments jest wysyłane do kanału sprzedaży po spakowaniu. 'Natychmiast' wysyła w ciągu ~30s. 'Cutoff' wstrzymuje każde powiadomienie do dziennego czasu odcięcia — przydatne, jeśli operatorzy mają poprawić etykiety zanim kupujący zostanie powiadomiony.",
    dispatch_shipments_release_mode_col: "Tryb",
    pallet_orders_settings: "Zamówienia paletowe",
    pallet_orders_settings_hint: "Jak zamówienie paletowe z kanału sprzedaży trafia do każdego magazynu. Zamówienie paletowe to takie, w którym każda linia jest SKU palety: całe zamówienie złożone z palet albo połowa _PAL, na którą zamówienie mieszane jest dzielone przy przyjęciu. Zamówienia paczkowe oraz paczkowa połowa zamówienia mieszanego nigdy nie są objęte tym ustawieniem.",
    pallet_order_status_col: "Trafia jako",
    pallet_order_status_unfulfilled: "Niezrealizowane",
    pallet_order_status_on_hold: "Wstrzymane",
    pallet_order_status_unfulfilled_note: "Kierowane od razu do Kompletacji palet.",
    pallet_order_status_on_hold_note: "Wstrzymane przy przyjęciu. Zwolnij je na stronie Zamówienia (status → Niezrealizowane), aby trafiło do Kompletacji palet.",
    dispatch_shipments_release_time_col: "Czas odcięcia",
    dispatch_shipments_release_timezone_col: "Strefa czasowa",
    dispatch_shipments_release_schedule_col: "Harmonogram",
    dispatch_shipments_immediate_delay: "Opóźnienie wysyłki",
    dispatch_shipments_immediate_delay_hint: "Tryb natychmiastowy wstrzymuje powiadomienie na krótkie opóźnienie (domyślnie 15 min), aby można było jeszcze ponownie otworzyć i poprawić zamówienie, zanim kanał sprzedaży dowie się o wysyłce. 0 wysyła od razu.",
    dispatch_shipments_release_immediate: "Natychmiast",
    dispatch_shipments_release_cutoff: "Dzienny cutoff",
    shipped_items: "Wysłane",
    parcels_count: "paczek",
    parcel: "Paczka",
    box_label: "Pudełko",
    boxes_label: "Pudełka",
    item_singular: "przedmiot",
    item_plural: "przedmiotów",
    from_label: "OD",
    deliver_to_label: "DOSTARCZYĆ DO",
    remove_box: "Usuń Pudełko",
    remove_box_confirm: "Pudełko {box} ma zeskanowane przedmioty. Usunięcie cofnie skanowanie tych przedmiotów. Czy na pewno?",
    remove_box_confirm_question: "Czy na pewno chcesz usunąć to pudełko i wszystkie zeskanowane do niego przedmioty?",
    will_be_unscanned: "zostanie cofnięte",
    empty_boxes_warning: "Pudełko {boxes} nie ma przedmiotów. Zeskanuj przedmioty lub usuń je.",
    empty_boxes_warning_rebook: "Pudełko {boxes} nie ma przedmiotów. Przenieś do niego przedmioty, a etykieta zostanie zarezerwowana ponownie na {packed} paczek, albo usuń pudełko, aby zachować obecną etykietę.",
    scan_box_before_complete: "Zeskanuj kod pudełka przed zakończeniem zamówienia.",
    scan_box_prompt: "Skanuj pudełko",
    box_override_title: "Zeskanowano inne pudełko",
    box_override_dismiss_hint: "Zeskanowano przez pomyłkę? Zamknij to okno, a pudełko zostanie usunięte z zamówienia.",
    box_override_question: "Zeskanowano {scanned} zamiast zalecanego {recommended}. Dlaczego?",
    box_override_reason_items_dont_fit: "Przedmioty się nie mieszczą",
    box_override_reason_items_too_heavy: "Przedmioty za ciężkie",
    box_override_reason_box_unavailable: "Zalecane pudełko niedostępne",
    box_override_reason_smaller_box_fits: "Mniejsze pudełko wystarczy",
    box_override_reason_extra_protection: "Potrzebna dodatkowa ochrona",
    recommended_boxes: "Zalecane",
    next_box: "Następne pudełko",
    box_recommendation_no_fit: "Żadne dostępne pudełko nie pasuje do tego zamówienia — wybierz ręcznie",
    box_recommendation_skipped: "{count} pozycja(e) bez wymiarów — pominięte",
    box_recommendation_diagonal: "Umieść po przekątnej: {skus}",
    box_recommendation_fragile: "Zamówienie kruche",
    box_recommendation_fragile_on: "Kruche — bez foliopaków",
    box_recommendation_fragile_clear: "Dotknij, aby usunąć ograniczenie dla kruchych",
    box_recommendation_settings: "Rekomendacja Pudełek",
    box_recommendation_settings_hint: "Tolerancje per magazyn używane przez ekran pakowania do sugerowania najmniejszych pudełek pasujących do każdego zamówienia.",
    dispatch_void_fill_pct: "Tolerancja wypełnienia (%)",
    dispatch_void_fill_pct_hint: "Dodatkowa przestrzeń w pudełku zarezerwowana na wypełnienie, jako procent objętości pudełka. Domyślnie: 15.",
    dispatch_packing_tolerance_mm: "Tolerancja pakowania (mm)",
    dispatch_packing_tolerance_mm_hint: "Luz odjęty od każdego wymiaru pudełka przy sprawdzaniu dopasowania — uwzględnia niedokładne pakowanie. Domyślnie: 10.",
    dispatch_stock_aware_recommendation: "Uwzględniaj stan pudełek",
    dispatch_stock_aware_recommendation_hint: "Gdy WŁĄCZONE, rekomendowane są tylko pudełka z zapisanym stanem (stan powyżej zera). Pozostaw WYŁĄCZONE, jeśli magazyn nie śledzi zapasów pudełek — każde skonfigurowane pudełko pozostaje dostępne.",
    dispatch_diagonal_recommendation: "Umieszczanie po przekątnej",
    dispatch_diagonal_recommendation_hint: "Gdy WŁĄCZONE, długi przedmiot, który nie mieści się prosto w żadnym pudełku, może otrzymać rekomendację mniejszego pudełka, kartonowej koperty lub foliopaku, w które zmieści się ułożony po przekątnej (płasko, obrócony ku narożnikom). Ekran pakowania wskazuje operatorowi, które pozycje ułożyć pod kątem. Domyślnie: WŁĄCZONE.",
    dispatch_diagonal_tolerance_mm: "Tolerancja po przekątnej — pudełka (mm)",
    dispatch_diagonal_tolerance_mm_hint: "Tolerancja pakowania używana zamiast standardowej przy sprawdzaniu dopasowania PO PRZEKĄTNEJ w sztywnych pudełkach — przedmioty pod kątem stykają się ze ściankami narożnikami, więc potrzebują więcej luzu. Domyślnie: 10 (dwukrotność standardowej tolerancji).",
    dispatch_diagonal_bag_tolerance_mm: "Tolerancja po przekątnej — koperty wysyłkowe (mm)",
    dispatch_diagonal_bag_tolerance_mm_hint: "Tolerancja pakowania przy sprawdzaniu dopasowania PO PRZEKĄTNEJ w foliopakach i kopertach kartonowych — oba są płaskimi opakowaniami owijającymi, więc przedmiot po przekątnej leży w nich równie ciasno. Oddzielona od sztywnych pudełek, aby opakowaniom owijającym można było osobno dodać luzu. Domyślnie: 10 (dwukrotność standardowej tolerancji).",
    dispatch_extra_protection_excluded_boxes: "Opakowania niedozwolone przy dodatkowej ochronie",
    dispatch_extra_protection_excluded_boxes_hint: "Zaznacz typy opakowań, w których NIE wolno pakować produktu oznaczonego „Wymagana dodatkowa ochrona” — rekomendacja je pomija i proponuje kolejne pasujące opakowanie. Pozostaw wszystkie niezaznaczone, aby dopuścić każde opakowanie. Wybór dotyczy całej przesyłki: jeden delikatny przedmiot wyklucza opakowanie dla wszystkiego, co jedzie razem z nim.",
    dispatch_extra_protection_excluded_boxes_none: "Brak skonfigurowanych opakowań",

    // Dispatch admin (settings page) + Dispatch FE box-scan flow
    dispatch_settings: "Wysyłka",
    dispatch_settings_hint: "Stanowiska pakowania i pudełka używane na stanowisku wysyłki, w podziale na magazyny.",
    desks_settings: "Stanowiska Pakowania",
    desks_settings_hint: "Dodawaj i usuwaj stanowiska pakowania w magazynie. Kod kreskowy generowany automatycznie z kodu magazynu.",
    dispatch_warehouse_toggles: "Przełączniki magazynów",
    dispatch_warehouse_toggles_hint: "Ustawienia funkcji widoku pakowania w podziale na magazyny.",
    dispatch_show_images: "Pokaż zdjęcia",
    dispatch_show_images_hint: "Gdy włączone, ekran pakowania wyświetla zdjęcia produktów dla każdej pozycji. Gdy wyłączone, każda pozycja pokazuje szare puste pole (przydatne, gdy adresy URL zdjęć nie są dostępne z sieci magazynu).",
    dispatch_box_recommendation_enabled: "Rekomendacja pudełek",
    dispatch_box_recommendation_enabled_hint: "Gdy włączone, ekran pakowania wyświetla baner z sugestią najmniejszych pudełek pasujących do zamówienia. Tolerancje konfiguruje się poniżej.",
    add_desk: "Dodaj stanowisko",
    desk_name: "Nazwa stanowiska",
    remove_desk: "Usuń stanowisko",
    no_desks_yet: "Brak stanowisk",

    // Palety kurierskie (Ustawienia > Wysyłka) — rozładunek przenośnika
    carrier_bays_settings: "Palety kurierskie",
    carrier_bays_settings_hint: "Jeden kod kreskowy na paletę lub klatkę przy rozładunku przenośnika, każdy przypisany do kuriera. Strona Rozładunek przenośnika wskazuje kuriera dla każdej paczki, a operator potwierdza, skanując paletę.",
    add_bay: "Dodaj paletę",
    edit_bay: "Edytuj paletę",
    bay_name: "Nazwa palety",
    bay_carrier: "Kurier",
    bay_sort_codes: "Kody sortowania",
    bay_sort_codes_hint: "Które paczki tego kuriera trafiają na tę paletę, rozdzielone przecinkami. APC: numer w czarnym polu na etykiecie (np. 1, 2). InPost: 24, 48 lub LOCKER. Zostaw puste dla palety zbiorczej kuriera.",
    remove_bay: "Usuń paletę",
    no_bays_yet: "Brak palet kurierskich",
    confirm_remove_bay: "Usunąć paletę {name}? Operatorzy nie będą mogli jej skanować. Tej operacji nie można cofnąć.",
    confirm_remove_desk: "Usunąć stanowisko {name}? Operatorzy nie będą mogli go zeskanować. Operacji nie można cofnąć.",
    desk_unknown: "Nieznane stanowisko",
    edit_desk: "Edytuj stanowisko",

    // Scansheet locations (Settings > Goods In > Scan Sheet)
    scansheet_locations_settings: "Kody lokalizacji",
    scansheet_locations_settings_hint: "Operatorzy skanują jeden z tych kodów, aby ustawić magazyn i pozycję zapisywaną przy każdym skanie w sesji. Usunięte kody są ukrywane przed operatorami, ale zachowane w historii skanów.",
    add_location: "Dodaj lokalizację",
    edit_location: "Edytuj lokalizację",
    remove_location: "Usuń lokalizację",
    location_barcode: "Kod kreskowy",
    location_position: "Pozycja",
    location_warehouse: "Magazyn",
    no_locations_yet: "Brak lokalizacji",
    confirm_remove_location: "Ukryć lokalizację {barcode}? Operatorzy nie będą mogli jej zeskanować. Pozostanie w bazie do celów historii skanów.",
    location_barcode_taken: "Ten kod jest już w użyciu",
    position_goods_in: "Przyjęcie towaru",
    position_envelopes: "Koperty",
    position_pallets: "Palety",
    desk_display_name_en: "Nazwa wyświetlana (angielski)",
    desk_display_name_pl: "Nazwa wyświetlana (polski)",
    ship_in_packaging: "Wysyłka w opakowaniu",
    ship_in_packaging_hint: "Gdy TRUE, produkt był już wysyłany we własnym opakowaniu detalicznym — przy wysyłce przycisk „Wyślij we własnym opakowaniu” jest podświetlony jako wskazówka. Nic nie jest wybierane automatycznie; pakujący decyduje.",
    ship_in_packaging_box_name: "Własne opakowanie",
    ship_in_own_packaging_action: "Wyślij we własnym opakowaniu",
    ship_in_own_packaging_hinted: "Wyślij we własnym opakowaniu (ten produkt był już wysyłany we własnym opakowaniu)",
    ship_in_packaging_no_dims: "Dodaj wymiary produktu, aby włączyć",
    ship_in_packaging_enabled: "{sku} oznaczony jako wysyłka w opakowaniu",
    ship_in_packaging_weight_kg: "Waga (kg)",
    ship_in_packaging_prefilled_sku: "Uzupełniono z ostatniego pakowania tego SKU ({name}, {date}). Popraw to, co się różni, a zmiany zostaną zapamiętane.",
    ship_in_packaging_prefilled_asin: "Uzupełniono z {sku}, ten sam produkt (ASIN {asin}), pakowane przez: {name}, {date}. Popraw to, co się różni, a zmiany zostaną zapamiętane.",
    ship_in_packaging_prefilled_catalogue: "Uzupełniono z wymiarów produktu w katalogu. Popraw to, co się różni, a zmiany zostaną zapamiętane.",
    boxes_settings: "Pudełka",
    boxes_settings_hint: "Dodawaj pudełka per magazyn — wymiary, waga, zapas. Operatorzy skanują kod pudełka na wysyłce, aby je przypisać.",
    archive_box: "Zarchiwizuj pudełko",
    edit_box: "Edytuj pudełko",
    dimensions_label: "Wymiary",
    barcode_label: "Kod kreskowy",
    forecast: "Prognoza",
    forecast_avg_daily: "Śr. / dzień (ostatnie 7 dni)",
    forecast_to_buy: "Sugerowane zamówienie",
    forecast_units: "szt.",
    forecast_from: "od",
    forecast_no_config: "Ustaw dostawcę, dni zapasu, czas dostawy i bufor, aby uzyskać sugestię zamówienia.",
    forecast_current_stock: "Aktualny stan",
    box_reorder_section: "Dostawca i zamówienia",
    box_supplier_name: "Dostawca",
    box_supplier_none: "— Brak dostawcy —",
    box_supplier_inactive: "zarchiwizowany",
    box_unit_cost: "Koszt jednostkowy (£)",
    box_target_days: "Dni zapasu",
    box_lead_time: "Czas dostawy (dni)",
    box_buffer_units: "Bufor (szt.)",
    box_min_purchase: "Min. zamówienie",
    box_purchase_increment: "Krok zamówienia",
    drag_to_reorder: "Przeciągnij, aby zmienić kolejność",
    forecast_range_days: "{days} dni",
    forecast_avg_daily_range: "Śr. / dzień (ostatnie {days} dni)",
    box_name: "Nazwa pudełka",
    box_dimensions_external_hint: "Wpisz wymiary zewnętrzne (te, które mierzysz miarą). Wnętrze pudełka jest mniejsze o grubość kartonu wybraną poniżej.",
    box_wall_type: "Typ ścianki",
    box_wall_type_single: "Pojedyncza (−8 mm na oś)",
    box_wall_type_double: "Podwójna (−14 mm na oś)",
    box_wall_type_mailbag: "Worek foliowy (mierzony na płasko)",
    box_wall_type_cardboard_mailbag: "Koperta kartonowa (−5 mm na oś, maks. wysokość)",
    box_max_height_mm: "Maks. wysokość (mm)",
    box_height_na_mailbag: "Płaski — bez wysokości",
    box_label_size_title: "Rozmiar etykiety pudełka",
    box_label_size_btn: "Rozmiar etykiety",
    box_label_size_hint: "Pozostaw puste, aby drukować etykiety pudełek w rozmiarze etykiet Wipe tego magazynu (obecnie {w} × {h} mm). Ustaw wartości tylko, jeśli drukarka etykiet pudełek ma załadowany inny materiał.",
    box_label_width_mm: "Szerokość etykiety (mm)",
    box_label_height_mm: "Wysokość etykiety (mm)",
    box_wall_type_hint: "Karton zajmuje miejsce wewnątrz pudełka. Pojedyncza ścianka odejmuje ~8 mm od każdej osi; podwójna ~14 mm. Worki mierzone są na płasko (długość × szerokość): foliowy nic nie traci, koperta kartonowa traci ~5 mm na oś i ma maks. wysokość wypełnienia. Produkty z oznaczeniem Dodatkowa ochrona nigdy nie dostaną worka foliowego.",
    box_primary_large: "Główne duże pudełko",
    box_primary_large_badge: "Główne Duże",
    box_primary_large_hint: "Używaj tego pudełka jako domyślnego największego w rekomendacjach. Większe pudełka są sugerowane tylko wtedy, gdy wymiary przedmiotu naprawdę tego wymagają. Jedno na magazyn — zaznaczenie odznacza inne pudełko.",
    box_length_mm: "Długość (mm)",
    box_width_mm: "Szerokość (mm)",
    box_height_mm: "Wysokość (mm)",
    box_weight_g: "Waga (g)",
    box_max_weight_g: "Maks. waga zawartości (g)",
    box_max_weight_placeholder: "Opcjonalnie",
    box_max_weight_meta: "maks. {kg}kg",
    box_max_weight_invalid: "Maks. waga musi być pusta lub liczbą większą od 0",
    box_max_fill_mm: "Maks. grubość po wypełnieniu (mm)",
    box_max_fill_placeholder: "Opcjonalnie — bez limitu",
    box_max_fill_hint: "Rekomendacja nie zaproponuje tej torby dla zawartości grubszej niż ta wartość. Nigdy nie jest wysyłane do przewoźników.",
    box_max_fill_meta: "≤ {cm} cm po wypełnieniu",
    box_max_fill_invalid: "Maks. grubość musi być pusta lub liczbą większą od 0",
    pack_over_box_max: "Przekroczony limit pudełka {limit}kg ({weight}kg)",
    pack_over_carrier_max: "Przekroczony limit przewoźnika {limit}kg ({weight}kg)",
    box_stock: "Stan",
    add_inventory: "Dodaj zapas",
    add_units: "Liczba sztuk",
    no_boxes_yet: "Brak pudełek",
    confirm_archive_box: "Zarchiwizować pudełko {name}? Operatorzy nie będą mogli go zeskanować. Operacji nie można cofnąć.",
    box_unknown: "Nieznane pudełko",
    box_wrong_warehouse: "To pudełko należy do innego magazynu",
    scan_is_transparency_label: "To etykieta Amazon Transparency — identyfikuje pojedynczą sztukę, nie produkt. Zeskanuj własny kod kreskowy przedmiotu.",
    scan_is_url_qr: "To kod QR ze stroną internetową na opakowaniu, nie kod kreskowy produktu. Zeskanuj własny kod kreskowy przedmiotu.",
    scan_is_logistics_label: "To etykieta kurierska / logistyczna, nie kod kreskowy produktu. Zeskanuj własny kod kreskowy przedmiotu.",
    scan_belongs_to_order: "{item} — należy do zamówienia #{order}, nie do tego. Wygląda na błędne posortowanie.",
    scan_belongs_to_order_tote: "{item} — należy do zamówienia #{order} (pojemnik {tote}), nie do tego. Wygląda na błędne posortowanie.",
    scan_belongs_to_no_order: "{item} — nie ma go w tym zamówieniu ani w żadnym ostatnim zamówieniu tutaj.",
    box_form_invalid: "Wymagane: nazwa, wymiary i waga",
    box_units_invalid: "Wpisz przynajmniej 1 sztukę",
    printer_select: "Wybierz drukarkę",
    scan_box_to_add: "Zeskanuj kod pudełka, aby dodać",
    scan_box_to_reassign: "Zeskanuj kod pudełka, aby zmienić",
    assign_box_1_first: "Najpierw przypisz pudełko 1",
    weight_breakdown: "Przedmioty {items} kg + Pudełko {box} kg",
    size_prefix: "Rozmiar:",
    add_box_hint: "Zeskanuj kod pudełka lub wpisz własne wymiary poniżej.",
    custom_box_name: "Własne",
    length_cm: "Długość (cm)",
    width_cm: "Szerokość (cm)",
    height_cm: "Wysokość (cm)",
    weight_g: "Waga (g)",
    units_in_container: "Sztuk w tym opakowaniu",

    idle_alert: "Czy nadal jesteś?",
    idle_alert_sub: "Nie wykryto aktywności skanowania",
    im_here: "Jestem tutaj",
    session_stats: "Statystyki Sesji",
    dispatch_scanned: "zeskanowano",
    dispatch_shipped: "wysłano",
    order_title_label: "Zamówienie",
    orders_part_of_parent: "Część zamówienia {parent}",
    orders_related_orders: "Powiązane zamówienia",
    orders_view_related: "Otwórz powiązane zamówienie",
    orders_related_open_failed: "Nie udało się otworzyć powiązanego zamówienia",
    orders_consolidated_children: "Skonsolidowane zamówienia w tej przesyłce",
    orders_consolidated_into: "Skonsolidowane do przesyłki {master}",
    orders_remove_from_shipment: "Usuń z przesyłki",
    orders_remove_from_shipment_title: "Usunąć zamówienie z przesyłki?",
    orders_remove_from_shipment_body: "Zamówienie {order} zostanie wyłączone ze skonsolidowanej przesyłki {master} i wysłane osobno. Nie zostanie automatycznie ponownie połączone z przesyłką.",
    orders_remove_from_shipment_last_note: "To ostatnie zamówienie w przesyłce, więc {master} zostanie anulowana.",
    orders_remove_from_shipment_confirm: "Usuń {order}",
    orders_removed_from_shipment: "{order} usunięto z przesyłki {master} — zostanie wysłane osobno",
    orders_removed_from_shipment_last: "{order} usunięto — przesyłka {master} nie miała już zamówień i została anulowana",
    orders_consolidated_lines_hint: "Te pozycje są kopiami pozycji skonsolidowanych zamówień i nie można ich tu edytować. Aby zmienić zawartość przesyłki, usuń zamówienie z przesyłki.",
    orders_shipped_via_master: "Wysłane w ramach zamówienia skonsolidowanego {master}",
    order_tab_details: "Szczegóły",
    // Zakładka Reklamacje (modal szczegółów zamówienia) — order-claims.tsx
    claims_tab: "Reklamacje",
    claims_intro: "Wybierz paczkę (paczki), które zaginęły lub zostały uszkodzone, a następnie produkty w nich. Reklamacje są grupowane i wysyłane e-mailem do przewoźnika według harmonogramu ustawionego w Ustawienia > Integracje > Przewoźnicy.",
    claims_no_parcels: "Żadna paczka z tego zamówienia nie została jeszcze wysłana, więc nie ma czego reklamować.",
    claims_parcels_heading: "Paczki",
    claims_select_all_parcels: "Zaznacz wszystkie paczki",
    claims_unselect_all_parcels: "Odznacz wszystkie paczki",
    claims_select_all_items: "Zaznacz wszystko",
    claims_unselect_all_items: "Odznacz wszystko",
    claims_items_selected: "{n} z {of} produktów",
    claims_packed_in_parcel: "{n} zapakowano w tej paczce",
    claims_carrier_not_supported: "Reklamacje dla {carrier} nie są jeszcze skonfigurowane w Portalu — na razie zgłoś tę reklamację ręcznie u przewoźnika.",
    claims_carrier_disabled: "Reklamacje dla {carrier} są wyłączone. Włącz je w Ustawienia > Integracje > Przewoźnicy, aby zgłaszać stąd.",
    claims_carrier_mixed: "Wybrane paczki wysłano różnymi przewoźnikami — zgłoś osobną reklamację dla każdego przewoźnika.",
    claims_type_label: "Rodzaj reklamacji",
    claims_type_loss: "Zaginięcie",
    claims_type_part_loss: "Częściowe zaginięcie",
    claims_type_damage: "Uszkodzenie",
    claims_cost_label: "Wartość reklamacji £",
    claims_notes_label: "Uwagi dla przewoźnika",
    claims_notes_placeholder: "Opcjonalnie — np. karton zgnieciony, dwie sztuki uszkodzone",
    claims_total: "Suma reklamacji",
    claims_submit: "Zgłoś reklamację ({n} pozycji)",
    claims_submitted: "Reklamacja zgłoszona — trafi do przewoźnika w następnej wysyłce",
    claims_failed: "Nie udało się zgłosić reklamacji",
    claims_existing_heading: "Reklamacje do tego zamówienia",
    claims_existing_empty: "Brak zgłoszonych reklamacji do tego zamówienia",
    claims_status_pending: "Oczekuje na wysyłkę",
    claims_status_submitted: "Wysłano {date}",
    claims_col_parcel: "Paczka",
    claims_col_sku: "SKU",
    claims_col_type: "Rodzaj",
    claims_col_cost: "Wartość",
    claims_col_status: "Status",
    claims_col_by: "Zgłosił(a)",
    claims_col_actions: "Akcje",
    claims_cancel: "Anuluj",
    claims_cancel_aria: "Anuluj reklamację dla {sku}",
    claims_cancel_confirm: "Anulować reklamację dla {sku}? Nie zostanie wysłana do przewoźnika.",
    claims_cancelled: "Reklamacja anulowana",
    claims_cost_source_invoice: "faktura",
    claims_cost_source_portal: "Portal",
    claims_cost_source_invoice_title: "Wycena z faktury Amazon Liquidation Program {invoice} — kwota, którą otrzymuje przewoźnik",
    claims_cost_source_portal_title: "Brak faktury dostawcy dla tego SKU — użyto wprowadzonej wartości",
    claims_invoices_download: "Faktury dostawcy (PDF)",
    claims_invoices_downloading: "Przygotowywanie PDF…",
    claims_invoices_row_aria: "Pobierz fakturę dostawcy dla {sku}",
    claims_invoices_failed: "Nie udało się utworzyć PDF z fakturami dostawcy",

    // Ustawienia reklamacji przewoźnika (Ustawienia > Integracje > Przewoźnicy)
    carriers_claims_toggle: "Automatyczne wysyłanie reklamacji",
    carriers_claims_hint: "Wysyła oczekujące reklamacje (zguba/uszkodzenie) ze strony Zamówień do przewoźnika według harmonogramu.",
    carriers_claims_settings: "Ustawienia reklamacji",
    claims_settings_title: "Ustawienia wysyłki reklamacji",
    claims_settings_from: "Adres nadawcy",
    claims_settings_from_name: "Nazwa nadawcy",
    claims_settings_to: "Adres odbiorcy",
    claims_settings_cc: "Adres DW",
    claims_settings_reply_to: "Adres odpowiedzi",
    claims_settings_subject: "Temat",
    claims_settings_body: "Treść wiadomości",
    claims_settings_placeholders: "{date} zostanie zastąpione datą wysyłki (dd/mm/rr), a {count} liczbą reklamacji. Kilka adresów można rozdzielić przecinkami. Adres nadawcy musi być zweryfikowany w Amazon SES.",
    claims_settings_frequency: "Częstotliwość",
    claims_freq_daily: "Codziennie",
    claims_freq_weekly: "Co tydzień",
    claims_freq_monthly: "Co miesiąc",
    claims_settings_weekly_day: "Dzień tygodnia",
    claims_settings_monthly_day: "Dzień miesiąca",
    claims_settings_time: "Godzina wysyłki (UK)",
    claims_settings_time_hint: "Każda wysyłka zawiera wszystkie reklamacje dodane od poprzedniej. Jeśli nie ma żadnych, e-mail nie jest wysyłany.",
    claims_settings_status_pending: "Oczekujące reklamacje",
    claims_settings_status_next: "Następna zaplanowana wysyłka",
    claims_settings_status_last_run: "Ostatnie uruchomienie",
    claims_settings_last_submission: "Ostatnia wysyłka",
    claims_settings_send_now: "Wyślij oczekujące reklamacje teraz",
    claims_settings_send_now_confirm: "Wysłać teraz {n} oczekujących reklamacji na {to}?",
    claims_settings_saved: "Ustawienia reklamacji zapisane",
    claims_settings_mail_not_configured: "E-mail nie jest skonfigurowany na tym serwerze (zmienne MAIL_*), więc nic nie może zostać wysłane.",
    claims_settings_no_recipient: "Wpisz adres e-mail reklamacji przewoźnika (Do) i zapisz, zanim cokolwiek będzie można wysłać. Zgłoszone w tym czasie reklamacje czekają jako oczekujące.",
    claims_settings_disabled_note: "Wysyłka według harmonogramu jest wyłączona. Reklamacje nadal można zgłaszać w zamówieniach i wysyłać ręcznie stąd.",
    claims_settings_download: "Pobierz arkusz",
    claims_settings_download_invoices: "Pobierz PDF faktur",
    claims_settings_send_failed: "Ostatnia wysyłka nie powiodła się: {error}",
    claims_settings_never: "Nigdy",
    claims_settings_none: "Jeszcze brak",
    claims_settings_off: "Wyłączone",
    claims_day_0: "Niedziela",
    claims_day_1: "Poniedziałek",
    claims_day_2: "Wtorek",
    claims_day_3: "Środa",
    claims_day_4: "Czwartek",
    claims_day_5: "Piątek",
    claims_day_6: "Sobota",

    attachments_tab: "Załączniki",
    attachments_upload: "Prześlij plik",
    attachments_hint: "PDF, PNG, JPG, XLSX lub CSV — maks. 10 MB",
    attachments_empty: "Brak załączników do tego zamówienia",
    attachments_uploaded: "Załącznik przesłany",
    attachments_too_large: "Plik jest za duży — maksymalnie 10 MB",
    attachments_file_missing: "Ten plik nie jest już dostępny — prześlij go ponownie",
    attachments_mark_shipping_label: "Oznacz jako etykietę wysyłkową",
    attachments_shipping_label_badge: "Etykieta wysyłkowa",
    attachments_delete_confirm: "Usunąć {filename}? Tej operacji nie można cofnąć.",
    attachments_download: "Pobierz",
    attachments_delete: "Usuń",
    attachments_col_file: "Plik",
    attachments_col_size: "Rozmiar",
    attachments_col_uploaded_by: "Przesłał(a)",
    attachments_col_date: "Data",
    attachments_col_actions: "Akcje",

    // Zbiorcze przesyłanie etykiet wysyłkowych (menu ⋯ Zamówień)
    orders_bulk_labels: "Prześlij etykiety wysyłkowe",
    bulk_labels_title: "Prześlij etykiety wysyłkowe",
    bulk_labels_intro: "Każdy plik jest dopasowywany do zamówienia po nazwie pliku — numerem zamówienia może być dowolna część między znakami podkreślenia, więc 1_407-1591342-5410759.pdf trafia do zamówienia 407-1591342-5410759. Zaznaczone pliki są dołączane jako etykieta wysyłkowa tego zamówienia.",
    bulk_labels_resolving: "Dopasowywanie {n} plików do zamówień…",
    bulk_labels_resolve_failed: "Nie udało się dopasować plików do zamówień — spróbuj ponownie",
    bulk_labels_summary: "{ready} gotowych · {has_label} ma już etykietę · {unmatched} nie można dołączyć",
    bulk_labels_done_summary: "{done} dołączono · {failed} nieudanych",
    bulk_labels_col_include: "Dołącz",
    bulk_labels_col_file: "Plik",
    bulk_labels_col_order: "Zamówienie",
    bulk_labels_col_status: "Status",
    bulk_labels_choose_order: "Wybierz zamówienie…",
    bulk_labels_status_ready: "Gotowe",
    bulk_labels_status_has_label: "Ma już etykietę wysyłkową — zaznacz, aby zastąpić",
    bulk_labels_status_not_found: "Brak zamówienia o tym numerze",
    bulk_labels_status_ambiguous: "Pasuje kilka zamówień — wybierz jedno",
    bulk_labels_status_invalid_type: "To nie jest PDF, PNG ani JPG",
    bulk_labels_status_too_large: "Ponad 10 MB",
    bulk_labels_status_uploading: "Przesyłanie…",
    bulk_labels_status_done: "Dołączono",
    bulk_labels_status_failed: "Niepowodzenie",
    bulk_labels_upload_n: "Dołącz etykiety: {n}",
    bulk_labels_toast_done: "Dołączono etykiety wysyłkowe: {n}",
    bulk_labels_toast_partial: "Dołączono {done} etykiet, {failed} nieudanych — sprawdź tabelę",

    // Dispatch — oznaczone / szukaj / menu admina
    dispatch_start: "Wysyłka",
    dispatch_flagged: "Oznaczone",

    // Wysyłka — rozładunek przenośnika (paczka na paletę kuriera)
    dispatch_unload: "Rozładunek przenośnika",
    unload_scan_parcel: "Skanuj paczkę",
    unload_put_on: "Połóż na",
    unload_piece_of: "Paczka {position} z {total}",
    unload_scan_pallet: "Zeskanuj paletę {carrier}, aby potwierdzić",
    unload_no_bays: "Brak skonfigurowanych palet kurierskich dla {warehouse}. Dodaj je w Ustawienia › Wysyłka › Palety kurierskie.",
    unload_no_bay_for_carrier: "Brak palety dla {carrier}",
    unload_set_aside: "Odłóż",
    unload_ok: "OK",
    unload_wrong_pallet: "Zła paleta",
    unload_wrong_pallet_detail: "To paleta {scanned}. Ta paczka ma trafić na {expected}.",
    unload_finish_parcel_first: "Najpierw dokończ tę paczkę — zeskanuj paletę {carrier}",
    unload_not_a_pallet: "To nie jest kod palety",
    unload_voided_title: "Nie ładować",
    unload_voided_reopened: "Zamówienie {order} zostało ponownie otwarte. Ta etykieta jest nieważna — zanieś paczkę z powrotem na stanowisko pakowania.",
    unload_voided_cancelled: "Zamówienie {order} zostało anulowane. Ta etykieta jest nieważna — odłóż paczkę.",
    unload_voided_booking: "Rezerwacja {carrier} dla zamówienia {order} została anulowana. Ta etykieta jest nieważna — odłóż paczkę.",
    unload_voided_not_shipped: "Zamówienie {order} nie zostało jeszcze wysłane. Zanieś paczkę z powrotem na stanowisko pakowania.",
    unload_duplicate_title: "Już załadowana",
    unload_duplicate_detail: "Ta etykieta została załadowana na {bay} o {time} przez {name}. Sprawdź, czy etykieta nie jest zdublowana.",
    unload_duplicate_detail_short: "Ta etykieta została już załadowana. Sprawdź, czy etykieta nie jest zdublowana.",
    unload_unknown_title: "Nieznana etykieta",
    unload_unknown_detail: "Ten kod nie jest etykietą zarezerwowaną w Portalu. Odłóż paczkę.",
    unload_unknown_looks_like: "Wygląda jak etykieta {carrier}.",
    unload_wrong_warehouse_title: "Zły magazyn",
    unload_wrong_warehouse_detail: "Zamówienie {order} należy do {warehouse}. Odłóż paczkę.",
    unload_session_wrong: "zła paleta",
    unload_session_aside: "odłożono",
    unload_not_a_parcel_pallet_label: "To etykieta palety. Najpierw naciśnij Zamknij paletę, potem ją zeskanuj.",
    unload_not_a_parcel_floor: "To kod z podłogi. Najpierw zeskanuj paczkę.",
    unload_wrong_barcode_routing: "To numer sortowania. Zeskanuj długi kod kreskowy na etykiecie.",
    unload_wrong_barcode_postcode: "To kod pocztowy. Zeskanuj kod śledzenia.",
    unload_wrong_barcode: "To nie jest kod etykiety wysyłkowej. Zeskanuj kod śledzenia.",
    unload_wrong_barcode_qr: "To kod QR. Zeskanuj kod śledzenia.",
    unload_collection_title: "Odbiór osobisty",
    unload_collection_detail: "Zamówienie {order} jest odbierane z magazynu. Nie ładuj go na paletę kuriera — zanieś je do punktu odbioru.",
    unload_scan_floor_not_label: "Zeskanuj kod z podłogi, nie etykietę palety",
    unload_on_pallet: "{count} na tej palecie",
    unload_close_pallet: "Zamknij paletę",
    unload_close_title: "Zamknij paletę",
    unload_close_pick_bay: "Zeskanuj kod z podłogi palety do zamknięcia",
    unload_close_target: "Zamykanie {carrier} · {count} paczek",
    unload_close_other_bay: "lub zeskanuj inny kod z podłogi",
    unload_close_cancel: "Anuluj",
    unload_close_no_pallets: "{carrier} nie ma palety do zamknięcia. Paczki są tylko sprawdzane na właściwej pozycji.",
    unload_close_scan_again: "Zeskanuj ten sam kod z podłogi ponownie, aby ją zamknąć",
    unload_close_done_hint: "Lider zespołu wydrukuje etykietę palety.",
    unload_close_printed_hint: "Etykieta wydrukowana. Naklej ją na tę paletę.",
    unload_close_printing: "Drukowanie etykiety…",
    unload_close_print_failed: "Etykieta się nie wydrukowała. Sprawdź drukarkę i naciśnij Drukuj ponownie.",
    unload_close_print_again: "Drukuj ponownie",
    print_on_close_title: "Drukuj przy zamknięciu",
    print_on_close_hint: "Drukuj etykietę palety na drukarce terminala przy rozładunku, gdy tylko paleta zostanie zamknięta. Gdy wyłączone, etykietę drukuje lider zespołu z Wysyłki.",
    print_on_close_unavailable: "Wymaga migracji bazy danych 226, zanim będzie można to włączyć.",
    outbound_view: "Widok",
    outbound_view_parcels: "Paczki",
    outbound_view_pallets: "Palety",
    outbound_print_label: "Drukuj etykietę",
    outbound_print_failed: "Etykieta palety się nie wydrukowała. Sprawdź drukarkę.",
    outbound_printed: "Wydrukowano {sku}",
    unload_close_done: "Paleta zamknięta",
    unload_close_done_detail: "{sku} · {count} paczek",
    unload_close_empty: "Na tę paletę nic jeszcze nie zeskanowano",
    unload_added_closed: "Dodano do zamkniętej palety",
    unload_pallet_loaded: "{sku} jest już na ciężarówce — zeskanuj kod z podłogi",
    unload_scan_pallet_or_label: "Lub zeskanuj etykietę zamkniętej palety, aby dodać do niej paczkę",
    unload_move_start: "Przenieś na inną paletę",
    unload_move_to: "Przenieś na",
    unload_move_from: "Teraz na {from}",
    unload_move_cancel: "Anuluj przeniesienie",
    unload_move_same: "Paczka już jest na tej palecie — zeskanuj paletę docelową",
    unload_move_loaded: "{sku} jest już na ciężarówce — tej paczki nie można przenieść",
    unload_move_unavailable: "Przenoszenie paczek nie jest jeszcze włączone",
    unload_moved: "Paczka przeniesiona",
    unload_moved_detail: "Z {from} na {to}",
    dispatch_found_items: "Znalezione przedmioty",
    found_scan_item: "Skanuj znaleziony przedmiot",
    found_scan_shelf: "Skanuj półkę",
    found_for_order: "Potrzebny do zamówienia",
    found_last_booked: "Ostatnio: zamówienie {order} → półka {shelf}",
    found_not_a_shelf: "To nie jest półka na znalezione przedmioty — zeskanuj półkę przy wysyłce",
    found_wrong_warehouse: "Ta półka należy do innego magazynu",
    found_book_back_title: "Przyjmij przedmiot z powrotem",
    found_book_back_dispatched: "Zamówienie {order} zostało wysłane {time}, ponad 48 godzin temu, więc klient mógł już otrzymać zwrot pieniędzy. Przyjmij ten przedmiot z powrotem, aby mógł wrócić na aukcję.",
    found_ship_separately_title: "Wyślij ten przedmiot osobno",
    found_ship_separately_detail: "Zamówienie {order} dla {customer} zostało wysłane {shipped} bez tego przedmiotu. Wyślij go klientowi w osobnej paczce.",
    found_ship_separately_deadline: "Wyślij do {time} — później przyjmij go z powrotem.",
    found_ship_separately_detail_unpacked: "Zamówienie {order} dla {customer} zostało zamknięte bez tego przedmiotu. Wyślij go klientowi w osobnej paczce.",
    found_ship_how: "Utwórz dodatkową paczkę: Zamówienia › {order} › Wyślij dodatkową paczkę.",
    found_ship_how_refund_pending: "Zwrot nie został jeszcze wystawiony — wybierz \"Anuluj oczekujący zwrot i wyślij\", aby klient nie dostał również zwrotu.",
    found_book_back_cancelled: "Zamówienie {order} zostało anulowane. Przyjmij ten przedmiot z powrotem, aby mógł wrócić na aukcję.",
    found_book_back_refunded: "Za ten przedmiot w zamówieniu {order} zwrócono pieniądze. Przyjmij go z powrotem, aby mógł wrócić na aukcję.",
    found_book_back_no_order: "Żadne otwarte zamówienie nie potrzebuje {sku}. Przyjmij ten przedmiot z powrotem, aby mógł wrócić na aukcję.",
    found_book_back_not_worth: "Zamówienie {order} zostało wysłane bez tego przedmiotu, ale wysłanie go osobno kosztuje więcej, niż klient za niego zapłacił. Zamiast tego zwróć klientowi pieniądze i przyjmij przedmiot z powrotem, aby mógł wrócić na aukcję.",
    found_book_back_not_worth_done: "Przedmiot z zamówienia {order} ma status „Oczekuje na zwrot”. Przyjmij go z powrotem przez Przyjęcie Towaru, aby mógł wrócić na aukcję.",
    found_cost_line_tariff: "Wysyłka osobno ≈ {shipping} · klient zapłacił {value}",
    found_cost_line_estimate: "Wysyłka osobno ≈ {shipping} (szacunek) · klient zapłacił {value}",
    found_refund_instead: "Przenieś do „Oczekuje na zwrot”",
    found_refund_instead_refused: "Tego przedmiotu nie można już zwrócić z tego miejsca. Zeskanuj go ponownie.",
    found_single_item_title: "Zamówienie z jednym przedmiotem",
    found_single_item_detail: "To jedyny przedmiot w zamówieniu {order}, więc nic innego nie przyniesie go na stanowisko pakowania. Nie odkładaj go na półkę.",
    found_single_item_how: "Wyślij do pakowania — wygeneruj tymczasową skrzynkę: Zamówienia › {order} › Wyślij do pakowania. Zanieś przedmiot na stanowisko pakowania i zeskanuj lub wpisz tam kod tymczasowej skrzynki.",
    found_already_shelved_title: "Już na półce",
    found_already_shelved_detail: "Ten przedmiot jest już przypisany do zamówienia {order} na półce {shelf}.",
    found_flagged_title: "Zamówienie oznaczone",
    found_flagged_detail: "Przedmiot jest na półce {shelf}. Zamówienie {order} jest oznaczone — wyślij je przez Wysyłka › Oznaczone › {order} › Rozwiąż › Wyślij i zapakuj w nowe pudełko.",
    found_at_desk_title: "Zanieś na stanowisko {desk}",
    found_at_desk_detail: "{packer} pakuje teraz zamówienie {order} na stanowisku {desk}. Przekaż ten przedmiot pakowaczowi — zeskanuje go od razu do zamówienia. Nie odkładaj go na półkę: pakowacz go tam nie zobaczy.",
    found_at_desk_detail_no_packer: "Zamówienie {order} jest teraz pakowane na stanowisku {desk}. Przekaż ten przedmiot pakowaczowi — zeskanuje go od razu do zamówienia. Nie odkładaj go na półkę: pakowacz go tam nie zobaczy.",
    found_at_desk_shelve: "Nikogo nie ma — odłóż na półkę",
    found_on_shelf_title: "Na półce — czeka na pakowacza",
    found_on_shelf_none: "Na półkach nie ma znalezionych przedmiotów",
    found_put_back_title: "Zamówienie nieaktualne — przyjmij z powrotem",
    found_put_back_meta: "Półka {shelf} · zamówienie {order}",
    found_booked_back: "Przyjęto z powrotem",
    found_pill_found: "Znalezione",
    found_pill_book_in: "Przyjmij",
    found_book_in_title: "Zdejmij z półki i przyjmij z powrotem",
    found_book_in_hint: "Zeskanuj każdy przedmiot zdejmowany z półki (dotknij go, jeśli go nie ma), a potem naciśnij przycisk",
    found_book_in_none: "Nic do przyjęcia z powrotem",
    found_book_in_reason_cancelled: "zamówienie {order} anulowane",
    found_book_in_reason_not_at_desk: "zamówienie {order} wysłane bez niego",
    found_book_in_scanned: "Zeskanowano {scanned} z {total}",
    found_taken_off_shelf: "Zdjęte z półki ({count})",
    found_taken_off_done: "Zdjęto z półki: {count} — przyjmij je z powrotem przez Goods In",
    found_book_in_not_listed: "Tego przedmiotu nie ma na liście do przyjęcia",
    found_book_in_already: "Już zeskanowany",
    dispatch_load: "Załadunek ciężarówki",
    load_pick_courier: "Który kurier jest ładowany?",
    load_scan_pallet: "Skanuj etykietę palety",
    load_loading: "Załadunek {carrier}",
    load_loaded_detail: "{label} · {count} paczek",
    load_loaded_today: "{count} załadowano dziś",
    load_session_loaded: "załadowano",
    load_wrong_courier_title: "Zła ciężarówka",
    load_wrong_courier_detail: "{label} to paleta {pallet_carrier}. Ładujesz {loading_carrier}.",
    load_already_loaded_title: "Już załadowana",
    load_already_loaded_detail: "{label} załadowano o {time} przez {name}.",
    load_label_unused_title: "Paleta niezamknięta",
    load_label_unused_detail: "{label} nie została naklejona na paletę. Najpierw zamknij paletę przy rozładunku.",
    load_wrong_warehouse_title: "Zły magazyn",
    load_wrong_warehouse_detail: "{label} należy do {warehouse}.",
    load_not_a_pallet: "To nie jest etykieta palety",
    load_not_a_pallet_parcel: "To etykieta paczki. Zeskanuj etykietę palety.",
    load_not_a_pallet_floor: "To kod z podłogi. Zeskanuj etykietę palety.",
    outbound_courier_pallets_title: "Palety kurierskie",
    outbound_courier_pallets_empty: "Tego dnia nie zamknięto ani nie załadowano żadnej palety",
    outbound_col_pallet: "Paleta",
    outbound_col_position: "Pozycja",
    outbound_col_parcels: "Paczki",
    outbound_col_closed: "Zamknięto",
    outbound_col_loaded: "Załadowano",
    outbound_pallet_open: "Otwarta",
    outbound_pallet_closed: "Zamknięta",
    outbound_pallet_loaded: "Załadowana",
    outbound_detail_loaded_pallet: "Załadowano na {bay} ({pallet}) o {time}",
    outbound_detail_on_lorry: "na ciężarówce {time}",
    outbound_title: "Wysyłki wychodzące",
    outbound_hint: "Załadunek przy rozładunku przenośnika i palety, które opuściły {warehouse} wybranego dnia: paczki wysłane a załadowane wg kuriera, paczki niezaładowane, skany na złą paletę i wydane palety Palletways.",
    warehouse_tile_outbound_desc: "Załadunek wg kuriera — wysłane a załadowane",
    outbound_pallets_title: "Wydane palety",
    outbound_pallets_empty: "Tego dnia nie wydano żadnych palet",
    outbound_pallets_count: "Palety",
    outbound_pallets_state: "Stan",
    outbound_pallets_consignment: "Przesyłka",
    outbound_pallets_released: "Wydano",
    outbound_pallet_state_booked: "Zarezerwowana",
    outbound_pallet_state_released: "Wydana",
    outbound_pallet_state_shipped: "Wysłana",
    outbound_filter_courier: "Kurier",
    outbound_filter_status: "Status",
    outbound_search_placeholder: "Numer zamówienia lub przesyłki",
    outbound_parcels_title: "Paczki",
    outbound_rows_empty: "Brak paczek pasujących do filtrów",
    outbound_col_time: "Czas",
    outbound_col_order: "Zamówienie",
    outbound_col_courier: "Kurier",
    outbound_col_code: "Kod",
    outbound_col_status: "Status",
    outbound_col_detail: "Szczegóły",
    outbound_col_by: "Kto",
    outbound_tag_loaded: "Załadowana",
    outbound_tag_not_loaded: "Niezaładowana",
    outbound_tag_set_aside: "Odłożona",
    outbound_tag_wrong_pallet: "Zła paleta",
    outbound_tag_voided: "Nieważna etykieta",
    outbound_tag_duplicate: "Zdublowana etykieta",
    outbound_tag_unknown_label: "Nieznana etykieta",
    outbound_tag_wrong_warehouse: "Zły magazyn",
    outbound_detail_loaded: "Załadowano na {bay} o {time}",
    outbound_detail_not_loaded: "Wysłano {time} · paczka {position}{desk}",
    outbound_detail_set_aside: "Odłożono o {time}",
    outbound_detail_mismatch: "Zeskanowano na {bay} — powinno być {expected}",
    unload_summary_title: "Załadunek wg kuriera",
    unload_summary_date: "Data",
    unload_summary_courier: "Kurier",
    unload_summary_shipped: "Wysłano",
    unload_summary_loaded: "Załadowano",
    unload_summary_not_loaded: "Niezaładowane",
    unload_summary_mismatches: "Zła paleta",
    unload_summary_unknown: "Zeskanowane nieznane etykiety: {count}",
    unload_summary_not_loaded_list: "Wysłane, ale niezaładowane",
    unload_summary_events_list: "Problemy",
    unload_summary_empty: "Nic nie wysłano tego dnia",
    unload_summary_all_loaded: "Wszystkie paczki załadowane",
    unload_event_mismatch: "zeskanowano na {bay} ({scanned}) — powinno być {expected}",
    unload_event_set_aside: "odłożono",
    unload_event_voided: "nieważna etykieta",
    unload_event_duplicate: "zdublowana etykieta",
    unload_event_unknown: "nieznana etykieta",
    unload_event_wrong_warehouse: "zły magazyn",
    flag_order: "Oznacz Zamówienie",
    flag_order_confirm: "Oznaczyć to zamówienie do przeglądu przez lidera?",
    order_flagged: "Zamówienie Oznaczone",
    no_flagged_orders: "Brak oznaczonych zamówień",
    flagged_orders_title: "Oznaczone Zamówienia",
    flagged_reason_user: "Oznaczone przez personel wysyłki",
    flagged_reason_packing: "Problem z pakowaniem",
    flagged_reason_label: "Problem z etykietą",
    resolve: "Rozwiąż",
    resolved: "Rozwiązane",
    resolve_confirm: "Oznaczyć to zamówienie jako rozwiązane?",
    flagged_at: "Oznaczono",
    flagged_by_name: "Oznaczone przez {name}",
    search_placeholder: "Numer zamówienia, SKU, nazwa klienta lub kod pocztowy",
    search_placeholder_flagged: "Numer zamówienia, SKU, kod kreskowy, klient lub oznaczający",

    // Statusy zamówień
    status_all: "Wszystkie",
    status_unfulfilled: "Niezrealizowane",
    status_picking: "Kompletowanie",
    status_picked: "Skompletowane",
    status_sorting: "Sortowanie",
    status_dispatch: "Wysyłka",
    status_fulfilled: "Zrealizowane",
    status_partially_fulfilled: "Częściowo zrealizowane",
    status_flagged: "Oznaczone",
    status_partially_refunded: "Częściowo zwrócone",
    status_refunded: "Zwrócone",
    status_pending_refund: "Oczekuje na zwrot",
    status_cancelled: "Anulowane",
    status_on_hold: "Wstrzymane",
    status_exchange: "Wymiana",
    status_stock_blocked: "Brak zapasów",
    status_consolidated: "Skonsolidowane",
    order_locked_fulfilled: "To zamówienie zostało zrealizowane — przesyłka została wysłana i edycja nie jest już możliwa.",
    flagged_kpi_open: "Otwarte",
    flagged_kpi_avg_resolution: "Średni czas rozwiązania",
    flagged_kpi_resolved: "Rozwiązane",
    flagged_sort: "Sortuj wg",
    flagged_sort_oldest: "Najstarsze",
    flagged_sort_newest: "Najnowsze",
    flagged_kpi_overdue: "{count} zaległych",
    flagged_scan_hint: "Zeskanuj kod flagi, aby otworzyć zamówienie, lub produkt, aby filtrować",
    flagged_lines_count: "{count} pozycji",

    // Flagged Picks (2026-10-08) — Pick Face walk, Flagged tile, pack desk
    flagged_picks: "Oznaczone pobrania",
    fp_landing_open: "{count} szt. do pobrania",
    fp_landing_none: "Nic do pobrania — wszystkie brakujące pozycje są rozliczone",
    fp_landing_hint: "Pozycje, których pickerzy nie znaleźli na pick face, a które są na stanie na górze. Zeskanuj pojemnik, aby zanieść je na półkę w pakowalni.",
    fp_walk_in_progress: "{name} już idzie z pojemnikiem {tote}",
    fp_sub_tote: "Zeskanuj pusty pojemnik do kompletacji",
    fp_sub_go_to: "Idź do tej lokalizacji i zeskanuj ją",
    fp_sub_items: "Zeskanuj każdą sztukę do pojemnika",
    fp_sub_stage: "Zeskanuj sztukę z pojemnika lub dotknij jej poniżej, a potem półkę odkładczą, na którą trafia",
    fp_stage_scan_for: "Zeskanuj półkę odkładczą dla {sku}",
    fp_stage_item_done: "{units} × {sku} odłożono na {location}",
    fp_stage_scan_unknown: "Najpierw zeskanuj sztukę z pojemnika, potem jej półkę",
    fp_stage_not_in_tote: "Tej pozycji nie ma w pojemniku",
    fp_stage_continue: "Kontynuuj obchód",
    fp_stage_tote_empty: "Pojemnik jest jeszcze pusty — użyj Opuść obchód, aby przerwać",
    fp_stage_nothing_left: "Pojemnik jest pusty i nie ma więcej przystanków — opuść obchód, aby zwolnić pojemnik",
    fp_walk_closed_empty: "Obchód zakończony — nic do odłożenia, pojemnik jest wolny",
    fp_stage_tote_title: "W pojemniku",
    fp_stage_shelved_title: "Na półkach",
    fp_stage_shelved_at: "Na półce {location}",
    fp_next_location: "Następna lokalizacja",
    fp_skip_location: "Pomiń na razie",
    fp_not_here_btn: "Nie ma",
    fp_not_here_confirm: "Potwierdzić, że tej sztuki nie ma w {location}? Zapas zapisany tutaj zostanie odpisany, a system poszuka jej gdzie indziej; jeśli jej nie ma, zamówienie wyjdzie bez niej.",
    fp_not_here_done: "Odpisano — zamówienie wyjdzie bez tej sztuki",
    fp_not_here_found: "Odpisano tutaj — {units} szt. znaleziono w {locations}, dodano do tego obchodu",
    fp_not_here_awaiting: "Odpisano tutaj — {units} szt. jest w pojemniku drop, dołączy do obchodu po odłożeniu",
    fp_stage_done: "Pojemnik opróżniony — {units} szt. na półkach odkładczych",
    fp_stage_returned: "{count} przystanków zostaje na następny obchód",
    fp_not_staging: "To nie jest półka odkładcza — zeskanuj półkę w pakowalni",
    fp_not_a_stop: "Ta lokalizacja nie jest na tym obchodzie",
    fp_wrong_location: "Zła lokalizacja — idź do {location}",
    fp_no_tasks: "Teraz nie ma nic do pobrania",
    fp_locked: "Ten pojemnik jest używany przez {by}",
    fp_user_has_open_tote: "Masz już otwarty pojemnik {tote} gdzie indziej — najpierw go zakończ",
    fp_tote_rejected: "Tego pojemnika nie można użyć ({reason})",
    fp_scan_not_wanted: "Ta pozycja nie jest potrzebna w tej lokalizacji",
    fp_scan_done: "Wszystkie sztuki tej pozycji są już w pojemniku",
    fp_scan_unknown: "Nieznany kod kreskowy",
    fp_for_order: "Zamówienie #{order}",
    fp_abandon: "Opuść obchód",
    fp_abandon_confirm: "Opuścić ten obchód? Przystanki wrócą na listę dla następnego lidera.",
    fp_abandon_must_stage: "W pojemniku są sztuki — zeskanuj półkę odkładczą, aby zakończyć",
    fp_put_back_title: "Odłóż z powrotem",
    fp_put_back_hint: "Anulowane po pobraniu - Zeskanuj sztukę z półki lub dotknij pozycji poniżej",
    fp_put_back_none: "Nic do odłożenia",
    fp_put_back_done: "Odłożono {units} szt. na {location}",
    fp_put_back_scan: "Zeskanuj lokalizację regałową dla {qty} × {sku}",
    fp_put_back_not_storage: "To nie jest lokalizacja magazynowa",
    fp_put_back_all_counted: "Wszystkie {count} szt. z półki są już policzone",
    fp_put_back_not_on_shelf: "Tej pozycji nie ma na półce do odłożenia",
    fp_put_back_scan_unknown: "Nieznany kod kreskowy - zeskanuj sztukę lub dotknij pozycji poniżej",
    fp_put_back_gone: "Ta pozycja została już odłożona",
    fp_put_back_qty_label: "Odkładanie",
    fp_put_back_clear: "Wyczyść",
    fp_pill_walk: "Obchód",
    fp_pill_put_back: "Odłóż",
    fp_not_available: "Oznaczone pobrania są włączone tylko w Pembroke",
    fp_tote: "Pojemnik {tote}",
    fp_remaining_units: "{count} do zrobienia",
    fp_session_ended: "Ten obchód został zamknięty gdzie indziej",
    flagged_picks_tile: "Oznaczone pobrania",
    flagged_picks_tile_sub: "{count} w drodze",
    fp_kpi_open: "Otwarte",
    fp_kpi_shelf_time: "Śr. czas od oznaczenia do półki",
    fp_kpi_put_back: "Do odłożenia",
    fp_status_awaiting_stock: "Czeka na odłożenie — w pojemniku {module} {tote} ({name})",
    fp_status_awaiting_stock_unknown: "Czeka, aż towar zostanie odłożony",
    fp_hold_module_shelf: "shelf drop",
    fp_hold_module_forecast: "forecast drop",
    fp_no_shelf_yet: "jeszcze bez półki",
    fp_eta_after_put_away: "Obchód po odłożeniu",
    fp_notice_awaiting_stock: "W pojemniku drop — lider przyniesie po odłożeniu",
    fp_landing_awaiting: "{count} szt. więcej jest w pojemnikach shelf / forecast drop — dołączą do obchodu po odłożeniu",
    fp_status_pending: "Czeka na lidera",
    fp_status_picking: "Pobiera {name}",
    fp_status_staged: "Na półce {location}",
    fp_status_put_back: "Do odłożenia z {location}",
    fp_eta_due_in: "Na stanowisku za {time}",
    fp_eta_overdue: "Pakowacz czeka {time}",
    fp_eta_now: "Teraz na stanowisku",
    fp_eta_unknown: "Brak szacunku",
    fp_cancel: "Anuluj pobranie",
    fp_cancel_confirm: "Anulować to pobranie? Zamówienie wyjdzie bez tej sztuki.",
    fp_release_order: "Zwróć do wysyłki",
    fp_release_done: "Zamówienie #{order} wróciło do kolejki pakowania",
    fp_release_not_staged: "Sztuki nie ma jeszcze na półce",
    fp_awaiting_flag: "Oznaczone na stanowisku przez {name}",
    fp_from_location: "z {location}",
    fp_back_to_orders: "Oznaczone zamówienia",
    fp_empty: "Brak oznaczonych pobrań",
    fp_origin_picking_missing: "Brak przy pobraniu",
    fp_origin_pas_flag_missing: "Brak przy sortowaniu",
    fp_origin_pas_flag_remaining: "Brak przy sortowaniu",
    fp_origin_found_item: "Znaleziony przedmiot",
    fp_shelf_wait: "Czeka na pakowanie",
    fp_shelf_resolve: "Rozwiąż w Oznaczonych",
    fp_shelf_ship: "Wyślij osobno",
    fp_shelf_ship_by: "Wyślij osobno do {time}",
    fp_shelf_book_back_in: "Przyjmij z powrotem",
    flagged_found_tile: "Znalezione przedmioty na półce",
    flagged_found_tile_sub: "czekają na pakowacza",
    fp_kpi_on_shelf: "Na półce",
    fp_found_empty: "Brak znalezionych przedmiotów na półkach",
    fp_found_by: "Znalazł(a) {name} o {time}",
    fp_notice_found_hint: "Znalezionego przedmiotu nie ma na półce? Kontynuuj i oznacz go jako brakujący — zamówienie wyjdzie bez niego.",
    fp_notice_title: "Pozycje z Oznaczonych pobrań",
    fp_notice_body: "Tych sztuk brakowało na pick face, ale są na stanie. Zabierz odłożone przed pakowaniem; oznacz zamówienie, jeśli któraś jest jeszcze w drodze.",
    fp_notice_staged: "Na półce {location}",
    fp_notice_pending: "Pobierana z górnych regałów",
    fp_notice_picking: "Pobiera {name}",
    fp_notice_eta: "Oczekiwana na stanowisku {time}",
    fp_notice_continue: "Kontynuuj",
    fp_notice_flag: "Oznacz zamówienie — jeszcze niegotowe",
    fp_notice_title_pending: "Jeszcze nie na półce",
    fp_notice_body_pending: "Sztuka do tego zamówienia jest wciąż pobierana z górnych regałów. Oznacz zamówienie i zostaw przy nim pojemnik — lider odeśle je do kolejki pakowania, gdy sztuka będzie na półce.",
    fp_notice_body_scan: "Zabierz każdą sztukę z półki w pakowni i zeskanuj ją tutaj — liczy się jako spakowana, więc nie skanujesz jej ponownie.",
    fp_notice_collected: "{got} / {qty} zeskanowano",
    fp_notice_leave: "Opuść zamówienie",
    dsd_notice_title: "To jest zamówienie z nośnikami danych",
    dsd_notice_instruction: "Zostaw w oryginalnym opakowaniu",
    dsd_notice_scan: "Zeskanuj pierwszy produkt, aby kontynuować",
    order_notes_notice_title: "Notatka do zamówienia {order}",
    fp_eta_due_at: "Na stanowisku ok. {time}",
    fp_item_chip_awaiting: "Czeka na pobranie",
    fp_item_chip_shelf: "Półka {location}",
    fp_complete_blocked: "Sztuka jest wciąż pobierana z górnych regałów — poczekaj lub oznacz zamówienie",
    flagged_reason_awaiting_pick: "Oczekuje na oznaczone pobranie",
    sales_channel: "Kanał sprzedaży",
    inventory_title: "Zapasy",
    inventory_hint: "Stany magazynowe zsumowane na (SKU, magazyn). Sumy są przeliczane automatycznie przy rejestracji, odkładaniu i rezerwacji zamówień.",
    pos_settings: "Zamówienia (PO)",
    pos_settings_hint: "Zamówienia zakupu pogrupowane z tabeli manifestów wg dostawcy i numeru PO. Wybierz dostawcę, potem PO, aby porównać ilości oczekiwane z przyjętymi. Wiersze zmieniają kolor na zielony po pełnym przyjęciu. Akcje PO dotyczą wszystkich wierszy tego PO i od razu widać je na stronie Manifest.",
    pos_crumb_suppliers: "Dostawcy",
    pos_no_supplier: "Brak dostawcy",
    pos_no_po: "Brak numeru PO",
    pos_col_active_pos: "Aktywne PO",
    pos_col_total_pos: "Wszystkie PO",
    pos_col_open_lines: "Otwarte wiersze",
    pos_col_lines: "Wiersze gotowe",
    pos_col_progress: "Postęp",
    pos_col_updated: "Ostatnia aktywność",
    pos_active_only: "Aktywne",
    pos_show_all: "Pokaż wszystkie",
    pos_no_suppliers: "Brak manifestów — wczytaj manifest na stronie Manifest, aby zobaczyć tu dostawców.",
    pos_no_pos: "Brak aktywnych PO dla tego dostawcy.",
    pos_no_lines: "Brak pasujących wierszy.",
    pos_lines_filter_all: "Wszystkie wiersze",
    pos_lines_filter_outstanding: "Zaległe",
    pos_lines_filter_complete: "Zakończone",
    pos_lines_search_hint: "Filtruj wg SKU…",
    pos_lines_showing: "Wyświetlono {shown} z {total} wierszy",
    pos_summary_lines: "{done} z {total} wierszy zakończonych",
    pos_summary_units: "Przyjęto {received} z {expected} sztuk",
    pos_action_cancel: "Anuluj PO",
    pos_action_reopen: "Otwórz ponownie PO",
    pos_action_close_short: "Zamknij z brakiem",
    pos_action_done: "Zaktualizowano wierszy: {count}",
    pos_confirm_cancel_title: "Anulować to PO?",
    pos_confirm_cancel_body: "{count} otwartych wierszy na PO {po} zostanie anulowanych. Wiersze już przyjęte pozostaną bez zmian. Rejestracja nie będzie już dopasowywać do tego PO.",
    pos_confirm_reopen_title: "Otworzyć ponownie to PO?",
    pos_confirm_reopen_body: "{count} wierszy na PO {po}, które wciąż mają zaległe sztuki, wróci do statusu otwartego, aby rejestracja mogła je ponownie dopasować.",
    pos_confirm_close_short_title: "Zamknąć to PO z brakiem?",
    pos_confirm_close_short_body: "{count} otwartych wierszy na PO {po} zostanie oznaczonych jako zrealizowane, mimo że przyjęto mniej sztuk niż oczekiwano. Użyj, gdy reszta nie dotrze. Później można otworzyć ponownie.",
    manifest_settings: "Manifest",
    manifest_settings_hint: "Oczekiwany zapas — PO i preordery oczekujące na przyjęcie. Rejestracja dopasowuje każdy zeskanowany przedmiot do otwartego wpisu manifestu, aby pobrać koszt. Jeden wiersz na SKU; powtórz po_number na wielu wierszach dla PO z wieloma SKU.",
    inventory_tab_stock: "Podsumowanie zapasów",
    inventory_tab_receipts: "Przyjęcia",
    inventory_tab_manifests: "Manifest",
    inventory_tab_detail: "Szczegóły zapasów",
    inventory_tab_locations: "Lokalizacje zapasów",
    inventory_export_csv: "Eksport CSV",
    inventory_export_xlsx: "Eksport XLSX",
    inventory_exporting: "Eksportowanie…",
    inventory_filter_sku: "Filtruj po SKU…",
    inventory_filter_detail: "Szukaj SKU, lokalizacji, PO lub pojemnika…",
    inventory_filter_locations: "Szukaj SKU, lokalizacji lub pojemnika…",
    inventory_filter_sku_hint: "Filtruj po SKU lub kodzie kreskowym (naciśnij Enter)",
    inventory_filter_detail_hint: "Szukaj SKU, kodu kreskowego, lokalizacji, PO lub pojemnika (naciśnij Enter)",
    inventory_filter_locations_hint: "Szukaj SKU, kodu kreskowego, lokalizacji lub pojemnika (naciśnij Enter)",
    inventory_filter_sellable_all: "Wszystkie",
    inventory_filter_supplier: "Filtruj po dostawcy…",
    inventory_filter_supplier_hint: "Filtruj po dostawcy (naciśnij Enter)",
    manifest_filter_search: "Szukaj nr manifestu, SKU, PO lub dostawcy…",
    manifest_filter_search_hint: "Szukaj nr manifestu, SKU, PO lub dostawcy (naciśnij Enter)",
    inventory_col_sku: "SKU",
    inventory_col_barcode: "Kod kreskowy",
    inventory_col_warehouse: "Magazyn",
    inventory_col_location: "Lokalizacja",
    inventory_col_tote: "Pojemnik",
    inventory_col_qty: "Ilość",
    inventory_col_sellable: "Sprzedawalne",
    inventory_col_unsellable: "Niesprz.",
    inventory_col_allocated: "Zarezerw.",
    inventory_col_reserved: "Sprzedane",
    inventory_reserved_hint: "Sprzedane w kanale, oczekuje na falę kompletacji — lokalizacja nie jest jeszcze przypisana. Dostępność w kanale = Dostępne − Sprzedane (oczekujące).",
    inventory_col_reserved_projected: "Sprzedane (prognoza)",
    inventory_reserved_projected_hint: "Prognozowany udział sprzedanych (oczekujących na falę) sztuk SKU w tym wierszu — najstarsze zapasy najpierw. Rzeczywiste lokalizacje wybiera fala kompletacji.",
    inventory_col_on_hand: "Dostępne",
    inventory_col_total: "Razem",
    inventory_col_remaining: "Pozostało",
    inventory_col_total_cost: "Łączny koszt",
    inventory_col_unit_cost: "Cena jedn.",
    inventory_col_currency: "Waluta",
    inventory_col_po: "Nr PO",
    inventory_col_supplier: "Dostawca",
    inventory_col_received: "Przyjęto",
    inventory_col_status: "Status",
    inventory_status_available: "Dostępne",
    inventory_status_reserved: "Zarezerwowane",
    inventory_status_damaged: "Uszkodzone",
    inventory_status_quarantined: "Kwarantanna",
    inventory_status_archived: "Zarchiwizowane",
    inventory_detail_download_template: "Pobierz szablon",
    inventory_detail_upload_csv: "Wgraj CSV",
    inventory_detail_upload_xlsx: "Wgraj XLSX",
    inventory_detail_upload_empty: "Arkusz jest pusty",
    inventory_detail_upload_bad_header: "Arkusz musi zawierać kolumny action i sku (lub detail_id dla update/remove)",
    inventory_detail_upload_parse_error: "Nie można odczytać arkusza — upewnij się, że to prawidłowy plik .xlsx",
    inventory_receive_stock: "Przyjmij zapas",
    inventory_receive_btn: "Przyjmij",
    inventory_receive_invalid: "SKU, magazyn, lokalizacja, ilość (>0) i cena jednostkowa (≥0) są wymagane.",
    inventory_no_stock: "Brak zapasów dla wybranych filtrów.",
    inventory_no_receipts: "Brak przyjęć dla wybranych filtrów.",
    inventory_no_locations: "Brak lokalizacji dla wybranych filtrów.",

    // Manifest — oczekiwany zapas (PO / preordery) przed przyjęciem.
    manifest_add_title: "Dodaj wpis manifestu",
    manifest_add_btn: "Dodaj",
    manifest_invalid: "SKU, magazyn, oczekiwana ilość (>0) i cena jednostkowa (≥0) są wymagane.",
    manifest_no_rows: "Brak wpisów manifestu dla wybranych filtrów.",
    manifest_col_id: "Nr manifestu",
    manifest_col_expected_qty: "Oczekiwana ilość",
    manifest_col_remaining_qty: "Pozostało",
    manifest_col_received: "Przyjęto",
    manifest_col_manifest_date: "Data manifestu",
    manifest_col_expected_at: "Oczekiwane",
    manifest_col_status: "Status",
    manifest_status_open: "Otwarty",
    manifest_status_fulfilled: "Zrealizowany",
    manifest_status_cancelled: "Anulowany",
    manifest_status_archived: "Zarchiwizowany",
    manifest_tab_hint: "Każdy wiersz manifestu obejmuje jedno SKU. Gdy PO zawiera wiele produktów, dodaj jeden wiersz na każde SKU i powtórz ten sam po_number — tak system je łączy. Można przyjąć więcej lub mniej niż oczekiwana ilość; rejestracja zużywa najpierw najstarszy pasujący PO.",
    manifest_download_template: "Pobierz szablon",
    manifest_download_current: "Pobierz bieżący",
    manifest_upload_csv: "Wgraj CSV",
    manifest_upload_xlsx: "Wgraj XLSX",
    manifest_upload_empty: "Arkusz jest pusty",
    manifest_upload_bad_header: "Arkusz musi zawierać kolumny action i sku (lub manifest_id dla cancel/archive)",
    manifest_upload_parse_error: "Nie można odczytać arkusza — upewnij się, że to prawidłowy plik .xlsx",
    manifest_upload_forbidden: "Nie masz uprawnień do wgrywania manifestów. Poproś administratora o sprawdzenie dostępu.",
    manifest_upload_forbidden_warehouse: "Import odrzucony: arkusz zawiera wiersze dla magazynu „{warehouse}”, dla którego nie możesz wgrywać manifestów. Sprawdź, czy kolumna warehouse dokładnie odpowiada nazwie Twojego magazynu.",
    delivery_type: "Rodzaj dostawy",
    delivery_type_standard: "Standardowa",
    delivery_type_priority: "Priorytetowa",
    delivery_type_express: "Ekspresowa",
    // Zamówienie do odbioru osobistego: zakup pracowniczy odbierany w
    // magazynie — kompletowane jak każde inne, bez kuriera, zamykane na
    // stanowisku pakowania etykietą ODBIÓR zamiast etykiety kurierskiej.
    delivery_type_collection: "Odbiór osobisty",
    collection_order_banner: "ODBIÓR OSOBISTY — nie wysyłać. Wydaj przy ladzie; zamiast etykiety kurierskiej drukuje się etykieta odbioru.",
    print_collection_label: "Drukuj etykietę odbioru",
    collection_label_heading: "ODBIÓR OSOBISTY",
    collection_label_customer: "Klient",
    collection_label_packed: "Spakowano",
    filter_by_status: "Filtruj po statusie",
    filter_warehouse: "Magazyn",
    filter_all_warehouses: "Wszystkie Magazyny",
    filter_channel: "Kanał",
    filter_all_channels: "Wszystkie Kanały",
    // Nazwa kanału (jak w pl.ts: "w kanale BargainFox Returns").
    channel_bargainfox_returns: "BargainFox Returns",
    filter_date: "Data",
    filter_all_dates: "Wszystkie Daty",
    filter_from: "Od",
    filter_to: "Do",
    filter_all: "Wszystkie",
    filter_today: "Dzisiaj",
    filter_yesterday: "Wczoraj",
    filter_last_7: "Ostatnie 7 dni",
    filter_last_30: "Ostatnie 30 dni",
    filter_last_60: "Ostatnie 60 dni",
    filter_custom: "Niestandardowe",
    search_results_count: "Wyników: {count}",
    search_results_count_filtered: "Wyników: {count} z {total}",

    // Nagłówki kolumn tabeli zamówień
    col_order_number: "Nr zamówienia",
    col_ready_low: "Gotowe",
    ready_low_title: "Gotowe do kompletacji na dole — każda linia jest pokryta zapasem z niskich lokalizacji po uwzględnieniu starszych zamówień, więc zrzut z półek nie jest potrzebny",
    col_status: "Status",
    col_customer: "Klient",
    col_channel: "Kanał",
    col_items: "Pozycje",
    col_value: "Wartość",
    col_order_date: "Data",
    col_fulfilled_date: "Data realizacji",
    col_dispatched_by: "Wysłane przez",
    send_replacement: "Wyślij zamiennik",
    send_replacement_parcel_hint: "Zastąp tylko tę przesyłkę — zagubioną lub uszkodzoną w transporcie",
    // Wyślij do pakowania (Admin > Zamówienia, 2026-10-22)
    send_to_pack_hint: "Pakujesz ręcznie? Wyślij zamówienie prosto na stanowisko wysyłki z tymczasową skrzynką.",
    send_to_pack_confirm: "Zamówienie zostanie wyjęte z kompletacji, a towar zarezerwowany. Wysłać do pakowania?",
    send_to_pack_confirm_flagged: "To zamknie oznaczenie i wyśle zamówienie na stanowisko pakowania. Przedmioty oznaczone jako brakujące wrócą do zapakowania — stanowisko oznaczy to, czego nadal nie ma. Wysłać do pakowania?",
    send_to_pack_button: "Wyślij do pakowania",
    send_to_pack_sending: "Wysyłanie…",
    send_to_pack_failed: "Nie udało się wysłać zamówienia do pakowania",
    send_to_pack_ready_title: "Gotowe do pakowania",
    send_to_pack_ready_hint: "Zeskanuj lub wpisz tę skrzynkę na ekranie Wysyłki.",
    send_to_pack_copy: "Kopiuj",
    send_to_pack_print: "Drukuj",
    send_to_pack_copied: "Skopiowano",
    send_to_pack_copy_failed: "Nie udało się skopiować — wpisz kod ręcznie",
    // Wyślij dodatkową paczkę (Admin > Zamówienia, 2026-10-22)
    extra_box_title: "Wyślij dodatkową paczkę",
    extra_box_button: "Wyślij dodatkową paczkę",
    extra_box_intro: "Nadaj jeszcze jedną paczkę do zamówienia #{order} — wyjdzie jako paczka {n} z własną etykietą kuriera i będzie śledzona jak pozostałe. Stan magazynowy się nie zmienia, kanał sprzedaży nie jest informowany. Klient dostaje e-mail tylko wtedy, gdy kanał ma włączone e-maile do klientów — jak przy każdej paczce.",
    extra_box_draft_failed: "Nie udało się wczytać zamówienia dla dodatkowej paczki",
    extra_box_no_lines: "Wszystkie pozycje tego zamówienia zostały zwrócone — nie ma czego wysłać.",
    extra_box_line_ordered: "Zamówiono {ordered}",
    extra_box_line_refunded: "Zamówiono {ordered} · zwrócono {refunded}",
    extra_box_no_weight: "brak wagi w systemie",
    extra_box_box: "Karton",
    extra_box_custom_box: "Inny rozmiar…",
    extra_box_length_mm: "Długość (mm)",
    extra_box_width_mm: "Szerokość (mm)",
    extra_box_height_mm: "Wysokość (mm)",
    extra_box_weight: "Waga zawartości (g)",
    extra_box_weight_required: "Wpisz wagę",
    extra_box_weight_missing: "Produkt nie ma wagi w systemie — zważ zawartość i wpisz wynik.",
    extra_box_weight_hint: "{kg} kg z wag produktów — wpisz liczbę, aby ją zmienić",
    extra_box_courier: "Kurier",
    extra_box_original: "pierwotny",
    extra_box_no_services: "Żaden kurier nie może tu nadać dodatkowej paczki",
    extra_box_scan_hint: "Zeskanuj produkt, aby go dodać — każdy skan dodaje jedną sztukę.",
    extra_box_scan_added: "Dodano {item} — {n} w paczce.",
    extra_box_scan_full: "{item}: wszystkie {n} szt., które można wysłać, są już w paczce.",
    extra_box_scan_not_on_order: "{code} nie ma w tym zamówieniu.",
    extra_box_rules_note: "Produkt może pojawić się w dwóch paczkach, jeśli pierwsza wyszła bez niego — to jest w porządku.",
    extra_box_book: "Nadaj i drukuj paczkę {n} ({units})",
    extra_box_book_cancel_refund: "Anuluj oczekujący zwrot i wyślij paczkę {n} ({units})",
    extra_box_line_refund_pending: "zwrot oczekuje: {n}",
    extra_box_line_missing: "brakuje: {n}",
    extra_box_cancel_refund_note: "{n} szt. w tej paczce czeka na zwrot pieniędzy. Wysłanie ich anuluje ten zwrot, aby klient nie dostał zwrotu za przedmiot, który otrzyma.",
    extra_box_booking: "Nadawanie u {carrier}…",
    extra_box_waiting_label: "Czekam na etykietę kuriera…",
    extra_box_label_slow: "Kurier jeszcze nie zwrócił etykiety. Naciśnij Dokończ, aby spróbować ponownie.",
    extra_box_pending_note: "Dodatkowa paczka do tego zamówienia jest nadana, ale niedokończona. Dokończ, aby zapisać paczkę i wydrukować etykietę.",
    extra_box_finish: "Dokończ",
    extra_box_failed: "Nie udało się nadać dodatkowej paczki",
    extra_box_done: "Dodatkowa paczka {n} nadana — numer {tracking}. Naklej etykietę i wyślij z dzisiejszymi paczkami.",
    extra_box_print_again: "Drukuj ponownie",
    extra_box_close: "Gotowe",
    extra_box_tag: "Dodatkowa",
    extra_box_tag_hint: "Dodatkowa paczka wysłana po wysyłce zamówienia",
    extra_box_void: "Anuluj",
    extra_box_void_hint: "Anuluj tę dodatkową paczkę (tylko zanim kurier ją zeskanuje)",
    extra_box_void_confirm: "Anulować dodatkową paczkę {tracking}? Etykieta zostanie anulowana u kuriera, a paczka usunięta z zamówienia. Pierwotna wysyłka pozostaje bez zmian.",
    extra_box_voided: "Dodatkowa paczka anulowana",
    extra_box_void_failed: "Nie udało się anulować dodatkowej paczki",
    extra_box_setting_title: "Wyślij dodatkową paczkę",
    extra_box_setting_hint: "Pozwala w Admin > Zamówienia nadać jeszcze jedną paczkę kurierską do zamówienia, które już zostało wysłane — dla produktu znalezionego po wysyłce.",
    extra_box_setting_unavailable: "Wymaga migracji bazy danych 232, zanim będzie można to włączyć.",
    replacement_intro: "Utwórz bezpłatny zamiennik dla zamówienia #{order}. Wybierz pozycje do ponownego wysłania — nic nie zostanie utworzone, dopóki nie zapiszesz.",
    replacement_intro_parcel: "Wyślij ponownie, bezpłatnie, zawartość przesyłki {parcel} z zamówienia #{order}. Wszystko, co zawierała ta przesyłka, jest już zaznaczone — nic nie zostanie utworzone, dopóki nie zapiszesz.",
    replacement_no_charge: "£0,00 — bez opłat",
    replacement_add_all_items: "Dodaj wszystkie pozycje",
    replacement_remove_all_items: "Usuń wszystkie pozycje",
    replacement_free_stock: "{n} dostępnych w magazynie · zamówiono {ordered}",
    replacement_free_stock_refunded: "{n} dostępnych w magazynie · wysłano {ordered}, zwrócono {refunded}",
    replacement_free_stock_parcel: "{n} dostępnych w magazynie · {ordered} w tej przesyłce",
    replacement_no_stock: "Brak dostępnego stanu w tym magazynie",
    replacement_no_lines: "To zamówienie nie ma pozycji magazynowych do zastąpienia.",
    replacement_no_parcel_lines: "Ta przesyłka nie ma pozycji magazynowych do zastąpienia.",
    replacement_save_and_send: "Wyślij zamiennik ({n})",
    replacement_draft_failed: "Nie udało się wczytać pozycji tego zamówienia.",
    replacement_failed: "Nie udało się utworzyć zamiennika",
    replacement_insufficient_stock: "Stan magazynowy się zmienił — ilości zredukowano do obecnie dostępnych",
    replacement_created: "Zamiennik #{order} utworzony i przekazany do magazynu",
    orders_replacements_raised: "Utworzone zamienniki",
    orders_replacement_of: "Zamiennik dla",
    channel_email_branding: "Marka w e-mailach do klientów",
    channel_email_branding_hint: "Tożsamość nadawcy każdego e-maila, który Portal wysyła klientom tego kanału: wysyłek zamiennych oraz — jeśli przełączniki poniżej tak mówią — również zwykłych. Zamienniki zawsze powiadamiają klienta i nigdy API tego kanału, ponieważ kanał uważa, że pierwotne zamówienie już wysłano.",
    channel_section_api: "Integracja API",
    channel_section_api_configured: "połączono",
    channel_section_api_no_url: "brak adresu bazowego",
    channel_section_emails: "E-maile do klientów",
    channel_section_emails_no_sender: "brak nadawcy",
    channel_section_emails_non_api_on: "zamówienia ręczne wł.",
    channel_section_emails_api_on: "zamówienia API wł.",
    channel_order_status: "Śledzenie paczek do BargainFox",
    channel_order_status_hint: "Informuje BargainFox, gdy paczka znana mu już z powiadomienia o wysyłce jest w drodze, w doręczeniu lub doręczona (z czasem przewoźnika), dzięki czemu strona zamówień pokazuje prawdziwe daty doręczenia. Można zostawić włączone, zanim BargainFox włączy to po swojej stronie (flaga portal-order-status): do tego czasu nic się tam nie zmienia.",
    channel_section_api_order_status_on: "śledzenie paczek wł.",
    channel_documents: "Faktury i faktury korygujące z BargainFox",
    channel_documents_hint: "Pozwala pobrać na stronie Zamówienia własne faktury sprzedaży i faktury korygujące BargainFox do zamówienia; BargainFox generuje każdą na żądanie, a Portal ich nie przechowuje. Można zostawić włączone, zanim BargainFox włączy to po swojej stronie: do tego czasu panel jest ukryty.",
    channel_section_api_documents_on: "dokumenty wł.",
    channel_exchange_orders: "Zamówienia wymiany do BargainFox",
    channel_exchange_orders_hint: "Pokazuje klientom ich zamówienia wymiany z portalu zwrotów na stronie zamówień BargainFox (status, paczki, faktura i faktury korygujące), wysyłane przy każdej zmianie i raz dziennie. Można zostawić włączone, zanim BargainFox włączy to po swojej stronie.",
    channel_section_api_exchange_orders_on: "zamówienia wymiany wł.",
    channel_replacement_orders: "Zamówienia zastępcze do BargainFox",
    channel_replacement_orders_hint: "Pokazuje klientom wysyłane im zamówienia zastępcze (REP…) na stronie zamówień BargainFox, ze statusem i paczkami, aby mogli je śledzić i stamtąd zgłosić problem. Wysyłane przy każdej zmianie i raz dziennie. Włącz, gdy BargainFox włączy to po swojej stronie.",
    channel_section_api_replacement_orders_on: "zamówienia zastępcze wł.",
    channel_section_consolidation: "Konsolidacja zamówień",
    channel_section_protection: "Dodatkowa ochrona",
    channel_section_protection_ai: "ocena AI wł.",
    channel_section_protection_enforced: "egzekwowane przy stanowisku",
    channel_section_protection_off: "wył.",
    channel_notify_on: "Wł.",
    channel_notify_off: "Wył.",
    channel_notify_non_api: "E-maile do klientów dla zamówień ręcznych / spoza API",
    channel_notify_non_api_hint: "Zamówienia wgrane zbiorczo lub ręcznie, które nigdy nie przeszły przez API tego kanału. Kanał nie wie o ich istnieniu, więc nie może powiadomić kupującego — tylko Portal może. Domyślnie włączone.",
    channel_notify_api: "E-maile do klientów dla zamówień z API",
    channel_notify_api_hint: "Zamówienia otrzymane przez API tego kanału. Mają już wysyłkę powiadomienia, a kanał sam wysyła e-mail do kupującego — dlatego domyślnie wyłączone. Włącz dopiero, gdy kanał przestanie wysyłać własne powiadomienia o wysyłce.",
    channel_notify_api_warning: "Kanał również wysyła e-maile tym kupującym, o ile nie poproszono go o zaprzestanie — sprawdź to, inaczej klienci dostaną dwa powiadomienia.",
    channel_notify_needs_sender: "Ustaw powyżej adres nadawcy — bez niego żaden z przełączników nic nie wyśle.",
    channel_aliases: "Aliasy kanału sprzedaży",
    channel_aliases_hint: "Zamówienia bez powiązania z API są dopasowywane do tego kanału po tekście pola Kanał sprzedaży. Kod kanału pasuje zawsze; dodaj inne nazwy używane w Twoich wgraniach, np. \u201eJobalots UK\u201d.",
    channel_aliases_placeholder: "np. Jobalots UK",
    channel_aliases_add: "Dodaj",
    channel_aliases_remove: "Usuń alias {alias}",
    channel_aliases_empty: "Brak \u2014 dopasowywane są tylko zamówienia, których Kanał sprzedaży to \u201e{code}\u201d.",
    channel_sender_address: "Adres nadawcy",
    channel_sender_name: "Nazwa nadawcy",
    channel_sender_blank_hint: "Pozostaw puste, aby nie wysyłać e-maili do klientów tego kanału.",
    channel_logo: "Adres URL logo marki",
    channel_logo_hint: "Wklej publiczny adres URL obrazu (PNG lub JPG). Klienci poczty nie obsługują SVG, a adres musi być dostępny bez logowania. Szeroki baner (proporcje 3:1 lub szersze) zajmuje całą szerokość u góry e-maila; węższy obraz pojawia się jako logo o szerokości 140 px.",
    channel_logo_svg_warning: "To logo jest plikiem SVG, więc jest pomijane w e-mailu — zamiast niego wyświetlana jest nazwa marki. Zastąp je plikiem PNG lub JPG o szerokości co najmniej 280 px.",
    channel_reply_to_address: "Adres odpowiedzi (opcjonalnie)",
    channel_reply_to_hint: "Gdzie trafia odpowiedź klienta — zwykle skrzynka obsługi klienta marki. Pozostaw puste, a odpowiedzi trafią na adres nadawcy.",
    channel_test_email: "Wyślij e-mail testowy",
    channel_test_email_hint: "Wysyła wybrany przykład na podany adres, od nadawcy tego kanału, z prawdziwymi zdjęciami produktów z katalogu.",
    channel_test_email_scenario: "Przykładowy e-mail",
    channel_test_email_scenario_shipment: "Pojedyncza wysyłka — jedna paczka, wszystko wysłane",
    channel_test_email_scenario_shipment_multi: "Wysyłka wielopaczkowa — dwie paczki, wszystko wysłane",
    channel_test_email_scenario_shipment_partial: "Wysyłka częściowa — pozycje jeszcze do wysłania",
    channel_test_email_scenario_pallet: "Wysyłka paletowa — dwie palety w jednej przesyłce",
    channel_test_email_language: "Język e-maila",
    channel_test_email_scenario_consolidated: "Wysyłka skonsolidowana — dwa zamówienia w jednej dostawie",
    channel_test_email_scenario_consolidated_partial: "Wysyłka skonsolidowana — pozycje jeszcze do wysłania",
    channel_test_email_scenario_consolidated_many: "Wysyłka skonsolidowana — pięć zamówień w jednej dostawie",
    channel_test_email_scenario_replacement: "Zamiennik — nic do zapłaty",
    channel_test_email_prompt: "Na jaki adres wysłać przykładowy e-mail?",
    channel_test_email_sent: "E-mail testowy ({scenario}) wysłany z {from}",
    channel_test_email_failed: "E-mail testowy nie został wysłany: {detail}",
    col_tts: "TTS",
    col_delivery_type: "Dostawa",
    col_courier: "Kurier",
    col_parcel: "Paczka",
    col_service: "Usługa",
    col_weight: "Waga",
    col_tracking_number: "Numer śledzenia",
    col_link: "Link",
    col_label: "Etykieta",
    download_label_pdf: "Pobierz PDF",
    label_reprinted: "Etykieta wydrukowana ponownie",
    label_unavailable: "Brak zapisanej etykiety dla tej paczki",
    label_pdf_fallback_failed: "Zapasowy PDF niedostępny",
    // Statusy śledzenia paczki. Odpowiadają enumowi `label_status` w BE —
    // dokładny opis skanu od kuriera jest w podpowiedzi (tooltip).
    parcel_status_created: "Etykieta utworzona",
    parcel_status_in_transit: "W drodze",
    parcel_status_out_for_delivery: "W doręczeniu",
    parcel_status_delivered: "Dostarczona",
    parcel_status_exception: "Wymaga uwagi",
    parcel_status_returned: "Zwrócona",
    parcel_status_voided: "Anulowana",
    carrier_checked_just_now: "przed chwilą",
    carrier_checked_minutes: "{n} min temu",
    carrier_checked_hours: "{n} godz. temu",
    carrier_checked_days: "{n} dni temu",
    carrier_status_checked: "Sprawdzono {ago}",
    carrier_status_never_checked: "Nigdy nie sprawdzono u przewoźnika",
    carrier_status_last_checked: "Status przewoźnika sprawdzony {ago}",
    carrier_status_poller_idle: "Te paczki nigdy nie zostały sprawdzone u przewoźnika — usługa pobierania statusów może nie działać.",
    shipment_details: "Wysyłka",
    carrier_estimated_cost: "Szacowany koszt przewoźnika",
    carrier_estimated_cost_consignments: "{n} przesyłki",
    carrier_estimated_cost_note: "Wyliczony z zadeklarowanej wagi przy rezerwacji — porównaj z fakturą {carrier}.",
    cancel_carrier_label: "Anuluj etykietę",
    cancel_carrier_label_note: "Można anulować do {cutoff} dziś, zanim przesyłka trafi do manifestu.",
    cancel_carrier_label_note_until_scan: "Można anulować, dopóki {carrier} nie zeskanuje pierwszej paczki tego zamówienia.",
    cancel_carrier_label_done: "Etykieta anulowana — {n} przesyłek zakolejkowano do anulowania; zamówienie wróciło do wysyłki.",
    cancel_carrier_label_done_reship: "Etykieta anulowana u przewoźnika {carrier} (anulowano etykiet: {n}). Zamówienie wróciło do wysyłki: zeskanuj na stanowisku jego etykietę wysyłkową (albo oryginalny pojemnik / lokalizację), aby spakować ponownie.",
    cancel_carrier_label_done_cancelled: "Etykieta anulowana u przewoźnika {carrier} (anulowano etykiet: {n}). Zamówienie zostało anulowane.",
    carrier_void_failed_live: "Przewoźnik {carrier} NIE anulował etykiet ({n}) — są NADAL AKTYWNE i zostaną zafakturowane. Nie wysyłaj paczki; skontaktuj się z przewoźnikiem {carrier} w sprawie korekty. ({detail})",
    carrier_void_retrying: "Nie udało się połączyć z przewoźnikiem {carrier}, aby anulować etykiety ({n}). Próby będą powtarzane w tle — sprawdź, czy etykieta została anulowana przed dzisiejszym cut-offem.",
    carrier_labels_reissued: "Inne zamówienia ({n}) korzystają z tej samej przesyłki — przewoźnik {carrier} wystawił im nowe etykiety po usunięciu tych paczek. Stare etykiety są nieważne: wydrukuj je ponownie. ({detail})",
    cancel_label_why_title: "Dlaczego anulujesz tę etykietę?",
    cancel_label_opt_reship: "Wyślij zamówienie ponownie",
    cancel_label_opt_cancel_order: "Anuluj całe zamówienie",
    cancel_label_why_hint: "Ponowna wysyłka unieważnia etykietę i przywraca zamówienie do wysyłki — przedmioty pozostają w oryginalnej tocie, więc zeskanowanie jej na stanowisku otwiera zamówienie ponownie. Anulowanie całego zamówienia unieważnia etykietę i anuluje zamówienie.",
    cancel_carrier_label_failed: "Nie udało się anulować etykiety",
    track: "Śledź",
    show_parcel_items: "Pokaż zawartość paczki",
    hide_parcel_items: "Ukryj zawartość paczki",
    no_parcel_items_recorded: "Brak zarejestrowanych pozycji dla tej paczki.",
    not_shipped: "Niewysłane",
    order_item_awaiting_fulfilment: "Oczekuje na realizację — {n} z {total} niewysłane",
    order_item_refunded_badge: "Zwrócono — {n} z {total}",
    order_item_refund_pending_badge: "Zwrot oczekuje — {n} z {total}",
    refund_pending_items: "Zwrot oczekuje",
    refund_pending_title: "Zwrot oczekuje: {n} szt., {amount}",
    refund_pending_lines: "Pozycje do zwrotu",
    refund_pending_why: "Powód zwrotu",
    refund_pending_why_none: "Nie zapisano powodu. Sprawdź notatki zamówienia przed wystawieniem zwrotu.",
    refund_pending_parts_title: "Zwróć każde zamówienie osobno",
    refund_pending_parts_hint: "Ta przesyłka zawiera kilka zamówień klienta. Wystaw zwrot każdego w {channel}, a potem oznacz go jako wystawiony w danym zamówieniu (każde jest na liście „Oczekuje na zwrot”).",
    refund_pending_part_row: "{n} szt. · {amount}",
    refund_pending_issued_from_master: "„Wystaw zwrot” wypłaca to z połączonego zamówienia {order}.",
    refund_issue_email_queued: "Klient dostanie e-mail o zwrocie za około 10 minut.",
    refund_pending_detail: "Wystaw zwrot w {channel}, a następnie oznacz go tutaj jako wystawiony.",
    refund_issue_button: "Zwrot wystawiony",
    refund_issue_saving: "Zapisywanie…",
    refund_issue_done: "Zwrot oznaczony jako wystawiony ({n} szt.)",
    refund_issue_nothing_pending: "W tym zamówieniu nie ma już nic do zwrotu — zwrot został już wystawiony lub anulowany",
    refund_issue_failed: "Nie udało się oznaczyć zwrotu jako wystawionego — spróbuj ponownie",
    refund_pending_channel_detail: "Przycisk „Wystaw zwrot” zwraca pieniądze na kartę klienta w {channel}, który wysyła mu notę kredytową.",
    refund_issue_channel_button: "Wystaw zwrot",
    refund_issue_channel_saving: "Wystawianie zwrotu…",
    refund_issue_channel_done: "Zwrot {amount} wystawiony w {channel}",
    refund_issue_channel_failed: "{channel} nie wystawił zwrotu: {reason}",
    refund_issue_mark_only_button: "Zwrot już wykonany w {channel} — oznacz jako wystawiony",
    order_item_replacement_badge: "Zamiennik {order} · {n}×",
    refund_manual_channel_note: "Zwrot pieniędzy należy wykonać ręcznie w kanale sprzedaży",
    refunded_items: "Zwrócone",
    of_quantity: "z {n}",
    col_notes: "Notatki",
    sort_by: "Sortuj wg",
    sort_ascending: "Sortuj rosnąco",
    sort_descending: "Sortuj malejąco",

    // Rozwiązywanie oznaczonych zamówień
    resolve_order: "Rozwiąż Zamówienie",
    refund: "Zwrot",
    refund_summary: "Podsumowanie Zwrotu",
    items_to_refund: "Przedmioty do zwrotu",
    items_to_ship_count: "Przedmioty do wysłania",
    shipping_refund: "Zwrot kosztów wysyłki",
    shipping_refund_hint: "Podaj kwotę wysyłki do zwrotu",
    customer_paid_shipping: "Klient zapłacił za wysyłkę",
    no_shipping_charged: "Brak opłaty za wysyłkę",
    items_refund_total: "Zwrot za przedmioty",
    total_refund: "Całkowity zwrot",
    process_refund: "Zwrot",
    process_refund_and_continue: "Zwrot i kontynuuj",
    full_refund: "Pełny zwrot",
    partial_refund: "Częściowy zwrot",
    no_refund: "Zwrot niewymagany",
    resolve_complete: "Zamówienie Rozwiązane",
    refund_issued_for: "Zwrot {amount} przekazany do zakładki Oczekuje na zwrot",
    resolve_not_permitted: "Nie masz uprawnień, aby rozwiązać to zamówienie w ten sposób. Nic nie zostało zapisane — poproś lidera lub administratora o nadanie dostępu w Kontroli dostępu.",
    resolve_no_grant: "Rozwiązywanie oflagowanych zamówień nie jest dla Ciebie włączone. Administrator może je nadać w Kontroli dostępu.",
    resolve_refund_no_grant: "Zwroty nie są dla Ciebie włączone. Administrator może je nadać w Kontroli dostępu.",
    resolve_failed: "Nie udało się zapisać rozwiązania. Nic nie zostało zapisane — spróbuj ponownie.",
    remaining_to_resolve: "Pozostało do rozwiązania",
    unit_price: "Cena jednostkowa",

    // Flagged list — quick resolve (Resolve dropdown button)
    resolve_menu_dispatch: "Wyślij",
    resolve_menu_refund: "Zwrot",
    resolve_menu_manual_ship: "Zrealizuj ręcznie",
    resolve_menu_replace: "Wyślij zamiennik",
    replacement_intro_flagged: "Wyślij ponownie, bezpłatnie, sztuki brakujące w zamówieniu #{order}. To, czego według zgłoszenia brakuje, jest już zaznaczone — zmień, jeśli klient potrzebuje czegoś innego.",
    replacement_line_short: "brakuje {n}",
    replacement_flag_resolve_note: "Wysłanie rozwiązuje też zgłoszenie — oryginalne zamówienie zostanie oznaczone jako Zrealizowane, bez zwrotu.",
    replacement_created_flag_resolved: "Zamiennik #{order} przekazany do magazynu — zgłoszenie rozwiązane",
    flag_story_title: "Co poszło nie tak",
    flag_story_missing_picking: "{n} brak przy pobieraniu",
    flag_story_missing_sorting: "{n} brak przy sortowaniu",
    flag_story_missing_dispatch: "{n} brak przy pakowaniu",
    flag_story_checked_none: "{by} sprawdził(a) {shelf} o {when} i nic nie znalazł(a)",
    flag_story_checked_found: "{by} sprawdził(a) {shelf} o {when} i znalazł(a) tylko {found}",
    flag_story_never_picked: "nic nie pobrano z {shelf}",
    flag_story_short_pick: "pobrano tylko {picked} z {required} z {shelf} — {by}, {when}",
    flag_story_never_waved_stock: "{n} nigdy nie trafiło do pickera (brak zapasu przy tworzeniu fali). Zapas jest teraz w",
    flag_story_never_waved_no_stock: "{n} nigdy nie trafiło do pickera (brak zapasu przy tworzeniu fali). Nadal brak zapasu w tym magazynie",
    flag_story_more_shelves: "+{n} więcej półek",
    flag_story_premarked: "oznaczono jako brak przed sortowaniem",
    flag_story_not_sorted: "pobrano, ale nie posortowano do tego zamówienia na ścianie",
    flag_story_scanned_lost: "wszystkie {n} zeskanowano na półce ({by}), ale nie dotarły do stanowiska pakowania",
    flag_story_sorted_lost: "pobrano i posortowano do tego zamówienia, ale nie dotarło do stanowiska pakowania",
    flag_story_picked_lost: "pobrano, ale nie dotarło do stanowiska pakowania",
    flag_story_tote: "pojemnik {tote}",
    flag_story_high_shelf: "Wysoka półka",
    flag_stock_title: "Zapas dostępny do wysłania jako zamiennik",
    flag_stock_title_high: "Zapas na zamiennik jest tylko na wysokich półkach — trzeba go ściągnąć",
    flag_stock_title_none: "Brak zapasu do wysłania jako zamiennik",
    flag_stock_available: "{n} w zapasie",
    flag_stock_some_high: "{n} w zapasie ({high} na wysokich półkach)",
    flag_stock_high_only: "{n} w zapasie, tylko wysokie półki",
    flag_stock_none: "brak w zapasie",
    quick_refund_title: "Zwrot za zamówienie #{order}",
    refund_line_outstanding: "Zwrot do {n}",
    resolve_zero_refund_warning: "Bez zwrotu — zamówienie zostanie oznaczone jako Zrealizowane",
    resolve_status_result: "Zamówienie zostanie oznaczone: {status}",
    manual_ship_title: "Ręczna realizacja #{order}",
    manual_ship_items_note: "Te sztuki zostaną zapisane jako wysłane:",
    manual_ship_pick_parcel: "Do której paczki zostaną dodane?",
    manual_ship_confirm: "Oznacz jako wysłane",
    manual_ship_done: "Zapisano jako wysłane — zamówienie rozwiązane",
    manual_ship_done_partial: "Zapisano jako wysłane — {amount} przeniesiono do „Oczekuje na zwrot”",
    manual_ship_line_outstanding: "Brakuje: {n}",
    manual_ship_line_to_refund: "{n} do „Oczekuje na zwrot”",
    manual_ship_rest_to_refund: "Nieznalezione ({n}) trafią do „Oczekuje na zwrot” ({amount}).",
    manual_ship_none_selected: "Nic nie wybrano do wysyłki — użyj Zwrotu",
    manual_ship_refund_not_permitted: "Nieznalezione sztuki wymagają zwrotu, którego Twoje konto nie może wykonać — wyślij wszystkie lub poproś kierownika",
    resolve_conflict: "To zamówienie zostało już rozwiązane gdzie indziej — lista została odświeżona",
    filter_issue: "Problem",
    flag_issue_all: "Wszystkie problemy",
    flag_issue_packing: "Problem z pakowaniem",
    flag_issue_missing: "Brakujące produkty",
    flagged_parcels_sent: "Wysłane paczki: {count}",
    already_shipped_x: "Wysłano już x{count}",
    already_scanned_x: "Zeskanowano już x{count}",
    flag_and_print: "Oznacz i drukuj etykiety",
    flag_label_hint: "Zostanie wydrukowanych {count} etykiet. Naklej jedną na każde pudełko.",

    // Szukaj zamówień — modal szczegółów zamówienia
    order_items: "Przedmioty Zamówienia",
    order_shipping: "Wysyłka",
    order_tax: "Podatek",
    order_total: "Suma Zamówienia",
    qty: "Ilość",
    add_note: "Dodaj Notatkę",
    note_placeholder: "Dodaj notatkę o tym zamówieniu...",
    note: "Notatka",
    // Wątek notatek w modalu szczegółów zamówienia (order-notes.tsx)
    order_notes_hint: "Zapisywana od razu z Twoim imieniem i godziną. Własną notatkę możesz edytować lub usunąć przez godzinę.",
    order_notes_empty: "Brak notatek do tego zamówienia",
    order_notes_unknown_author: "Wcześniejsza notatka",
    order_notes_edited: "edytowano",
    order_notes_added: "Notatka dodana",
    order_notes_deleted: "Notatka usunięta",
    order_notes_delete_confirm: "Usunąć tę notatkę?",
    order_notes_delete_action: "Usuń",
    mobile: "Telefon",
    saved: "Zapisano",

    // Mapowanie SKU (modal szczegółów zamówienia)
    sku_map_title: "Przypisz pozycję do produktu",
    sku_map_unmapped_label: "Przychodzący SKU",
    sku_map_original: "Oryginalny",
    sku_map_needs_mapping: "Wymaga mapowania",
    sku_map_non_stock: "Spoza magazynu",
    sku_map_action_map: "Mapuj",
    sku_map_action_remap: "Zmień mapowanie",
    hold_reason_unmapped: "Wstrzymane: co najmniej jedna pozycja wymaga mapowania do produktu. Zamówienie zostanie zwolnione automatycznie, gdy każda linia będzie zmapowana lub oznaczona jako spoza magazynu.",
    hold_reason_stock: "Wstrzymane: za mało zapasów w {warehouse}, aby zrealizować to zamówienie. Przyjmij towar (zwolni się automatycznie) lub zwolnij je bez brakujących sztuk.",
    hold_reason_stock_multi: "Wstrzymane: za mało zapasów w {warehouses}, aby zrealizować to zamówienie. Przyjmij towar w dowolnym z tych magazynów (zwolni się lub przeniesie automatycznie) lub zwolnij je bez brakujących sztuk.",
    hold_reason_or: "lub",
    // Zwolnienie zamówienia bez brakujących pozycji (release short).
    stock_blocked_banner: "Brak zapasów — tego zamówienia nie można skompletować, dopóki towar nie dotrze lub nie zostanie zwolnione bez braków.",
    stock_blocked_line_missing: "Brak zapasów — {missing} z {need} niedostępne",
    orders_release_short_btn: "Zwolnij bez braków",
    orders_release_short_title: "Zwolnij zamówienie bez braków",
    orders_release_short_body: "Te sztuki nie mają dostępnych zapasów w magazynie. Zwolnienie oznaczy je jako brakujące: zamówienie trafi do kompletacji bez nich, a przy wysyłce pokażą się jako brakujące do zwrotu.",
    orders_release_short_confirm: "Oznacz {count} szt. jako brakujące i zwolnij",
    orders_release_short_done: "Zamówienie zwolnione — oznaczono {count} szt. jako brakujące.",
    orders_release_short_failed: "Zwolnienie nie powiodło się — spróbuj ponownie.",
    orders_release_short_not_blocked: "To zamówienie nie jest już zablokowane przez braki — zwolnienie niepotrzebne.",
    orders_release_short_hold_note: "Zamówienie zostanie też zdjęte ze wstrzymania i trafi do kolejki kompletacji.",
    orders_release_hold_none_body: "Każda sztuka ma zapas na półce, ale jest zarezerwowany dla innych zamówień. Zwolnienie zdejmuje to zamówienie ze wstrzymania i ustawia je w zwykłej kolejce kompletacji — żadne sztuki nie zostaną oznaczone jako brakujące.",
    orders_release_hold_confirm: "Zwolnij zamówienie",
    orders_release_hold_done: "Zamówienie zdjęte ze wstrzymania.",
    hold_reason_manual: "Wstrzymane: ustawione ręcznie. Zmień status na Niezrealizowane, aby je zwolnić.",
    exchange_order_banner: "Zamówienie wymiany: nowe produkty za zwrot klienta. Rezerwuje towar i samo przejdzie do Niezrealizowanych, gdy zwrot zostanie nadany, dostarczony lub odebrany (zależnie od wartości). Zwolnij je lub anuluj w zwrocie na stronie Zwroty.",
    hold_reason_pallet_order: "Wstrzymane: zamówienie paletowe wstrzymane przy przyjęciu (Ustawienia › Wysyłka › Zamówienia paletowe). Zmień status na Niezrealizowane, aby skierować je do Kompletacji palet.",
    sku_map_search_by: "Szukaj według",
    sku_map_field_sku: "SKU",
    sku_map_field_ean: "EAN",
    sku_map_field_title: "Nazwa",
    sku_map_placeholder_sku: "Dokładny SKU (wielkość liter ma znaczenie)",
    sku_map_placeholder_ean: "Kod kreskowy / EAN",
    sku_map_placeholder_title: "Dokładna nazwa produktu",
    sku_map_no_results: "Brak pasujących produktów.",
    sku_map_search_failed: "Wyszukiwanie nieudane. Spróbuj ponownie.",
    sku_map_failed: "Nie udało się zaktualizować pozycji.",
    sku_map_success: "Pozycja zmapowana.",
    sku_map_non_stock_marked: "Oznaczono jako spoza magazynu.",
    sku_map_mark_non_stock: "Oznacz jako spoza magazynu",
    sku_map_non_stock_hint: "Dla produktów dropshipping, których nie kompletujemy ani nie wysyłamy.",

    // Administracja produktami
    products_settings: "Produkty",
    products_settings_hint: "Zarządzaj katalogiem produktów. Pobierz szablon XLSX, edytuj go w Excelu, a następnie prześlij, aby zbiorczo dodać, zaktualizować, zarchiwizować lub usunąć produkty. Kolumny SKU i Barcode są wstępnie sformatowane jako Tekst, dzięki czemu długie ciągi cyfr nie są zamieniane na notację naukową.",
    products_total: "Wszystkie produkty",
    products_active: "Aktywne",
    products_archived: "Zarchiwizowane",
    products_upload_xlsx: "Wgraj XLSX",
    products_download_limit: "Pobieranie jest ograniczone do {max} wierszy, a ten filtr obejmuje {total}. Zawęź filtr (dostawca, status lub wyszukiwanie), aby pobrać.",
    products_upload_empty: "Arkusz jest pusty",
    products_upload_bad_header: "Arkusz musi zawierać kolumny 'action' i 'sku'",
    products_upload_parse_error: "Nie można odczytać arkusza — upewnij się, że to prawidłowy plik .xlsx",
    orders_upload_bad_header: "CSV musi zawierać kolumny 'action' i 'order_id'",
    orders_upload_rejected: "Import odrzucony — błędy: {n}. Nic nie zostało zaimportowane; popraw plik i prześlij go ponownie.",
    orders_upload_partial: "Import zakończony z błędami: {n} — wymienione wiersze NIE zostały zastosowane. Sprawdź błędy poniżej.",
    orders_more_errors: "…i {n} więcej",
    products_upload_scientific_notation: "{field} '{value}' wygląda jak notacja naukowa — precyzja została utracona. Sformatuj kolumnę {field} jako Tekst w Excelu i wprowadź wartość ponownie.",
    no_products: "Brak produktów",
    products_col_sku: "SKU",
    products_col_master_sku: "Główne SKU",
    products_col_title: "Nazwa",
    products_col_supplier: "Dostawca",
    products_col_origin: "Pochodzenie",
    products_col_weight: "Waga",
    products_col_barcode: "Kod kreskowy",
    products_col_rrp: "RRP",
    products_col_cost_price: "Koszt",
    products_col_status: "Status",
    products_filter_search: "Szukaj SKU, nazwy, kodu, dostawcy",
    products_search_hint: "Szukaj SKU, nazwy, kodu, dostawcy (naciśnij Enter)",
    products_filter_all_suppliers: "Wszyscy dostawcy",
    products_no_matches: "Brak produktów pasujących do filtrów",
    products_modal_title: "Edytuj produkt",
    products_modal_tab_details: "Szczegóły",
    products_modal_tab_logs: "Logi",
    products_modal_image: "URL obrazka",
    products_modal_commodity: "Kod taryfowy",
    products_modal_length: "Długość (cm)",
    products_modal_width: "Szerokość (cm)",
    products_modal_height: "Wysokość (cm)",
    products_modal_ship_in_packaging: "Wysyłka w oryginalnym opakowaniu",
    products_modal_extra_protection: "Wymaga dodatkowej ochrony (bez worków foliowych)",
    products_modal_ships_as_pallet: "Wysyłka jako paleta (kolejka palet, przewoźnik paletowy)",
    products_modal_soft_item: "Produkt miękki — po złożeniu mieści się w worku foliowym (odzież, kostiumy)",
    products_modal_channels_heading: "Kanały sprzedaży",
    products_modal_section_identity: "Identyfikatory",
    products_modal_section_listing: "Prezentacja",
    products_modal_section_physical: "Wymiary i waga",
    products_modal_section_commercial: "Cena i cło",
    products_modal_sync_to: "Synchronizuj z {channel}",
    products_modal_push_stock: "Wyślij stan teraz",
    products_modal_push_stock_value: "Do wysłania: {n}",
    products_modal_sync_status_heading: "Ostatni wynik synchronizacji wg kanału",
    products_modal_sync_pending: "Oczekuje",
    products_modal_sync_failed: "Niepowodzenie",
    products_modal_sync_success: "Sukces",
    products_modal_sync_col_vendor: "Sprzedawca",
    products_modal_sync_col_warehouse: "Magazyn",
    products_modal_sync_col_qty: "Ilość",
    products_modal_sync_col_status: "Status",
    products_modal_sync_col_detail: "API",
    products_modal_sync_view_response: "Pokaż żądanie i odpowiedź API",
    products_modal_sync_no_trace: "Brak zapisu API",
    products_modal_sync_request: "Wysłane żądanie",
    products_modal_sync_response: "Otrzymana odpowiedź",
    products_modal_push_stock_hint: "Ponownie zsynchronizuj stan z każdym włączonym kanałem — przydatne po ręcznej korekcie.",
    products_modal_push_stock_ok: "Zakolejkowano {n} wysyłek",
    products_modal_push_stock_err: "Nie udało się zakolejkować wysyłki stanu",
    products_modal_add_barcode: "Dodaj kod kreskowy",
    products_modal_remove_barcode: "Usuń kod kreskowy",

    // Dostawcy — administracja
    suppliers_settings: "Dostawcy",
    suppliers_settings_hint: "Zarządzaj kanoniczną listą dostawców. Dodawaj, archiwizuj lub zmieniaj nazwy dostawców; produkty i manifesty korzystają z tej listy w filtrach i przy wczytywaniu plików. Zmiana nazwy dostawcy aktualizuje również wszystkie produkty obecnie z nim powiązane.",
    suppliers_total: "Łączna liczba dostawców",
    suppliers_active: "Aktywni",
    suppliers_archived: "Zarchiwizowani",
    suppliers_search_hint: "Szukaj nazwy dostawcy (naciśnij Enter)",
    suppliers_no_matches: "Brak dostawców pasujących do filtrów",
    suppliers_col_name: "Dostawca",
    suppliers_col_status: "Status",
    suppliers_col_book_in: "Rejestracja",
    suppliers_book_in_label: "Pokazuj w rejestracji wg dostawcy (gdy ma otwarte PO)",
    suppliers_book_in_yes: "Widoczny",
    suppliers_book_in_no: "Ukryty",
    suppliers_col_allow_duplicates: "Duplikaty",
    suppliers_allow_duplicates_label: "Zezwalaj na duplikaty (pomiń kontrolę „już na stanie” przy rejestracji produktów tego dostawcy)",
    suppliers_allow_duplicates_yes: "Dozwolone",
    suppliers_allow_duplicates_no: "Blokowane",
    suppliers_add: "Dodaj dostawcę",
    suppliers_modal_add_title: "Dodaj dostawcę",
    suppliers_modal_edit_title: "Edytuj dostawcę",
    suppliers_modal_name_label: "Dostawca",
    suppliers_upload_xlsx: "Wczytaj XLSX",
    suppliers_upload_empty: "Arkusz jest pusty",
    suppliers_upload_bad_header: "Arkusz musi zawierać kolumny 'action' i 'name'",
    suppliers_upload_parse_error: "Nie udało się odczytać arkusza — upewnij się, że to prawidłowy plik .xlsx",
    suppliers_preflight_title: "Nieznani dostawcy",
    suppliers_preflight_body_missing: "Ci dostawcy z pliku jeszcze nie istnieją. Dodać ich automatycznie?",
    suppliers_preflight_body_archived: "Ci dostawcy istnieją, ale są zarchiwizowani — zostaną przywróceni:",
    suppliers_preflight_confirm: "Utwórz i kontynuuj wczytywanie",
    suppliers_preflight_cancel_hint: "Anuluj — żaden wiersz nie zostanie wczytany",
    products_upload_cancelled_missing_suppliers: "Wczytywanie anulowane — żaden wiersz nie został zapisany.",
    manifest_upload_cancelled_missing_suppliers: "Wczytywanie anulowane — żaden wiersz nie został zapisany.",

    // Pojemniki — tabela
    totes_filter_id: "Szukaj ID pojemnika",
    totes_filter_user: "Filtruj po użytkowniku…",
    totes_filter_all_types: "Wszystkie typy",
    totes_no_matches: "Brak pojemników pasujących do filtrów",
    totes_col_id: "ID pojemnika",
    totes_col_created: "Utworzono",
    tote_status_available_filter: "Dostępne",
    tote_status_open_filter: "W użyciu",
    tote_status_closed_filter: "Zamknięte",
    tote_status_stored_filter: "Zmagazynowane",
    totes_search_hint: "Szukaj ID pojemnika (Enter; dodaj * dla dokładnego dopasowania)",
    totes_user_search_hint: "Filtruj po użytkowniku (naciśnij Enter)",
    totes_reset_action: "Zresetuj na 'Dostępny'",
    totes_reset_title: "Zresetować pojemnik na dostępny?",
    totes_reset_body: "Pojemnik {toteId} zostanie przywrócony do statusu 'dostępny'. Wszystkie przedmioty obecnie w nim zarejestrowane zostaną z niego usunięte.",
    totes_reset_hint: "Tej operacji nie można cofnąć.",
    totes_reset_confirm: "Zresetuj pojemnik",
    totes_reset_done: "Pojemnik {toteId} zresetowany na dostępny",
    totes_reset_failed: "Nie udało się zresetować pojemnika — spróbuj ponownie",

    // Admin Settings — Strefa zagrożenia

    // Logs (admin)
    logs: "Dzienniki",
    logs_hint: "Każda uwierzytelniona czynność w Portalu — rejestracja, odłożenie, sorter, przenośnik, skany, zmiany ustawień, funkcje administratora. Filtruj po magazynie, użytkowniku, uprawnieniach, dziale, akcji i dacie.",
    logs_filter_search: "Szukaj użytkownika, pojemnika, lokalizacji, zamówienia, PO, SKU, przedmiotu, kodu",
    logs_filter_department: "Dział",
    logs_filter_department_all: "Wszystkie działy",
    logs_filter_user: "Użytkownik",
    logs_filter_user_all: "Wszyscy użytkownicy",
    logs_page_size: "Wierszy na stronę",
    logs_page_size_option: "{count} wierszy",
    logs_filter_action: "Akcja",
    logs_filter_action_all: "Wszystkie akcje",
    logs_filter_permission: "Uprawnienia",
    logs_filter_permission_all: "Wszystkie uprawnienia",
    logs_filter_status: "Status",
    logs_filter_status_all: "Wszystkie statusy",
    logs_filter_warehouse_all: "Wszystkie magazyny",
    logs_filter_search_hint: "Szukaj… (naciśnij Enter)",
    logs_search_by: "Szukaj w",
    logs_search_by_all: "Wszystkie pola",
    logs_search_by_user: "Użytkownik",
    logs_search_by_tote: "Pojemnik",
    logs_search_by_location: "Lokalizacja",
    logs_search_by_order: "Zamówienie",
    logs_search_by_po: "PO",
    logs_search_by_sku: "SKU",
    logs_search_by_item: "Przedmiot",
    logs_search_by_barcode: "Kod kreskowy",
    logs_filter_from: "Od",
    logs_filter_to: "Do",
    logs_filter_range: "Zakres dat",
    date_preset_today: "Dzisiaj",
    date_preset_yesterday: "Wczoraj",
    date_preset_last_7: "Ostatnie 7 dni",
    date_preset_last_30: "Ostatnie 30 dni",
    date_preset_last_90: "Ostatnie 90 dni",
    date_preset_custom: "Zakres niestandardowy",
    logs_status_success: "Sukces",
    logs_status_error: "Błąd",
    logs_no_matches: "Żaden dziennik nie pasuje do filtrów",
    logs_load_failed: "Nie udało się załadować dzienników — spróbuj ponownie",
    logs_col_ts: "Znacznik czasu",
    logs_col_user: "Użytkownik",
    logs_col_department: "Dział",
    logs_col_action: "Akcja",
    logs_col_status: "Status",
    logs_col_warehouse: "Magazyn",
    logs_col_context: "Kontekst",
    logs_drawer_method: "Metoda",
    logs_drawer_path: "Ścieżka",
    logs_drawer_duration: "Czas trwania",
    logs_drawer_metadata: "Metadane",
    email_log_chip_to: "Do",
    email_log_chip_lang: "Język",
    email_log_chip_sends: "Wysyłka",
    email_log_chip_error: "Błąd",
    email_log_copied: "Skopiowano",
    email_log_copy_failed: "Nie udało się skopiować — zaznacz tekst i skopiuj go ręcznie",
    email_log_status: "Status",
    email_log_status_sent: "Wysłano",
    email_log_status_queued: "W kolejce",
    email_log_status_failed_retry: "Błąd — ponowi próbę",
    email_log_status_failed_permanent: "Błąd — bez ponownej próby",
    email_log_type: "E-mail",
    email_log_kind_shipment: "Potwierdzenie wysyłki",
    email_log_kind_replacement: "Zamiennik w drodze",
    email_log_kind_extra_box: "Dodatkowa paczka w drodze",
    email_log_queued_at: "W kolejce od",
    email_log_sends_at: "Wysyłka o",
    email_log_attempts: "Dotychczasowe próby",
    email_log_last_error: "Ostatni błąd",
    email_log_sent_at: "Wysłano",
    email_log_attempted_at: "Próba",
    email_log_error: "Błąd",
    email_log_to: "Do",
    email_log_erased: "Usunięto (retencja danych)",
    email_log_from: "Od",
    email_log_reply_to: "Odpowiedź do",
    email_log_subject: "Temat",
    email_log_language: "Język",
    email_log_titles_translated: "Przetłumaczone nazwy produktów: {n}",
    email_log_language_note: "Wysłano po angielsku: {reason}",
    email_log_message_id: "ID wiadomości SES",
    email_log_copy: "Kopiuj",
    email_log_delivery: "Dostarczenie",
    email_log_attempt_n: "próba {n}",
    email_log_outbox_row: "wiersz kolejki {id}",
    email_log_contents: "Co zawierał e-mail",
    email_log_parcel: "Paczka",
    email_log_pallet: "Paleta",
    email_log_carrier: "Przewoźnik",
    email_log_tracking: "Śledzenie",
    email_log_units: "Sztuki",
    email_log_still_to_come: "Jeszcze do wysłania",
    email_log_units_n: "Sztuki: {n}",
    email_log_orders_in_shipment: "Zamówienia w tej przesyłce",
    email_log_the_email: "E-mail",
    email_log_bodies_erased: "Treść e-maila usunięto razem z danymi osobowymi zamówienia.",
    email_log_bodies_dropped: "Treść e-maila nie jest już przechowywana (przechowujemy ją 180 dni). Powyższe szczegóły pozostają.",
    email_log_bodies_none: "Ta próba nie powiodła się przed utworzeniem e-maila.",
    email_log_view_preview: "Podgląd",
    email_log_view_html: "Źródło HTML",
    email_log_view_text: "Zwykły tekst",
    email_log_open_tab: "Otwórz w nowej karcie",
    email_log_copy_html: "Kopiuj HTML",
    email_log_copy_text: "Kopiuj tekst",

    // Zmiana hasła (wymuszone rotowanie dla admin / superAdmin)
    change_password_title: "Ustaw nowe hasło",
    change_password_subtitle: "Ze względów bezpieczeństwa wybierz nowe hasło, zanim przejdziesz dalej. To czynność jednorazowa.",
    change_password_new_label: "Nowe hasło",
    change_password_confirm_label: "Potwierdź nowe hasło",
    change_password_show: "Pokaż hasło",
    change_password_hide: "Ukryj hasło",
    change_password_mismatch: "Hasła nie są zgodne",
    change_password_rules_label: "Wymagania hasła",
    change_password_rule_length: "Co najmniej {min} znaków",
    change_password_rule_upper: "Wielka litera",
    change_password_rule_lower: "Mała litera",
    change_password_rule_digit: "Cyfra",
    change_password_rule_symbol: "Znak specjalny",
    change_password_rule_no_spaces: "Bez spacji",
    change_password_submit: "Zapisz nowe hasło",
    change_password_done: "Hasło zaktualizowane",
    change_password_failed: "Nie udało się zaktualizować hasła. Spróbuj ponownie.",

    // Komunikaty o próbach logowania
    login_attempts_remaining: "Nieprawidłowe logowanie. Pozostało {count} prób przed 15-minutową blokadą.",
    login_one_attempt_remaining: "Nieprawidłowe logowanie. Pozostała 1 próba przed 15-minutową blokadą.",
    login_colour_locked: "Zbyt wiele nieudanych prób. Ten kolor jest zablokowany. Spróbuj ponownie za {minutes} min.",

    // Wylogowanie wymuszone — pokazywane na ekranie logowania, gdy
    // serwer przestał rozpoznawać sesję. Portal dopuszcza jedną sesję
    // na użytkownika, więc zalogowanie się gdziekolwiek wylogowuje
    // wszędzie indziej.
    login_signed_out_elsewhere: "Nastąpiło wylogowanie, ponieważ tego konta użyto do zalogowania na innym urządzeniu. Tylko jedno urządzenie może być zalogowane naraz.",
    login_session_expired: "Twoja sesja wygasła. Zaloguj się ponownie.",
    no_module_access: "Nie masz dostępu do tego modułu.",
    no_area_access: "Nie masz jeszcze dostępu do żadnego obszaru Portalu. Poproś przełożonego o nadanie dostępu.",
    // Tryb tylko do odczytu kontroli dostępu (ACCESS_CONTROL_PLAN.md §8.4) —
    // wyświetlany, gdy zalogowane stanowisko ma dostęp "read" (nie "write")
    // do klucza tej strony: kolejki/liczniki nadal się ładują, ale każdy
    // element mutujący jest zablokowany, a skanowanie kończy się dźwiękiem błędu.
    read_only_mode: "Tylko do odczytu: możesz przeglądać tę stronę, ale nie możesz wprowadzać zmian",

    // Zapomniałeś hasła (brak samoobsługi, znajdź dorosłego)
    forgot_password: "Zapomniałeś hasła?",
    forgot_password_title: "Zamknięci na klucz, prawda?",
    forgot_password_body: "Na tej stronie nie ma przycisku resetu. Tylko współczucie. Musisz znaleźć lidera z dostępem administratora, żeby cię wybawił. Podejdź spokojnie, poproś grzecznie, przygotuj przekonującą historię o tym jak do tego doszło, i nie mów za dużo. Pewność siebie pomaga. Błaganie też działa.",
    forgot_password_dismiss: "Rozumiem",

    // Magic-link login ("email me a login link")
    login_link: "Wyślij mi link do logowania",
    login_link_title: "Otrzymaj link do logowania",
    login_link_body: "Podaj adres e-mail swojego konta, a wyślemy Ci jednorazowy link. Otwórz go na dowolnym urządzeniu i potwierdź. To urządzenie zaloguje się automatycznie.",
    login_link_email_placeholder: "Adres e-mail",
    login_link_invalid_email: "Podaj prawidłowy adres e-mail",
    login_link_send: "Wyślij link",
    login_link_sending: "Wysyłanie…",
    login_link_waiting_title: "Sprawdź pocztę",
    login_link_waiting_body: "Wysłaliśmy link na {email}. Otwórz go gdziekolwiek, także na telefonie, i potwierdź. Ten ekran zaloguje się sam.",
    login_link_waiting_hint: "Czekamy, aż potwierdzisz link…",
    login_link_expired_title: "Link wygasł",
    login_link_expired_body: "Link nie został potwierdzony w ciągu 10 minut i stracił ważność. Poproś o nowy.",
    login_link_try_again: "Zacznij od nowa",
    // Emailed-link confirm page (/login/link)
    login_link_approve_title: "Potwierdź logowanie",
    login_link_approve_body: "To zaloguje urządzenie, z którego poproszono o link, nie to, na którym to czytasz. Jeśli nie prosiłeś o link do logowania, zamknij tę stronę.",
    login_link_approve_confirm: "Potwierdź logowanie",
    login_link_approve_working: "Potwierdzanie…",
    login_link_approved_title: "Gotowe",
    login_link_approved_body: "Urządzenie, które poprosiło o link, jest już zalogowane. Możesz zamknąć tę stronę.",
    login_link_invalid_title: "Link nieprawidłowy",
    login_link_invalid_body: "Ten link do logowania jest nieprawidłowy, wygasł lub został już użyty. Poproś o nowy na stronie logowania.",

    // User email (Users Panel add/edit modals)
    email_optional: "E-mail (opcjonalnie)",
    email_placeholder: "imie@przyklad.pl",
    users_permissions_locked: "To stanowisko jest zablokowane: nikt nie zmienia własnego, a stanowisko administratora jest stałe",
    // Logowanie nazwą użytkownika / e-mailem + jednorazowa konfiguracja konta (2026-10-19)
    login_identifier_label: "Nazwa użytkownika lub e-mail",
    login_identifier_placeholder: "Nazwa użytkownika lub e-mail",
    login_identifier_required: "Wpisz nazwę użytkownika lub e-mail oraz hasło",
    login_or_choose_colour: "albo wybierz swój kolor",
    login_identifier_locked: "Zbyt wiele nieudanych prób. To konto jest zablokowane. Spróbuj ponownie za {minutes} min.",
    login_rate_limited_account: "Zbyt wiele nieudanych prób dla tego konta. Spróbuj ponownie za 15 min.",
    login_rate_limited_network: "Zbyt wiele nieudanych prób logowania z tej sieci. Spróbuj ponownie za 15 min.",
    login_colour_retired: "Logowanie kolorem zostało wyłączone. Zaloguj się nazwą użytkownika. Jeśli jej nie masz, poproś lidera z dostępem administratora.",
    account_setup_title: "Skonfiguruj swoje konto",
    account_setup_subtitle: "Portal loguje teraz nazwą użytkownika i hasłem zamiast kolorem i PIN-em. Wybierz swoje poniżej. To czynność jednorazowa.",
    account_setup_username_section: "Nazwa użytkownika",
    account_setup_username_label: "Wybierz nazwę użytkownika",
    account_setup_username_hint: "3–15 znaków, tylko litery i cyfry, bez spacji i znaków specjalnych. Będziesz ją wpisywać przy każdym logowaniu, więc niech będzie krótka.",
    account_setup_username_fixed_hint: "Twoja nazwa użytkownika jest już ustawiona.",
    username_checking: "Sprawdzanie…",
    username_available: "Dostępna",
    username_err_too_short: "Co najmniej 3 znaki",
    username_err_too_long: "Maksymalnie 15 znaków",
    username_err_invalid_chars: "Tylko litery i cyfry",
    username_err_reserved: "Ta nazwa jest zarezerwowana. Wybierz inną.",
    username_err_profanity: "Ta nazwa jest niedozwolona. Wybierz inną.",
    username_err_taken: "Ta nazwa jest już zajęta",
    username_err_invalid: "Tej nazwy nie można użyć",
    account_setup_email_section: "E-mail",
    account_setup_email_label: "Służbowy e-mail",
    account_setup_email_hint: "Menedżerowie i administratorzy muszą mieć zapisany e-mail. Służy do logowania e-mailem i do linków logowania na nowym urządzeniu.",
    account_setup_password_section: "Hasło",
    account_setup_password_hint: "Wybierz coś, co zapamiętasz i łatwo wpiszesz na skanerze: dwa słowa i liczba, np. zielonykot42 (ale nie dokładnie to). Wielkie litery i znaki specjalne są dozwolone, ale niewymagane.",
    account_setup_submit: "Zakończ konfigurację",
    account_setup_done: "Konto skonfigurowane. Witaj w Portalu.",
    account_setup_failed: "Nie udało się zakończyć konfiguracji. Spróbuj ponownie.",
    // Krótsze teksty na telefonach (hooks/useIsPhone) — to samo znaczenie, mniej linii
    account_setup_subtitle_short: "Portal używa teraz nazwy użytkownika i hasła. Wybierz swoje raz, poniżej.",
    account_setup_username_hint_short: "3–15 liter lub cyfr, bez spacji i znaków specjalnych.",
    account_setup_email_hint_short: "Potrzebny do logowania e-mailem i linków logowania.",
    account_setup_password_hint_short: "Dwa słowa i liczba, np. zielonykot42. Wielkie litery i znaki specjalne opcjonalne.",
    change_password_subtitle_short: "Wybierz nowe hasło, aby kontynuować.",
    password_suggest: "Zaproponuj hasło",
    password_suggested_hint: "Zaproponowane hasło zostało wpisane i odsłonięte. Zapisz je, zanim zatwierdzisz.",
    password_generate: "Wygeneruj hasło",
    password_generated_hint: "Wygenerowane dla ciebie. Użyj go albo naciśnij ponownie, aby wylosować inne.",
    password_suggest_short: "Zaproponuj",
    password_generate_short: "Generuj",
    change_password_subtitle_expired: "Twoje hasło ma ponad {days} dni. Ze względów bezpieczeństwa wybierz nowe, zanim przejdziesz dalej.",
    change_password_subtitle_expired_short: "Twoje hasło wygasło. Wybierz nowe, aby kontynuować.",
    change_password_rule_letter: "Litera",
    change_password_rule_not_guessable: "Trudne do odgadnięcia",
    password_weak_common: "Zbyt popularne. Wybierz coś mniej oczywistego.",
    password_weak_sequence: "Bez ciągów typu abcd, 1234 lub qwer",
    password_weak_repeated: "Bez powtarzania tych samych znaków",
    password_weak_username: "Nie może zawierać nazwy użytkownika",
    password_weak_contains_username: "Nie może zawierać nazwy użytkownika",
    password_weak_contains_name: "Nie może zawierać twojego imienia ani nazwiska",
    users_col_username: "Nazwa użytkownika",
    users_needs_setup: "Wymaga konfiguracji",
    users_needs_setup_hint: "Brak nazwy użytkownika. Przy następnym logowaniu użytkownik zostanie poproszony o jej wybór i ustawienie hasła",
    users_username_hint: "Małe litery i cyfry, 3–15 znaków. Zostaw puste, aby użytkownik wybrał ją przy następnym logowaniu.",
    users_username_updated: "Zaktualizowano nazwę użytkownika {name}",
    users_reset_password: "Resetuj hasło",
    users_reset_password_hint: "Ustaw tymczasowe hasło dla {name} i przekaż je osobiście. Nigdy nie jest wysyłane e-mailem.",
    users_reset_require_change: "Wymagaj nowego hasła przy następnym logowaniu",
    users_reset_password_save: "Zapisz hasło",
    users_reset_password_done: "Hasło użytkownika {name} zresetowane",
    users_email_required_manager: "Menedżerowie i administratorzy muszą mieć adres e-mail",
    users_add_password_hint: "Tymczasowe hasło przekazywane osobiście. Użytkownik wybierze własne przy pierwszym logowaniu.",
    email_required: "E-mail (wymagany)",
    // Uwierzytelnianie dwuskładnikowe (2026-10-20): drugi krok logowania i strona Użytkownicy
    tfa_verify_title: "Wprowadź kod uwierzytelniający",
    tfa_signed_in_as: "Logowanie jako {name}",
    tfa_verify_subtitle: "Wpisz 6-cyfrowy kod z aplikacji uwierzytelniającej.",
    tfa_backup_code_help: "Wpisz jeden z zapisanych kodów zapasowych. Każdy działa raz.",
    tfa_code_label: "Kod uwierzytelniający",
    tfa_code_placeholder: "000000",
    tfa_use_backup_code: "Użyj zamiast tego kodu zapasowego",
    tfa_use_authenticator_code: "Użyj zamiast tego kodu z aplikacji",
    tfa_backup_code_label: "Kod zapasowy",
    tfa_backup_code_placeholder: "XXXX-XXXX",
    tfa_verify_button: "Zweryfikuj",
    tfa_verifying: "Weryfikowanie…",
    tfa_error_invalid_code: "Nieprawidłowy kod. Spróbuj ponownie.",
    tfa_error_required: "Wprowadź kod.",
    tfa_error_generic: "Coś poszło nie tak. Spróbuj ponownie.",
    tfa_locked: "Zbyt wiele błędnych kodów. To konto jest zablokowane. Spróbuj ponownie za {minutes} min.",
    tfa_rate_limited: "Zbyt wiele prób. Odczekaj kilka minut i spróbuj ponownie.",
    tfa_challenge_expired: "Logowanie wygasło. Wprowadź hasło ponownie.",
    tfa_time_left: "Pozostało {time}",
    tfa_trust_device: "Zapamiętaj to urządzenie na 7 dni",
    tfa_back_to_login: "Powrót do logowania",
    tfa_backup_code_used_warning: "Zalogowano kodem zapasowym. Pozostało kodów: {count}. Jeśli się skończą, poproś administratora o zresetowanie uwierzytelniania dwuskładnikowego.",
    tfa_enrol_title: "Skonfiguruj uwierzytelnianie dwuskładnikowe",
    tfa_enrol_subtitle: "Twoje stanowisko wymaga kodu z aplikacji uwierzytelniającej przy logowaniu. Skonfiguruj to raz.",
    tfa_enrol_step1_title: "1. Zeskanuj kod QR",
    tfa_enrol_step1_body: "W Google lub Microsoft Authenticator dodaj konto i zeskanuj ten kod.",
    tfa_enrol_qr_alt: "Kod QR dla aplikacji uwierzytelniającej",
    tfa_enrol_loading: "Przygotowywanie kodu konfiguracyjnego…",
    tfa_enrol_manual_entry_label: "Nie możesz zeskanować? Wpisz ten klucz:",
    tfa_enrol_copy_secret: "Kopiuj",
    tfa_enrol_secret_copied: "Skopiowano!",
    tfa_enrol_step2_title: "2. Wprowadź 6-cyfrowy kod",
    tfa_enrol_step2_body: "Wpisz kod, który aplikacja pokazuje teraz.",
    tfa_enrol_confirm_button: "Potwierdź i kontynuuj",
    tfa_enrol_confirming: "Potwierdzanie…",
    tfa_enrol_error_invalid_code: "Ten kod nie pasuje. Sprawdź aplikację i spróbuj ponownie.",
    tfa_backup_codes_title: "Zapisz swoje kody zapasowe",
    tfa_backup_codes_subtitle: "Wyświetlane tylko raz. Każdy kod loguje jednorazowo, jeśli stracisz telefon.",
    tfa_backup_codes_warning: "Po opuszczeniu tej strony nie zobaczysz tych kodów ponownie.",
    tfa_backup_codes_copy: "Kopiuj kody",
    tfa_backup_codes_copied: "Skopiowano!",
    tfa_backup_codes_download: "Pobierz .txt",
    tfa_backup_codes_file_header: "JLI Portal, kody zapasowe uwierzytelniania dwuskładnikowego. Każdy kod działa raz. Przechowuj ten plik w bezpiecznym miejscu.",
    tfa_backup_codes_confirm_checkbox: "Zapisałem/-am te kody w bezpiecznym miejscu",
    tfa_backup_codes_continue: "Przejdź do Portalu",
    users_two_factor: "Uwierzytelnianie dwuskładnikowe",
    users_two_factor_pill: "2FA",
    users_two_factor_pending_pill: "2FA oczekuje",
    users_two_factor_enrolled_hint: "Uwierzytelnianie dwuskładnikowe skonfigurowane. Użytkownik podaje kod z aplikacji przy logowaniu",
    users_two_factor_pending_hint: "To stanowisko wymaga uwierzytelniania dwuskładnikowego. Użytkownik zostanie poproszony o konfigurację przy następnym logowaniu",
    users_two_factor_status_enrolled: "Uwierzytelnianie dwuskładnikowe skonfigurowane {date}",
    users_two_factor_status_pending: "Uwierzytelnianie dwuskładnikowe jeszcze nieskonfigurowane. Prośba przy następnym logowaniu",
    users_reset_two_factor: "Zresetuj 2FA",
    users_reset_two_factor_title: "Zresetować uwierzytelnianie dwuskładnikowe?",
    users_reset_two_factor_body: "Aplikacja uwierzytelniająca i kody zapasowe użytkownika {name} przestaną działać, a przy następnym logowaniu zostanie on poproszony o ponowną konfigurację. Użyj tego, gdy stracił telefon i kody zapasowe.",
    users_reset_two_factor_confirm: "Zresetuj 2FA",
    users_reset_two_factor_done: "Uwierzytelnianie dwuskładnikowe użytkownika {name} zresetowane. Skonfiguruje je ponownie przy następnym logowaniu",
    users_reset_two_factor_error: "Nie udało się zresetować uwierzytelniania dwuskładnikowego tego użytkownika",
    users_reset_two_factor_self_refused: "Nie możesz zresetować własnego uwierzytelniania dwuskładnikowego. Poproś innego administratora.",
    users_reset_two_factor_stepup_title: "Potwierdź swoją tożsamość",
    users_reset_two_factor_stepup_body: "Wpisz aktualny kod ze swojej aplikacji uwierzytelniającej, aby potwierdzić ten reset.",
    users_reset_two_factor_stepup_label: "Twój kod uwierzytelniający",
    users_reset_two_factor_stepup_hint: "6-cyfrowy kod wyświetlany w aplikacji dla JLI Portal.",
    users_reset_two_factor_stepup_confirm: "Potwierdź reset",
    users_reset_two_factor_stepup_wrong: "Ten kod jest nieprawidłowy. Spróbuj ponownie.",
    users_reset_two_factor_stepup_locked: "Zbyt wiele błędnych kodów. Twoje konto jest zablokowane na {minutes} min.",

    logs_export: "Eksport",
    logs_export_progress: "Eksportowanie…",
    logs_export_done: "Wyeksportowano {count} wierszy",
    logs_export_empty: "Nic do eksportu — żadne wiersze nie pasują do bieżących filtrów",
    logs_export_failed: "Eksport nie powiódł się — spróbuj ponownie",
    logs_export_truncated: "Wyeksportowano pierwsze {exported} z {total} wierszy. Zawęź filtry, aby uchwycić resztę.",

    // Ekran logowania — czy urządzenia mogą zapisywać dane logowania? (2026-10-29)
    login_screen_settings: "Ekran logowania",
    login_screen_settings_hint: "Jak działa ekran logowania na każdym urządzeniu, we wszystkich lokalizacjach.",
    saved_logins_toggle: "Zapisywanie danych logowania na urządzeniach",
    saved_logins_toggle_hint: "Wyłączone (zalecane, bo urządzenia są współdzielone): przeglądarka nigdy nie proponuje zapisania nazwy użytkownika i hasła, a dane zapisane wcześniej na urządzeniu nie są już uzupełniane, więc każdy za każdym razem wpisuje swoje. Wcześniej zapisane dane pozostają na liście haseł tej przeglądarki, dopóki ktoś ich tam nie usunie. Włączone: telefony i komputery mogą proponować ich zapisanie i uzupełniać je następnym razem.",
    saved_logins_now_on: "Urządzenia mogą teraz zapisywać dane logowania",
    saved_logins_now_off: "Urządzenia nie będą już zapisywać ani uzupełniać danych logowania",
    saved_logins_save_failed: "Nie udało się zapisać ustawienia",
    // IP allow-list (Dostęp sieciowy)
    ip_allowlist_title: "Dostęp sieciowy",
    ip_allowlist_hint: "Tylko zakresy IP poniżej mogą łączyć się z portalem. Jeśli lista jest pusta, brama jest otwarta, a w każdym żądaniu zapisywane jest ostrzeżenie — dodaj co najmniej jeden wpis, aby włączyć egzekwowanie.",
    ip_allowlist_add_title: "Dodaj sieć",
    ip_allowlist_add_hint: "Użyj pojedynczego IP (np. 203.0.113.5) lub zakresu CIDR (np. 203.0.113.0/29) dla całego oddziału. Kliknij „Użyj mojego IP\", aby wstawić adres, z którego się łączysz.",
    ip_allowlist_cidr_label: "CIDR / IP",
    ip_allowlist_cidr_placeholder: "203.0.113.0/24",
    ip_allowlist_label_label: "Etykieta",
    ip_allowlist_label_placeholder: "np. Magazyn Pembroke lub Imię i nazwisko",
    ip_allowlist_use_my_ip: "Użyj mojego IP",
    ip_allowlist_add_button: "Dodaj do listy dozwolonych",
    ip_allowlist_my_network_label: "Moja sieć",
    ip_allowlist_form_required: "CIDR i etykieta są wymagane",
    ip_allowlist_added: "Dodano do listy dozwolonych",
    ip_allowlist_added_from_blocked: "Szybko dodano z zablokowanej próby: {ip}",
    ip_allowlist_deleted: "Usunięto z listy dozwolonych",
    ip_allowlist_confirm_delete: "Usunąć {cidr} z listy dozwolonych?",
    ip_allowlist_active_title: "Aktywna lista dozwolonych",
    ip_allowlist_empty_warning: "Lista dozwolonych jest pusta. Dopóki nie zostanie dodany żaden wpis, brama IP przepuszcza wszystkie żądania.",
    ip_allowlist_col_cidr: "CIDR",
    ip_allowlist_col_label: "Etykieta",
    ip_allowlist_col_enabled: "Aktywne",
    ip_allowlist_col_created: "Dodano",
    ip_allowlist_blocked_title: "Niedawne zablokowane próby",
    ip_allowlist_blocked_hint: "Adresy IP odrzucone przez portal. Kliknij ptaszek, aby dodać IP do listy dozwolonych, lub krzyżyk, aby je odrzucić. Starsze wpisy wygasają automatycznie po 30 dniach bezczynności.",
    ip_allowlist_blocked_empty: "Brak zarejestrowanych zablokowanych prób.",
    ip_allowlist_search_placeholder: "Szukaj IP…",
    ip_allowlist_col_ip: "IP",
    ip_allowlist_col_attempts: "Próby",
    ip_allowlist_col_first_seen: "Pierwsza próba",
    ip_allowlist_col_last_seen: "Ostatnia próba",
    ip_allowlist_col_last_request: "Ostatnie żądanie",
    ip_allowlist_quick_add: "Dodaj do listy dozwolonych",
    ip_allowlist_dismiss: "Odrzuć",
    ip_allowlist_already_allowed: "Już na liście dozwolonych",
    ip_allowlist_edit_label_hint: "Kliknij, aby edytować",
    tile_ip_allowlist_desc: "Zarządzaj, które sieci mogą łączyć się z portalem",

    // Aktywność logowania (dziennik prób logowania na IP)
    ip_allowlist_logins_title: "Aktywność logowania",
    ip_allowlist_logins_hint: "Każdy adres IP, który próbował zalogować się do portalu, z licznikami sukcesów i niepowodzeń. Użyj tego, by zidentyfikować legitymne sieci i dodać je do listy dozwolonych przed włączeniem egzekwowania.",
    ip_allowlist_logins_empty: "Brak zarejestrowanej aktywności logowania.",
    ip_allowlist_added_from_login: "Szybko dodano z aktywności logowania: {ip}",
    ip_allowlist_added_from_login_named: "Sieć użytkownika {name}",
    ip_allowlist_col_user: "Ostatni użytkownik",
    ip_allowlist_col_status: "Ostatni status",
    ip_allowlist_col_success: "Sukces",
    ip_allowlist_col_failure: "Błąd",
    ip_allowlist_status_success: "Sukces",
    ip_allowlist_status_failure: "Błąd",

    // Ekran zablokowanej sieci — lista dozwolonych IP odrzuciła to urządzenie
    network_blocked_title: "Ta sieć nie ma autoryzacji",
    network_blocked_body: "Portal przyjmuje połączenia wyłącznie z zatwierdzonych sieci magazynów i biur. Połączenie, z którego teraz korzystasz, nie znajduje się na tej liście.",
    network_blocked_ip_label: "Twój adres IP",
    network_blocked_ip_unknown: "nieznany",
    network_blocked_copy: "Kopiuj adres",
    network_blocked_copied: "Skopiowano",
    network_blocked_hint: "Poproś administratora o dodanie tego adresu w Ustawienia > Dostęp sieciowy albo połącz się z zatwierdzonej sieci, a następnie spróbuj ponownie.",
    network_blocked_retry: "Spróbuj ponownie",

    // Blokady kolorów (zabezpieczenie przed atakami brute-force)
    colour_lockout_title: "Zablokowane kolory",
    colour_lockout_hint: "Te kolory zostały tymczasowo zablokowane po zbyt wielu nieudanych próbach logowania. Blokady znikają automatycznie po 15 minutach; superAdmin może odblokować ręcznie.",
    colour_lockout_col_colour: "Kolor / konto",
    colour_lockout_col_failures: "Niepowodzenia",
    colour_lockout_col_distinct_ips: "Unikalne IP",
    colour_lockout_col_locked_until: "Zablokowane do",
    colour_lockout_col_last_ip: "IP ostatniej porażki",
    colour_lockout_unlock: "Odblokuj",
    colour_lockout_unlocked: "Odblokowano {colour}",

    // Integracje — Kanały sprzedaży
    integrations_settings: "Integracje",
    integrations_settings_hint: "Połącz Portal z zewnętrznymi kanałami sprzedaży. Każdy kanał ma własne dane uwierzytelniające API i można je włączać niezależnie.",
    integrations_sales_channels_heading: "Kanały sprzedaży",
    integrations_jobalots: "Jobalots",
    integrations_jobalots_hint: "Połączenie z platformą Jobalots. JLI sprzedaje pod kilkoma kontami dostawcy na Jobalots — wszystkie korzystają z poniższych poświadczeń, ale każde można włączać i wyłączać niezależnie.",
    integrations_bargainfox: "BargainFox",
    integrations_bargainfox_hint: "Połączenie z platformą BargainFox — oddzielny kanał sprzedaży z własnymi poświadczeniami, niezależny od Jobalots. Jedno konto dostawcy; przed włączeniem ustaw jego magazyn realizacji, inaczej przychodzące zamówienia będą odrzucane.",
    // --- Mapowanie SKU (Shopify + Amazon) -----------------------------
    sku_map_heading: "Mapowanie SKU",
    sku_map_hint: "Które SKU Portalu stoją za każdym SKU wystawionym w tym kanale. Kilka SKU Portalu może dzielić jedną ofertę — tak sprzedaje się jako jeden produkt to, co u nas jest rozbite na dostawy. Wysyłany stan to ich suma, a przychodząca linia zamówienia jest automatycznie dzielona między nie.",
    sku_map_empty: "Nic jeszcze nie zmapowano — uruchom Synchronizuj katalog, a potem połącz to, czego nie dopasował.",
    sku_map_search_placeholder: "Szukaj SKU kanału lub SKU Portalu",
    sku_map_unbacked: "{n} ofert nie ma za sobą żadnego produktu Portalu. Nigdy nie otrzymają stanu — połącz poniżej SKU Portalu lub utwórz produkt.",
    sku_map_unknown_sku: "W Portalu nie ma jeszcze produktu o tym SKU",
    sku_map_untracked: "bez śledzenia stanu",
    sku_map_summed: "{n} SKU Portalu — stan to ich suma",
    sku_map_link: "Połącz",
    sku_map_link_hint: "Połącz ręcznie SKU Portalu z ofertą. Połączenia ręczne przetrwają ponowną synchronizację katalogu; automatyczne są za każdym razem odtwarzane.",
    sku_map_linked: "Połączono {sku} z {external}.",
    sku_map_unlink: "Rozłącz",
    sku_map_external_placeholder: "SKU kanału",
    sku_map_portal_placeholder: "SKU Portalu",
    // --- Amazon Seller Central ---------------------------------------
    amazon_add_channel: "Podłącz rynek",
    amazon_add_channel_hint: "Podłącz rynek Amazon. Jeden kanał na konto sprzedawcy i rynek — sprzedaż na amazon.co.uk i amazon.de to dwa kanały, każdy kierowany do własnego magazynu. Tylko oferty realizowane przez sprzedawcę: towar FBA trzyma i wysyła Amazon i nie jest ruszany.",
    amazon_channel_created: "Podłączono {name}. Dodaj poświadczenia aplikacji, następnie zsynchronizuj katalog.",
    amazon_channel_deleted: "Usunięto {name}.",
    amazon_channel_hint: "Podłączony rynek Amazon. Zamówienia są pobierane cyklicznie (Amazon nie wysyła webhooków), stany zapisywane przy każdej zmianie, a wysyłka potwierdzana numerem śledzenia. Przechodź po karcie: poświadczenia, katalog, zamówienia.",
    amazon_delete_channel: "Usuń rynek",
    amazon_field_seller_id: "ID sprzedawcy",
    amazon_field_marketplace: "Rynek",
    amazon_field_region: "Region",
    amazon_field_warehouse: "Magazyn realizacji",
    amazon_field_display_name: "Nazwa kanału",
    amazon_choose_marketplace: "Wybierz rynek…",
    amazon_choose_warehouse: "Wybierz magazyn…",
    amazon_field_client_id: "Client ID (LWA)",
    amazon_field_client_id_hint: "Z Twojej prywatnej aplikacji w Seller Central (zaczyna się amzn1.application-oa2-client). Wspólny dla wszystkich rynków autoryzowanych w tym samym profilu dewelopera.",
    amazon_field_client_secret: "Client secret (LWA)",
    amazon_field_client_secret_hint: "Sekret prywatnej aplikacji. Przechowywany zaszyfrowany i nigdy nie odsyłany do przeglądarki.",
    amazon_field_refresh_token: "Refresh token (LWA)",
    amazon_field_refresh_token_hint: "Z samodzielnej autoryzacji aplikacji dla tego konta sprzedaży. Długotrwały; Portal wymienia go na godzinny token dostępu w miarę potrzeb.",
    amazon_needs_credentials: "Dodaj client ID, client secret i refresh token przed włączeniem tego rynku.",
    amazon_push_mode_hint: "Tryb próbny waliduje i zapisuje w logach wszystko, co Portal wysłałby do Amazona, nic nie zapisując. Zostaw nowy rynek w trybie próbnym, dopóki strona Logi nie pokaże poprawnych danych dla prawdziwego ruchu.",
    amazon_sandbox: "Tryb piaskownicy",
    amazon_sandbox_hint: "Kieruje ten kanał do piaskownicy Amazona zamiast do prawdziwego rynku. Piaskownica odpowiada danymi testowymi na tych samych poświadczeniach, więc potwierdza działanie połączenia i kształtów zapytań — ale nigdy prawdziwych zamówień ani stanów. Użyj do próby, potem wyłącz.",
    amazon_sandbox_on: "Połączono z piaskownicą — brak prawdziwych zamówień i stanów",
    amazon_sandbox_off: "Połączono z prawdziwym rynkiem",
    amazon_sandbox_pill: "Piaskownica",
    amazon_test_success_sandbox: "Piaskownica osiągalna — {latencyMs} ms. Potwierdza tylko poświadczenia i transport, nie Twoje prawdziwe oferty.",
    amazon_test_success: "Połączono z {marketplace} — {latencyMs} ms",
    amazon_catalogue: "Katalog",
    amazon_catalogue_hint: "Pobiera oferty realizowane przez sprzedawcę i mapuje każde SKU Amazona na SKU Portalu, dopasowując po SKU, a następnie po SKU nadrzędnym. To mapowanie jest zarazem przełącznikiem synchronizacji per produkt: tylko zmapowane oferty otrzymują stany.",
    amazon_catalogue_synced: "Znaleziono {listings} ofert realizowanych przez sprzedawcę; {matched} ma za sobą stan w Portalu.",
    amazon_catalogue_fba_skipped: "Pominięto {n} ofert FBA — ten towar trzyma i wysyła Amazon.",
    amazon_orders: "Zamówienia",
    amazon_orders_hint: "Amazon nie ma webhooków, więc Portal odpytuje co kilka minut. Adresy kupujących wymagają zatwierdzonej roli Direct-to-Consumer Shipping dla Twojej aplikacji, inaczej każdy przebieg kończy się błędem.",
    amazon_poll_now: "Pobierz teraz",
    amazon_poll_now_hint: "Uruchom jeden przebieg pobierania zamówień od razu, zamiast czekać na kolejny zaplanowany.",
    amazon_polling: "Pobieram…",
    amazon_poll_result: "Przejrzano {seen} zamówień: {ingested} przyjęto, {skipped} pominięto.",
    amazon_poll_failed: "{n} zamówień nie udało się przyjąć — kursor wstrzymano, kolejny przebieg spróbuje ponownie.",
    amazon_poll_error: "Ostatni przebieg zamówień nie powiódł się: {detail}",
    amazon_last_polled: "Ostatni przebieg {when}",
    amazon_never_polled: "Nigdy nie uruchomiono — zamówienia nie dotrą, dopóki się nie powiedzie",
    amazon_routing_heading: "Magazyn realizacji",
    amazon_routing_hint: "Który magazyn realizuje zamówienia tego rynku. Nieskierowany kanał odrzuca każde otrzymane zamówienie, a odrzucone zamówienie Amazona liczy się przeciwko Twoim wskaźnikom sprzedawcy.",
    amazon_unrouted: "Nie ustawiono magazynu",
    amazon_address_only_hint: "Amazon nadaje każdemu zamówieniu unikalny anonimowy e-mail kupującego, więc normalne dopasowanie klienta nigdy nie znajdzie powracającego nabywcy. Dopasowanie po nazwie odbiorcy i adresie dostawy sprawia, że łączenie działa — kosztem możliwego połączenia dwóch różnych kupujących o tej samej nazwie pod jednym adresem.",
    amazon_address_only_on: "Dopasowanie po nazwie odbiorcy i adresie dostawy",
    amazon_address_only_off: "Dopasowanie po e-mailu (na Amazonie nigdy nie zadziała)",
    // --- Kreator dodawania kanału sprzedaży ---------------------------
    add_channel_title: "Dodaj kanał sprzedaży",
    add_channel_choose: "Którą platformę podłączasz?",
    add_channel_shopify: "Shopify",
    add_channel_amazon: "Amazon Seller Central",
    add_channel_shopify_hint: "Podaj stałą domenę administracyjną sklepu i poświadczenia aplikacji własnej. Nic nie zostanie zapisane, dopóki sklep nie odpowie.",
    add_channel_amazon_hint: "Podaj konto sprzedawcy i poświadczenia Twojej prywatnej aplikacji. Nic nie zostanie zapisane, dopóki Amazon nie odpowie.",
    add_channel_webhook_secret_hint: "Klucz API aplikacji własnej. Opcjonalny tutaj — możesz dodać go na karcie — ale zamówienia nie dotrą, dopóki nie zostanie ustawiony.",
    add_channel_test_ok: "Połączono z {name}",
    add_channel_test_first: "Najpierw przetestuj połączenie",
    add_channel_create: "Dodaj kanał",
    add_channel_created: "Dodano {name}.",
    add_channel_next_steps: "Cała reszta — katalog, mapowanie SKU, lokalizacje magazynów, webhooki — konfigurowana jest na karcie kanału, gdy już powstanie.",
    integrations_coming_soon: "Wkrótce",
    // --- Sklepy Shopify (kanał sprzedaży z wieloma sklepami) ----------
    shopify_add_store: "Podłącz sklep",
    shopify_add_store_hint: "Podłącz sklep Shopify. Podaj jego stałą domenę administracyjną — możesz dodać tyle sklepów, z ilu sprzedajesz, każdy z własnymi poświadczeniami i kierowaniem do magazynów.",
    shopify_store_created: "Podłączono {name}. Dodaj poświadczenia, następnie zsynchronizuj katalog.",
    shopify_store_deleted: "Usunięto {name}.",
    shopify_store_hint: "Podłączony sklep Shopify. Zamówienia przychodzą webhookiem, stany magazynowe są wysyłane przy każdej zmianie, a numer śledzenia wraca jako realizacja po spakowaniu zamówienia. Przechodź po karcie po kolei: poświadczenia, katalog, lokalizacje magazynów, webhooki.",
    shopify_field_display_name: "Nazwa sklepu",
    shopify_field_domain: "Domena sklepu",
    shopify_field_domain_hint: "Stała domena administracyjna .myshopify.com, nie domena widoczna dla klientów. Niezmienna po podłączeniu sklepu.",
    shopify_field_api_version: "Wersja Admin API",
    shopify_field_api_version_hint: "Przypięta per sklep (np. 2026-07), aby wydanie Shopify nigdy nie zmieniło kształtu pól pod działającym magazynem. Zaktualizuj jeden sklep, sprawdź, potem resztę.",
    shopify_field_access_token: "Token dostępu Admin API",
    shopify_field_access_token_hint: "Z aplikacji własnej sklepu (zaczyna się od shpat_). Wymaga odczytu/zapisu produktów, stanów, zamówień, realizacji i lokalizacji. Przechowywany zaszyfrowany i nigdy nie odsyłany do przeglądarki.",
    shopify_field_webhook_secret: "Sekret podpisu webhooków",
    shopify_field_webhook_secret_hint: "Klucz API aplikacji własnej. Portal weryfikuje nim każdy przychodzący webhook — bez niego zamówienia z tego sklepu są odrzucane.",
    shopify_push_mode_hint: "Tryb próbny waliduje i zapisuje w logach wszystko, co Portal wysłałby do Shopify, nic nie zmieniając w sklepie. Zostaw nowy sklep w trybie próbnym, dopóki strona Logi nie pokaże poprawnych danych dla prawdziwego ruchu.",
    shopify_test_success: "Połączono z {shop} — {latencyMs} ms",
    shopify_require_paid: "Realizuj tylko opłacone zamówienia",
    shopify_require_paid_hint: "Włączone: zamówienie trafia do magazynu dopiero, gdy Shopify zgłosi je jako opłacone, częściowo opłacone lub autoryzowane. Wyłącz tylko dla sklepów przyjmujących płatność na fakturę lub poza systemem.",
    shopify_require_paid_on: "Czekam na płatność przed realizacją",
    shopify_require_paid_off: "Realizuję niezależnie od statusu płatności",
    shopify_notify_customer: "Wyślij kupującemu e-mail o wysyłce",
    shopify_notify_customer_hint: "Czy Shopify wysyła własne potwierdzenie wysyłki, gdy Portal oznaczy zamówienie jako zrealizowane. Wyłącz, jeśli sklep wysyła je sam.",
    shopify_notify_customer_on: "Shopify wysyła e-mail do kupującego",
    shopify_notify_customer_off: "Brak e-maila z Shopify",
    shopify_catalogue: "Katalog",
    shopify_catalogue_hint: "Pobiera każdy wariant w sklepie i mapuje jego SKU na SKU Portalu. To mapowanie jest zarazem przełącznikiem synchronizacji per produkt: tylko SKU wystawione w sklepie otrzymują aktualizacje stanów. Uruchom ponownie po dodaniu lub usunięciu produktów w Shopify.",
    shopify_catalogue_sync: "Synchronizuj katalog",
    shopify_catalogue_syncing: "Synchronizuję…",
    shopify_catalogue_synced: "Zmapowano {mapped} wariant(ów); {matched} pasuje do produktów Portalu.",
    shopify_catalogue_duplicates: "Kilka wariantów ma to samo SKU ({skus}) — tylko jeden z nich może otrzymywać stany. Popraw duplikaty w Shopify.",
    shopify_catalogue_state: "{n} wariant(ów) zmapowanych · {when}",
    shopify_catalogue_never: "Nigdy nie synchronizowano — stany nie będą wysyłane, dopóki tego nie zrobisz",
    shopify_locations: "Lokalizacje magazynów",
    shopify_locations_hint: "Shopify trzyma stany per lokalizacja, więc każdy magazyn realizacji potrzebuje jednej. Magazyn bez mapowania po prostu nie jest zatowarowany w tym sklepie i jego ruchy nigdy nie są wysyłane.",
    shopify_locations_load: "Wczytaj lokalizacje",
    shopify_locations_no_routing: "Najpierw ustaw poniżej magazyny realizacji tego sklepu — lokalizacje mapuje się per skierowany magazyn.",
    shopify_locations_unmapped: "Brak lokalizacji Shopify dla: {warehouses}. Stany z tych magazynów nie będą wysyłane.",
    shopify_location_none: "— brak zatowarowania —",
    shopify_webhooks: "Webhooki",
    shopify_webhooks_hint: "Shopify wysyła do Portalu nowe, opłacone i anulowane zamówienia. Rejestracja kieruje ten sklep na TO środowisko Portalu — zarejestruj ponownie po przejściu ze stagingu na produkcję, inaczej sklep dalej będzie wysyłał prawdziwe zamówienia pod stary adres.",
    shopify_webhooks_check: "Sprawdź",
    shopify_webhooks_register: "Zarejestruj webhooki",
    shopify_webhooks_registering: "Rejestruję…",
    shopify_webhooks_registered: "Zarejestrowano {n} webhook(ów).",
    shopify_webhooks_target: "Ta instancja Portalu odpowiada pod {url}",
    shopify_webhooks_wrong_env: "Ten sklep wysyła zamówienia do innego środowiska Portalu. Zamówienia nie dotrą tutaj, dopóki nie zarejestrujesz ponownie.",
    shopify_webhook_ok: "wysyła tutaj",
    shopify_webhook_missing: "niezarejestrowany",
    shopify_webhook_wrong_env_detail: "idzie do {url}",
    shopify_routing_heading: "Kierowanie realizacji",
    shopify_routing_hint: "Które magazyny realizują zamówienia tego sklepu, w kolejności priorytetu. Zamówienie dla nieskierowanego sklepu jest odrzucane, zamiast trafić do zgadniętego magazynu.",
    shopify_delete_store: "Usuń sklep",
    shopify_delete_store_hint: "Możliwe tylko, gdy żadne zamówienie nie odwołuje się do tego sklepu. Zamiast tego wyłącz go, aby zatrzymać ruch bez utraty historii.",
    shopify_delete_store_confirm: "Usunąć {name} wraz ze wszystkimi ustawieniami?",
    integrations_master_enabled: "Kanał włączony",
    integrations_master_enabled_hint: "Główny przełącznik. Wyłączenie wstrzymuje wszystkie konta dostawcy w tym kanale.",
    integrations_vendors_heading: "Konta dostawcy",
    integrations_vendors_hint: "Tożsamości dostawcy, pod którymi JLI sprzedaje w tym kanale. Każde niesie własny X-Vendor-Id i można je niezależnie włączać i wyłączać.",
    integrations_vendors_empty: "Nie skonfigurowano jeszcze żadnych kont dostawcy.",
    integrations_vendor_enabled_hint: "Włącz lub wyłącz to konto bez wpływu na pozostałe.",
    integrations_status_pill_enabled: "Włączone",
    integrations_status_pill_disabled: "Wyłączone",
    integrations_warehouse_routing_heading: "Trasowanie magazynów",
    integrations_warehouse_routing_hint: "Powiąż każdy magazyn Portalu z kontem dostawcy na tym kanale. Zamówienia przychodzące z tym vendor_key będą realizowane z odpowiedniego magazynu.",
    integrations_warehouse_routing_empty: "Brak skonfigurowanych magazynów.",
    integrations_warehouse_vendor_select: "Wybierz konto dostawcy",
    integrations_warehouse_vendor_unset: "Brak przypisania",
    integrations_vendor_warehouse: "Magazyn realizacji",
    integrations_vendor_warehouse_select: "Wybierz magazyn realizacji",
    integrations_vendor_warehouses: "Magazyny realizacji",
    integrations_vendor_warehouses_select: "Wybierz magazyny realizacji",
    integrations_vendor_warehouses_hint: "Wybierz jeden lub więcej magazynów w kolejności priorytetu — pierwszy jest podstawowy. Zamówienia są konsolidowane do magazynu o najwyższym priorytecie, który ma zapas, i dzielone między magazyny tylko wtedy, gdy zapas jest rozdzielony.",
    integrations_vendor_warehouses_summary: "{count} magazynów · podstawowy {primary}",
    integrations_warehouse_primary: "Podstawowy",
    integrations_push_mode: "Tryb wysyłki",
    integrations_push_mode_hint: "Tryb próbny waliduje i loguje oba kierunki bez zapisywania ani realizacji czegokolwiek — użyj go do przebiegu równoległego. Przełącz na Na żywo dopiero przy skoordynowanym przełączeniu.",
    integrations_push_mode_dry_run: "Tryb próbny",
    integrations_push_mode_live: "Na żywo",
    integrations_consolidate_orders: "Konsoliduj zamówienia paczkowe",
    integrations_consolidate_orders_hint: "Łącz nowe niezrealizowane zamówienia paczkowe z tym samym adresem e-mail klienta, nazwą odbiorcy i adresem dostawy w jedną przesyłkę do wysyłki, w oknie czasowym poniżej. Zamówienia paletowe nigdy nie są łączone tutaj. Kanał sprzedaży nadal otrzymuje aktualizacje wysyłki dla każdego oryginalnego numeru zamówienia.",
    integrations_consolidate_orders_on: "Włączone — pasujące zamówienia paczkowe łączą się w jedną przesyłkę",
    integrations_consolidate_orders_off: "Wyłączone — każde zamówienie wysyłane osobno",
    integrations_consolidate_pallet_orders: "Konsoliduj zamówienia paletowe",
    integrations_consolidate_pallet_orders_hint: "Łącz niezrealizowane zamówienia paletowe (każda pozycja to produkt paletowy, w tym część _PAL zamówienia mieszanego) z tym samym adresem e-mail klienta, nazwą odbiorcy i adresem dostawy w jedną przesyłkę paletową. Bez okna czasowego i bez limitu — dołącza każde otwarte zamówienie paletowe tego klienta, którego kompletacja jeszcze się nie zaczęła. Zamówienia paletowe łączą się wyłącznie z paletowymi.",
    integrations_consolidate_pallet_orders_on: "Włączone — zamówienia paletowe klienta wysyłane jako jedna przesyłka",
    integrations_consolidate_pallet_orders_off: "Wyłączone — każde zamówienie paletowe wysyłane osobno",
    integrations_consolidate_pallet_warehouses: "Konsoliduj w",
    integrations_consolidate_pallet_warehouses_hint: "Podświetlone magazyny łączą zamówienia paletowe klienta. Odznacz magazyn, aby każde zamówienie paletowe z niego wysyłać osobno (np. MCL, gdzie zamówienia paletowe realizowane są pojedynczo). Nowo dodany magazyn konsoliduje, dopóki go tu nie wyłączysz.",
    channel_section_consolidation_parcel_on: "Paczki włączone",
    channel_section_consolidation_pallet_on: "Palety włączone",
    channel_section_consolidation_pallet_on_except: "Palety włączone (bez {warehouses})",
    integrations_ai_extra_protection: "Ocena AI dodatkowej ochrony",
    integrations_ai_extra_protection_hint: "Gdy produkt zostanie po raz pierwszy zamówiony przez ten kanał, AI sprawdza tytuł pod kątem kruchości (szkło, ceramika itp.) i wypełnia pole \"Wymaga dodatkowej ochrony\". Każdy produkt jest oceniany dokładnie raz; ręczne ustawienia na stronie Produkty nigdy nie są nadpisywane. To ustawienie tylko wypełnia flagę — o tym, czy stanowisko pakowania z niej korzysta, decyduje ustawienie poniżej.",
    integrations_ai_extra_protection_on: "Włączone — nowe produkty oceniane automatycznie",
    integrations_ai_extra_protection_off: "Wyłączone — produkty z tego kanału nie są oceniane",
    integrations_enforce_extra_protection: "Stosuj opakowania do dodatkowej ochrony",
    integrations_enforce_extra_protection_hint: "Czy zamówienia z tego kanału respektują flagę „Wymaga dodatkowej ochrony” na stanowisku pakowania: gdy włączone, rekomendacja pomija typy opakowań wykluczone w Ustawienia > Wysyłka > Rekomendacja pudełka. Niezależne od oceny AI powyżej — zostaw włączone przy wyłączonej ocenie, aby nadal respektować już posiadane flagi, w tym ustawione ręcznie na stronie Produkty.",
    integrations_enforce_extra_protection_on: "Włączone — oznaczone produkty pomijają wykluczone typy opakowań",
    integrations_enforce_extra_protection_off: "Wyłączone — zamówienia z tego kanału całkowicie ignorują flagę",
    integrations_consolidation_cutoff: "Godzina graniczna",
    integrations_consolidation_timezone: "Strefa czasowa",
    integrations_consolidation_days: "Dni graniczne",
    integrations_consolidation_days_hint: "Godzina graniczna obowiązuje o ustawionej porze w każdy wybrany dzień. Zamówienia grupują się między jedną godziną graniczną a następną — np. pon + śr + pt daje trzy okna tygodniowo (pt-pon, pon-śr, śr-pt).",
    integrations_consolidation_cutoff_hint: "Zamówienia łączą się tylko z zamówieniami złożonymi po ostatniej godzinie granicznej — każda godzina graniczna otwiera nowe okno konsolidacji. Wyczyść godzinę, aby usunąć limit.",
    integrations_consolidation_cutoff_none: "Brak godziny granicznej — nowe zamówienia łączą się z każdym otwartym zamówieniem, którego kompletacja się nie rozpoczęła.",
    integrations_consolidation_stats: "Ostatnie {days} dni: {orders} zamówień stało się {shipments} przesyłkami — zaoszczędzono {saved} paczek ({pct}%).",
    day_short_mon: "pon",
    day_short_tue: "wt",
    day_short_wed: "śr",
    day_short_thu: "czw",
    day_short_fri: "pt",
    day_short_sat: "sob",
    day_short_sun: "niedz",
    integrations_add_vendor_button: "Dodaj konto",
    integrations_add_vendor_display_name: "Nazwa wyświetlana",
    integrations_add_vendor_display_name_placeholder: "np. Jobalots AU",
    integrations_add_vendor_vendor_id: "Klucz dostawcy",
    integrations_add_vendor_vendor_id_hint: "Małe litery, musi zaczynać się od litery — tylko litery, cyfry i podkreślenia. Wysyłane na wire jako X-Vendor-Id.",
    integrations_add_vendor_vendor_id_placeholder: "jobalots_au",
    integrations_add_vendor_save: "Utwórz",
    integrations_add_vendor_invalid: "Nazwa wyświetlana i poprawny klucz dostawcy są wymagane.",
    integrations_field_enabled: "Włączone",
    integrations_field_base_url: "Adres bazowy",
    integrations_field_base_url_hint: "Adres API partnera, na który Portal wysyła informacje o wysyłkach i synchronizacji stanów. Dołącz prefiks /api/v1 jeśli wymagany.",
    integrations_field_base_url_placeholder: "https://api.jobalots.com/v1",
    integrations_field_vendor_id: "Identyfikator dostawcy",
    integrations_field_vendor_id_hint: "Identyfikator wysyłany jako X-Vendor-Id, aby partner mógł kierować żądania. Uzgodniony między zespołami.",
    integrations_field_vendor_id_placeholder: "JOBALOTS_UK",
    integrations_field_outbound_secret: "Klucz HMAC wychodzący",
    integrations_field_outbound_secret_hint: "Portal podpisuje tym kluczem wywołania DO partnera. Partner weryfikuje. Wygenerowany przez partnera.",
    integrations_field_inbound_secret: "Klucz HMAC przychodzący",
    integrations_field_inbound_secret_hint: "Portal weryfikuje tym kluczem wywołania OD partnera. Partner podpisuje. Wygenerowany przez ciebie i udostępniony przez 1Password.",
    integrations_secret_unset: "Nie ustawiono",
    integrations_secret_summary: "Ustawiony · fp {fingerprint}",
    integrations_secret_rotated_relative: "zmieniony {when}",
    integrations_secret_placeholder: "Wklej wartość klucza…",
    integrations_secret_rotate: "Zmień",
    integrations_secret_set: "Ustaw klucz",
    integrations_secret_clear: "Wyczyść",
    integrations_secret_clear_confirm: "Wyczyścić ten klucz? Ruch zależny od niego zacznie się nie udawać, dopóki nowa wartość nie zostanie ustawiona po obu stronach.",
    integrations_secret_clear_cancel: "Anuluj",
    integrations_secret_show: "Pokaż",
    integrations_secret_hide: "Ukryj",
    integrations_secret_min_length: "Klucz musi mieć co najmniej 16 znaków",
    integrations_secret_generate: "Wygeneruj",
    integrations_secret_generate_title: "Utwórz silny losowy sekret na serwerze i pokaż go jednorazowo",
    integrations_secret_or: "lub",
    integrations_secret_generated_title: "Nowy sekret — pokazany jednorazowo",
    integrations_secret_generated_hint: "Skopiuj go teraz i prześlij drugiej stronie bezpiecznym kanałem. Nie da się go ponownie wyświetlić; jeśli zginie, wygeneruj kolejny i zarejestruj ponownie.",
    integrations_secret_copy: "Kopiuj",
    integrations_secret_copied: "Skopiowano",
    integrations_secret_generated_done: "Gotowe, skopiowano",
    integrations_status_last_push_ok: "Ostatnia udana wysyłka",
    integrations_status_last_push_failed: "Ostatnia nieudana wysyłka",
    integrations_status_last_health: "Ostatnia kontrola stanu",
    integrations_status_never: "Nigdy",
    integrations_status_ok: "OK",
    integrations_status_down: "Niedostępny",
    integrations_test_connection: "Testuj połączenie",
    integrations_test_running: "Testowanie…",
    integrations_test_success: "Połączono — {latencyMs} ms",
    integrations_test_failure: "Niepowodzenie: {reason}",
    integrations_test_outbound: "Testuj wychodzące (HMAC)",
    integrations_test_outbound_hint: "Wysyła podpisane POST /stock/sync w trybie próbnym z pustą tablicą updates. Sprawdza klucz HMAC wychodzący + formułę podpisu + dostępność. Zawsze wysyłane jako dry_run.",
    integrations_test_outbound_success: "Wychodzące OK — HTTP {status}",
    integrations_test_outbound_failure: "Wychodzące nie powiodło się: {reason}",
    integrations_push_all_stock: "Wyślij cały stan",
    integrations_push_all_stock_running: "Uruchamianie…",
    integrations_push_all_stock_hint: "Kolejkuje wysłanie /stock/sync dla każdego aktywnego produktu zsynchronizowanego z tym kanałem. Działa jako zadanie w tle — skaluje się do 100k+ produktów bez przekroczenia limitu czasu.",
    integrations_push_all_stock_hint_counted: "Wyślij stan magazynowy dla {count} zsynchronizowanych produktów do tego kanału. Szacowany czas: {eta}.",
    integrations_push_all_stock_confirm: "Wysłać aktualny stan magazynowy wszystkich zsynchronizowanych produktów do {channel}?",
    integrations_push_all_stock_failure: "Push-all nie powiódł się: {reason}",
    integrations_push_all_stock_no_products: "Brak aktywnych zsynchronizowanych produktów ze stanem magazynowym.",
    integrations_push_all_stock_progress_label: "Wyślij cały stan → {channel}",
    // Modal potwierdzenia
    integrations_push_confirm_counting: "Obliczanie liczby produktów do synchronizacji…",
    integrations_push_confirm_detail: "Zostanie wysłanych {count} aktywnych zsynchronizowanych produktów. Szacowany czas: {eta}.",
    integrations_push_confirm_go: "Wyślij stan",
    integrations_push_eta_quick: "poniżej minuty",
    integrations_push_eta_minutes: "około {n} min",
    // Etykieta fazy
    integrations_push_phase_enqueueing: "Kolejkowanie",
    integrations_push_phase_delivering: "Wysyłanie",
    integrations_push_phase_completed: "Zakończono",
    integrations_push_phase_completed_with_errors: "Zakończono z błędami",
    integrations_push_phase_cancelling: "Anulowanie…",
    integrations_push_phase_cancelled: "Anulowano",
    integrations_push_phase_failed: "Niepowodzenie",
    // Komunikaty końcowe
    integrations_push_done_ok: "Gotowe — zsynchronizowano {n} produktów z kanałem.",
    integrations_push_done_errors: "Gotowe — {delivered} zsynchronizowano, {failed} nie powiodło się (zobacz poniżej).",
    integrations_push_job_cancel: "Anuluj",
    integrations_push_job_errors_summary: "{n} błąd(y) — kliknij, aby rozwinąć",
    integrations_push_job_unknown: "(nieznany)",
    integrations_push_progress_queued: "W kolejce",
    integrations_push_progress_delivered: "Wysłano",
    integrations_push_progress_pending: "{n} oczekuje",
    integrations_push_progress_failed: "{n} niepowodzeń",
    integrations_save: "Zapisz",
    integrations_saved: "Zapisano",
    integrations_save_failed: "Zapis nie powiódł się",
    integrations_load_failed: "Nie można wczytać integracji",

    // Pick & Sort — ustawienia + sortowanie
    pick_and_sort: "Kompletacja i sortowanie",
    pas_settings_hint: "Skonfiguruj regały sortujące, na które dzielona jest fala Kompletacji i sortowania. Każde miejsce ma unikalny kod kreskowy i kolorową etykietę; priorytet 1 = najszybsza lokalizacja.",
    // Putwall — nazwa stacji w wyborze zakresu agenta świateł; znacznik
    // regału i odznaka w nagłówku ekranu sortowania; przełącznik Dodaj regał.
    put_wall: "Putwall",
    pas_put_wall_badge: "Putwall",
    // Fale w parach: połowa fali jest jeszcze zbierana.
    pas_segment_picking: "Segment {no} wciąż zbiera {name} · {done} z {total} linii",
    pas_segment_waiting: "Segment {no} czeka na kompletatora — jego sztuki są policzone, ale jeszcze ich tu nie ma",
    pas_segment_picking_generic: "Część tej fali jest jeszcze kompletowana",
    pas_segment_still_picking: "Część tej fali jest jeszcze zbierana — nic nie można oznaczyć jako brakujące, dopóki nie dotrze",
    pas_add_bay_put_wall: "Putwall (4 półki × 18)",
    pas_add_bay_put_wall_hint: "Tworzy ten regał jako ścianę Putwall: 18 pozycji szerokości z kodami PW. Fale Putwall sortowane są tutaj; nigdy nie wchodzi w parę zatok Dużej fali.",
    pas_add_bay: "Dodaj regał",
    pas_no_bays: "Brak skonfigurowanych regałów",
    pas_slot_count: "{count} miejsc",
    pas_edit_grid: "Edytuj siatkę",
    pas_shelf_colours: "Kolory półek",
    pas_position_colours: "Kolory pozycji",
    pas_enable_slot: "Włącz miejsce",
    pas_priority: "Priorytet",
    pas_priority_mode_small: "Mała fala",
    pas_priority_mode_large: "Duża fala",
    pas_priority_cross_bay_hint: "Priorytety dużej fali porównywane są na OBU regałach — numeruj je globalnie (1, 2, 3… dla pary, najpierw wewnętrzne krawędzie). Największe zamówienie trafia na priorytet 1. Puste = użyj priorytetu małej fali.",
    pas_large_wave_badge: "Duża fala · 2 regały",
    pas_large_bays_not_empty: "Następna fala jest Duża — oba regały Pick & Sort muszą być puste. Najpierw opróżnij zajęty regał.",
    pas_large_wrong_bay: "Ten regał nie należy do pary dużej fali",
    pas_large_bays_unavailable: "Duża fala czeka, ale dwa regały Pick & Sort nie są już skonfigurowane",
    pas_grid_hint: "Zaznacz miejsce, aby je dodać. Priorytet 1 = najszybsza / najwygodniejsza lokalizacja.",
    pas_bay_name: "Nazwa regału",
    pas_rename_bay: "Zmień nazwę regału",
    pas_duplicate: "Duplikuj",
    pas_duplicate_bay: "Duplikuj regał",
    pas_label_colours: "Kolory etykiet",
    pas_colours_hint: "Ustaw kolor dla każdej litery i liczby. Dotyczy wszystkich magazynów i regałów.",
    pas_letters: "Litery",
    pas_numbers: "Liczby",
    pas_light_colours: "Kolory światła",
    pas_light_timeout: "Cel czasowy",
    pas_light_timeout_hint: "Po połowie celu czasowego lokalizacji wiązka szybko miga w aktywnym kolorze; po przekroczeniu całego celu świeci stale w tym kolorze.",
    pas_light_active: "Aktywny",
    pas_light_complete: "Zakończony",
    pas_light: "Światło",
    pas_light_settings: "Ustawienia światła",
    pas_time_targets: "Docelowe czasy lokalizacji",
    pas_time_target_label: "Docelowy czas na przedmiot",
    pas_time_target_hint: "Pełny cykl: zeskanuj przedmiot → odłóż → zeskanuj lokalizację → następny przedmiot. Pozostaw puste, aby użyć domyślnego (6s).",
    pas_brightness: "Jasność",
    pas_light_off_delay: "Opóźnienie wyłączenia",
    pas_move_base: "Czas ruchu (podstawa)",
    pas_move_step: "Czas ruchu (+ za każdy odstęp miejsca)",
    pas_move_threshold: "Próg ruchu przy zapalonej wiązce",
    pas_move_timing_hint: "Wiązka pozostaje wyłączona podczas ruchu głowicy i zapala się po upływie tego czasu — mniejsza wartość = szybsza reakcja, ale zbyt mała sprawi, że wiązka zapali się jeszcze w ruchu. Każdy ruch otrzymuje czas podstawowy plus czas za każdy odstęp miejsca rzeczywiście przebyty w pan/tilt (mierzony na podstawie odstępów miejsc w tym regale, więc przekątne, ruchy o część odstępu i długie ruchy skalują się proporcjonalnie). Ruchy mniejsze niż próg (delta DMX pan/tilt) pomijają fazę ciemną i przesuwają się zapalone — zwiększ próg, aby pobliskie miejsca zapalały się natychmiast; 65535 = nigdy nie gaś.",
    pas_light_enable: "Włącz ruchomą głowicę dla tego regału",
    pas_artnet_host: "Host Art-Net (IP DMX-AN2)",
    pas_artnet_universe: "Wszechświat",
    pas_dmx_start: "Kanał startowy DMX",
    pas_light_hint: "Lokalny agent światła kieruje głowicę na zeskanowane miejsce. Ustaw pan/tilt/zoom każdej lokalizacji w siatce poniżej.",
    pas_pan: "Pan",
    pas_tilt: "Tilt",
    pas_zoom: "Zoom",
    pas_aim: "Celuj",
    pas_aiming: "Celowanie",
    pas_aim_hint: "Skieruj głowicę na to miejsce na żywo — dostosuj strzałkami (↑/↓ pan, ←/→ tilt, Ctrl+↑/↓ zoom) lub przyciskami, aż plamka trafi na półkę, i zapisz. Kliknij ponownie, aby zgasić światło.",
    pas_aim_grid_hint: "Zaznacz miejsce, aby je dodać. Kliknij Celuj, aby skierować głowicę na żywo, a następnie dostosuj pan/tilt/zoom (%), aby plamka trafiła na półkę. Priorytet 1 = najszybsza lokalizacja.",
    pas_lights_off: "Wyłącz światło",
    sorting_print_labels_title: "Drukuj etykiety",
    sorting_label_orientation: "Orientacja",
    sorting_label_orientation_normal: "Zgodnie z projektem ({across}mm w poprzek)",
    sorting_label_orientation_cw: "Obróć o 90° w prawo ({across}mm w poprzek)",
    sorting_label_orientation_ccw: "Obróć o 90° w lewo ({across}mm w poprzek)",
    sorting_label_orientation_flip: "Do góry nogami ({across}mm w poprzek)",
    sorting_label_style: "Wzór etykiety",
    sorting_label_style_standard: "Standardowa — 185 x 35mm, kolor",
    label_style_standard_at: "Standardowa — {w} x {h}mm, kolor",
    label_style_racking_at: "Regałowa — {w} x {h}mm, alejka · regał · poziom · kod",
    label_style_tote_at: "Pojemnik — {w} x {h}mm, kod · numer pojemnika",
    sorting_label_style_compact: "Kompaktowa — 93 x 47mm, czarno-biała",
    sorting_label_style_compact_hint: "Stały rozmiar {w} x {h}mm, bez koloru i bez strzałki — do drukarki termicznej. Miejsce rozpoznaje się po literze, numerze i kodzie kreskowym.",
    sorting_label_style_large: "Duża wartość — 70 x 30mm, czarno-biała",
    sorting_label_style_large_hint: "Stały rozmiar {w} x {h}mm — pozycja regału dużą czcionką i kod kreskowy, nic więcej. Drukowana wartość to etykieta miejsca, która nie zawsze jest tym samym co kod odczytywany przez skaner.",
    sorting_label_style_large152: "Duża wartość — 152 x 70mm, czarno-biała",
    sorting_label_style_large152_hint: "Stały rozmiar {w} x {h}mm — ten sam wzór co etykieta 70 x 30mm, powiększony na większe etykiety. Drukowana wartość to etykieta miejsca, która nie zawsze jest tym samym co kod odczytywany przez skaner.",
    sorting_label_style_band6x4: "Duża wartość na 6 x 4in — 152 x 102mm, czarno-biała",
    sorting_label_style_band6x4_hint: "Ten sam wzór na etykietach 6 x 4in używanych przy wysyłce. Treść mieści się w pasie {band}mm na środku, zostawiając {gap}mm pustego miejsca u góry i u dołu. Domyślnie obrócona o ćwierć obrotu, bo te etykiety są ładowane pionowo — zmień orientację, jeśli u Ciebie podają się inaczej.",
    sorting_print_range: "Etykiety do wydruku",
    sorting_print_range_placeholder: "Wszystkie etykiety",
    sorting_print_range_hint: "Wybrano: {count}. Puste pole drukuje cały regał; albo wpisz miejsce (A1), blok (A1-D6) lub kilka oddzielonych przecinkami.",
    sorting_print_range_invalid: "To nie jest miejsce ani zakres: {token}",
    sorting_print_range_none: "Żadne miejsce w tej zatoce nie pasuje.",
    sorting_print_n: "Drukuj {count}",
    sorting_print_labels_hint: "Drukuje wszystkie etykiety miejsc ({count}) dla tego regału na etykietach ustawionych dla {warehouse}.",
    label_print_pick: "Etykiety do wydruku",
    label_print_pick_all: "Zaznacz wszystkie",
    label_print_pick_none: "Wyczyść",
    label_print_pick_filter: "Znajdź etykietę…",
    label_print_pick_empty: "Brak pasujących etykiet.",
    label_print_pick_count: "Wybrano {count} z {total}",
    label_print_skip_levels: "Pomiń poziomy {levels} ({count} etykiet)",
    sorting_label_width_mm: "Szerokość etykiety (mm)",
    sorting_label_height_mm: "Wysokość etykiety (mm)",
    sorting_label_size_hint: "Zapisywane dla magazynu i używane przy drukowaniu i pobieraniu. Pozostaw puste, aby użyć standardowych etykiet {w} x {h}mm.",
    printer_default_device: "Domyślna drukarka tego urządzenia",
    pas_barcodes: "Kody kreskowe",
    pas_barcodes_hint: "Pokaż skanowalny kod kreskowy każdego miejsca. Edytuj, aby użyć kodu już wydrukowanego w magazynie.",
    pas_barcode: "Kod kreskowy",
    pas_barcode_auto: "auto",
    pas_barcode_duplicate: "Zduplikowany kod kreskowy",
    pas_barcode_sorter_hint: "Kody sortera to rzeczywiste kody lokalizacji skanowane przez operatora — nie można ich tu edytować.",
    pas_light_agents: "Agenty światła",
    pas_light_agents_hint: "Przypisz, którym magazynem steruje każdy lokalny agent światła, i opcjonalnie ogranicz go do jednej stacji sortera. Agent steruje tylko przypisanymi mu regałami.",
    pas_light_agent_station_hint: "Ogranicz tego agenta do świateł jednego sortera. Zostaw „Wszystkie stacje”, chyba że obiekt używa osobnego urządzenia na sorter.",
    pas_unassigned: "— Nieprzypisany —",
    pas_station_all: "Wszystkie stacje",
    pas_bay_all: "Wszystkie regały",
    pas_light_agent_bay_hint: "Przypisz tego agenta do jednego regału, np. ściany odkładczej Sortera 2, która jest osobną konstrukcją z własnym urządzeniem. Przypisany regał nie jest już obsługiwany przez agentów całej stacji. W przeciwnym razie zostaw „Wszystkie zatoki”.",
    pas_online: "Online",
    pas_cue_latency_hint: "Opóźnienie skan→urządzenie zmierzone przez samego agenta: zapis sygnału w backendzie → dotarcie do agenta (mediana ostatnich sygnałów, uwzględnia różnicę zegarów). Fizyczny ruch głowicy dochodzi dodatkowo.",
    pas_offline: "Offline",
    pas_no_agents: "Brak agentów światła. Dodaj jednego poniżej lub uruchom agenta na miejscu — pojawi się tutaj po pierwszym połączeniu.",
    pas_agent_id_placeholder: "ID agenta (np. portal-pd)",
    pas_add_agent: "Dodaj agenta",
    pas_agent_exists: "Agent o tym ID już istnieje",
    pas_remove_agent: "Usuń agenta",
    pas_confirm_remove_agent: "Usunąć agenta \"{id}\"? Pojawi się ponownie, jeśli znów się połączy.",
    pas_wifi: "Sieć / WiFi",
    pas_wifi_title: "Sieć — {id}",
    pas_wifi_current: "Bieżące połączenie",
    pas_wifi_not_reported: "Urządzenie nie zgłosiło jeszcze stanu sieci — wysyła go co ~15 s, gdy jest online.",
    pas_wifi_scan: "Skanuj sieci",
    pas_wifi_waiting: "Oczekiwanie na urządzenie — sprawdza polecenia co ~15 s…",
    pas_wifi_offline_warn: "Urządzenie jest offline. Polecenie jest w kolejce i wykona się po ponownym połączeniu.",
    pas_wifi_networks: "Sieci w zasięgu",
    pas_wifi_in_use: "połączono",
    pas_wifi_open: "otwarta",
    pas_wifi_manual: "Lub wpisz sieć ręcznie (np. sieć ukrytą)",
    pas_wifi_ssid: "Nazwa sieci (SSID)",
    pas_wifi_password: "Hasło",
    pas_wifi_password_open_hint: "Zostaw puste dla sieci otwartej. Hasła WiFi mają 8–63 znaki.",
    pas_wifi_save: "Zapisz sieć",
    pas_wifi_save_switch: "Zapisz i przełącz teraz",
    pas_wifi_save_hint: "Zapisz dodaje sieć z autołączeniem — urządzenie dołączy do niej, gdy będzie w zasięgu; bezpieczne przed przeprowadzką. Zapisz i przełącz łączy natychmiast; jeśli się nie uda, urządzenie samo wraca do poprzedniej sieci.",
    pas_wifi_saved_ok: "Gotowe: {detail}",
    pas_wifi_failed: "Niepowodzenie: {detail}",
    pas_wifi_scan_failed: "Skanowanie nie powiodło się: {detail}",
    pas_wifi_no_networks: "Nie znaleziono sieci.",
    pas_agent_warehouse: "Magazyn",
    pas_agent_station: "Stacja",
    pas_agent_bay: "Regał",
    pas_agent_backend: "Backend",
    pas_agent_heads: "Głowice",
    pas_heads_choose: "Wyślij do głowic…",
    pas_heads_speed_2: "Prędkość 2 (szybka)",
    pas_heads_speed_1: "Prędkość 1 (domyślna)",
    pas_heads_wifly_off: "WiFly wył.",
    pas_heads_pan_tilt_reset: "Reset pan/tilt",
    pas_heads_hint: "Wyślij ustawienie do każdej głowicy sterowanej przez to urządzenie (przez DMX). Prędkość 2 to szybki tryb pan/tilt — nowe głowice mają Prędkość 1. Odbierają tylko głowice na regałach z włączonym światłem.",
    pas_heads_confirm: "Wysłać „{personality}” do wszystkich głowic urządzenia „{id}”? Urządzenie przytrzyma ustawienie na głowicach przez ~6 s.",
    pas_backend_staging: "Staging",
    pas_backend_production: "Produkcja",
    pas_backend_unknown: "Backend: —",
    pas_backend_hint: "Z którym backendem rozmawia to urządzenie. Musi odpowiadać backendowi, z którego korzystają stanowiska skanujące (sygnały świetlne istnieją tylko na instancji, która odbiera skan). Urządzenie zastosuje zmianę w ~15 s, zrestartuje się i samo wróci do poprzedniego, jeśli wybrany backend je odrzuci.",
    pas_backend_confirm: "Przełączyć \"{id}\" na backend {backend}? Urządzenie zrestartuje się na niego w ~15 s. Jeśli backend odrzuci klucz urządzenia, samo wróci do domyślnego po ~2 minutach.",
    pas_location_name: "Nazwa",
    pas_remove_bay: "Usuń regał",
    pas_confirm_remove_bay: "Usunąć regał \"{name}\" i wszystkie jego etykiety?",
    pas_no_demand: "Żadne niezsortowane zamówienie nie potrzebuje tego artykułu",
    pas_sort_complete: "Sortowanie zakończone — wysłano do wysyłki",
    pas_not_all_sorted: "Nie wszystkie artykuły zostały posortowane",
    pas_all_sorted: "Sortowanie zakończone",
    pas_more_waiting: "Więcej do sortowania. Zeskanuj następny pojemnik.",
    pas_unload_first: "Rozładuj tę falę przed rozpoczęciem następnej",
    pas_no_more_waves: "Brak kolejnych fal do sortowania",
    pas_finish_unload: "Zakończ i rozładuj",
    pas_scan_item: "Zeskanuj artykuł",
    pas_progress: "{sorted} / {total} posortowano",
    pas_no_wave_awaiting_sort: "Brak fali oczekującej na sortowanie",
    pas_insufficient_locations: "Za mało miejsc na regale dla tej fali",
    pas_nothing_to_sort: "Ta fala nie miała pobranych artykułów — zamknięta. Zeskanuj ponownie, aby rozpocząć następną falę.",
    // Sortowanie — przełącznik Załadunek / Rozładunek
    pas_view_loading: "Załadunek — sortuj artykuły",
    pas_view_unloading: "Rozładunek — do wysyłki",
    pas_scan_slot: "Zeskanuj miejsce",
    pas_scan_tote: "Zeskanuj pojemnik",
    pas_scan_tote_next_cubby: "Teraz zeskanuj pojemnik dla {label}",
    pas_cubby_of: "Przegródka {n} z 2",
    pas_or_cubby: "lub {label}, gdy pełna",
    pas_slot_not_in_order: "Ta przegródka nie należy do tego zamówienia",
    pas_scan_source_tote: "Zeskanuj pojemnik",
    pas_wrong_tote: "Ten pojemnik nie należy do tej fali",
    pas_available_waves: "Fale oczekujące na sortowanie",
    pas_available_waves_pas: "Fale Pick & Sort oczekujące na sortowanie",
    pas_available_waves_put_wall: "Fale Putwall oczekujące na sortowanie",
    pas_station_mismatch_put_wall: "Fala tego pojemnika jest na Putwall — sortuj ją tam",
    pas_station_mismatch_pas: "Fala tego pojemnika jest na regał Pick & Sort — sortuj ją tam",
    pas_wave_orders: "{count} zamówień",
    pas_wave_items: "{count} szt.",
    pas_wave_totes: "Pojemniki: {totes}",
    pas_tote_no_wave: "Ten pojemnik nie należy do żadnej fali oczekującej na sortowanie",
    pas_tote_wave_in_progress: "Fala tego pojemnika jest już sortowana na innym regale",
    pas_wave_in_progress: "W sortowaniu",
    pas_bay_wave_in_progress: "Fala w tej zatoce została już rozpoczęta — najpierw ją dokończ lub rozładuj",
    pas_now_sorting: "Teraz sortowane",
    pas_order_unloaded: "Wysłano do wysyłki",
    pas_slot_not_ready: "To miejsce nie jest gotowe do rozładunku",
    pas_slot_not_finished: "Miejsce niegotowe — posortowano {sorted} z {required} artykułów",
    pas_slot_already_unloaded: "To miejsce zostało już rozładowane",
    pas_tote_unavailable: "Pojemnik niedostępny — użyj pustego, dostępnego pojemnika",
    pas_nothing_to_unload: "Nic nie jest jeszcze gotowe do rozładunku",
    pas_unload_remaining: "{remaining} do rozładunku",
    pas_unload_items: "{count} szt.",
    pas_unload_load_more: "Pokaż więcej ({count})",
    pas_unload_see_less: "Pokaż mniej",
    // Rozładunek równoległy — drugi operator skanujący do zatoki, która jest
    // już sortowana, wybiera swoje zadanie, a następnie (jeśli wybierze
    // rozładunek) opróżnia gotowe miejsca w trakcie trwania sortowania.
    pas_role_sorting_by: "{name} sortuje w tej zatoce",
    pas_role_sorting_here: "Ten regał jest już sortowany",
    pas_role_sort: "Sortuj",
    pas_role_sort_sub: "{count} szt. pozostało",
    pas_role_unload: "Rozładuj",
    pas_role_unload_sub: "{count} zamówień gotowych",
    pas_unload_waiting: "Czekam na zakończenie sortowania",
    pas_unload_still_sorting: "{count} szt. jest jeszcze sortowanych",
    pas_bay_ready_title: "Gotowe do zamknięcia",
    pas_bay_ready_here: "tutaj",
    pas_bay_ready_row_aria: "{bay}: {count} gotowych do zamknięcia",
    // Per-bay status on the stacked unload grids of a Large (double-bay) wave.
    pas_bay_to_empty: "{count} do opróżnienia",
    // Podpis nad każdym pasmem regału szerszego niż 6 pozycji (Putwall).
    pas_bay_band: "Pozycje {from}–{to}",
    // Short form of pas_large_wave_badge for the entry-gate wave row, which
    // uppercases its badges and already carries orders / time / picker.
    pas_wave_large_badge: "Duża · 2 regały",
    pas_bay_clear: "Puste",
    pas_complete_items: "Posortowane artykuły",
    pas_complete_time: "Czas",
    pas_complete_rate: "Artykuły / godz.",
    pas_complete_points: "Zdobyte punkty",
    pas_complete_flagged: "{count} oznaczonych jako brakujące",
    pas_flag_missing_btn: "Zgłoś brakujące artykuły",
    pas_flag_missing_title: "Oznacz brakujące artykuły",
    pas_flag_missing_summary: "Posortowano {sorted} z {total} artykułów.",
    pas_flag_missing_question: "Oznaczyć pozostałe {count} jako brakujące? Zamówienia trafią do wysyłki z brakującymi artykułami wstępnie oznaczonymi — nadal można je spakować, jeśli się znajdą.",
    pas_flag_missing_qty: "{count} brakuje",
    pas_flag_missing_zero_note: "Zamówienia bez posortowanych artykułów zostaną oznaczone do weryfikacji — nie mogą trafić do wysyłki.",
    pas_flag_missing_confirm: "Oznacz wszystkie pozostałe {count} jako brakujące",
    pas_flag_success: "Oznaczono {count} artykułów jako brakujące",
    pas_manual_btn: "Kod kreskowy nie skanuje się?",
    pas_manual_title: "Sortuj artykuł ręcznie",
    pas_manual_hint: "Stuknij artykuł, którego kod kreskowy się nie skanuje. Zostanie posortowany jak po zeskanowaniu — potem zeskanuj jego miejsce jak zwykle.",
    pas_manual_remaining: "{count} do posortowania",
    pas_manual_empty: "Nic więcej do sortowania",
    pas_missing_item_btn: "Brakuje artykułu",
    pas_missing_item_title: "Którego artykułu brakuje?",
    pas_missing_item_hint: "Stuknij artykuł, którego nie ma w tocie. Nic nie zostanie odpisane, dopóki nie potwierdzisz na następnym ekranie.",
    pas_missing_item_confirm_title: "Potwierdź brakujący artykuł",
    pas_missing_item_confirm_q: "Oznaczyć {count} × {item} jako brakujące?",
    pas_missing_item_confirm_note: "Zamówienia trafią do wysyłki z tym artykułem wstępnie oznaczonym jako brakujący — nadal można go spakować, jeśli się znajdzie. Zamówienie bez żadnego posortowanego artykułu zostanie oznaczone do weryfikacji. Potem sortuj dalej resztę pojemnika.",
    pas_missing_item_confirm_btn: "Tak — oznacz {count} jako brakujące",
    pas_missing_item_success: "{item} oznaczono jako brakujący ({count})",
    pas_missing_item_gone: "Już posortowane lub oznaczone przez kogoś innego",

    // Wysyłka — skanowanie toty
    dispatch_tote_needs_sorting: "Ten pojemnik musi zostać posortowany przed wysyłką",
    dispatch_tote_no_orders: "Brak gotowych zamówień w tej tocie",
    dispatch_tote_unknown: "Nie rozpoznano pojemnika",
    dispatch_tote_partly_on_wall: "Połowa tego zamówienia jest nadal na Putwall w {label} — najpierw ją rozładuj",
    dispatch_tote_partly_on_wall_unknown: "Połowa tego zamówienia jest nadal na Putwall — najpierw ją rozładuj",
    dispatch_order_in_totes: "To zamówienie jest w {count} pojemnikach: {totes}",
    dispatch_scan_label_hint: "lub zeskanuj etykietę, aby otworzyć ponownie",
    // Dispatch bench redesign (2026-10-23) — counted nouns use "Label: {count}"
    dispatch_reset_short: "Zresetuj",
    dispatch_flag_short: "Oznacz",
    dispatch_stat_items: "Sztuki",
    dispatch_more_below: "Więcej poniżej: {count}",
    dispatch_orders_in_tote: "Zamówienia w pojemniku: {count}",
    dispatch_chip_desk: "Stanowisko",
    dispatch_chip_tote: "Pojemnik",
    dispatch_change_desk: "Zmień stanowisko",
    dispatch_change_tote: "Zmień pojemnik",
    dispatch_labels_count: "Etykiety",
    dispatch_box_units: "Sztuki: {count}",
    dispatch_item_damaged_chip: "Uszkodzone: {count}",
    dispatch_item_wrong_chip: "Złe przedmioty: {count}",
    dispatch_address_done: "Gotowe",
    dispatch_add_box_tab: "Dodaj kolejne pudełko",
    flag_labels_to_print: "Etykiety do wydruku",
    flag_label_apply_hint: "Naklej jedną na każde pudełko.",
    dispatch_flag_missing_short: "Zgłoś brak",
    flag_remaining_title: "Oznacz resztę jako brakującą",
    flagged_reason_missing_dispatch: "Brak produktu przy wysyłce",
    flag_remaining_hint: "Najpierw sprawdź pojemnik. Każde zamówienie poniżej trafi do Oznaczonych z produktami oznaczonymi jako brakujące. Etykiety nie są drukowane.",
    flag_remaining_confirm: "Oznacz jako brakujące: {count}",
    flag_remaining_failed: "Nie udało się oznaczyć: {count}. Spróbuj ponownie.",
    orders_flagged: "Oznaczone zamówienia: {count}",
    dispatch_label_reopen_warning: "To zamówienie zostało już wysłane. Ponowne otwarcie anuluje {n} etykiet(y) wysyłkowych u kuriera, wycofa numer śledzenia przesłany do kanału sprzedaży, a zamówienie trzeba spakować i oznaczyć etykietą od nowa.",
    dispatch_label_reopen_warning_no_labels: "To zamówienie zostało już wysłane. Ponowne otwarcie wycofa numer śledzenia przesłany do kanału sprzedaży, a zamówienie trzeba spakować i oznaczyć etykietą od nowa.",
    dispatch_label_reopen_past_cutoff: "Po godzinie zamknięcia manifestu ({cutoff}) — kurier odrzuci anulowanie, więc ta etykieta pozostaje aktywna i płatna. Zgłoś korektę.",
    dispatch_label_reopen_already_scanned: "InPost zeskanował już paczkę z tego zamówienia — jest w drodze i zostanie naliczona. Ponowne otwarcie anuluje etykietę tylko tutaj; paczki nie da się cofnąć.",
    dispatch_label_order_not_dispatchable: "Zamówienie #{order} ma status {status} — nie można go tutaj pakować",
    dispatch_item_not_in_tote: "Tego artykułu nie ma w tym pojemniku",
    // Pakowanie — wyszukiwanie po kodzie (2026-10-26)
    dispatch_search_open: "Szukaj po kodzie kreskowym",
    dispatch_search_label: "Kod kreskowy lub SKU",
    dispatch_search_placeholder: "Wpisz lub zeskanuj kod kreskowy",
    dispatch_search_hint: "Do zamknięcia skan tylko szuka",
    dispatch_search_none_hint: "Sprawdź kod i pojemnik",
    dispatch_search_count: "Wyników: {count}",
    dispatch_search_none: "Brak w tym zamówieniu",
    // Pakowanie — menu + i własne opakowanie (2026-10-26)
    dispatch_new_container: "Nowe opakowanie",
    dispatch_new_box: "Nowe pudełko",
    dispatch_new_box_hint: "Zeskanuj kod pudełka",
    dispatch_own_pkg_menu: "Własne opakowanie",
    dispatch_own_pkg_menu_hint: "Następny skan jedzie bez pudełka",
    dispatch_other_size: "Inny rozmiar",
    dispatch_other_size_hint: "Wpisz wymiary",
    dispatch_own_pkg_scan_item: "Skanuj produkt",
    dispatch_own_pkg_cancel: "Anuluj własne opakowanie",
    dispatch_own_pkg_already: "{sku} jest już we własnym opakowaniu",
    dispatch_own_pkg_take_out: "Wyjmij z Pudełka {box}: {count} szt.",
    dispatch_own_pkg_box_emptied: "Już spakowane w Pudełku {id}. Pudełko {id} będzie potem puste i zostanie usunięte.",
    dispatch_own_pkg_box_left: "Już spakowane w Pudełku {id}. Zostanie w nim: {count} szt.",
    dispatch_own_pkg_unscanned: "Jeszcze niezeskanowane: {count}. Też trafią do tego opakowania — nie trzeba ich skanować.",
    ship_in_packaging_moved: "{sku} przeniesiony z Pudełka {from} do Pudełka {to}",

    // Ustawienia > Integracje > Przewoźnicy
    carriers_heading: "Przewoźnicy",
    carriers_load_failed: "Nie udało się wczytać przewoźników",
    carriers_apc_hint: "APC Overnight przez Hypaship. Jedno konto depot na magazyn.",
    carriers_section_merging: "Łączenie przesyłek",
    carriers_section_claims: "Reklamacje przewoźnika",
    carriers_section_credentials: "Dane dostępowe",
    carriers_section_sender: "Nadawca i adres zwrotu",
    carriers_section_collection: "Okno odbioru",
    carriers_section_customs: "Cło (Irlandia Północna)",
    carriers_accounts_heading: "Konta",
    carriers_accounts_digest: "{enabled} z {total} włączonych",
    carriers_account_digest: "{services} usług wł.",
    carriers_badge_on: "Wł.",
    carriers_badge_off: "Wył.",
    carriers_badge_none: "Brak",
    carriers_badge_secret_set: "Sekret ustawiony",
    carriers_badge_needs_secret: "Brak sekretu",
    carriers_merging_digest_same: "Tylko ten sam kanał",
    carriers_merging_digest_cross: "Ten sam kanał + między kanałami",
    carriers_claims_digest: "Zaplanowany e-mail do {to}",
    carriers_surcharge_fuel_short: "Paliwo",
    carriers_surcharge_decarb_short: "Dekarb.",
    carriers_surcharge_ni_short: "IP",
    carriers_surcharge_remote_short: "Odległe",
    carriers_eori_hint_inpost: "Wysyłane w deklaracjach celnych do Irlandii Północnej. EORI opcjonalne dla GB→NI.",
    carriers_duty_hint_inpost: "Pozycja zawartości dla paczek do Irlandii Północnej; sztuki i wartość z zamówienia.",
    carriers_enabled_toggle: "Włącz tego przewoźnika",
    carriers_add_box_toggle: "Dodaj paczkę do istniejącej przesyłki",
    carriers_add_box_hint: "Dodaje pudełka do dzisiejszej, niezamanifestowanej przesyłki klienta, gdy taniej. Drukują się tylko nowe etykiety.",
    carriers_cross_channel_add_box_toggle: "Między kanałami — dodaj paczkę do istniejącej przesyłki",
    carriers_cross_channel_add_box_hint: "Dopasowuje też przesyłki z innych kanałów sprzedaży.",
    savings_open_button: "Zobacz oszczędności i aktywność",
    savings_title: "Oszczędności i aktywność",
    savings_headline_all_time: "zaoszczędzono łącznie",
    savings_feature_col: "Funkcja",
    savings_period_1d: "1 dzień",
    savings_period_7d: "7 dni",
    savings_period_30d: "30 dni",
    savings_period_60d: "60 dni",
    savings_period_all: "Cały czas",
    savings_feature_add_box_same_channel: "Dodaj paczkę do istniejącej przesyłki",
    savings_feature_add_box_cross_channel: "Między kanałami — dodaj paczkę",
    savings_feature_consolidate_orders: "Konsoliduj zamówienia",
    savings_feature_off: "wył.",
    savings_total_row: "Razem",
    savings_unit_boxes: "{n} paczek",
    savings_unit_orders: "{n} zamówień",
    savings_estimate_note: "Konsolidacja zamówień łączy trzy elementy. Transport: {rate} za wyeliminowaną przesyłkę (średnia APC potwierdzona fakturami). Opakowania: {packaging} za paczkę, której już nie pakujemy. Obsługa: {handling} za scaloną sztukę, za kompletację, sortowanie i pakowanie wykonane raz zamiast dwa razy. Dodawanie paczek wyceniane jest wyłącznie na podstawie dokładnej oszczędności transportu na scalenie — jego paczki nadal są kompletowane, pakowane i wysyłane, tylko w ramach istniejącej przesyłki, więc nie oszczędzamy ani na opakowaniach, ani na obsłudze. Konsolidacja liczy każde scalone zamówienie, także już wysłane.",
    carriers_environment: "Środowisko",
    carriers_environment_hint: "Training = piaskownica APC. Live = prawdziwe, płatne przesyłki.",
    carriers_environment_hint_inpost: "Training = host testowy InPost (brak danych, nie uwierzytelni). Live = produkcja. Niewydrukowane etykiety nie są naliczane.",
    carriers_env_training: "Training",
    carriers_env_live: "Live",
    carriers_account_heading: "Konto {warehouse}",
    carriers_account_enabled_toggle: "Włącz to konto depotu",
    carriers_login_email: "E-mail logowania",
    carriers_login_email_hint: "Login do portalu / API APC.",
    carriers_password: "Hasło",
    carriers_password_hint: "Przechowywane zaszyfrowane; widoczny tylko odcisk.",
    carriers_ready_at: "Gotowe od",
    carriers_closed_at: "Zamknięte o",
    carriers_times_hint: "Wysyłane przy każdej rezerwacji. Puste Gotowe od = czas etykiety. Po Zamknięte o rezerwacje przechodzą na następny dzień roboczy.",
    carriers_eori: "Numer EORI",
    carriers_ioss: "Zarejestrowany w IOSS",
    carriers_eori_hint: "Wysyłane w przesyłkach do Irlandii Północnej (Road Service).",
    carriers_duty_description: "Opis towarów (cło)",
    carriers_duty_hts: "Kod HTS",
    carriers_duty_origin: "Pochodzenie",
    carriers_duty_hint: "Jedna pozycja celna na przesyłkę do Irlandii Północnej; sztuki i wartość z zamówienia.",
    carriers_test_connection: "Testuj połączenie",
    carriers_test_ok: "Połączono ({ms} ms)",
    carriers_test_failed: "Połączenie nieudane",
    carriers_last_test_ok: "Ostatni test: OK",
    carriers_services_heading: "Usługi",
    carriers_services_hint: "Kody usług do rezerwacji. Limity to progi taryfy sprawdzane przy rezerwacji (waga = max z rzeczywistej i L×W×H ÷ 6000).",
    carriers_services_empty: "Brak usług — dodaj kody wydane przez APC dla tego konta.",
    carriers_service_add: "Dodaj usługę",
    carriers_service_code: "Kod",
    carriers_service_name: "Nazwa usługi",
    carriers_service_enabled: "Usługa włączona",
    carriers_service_max_pieces: "Maks. pudeł",
    carriers_service_max_kg: "Maks. kg",
    carriers_service_max_l: "Maks. dł. cm",
    carriers_service_max_w: "Maks. szer. cm",
    carriers_service_max_h: "Maks. wys. cm",
    carriers_service_delete: "Usuń",
    carriers_apc: "APC Overnight",
    carriers_inpost: "InPost UK",
    carriers_inpost_hint: "InPost UK 2Door (do drzwi) i OOH (automat/punkt). Cztery konta OAuth: magazyn × usługa. Jedna przesyłka na pudełko, cena za paczkę wg rozmiaru + dopłaty; brak rabatu za wiele paczek. Brak API anulowania: anulowanej etykiety nie wolno przekazać. Telefon odbiorcy musi być brytyjskim numerem komórkowym (inaczej numer zastępczy).",
    // DPD Polska + Cargus (magazyn Poland)
    carriers_dpd_hint: "DPD Polska (DPDServices) dla magazynu Poland — przesyłki krajowe PL. Jedna przesyłka na zamówienie z listem przewozowym na każde pudełko; etykiety ZPL. Pobranie etykiety to awizacja w DPD — opłata dopiero po wydruku i zeskanowaniu przez kuriera. Brak API anulowania: anulowanej etykiety nie wolno przekazać. Tracking (InfoServices) wymaga osobnego uruchomienia przez opiekuna DPD.",
    carriers_cargus_hint: "Cargus (Rumunia) dla magazynu Poland — adresy RO. Jeden AWB na zamówienie z kodem na każde pudełko; etykiety tylko PDF (druk ze stanowiska z PC). Usuwalny do pierwszego skanu. Każdy AWB odbierany jest z zarejestrowanego punktu nadania; zsynchronizuj nazwy okręgów i miejscowości, aby adresy się routowały.",
    carriers_environment_hint_dpd: "Training = host demo DPD z publicznymi danymi demo DPD, używanymi automatycznie (nie wysyła). Live = produkcja z własnymi danymi konta (od opiekuna DPD, inne niż do DPD Online).",
    carriers_dpd_demo_credentials_note: "Training używa automatycznie publicznych danych demo DPD (test / FID 1495) — nic nie zostanie wysłane. Pola poniżej to Twoje dane LIVE, używane dopiero po przełączeniu przewoźnika na Live.",
    carriers_dpd_live_credentials_note: "Live: nadania używają danych poniżej i tworzą prawdziwe paczki DPD. Przełącz przewoźnika na Training, aby testować na hoście demo DPD bez ponownego wpisywania danych.",
    carriers_environment_hint_cargus: "Cargus ma jeden host: Training i Live to ten sam adres. Testowe nadanie tworzy PRAWDZIWY AWB — usuń go w tej samej sesji, zanim dostanie checkpoint.",
    carriers_login_username: "Nazwa użytkownika",
    carriers_login_username_hint_dpd: "Login do DPDServices (nie DPD Online). Master FID = numer płatnika nadany przez DPD (nagłówek x-dpd-fid). FID płatnika = numkat, podnumer klienta obciążany za paczkę — umowy Local i INTER mogą mieć osobne; usługa może go nadpisać.",
    carriers_login_username_hint_cargus: "Użytkownik UrgentCargus (LoginUser) oraz id cennika z umowy (0 = domyślny).",
    carriers_master_fid: "Master FID",
    carriers_payer_fid: "FID płatnika",
    carriers_tracking_channel: "Kanał InfoServices",
    carriers_tracking_channel_hint: "Wartość `channel` nadana przez DPD dla Twojego konta w InfoServices (śledzenie przesyłek). Ten sam login i hasło co powyżej. Zostaw puste do czasu potwierdzenia przez DPD — cykliczne sprawdzanie statusów pomija takie konto.",
    carriers_price_table: "Id cennika",
    carriers_cargus_api_key: "Klucz subskrypcji APIM",
    carriers_cargus_api_key_hint: "Primary Key z urgentcargus.developer.azure-api.net (Profil) po zatwierdzeniu subskrypcji StandardUrgentOnlineAPI. Wysyłany jako Ocp-Apim-Subscription-Key przy każdym wywołaniu.",
    carriers_pickup_location: "Punkt nadania (Sender.LocationId)",
    carriers_pickup_location_hint: "Zarejestrowany punkt, z którego odbierany jest każdy AWB. Załaduj listę po zapisaniu klucza i hasła albo wpisz id.",
    carriers_pickup_locations_load: "Załaduj punkty nadania",
    carriers_pickup_locations_none: "— wybierz —",
    carriers_nomenclature_sync: "Synchronizuj nazwy miejscowości",
    carriers_nomenclature_synced: "Zsynchronizowano {counties} okręgów, {localities} miejscowości",
    carriers_nomenclature_hint: "Pobiera nomenklaturę okręgów i miejscowości Cargus, aby adresy z zamówień trafiały w pisownię i id, po których Cargus routuje. Powtarzaj od czasu do czasu; niezsynchronizowane nazwy i tak są wysyłane i weryfikowane przez Cargus.",
    carriers_sender_company: "Firma nadawcy",
    carriers_origin_county: "Województwo nadawcy",
    carriers_sender_origin_hint_pl: "Drukowane jako nadawca na każdej etykiecie i używane jako adres zwrotu. Najpierw ulica, potem numer (Relaksowa 33). Cargus routuje po okręgu nadawcy.",
    carriers_times_hint_day_close: "Ready-at / closed-at wyznaczają okno odbioru kuriera; closed-at to godzina zamknięcia dnia u przewoźnika (protokół przekazania + zamówienie kuriera DPD, zlecenie odbioru Cargus).",
    carriers_section_test_booking: "Nadanie testowe",
    carriers_test_booking_hint: "Nadaje przykładową przesyłkę na ten adres z prawdziwymi danymi dostępowymi, tym samym builderem i klientem co stanowisko pakowania, i pokazuje każdy krok odpowiedzi przewoźnika — bez zamówienia i bez wpisu rezerwacji.",
    carriers_test_booking_hint_dpd: "Wykonuje pełne nadanie i pobranie etykiety na hoście demo DPD (Training) — nic stamtąd nie zostanie wysłane. Na Live test odmawia nadania prawdziwej paczki; przełącz na Training, aby testować.",
    carriers_test_booking_hint_cargus: "Tylko odczyt: sprawdza token, prosi Cargus o routing adresu i wycenia to pudełko i usługę. Żaden AWB nie jest tworzony.",
    carriers_test_booking_recipient: "Przykładowy odbiorca",
    carriers_test_booking_name: "Nazwa",
    carriers_test_booking_line1: "Ulica i numer",
    carriers_test_booking_line2: "Linia 2",
    carriers_test_booking_city: "Miejscowość",
    carriers_test_booking_county: "Okręg (județ)",
    carriers_test_booking_postcode: "Kod pocztowy",
    carriers_test_booking_country: "Kraj (PL = umowa Local, inne UE = INTER)",
    carriers_test_booking_phone: "Telefon",
    carriers_test_booking_email: "E-mail",
    carriers_test_booking_box: "Przykładowe pudełko",
    carriers_test_booking_weight: "Waga (g)",
    carriers_test_booking_length: "D (mm)",
    carriers_test_booking_width: "S (mm)",
    carriers_test_booking_height: "W (mm)",
    carriers_test_booking_service: "Usługa",
    carriers_test_booking_service_default: "Jak na stanowisku (reguły wysyłki)",
    carriers_test_booking_service_used: "Użyta usługa",
    carriers_test_booking_service_source_shipping_rules: "wybrana regułą wysyłki „{rule}”, dokładnie jak na stanowisku",
    carriers_test_booking_service_source_account_service: "pierwsza usługa tego konta pasująca do kraju (reguły wysyłki nie trafiły na to konto — może być jeszcze wyłączone)",
    carriers_test_booking_service_source_carrier_default: "domyślna przewoźnika — żadna usługa tego konta nie pasuje do kraju, więc bez dodatków (np. bez PRIV)",
    carriers_test_booking_run: "Nadaj przesyłkę testową",
    carriers_test_booking_running: "Nadawanie…",
    carriers_test_booking_ok: "Nadanie testowe udane",
    carriers_test_booking_failed: "Nadanie testowe nieudane",
    carriers_test_booking_steps: "Kroki",
    carriers_test_booking_tracking: "Numery przesyłek",
    carriers_test_booking_download: "Pobierz etykietę ({format})",
    carriers_test_booking_cleanup: "Porządkowanie",
    carriers_delivery_mode_point: "automat / punkt",
    carriers_client_id: "Client ID",
    carriers_organization_id: "ID organizacji (Brand)",
    carriers_oauth_hint: "Wydane przez InPost Client Solutions, jeden zestaw na konto.",
    carriers_client_secret: "Client secret",
    carriers_client_secret_hint: "Przechowywane zaszyfrowane; widoczny tylko odcisk.",
    carriers_palletways_hint: "Sieć paletowa Palletways. Jeden klucz API na magazyn. Na razie tylko połączenie: klucz można zapisać i przetestować, ale nic nie jest nadawane przez Palletways, dopóki nie powstanie rezerwacja przesyłek.",
    carriers_api_key: "Klucz API",
    carriers_api_key_hint: "Wydany przez Palletways dla konta tego magazynu. Przechowywany zaszyfrowany; widoczny tylko odcisk.",
    carriers_connection_only_note: "Usługi, etykiety i śledzenie nie są jeszcze skonfigurowane dla tego przewoźnika.",
    carriers_environment_hint_palletways: "Palletways ma jedno produkcyjne API i nie ma środowiska testowego. Test połączenia tylko odczytuje; nigdy nie tworzy przesyłki.",
    carriers_environment_hint_manual_pallet: "Brak API. Palety u tego przewoźnika są nadawane ręcznie na jego stronie; etykieta jest dołączana do zamówienia, a stanowisko paletowe drukuje ją i rejestruje wysyłkę. Test połączenia nic nie wywołuje.",
    carriers_dbschenker_hint: "Fracht paletowy DB Schenker dla pozostałych krajów UE — zamówienia paletowe dostarczane do każdego kraju UE poza Polską. Ręcznie do czasu uruchomienia API: włączenie tego konta uruchamia kierowanie zamówień paletowych w Polsce.",
    carriers_jas_hint: "Fracht paletowy JAS-FBG dla Polski — zamówienia paletowe z polskim adresem dostawy, nadawane ze stanowiska paletowego przez API ShipmentGateway JAS: jedno Wyślij tworzy przesyłkę, drukuje etykietę Zebra i list przewozowy oraz oznacza zamówienie jako wysłane. JAS nie ma API anulowania — błędną przesyłkę anuluje się w Extranet 2. Statusy są odpytywane co 15 minut. Włączenie tego konta uruchamia kierowanie zamówień paletowych w Polsce.",
    carriers_environment_hint_jas: "Trening = instancja testowa JAS (shipment-test.jasfbg.com.pl, własny serwer logowania sts-api-test); przesyłki tam utworzone nigdy nie są odbierane. Produkcja = shipment.jasfbg.com.pl (login.jasfbg.com.pl) — każde Wyślij tworzy prawdziwą przesyłkę, od razu zatwierdzoną u JAS.",
    carriers_jas_test_credentials_note: "Trening: przesyłki trafiają na instancję testową JAS. Poniższe dane to login Extranet 2 wydany przez JAS dla Gateway (client id + secret, użytkownik + hasło). JAS wydał je dla instancji testowej — przed przełączeniem na Produkcję potwierdź z JAS, czy produkcja używa tego samego zestawu.",
    carriers_jas_live_credentials_note: "Produkcja: każde Wyślij tworzy prawdziwą przesyłkę JAS, którą JAS odbierze. Nie ma API anulowania — błędną przesyłkę anuluje się w Extranet 2 lub w oddziale JAS.",
    carriers_login_username_hint_jas: "Client id oraz użytkownik / hasło to login Extranet 2 wydany przez JAS dla Gateway. NIP jest nadawcy — JAS rozlicza miejsce załadunku B2B na jego podstawie. Adres nadawcy poniżej to miejsce załadunku na każdej przesyłce.",
    carriers_jas_client_secret: "Client secret",
    carriers_vat_number: "NIP",
    carriers_jas_sections_note: "Palety JAS nadaje się ze stanowiska paletowego: tu nie ma usług ani reguł wysyłki. Uzupełnij poniżej adres nadawcy — to miejsce załadunku na każdej przesyłce.",
    carriers_raben_hint: "Fracht paletowy Raben dla Polski — polski przewoźnik paletowy nadawany ze stanowiska paletowego przez interfejs SOAP GS1 XML Raben: jedno Wyślij wysyła przesyłkę i drukuje etykietę. Login, numer oddziału (department) i identyfikator płatnika pochodzą z obsługi klienta Raben. Wysyłanie dokumentu eWZ przez SFTP jest opcjonalne.",
    carriers_environment_hint_raben: "Trening = testowy OSB Raben, z odbiorcą „Raben Poland Test” (dopisywanym automatycznie). Produkcja = środowisko produkcyjne Raben — każde Wyślij tworzy prawdziwą przesyłkę.",
    carriers_raben_test_credentials_note: "Trening: przesyłki trafiają do środowiska testowego Raben i nigdy nie są odbierane.",
    carriers_raben_live_credentials_note: "Produkcja: każde Wyślij tworzy prawdziwą przesyłkę Raben, którą Raben odbierze.",
    carriers_login_username_hint_raben: "Nazwa użytkownika i hasło SOAP (WS-Security UsernameToken) wydane przez obsługę klienta Raben. NIP jest NIP-em nadawcy. Adres nadawcy poniżej to miejsce załadunku na każdej przesyłce.",
    carriers_raben_sections_note: "Palety Raben nadaje się ze stanowiska paletowego: tu nie ma usług ani reguł wysyłki. Uzupełnij poniżej adres nadawcy — to miejsce załadunku na każdej przesyłce.",
    carriers_raben_section_edi: "EDI, płatnik i produkt",
    carriers_raben_edi_sender: "Nadawca EDI (nazwa firmy klienta)",
    carriers_raben_edi_receiver: "Odbiorca EDI (jednostka Raben)",
    carriers_raben_department: "Numer oddziału (department)",
    carriers_raben_payer_searchname: "Identyfikator płatnika (PAYER_IDENTIFIER)",
    carriers_raben_edi_customer_number: "Numer klienta EDI",
    carriers_raben_ship_from_searchname: "Identyfikator adresu załadunku",
    carriers_raben_product_type: "Produkt",
    carriers_raben_product_prod01: "Cargo Classic (PROD01)",
    carriers_raben_product_prod02: "Cargo Premium (PROD02)",
    carriers_raben_edi_hint: "Numer oddziału i identyfikator płatnika pochodzą z obsługi klienta Raben. Identyfikator adresu załadunku ma najwyżej 20 znaków. Na Treningu do odbiorcy dopisywane jest „Test”.",
    carriers_raben_services: "Usługi dodatkowe",
    carriers_raben_services_hint: "Kody usług wysyłane na każdej przesyłce, np. ROD. Wpisz kod i naciśnij Enter.",
    carriers_raben_service_add: "Dodaj",
    carriers_raben_service_remove: "Usuń usługę {code}",
    carriers_raben_notes: "Uwagi na każdej przesyłce",
    carriers_raben_notes_hint: "Jedna uwaga w wierszu, do {max} uwag po {length} znaków.",
    carriers_raben_section_ewz: "Wysyłanie eWZ (opcjonalne)",
    carriers_raben_ewz_enabled: "Wysyłaj dokument eWZ przez SFTP",
    carriers_raben_ewz_hint: "Opcjonalne. Po włączeniu dokument dostawy jest wysyłany na SFTP Raben po nadaniu; nieudane wysłanie nigdy nie blokuje przesyłki.",
    carriers_raben_ewz_host: "Host SFTP",
    carriers_raben_ewz_port: "Port SFTP",
    carriers_raben_ewz_username: "Użytkownik SFTP",
    carriers_raben_ewz_relation_number: "Numer relacji (11 znaków)",
    carriers_raben_ewz_remote_path: "Folder zdalny",
    carriers_raben_sftp_password: "Hasło SFTP (eWZ)",
    carriers_raben_sftp_password_hint: "Opcjonalne. Przechowywane w postaci zaszyfrowanej; widoczny jest tylko odcisk.",
    carriers_raben_err_port: "Port musi być liczbą całkowitą od 1 do 65535 — nie zapisano.",
    carriers_raben_err_relation: "Numer relacji musi mieć dokładnie {n} znaków — nie zapisano.",
    carriers_raben_err_notes_count: "Najwyżej {max} uwag — nie zapisano.",
    carriers_raben_err_notes_length: "Każda uwaga może mieć najwyżej {length} znaków — nie zapisano.",
    carriers_raben_err_ship_from_length: "Identyfikator adresu załadunku może mieć najwyżej 20 znaków — nie zapisano.",
    carriers_sender_first_name: "Imię nadawcy",
    carriers_sender_last_name: "Nazwisko nadawcy",
    carriers_sender_email: "E-mail nadawcy",
    carriers_sender_phone: "Telefon nadawcy (E.164)",
    carriers_origin_house_number: "Budynek / jednostka nadania",
    carriers_origin_street: "Ulica nadania",
    carriers_origin_city: "Miasto nadania",
    carriers_origin_postcode: "Kod pocztowy nadania",
    carriers_sender_origin_hint: "Drukowane na etykietach; adres zwrotu niedoręczonych. Zamówienia bez brytyjskiego numeru komórkowego wysyłamy z numerem zastępczym InPost +447777777777.",
    carriers_service_priority: "Priorytet",
    carriers_service_price_s: "Mała £",
    carriers_service_price_m: "Średnia £",
    carriers_service_price_l: "Duża £",
    carriers_service_price_flat: "Stała £",
    carriers_claims_unsupported: "Reklamacje nieobsługiwane dla tego przewoźnika — zgłaszaj bezpośrednio.",
    carriers_webhook_heading: "Webhooki śledzenia",
    carriers_webhook_hint: "Produkcyjny adres do rejestracji przez InPost (cztery organizacje, wszystkie zdarzenia). Odpytywanie uzupełnia luki.",
    carriers_webhook_this_env: "To środowisko odbiera zdarzenia pod {url}.",
    carriers_webhook_secret: "Sekret podpisu webhooka",
    carriers_webhook_secret_hint: "Sekret HMAC wymieniony z InPost przy rejestracji. Wygeneruj go tutaj i prześlij do InPost albo wklej wartość uzgodnioną z nimi. Niepodpisane zdarzenia są odrzucane.",
    carriers_webhook_last_received: "Ostatnie zdarzenie {at}",
    carriers_webhook_none_yet: "Brak odebranych zdarzeń.",
    carriers_surcharges_heading: "Dopłaty umowne",
    carriers_surcharges_hint: "Dodawane do stawek przy szacowaniu i porównaniu. Zmień przy ogłoszeniu lub RPI.",
    carriers_surcharge_fuel: "Dopłata paliwowa",
    carriers_surcharge_fuel_from: "Obowiązuje od",
    carriers_apc_surcharges_hint: "Miesięczna dopłata paliwowa APC, dodawana do każdej opłaty za przesyłkę od podanej daty przy szacowaniu i porównaniu. Zaktualizuj, gdy APC ogłosi nową stawkę.",
    carriers_apc_fuel_digest: "Paliwo {pct}% od {from}",
    carriers_apc_fuel_none: "Brak dopłaty paliwowej",
    carriers_surcharge_decarb: "Dekarbonizacja za paczkę",
    carriers_surcharge_ni: "Irlandia Północna za paczkę",
    carriers_surcharge_remote: "Obszar odległy za paczkę",
    carriers_surcharge_oog1: "OOG1 za paczkę Medium",
    carriers_surcharge_oog2: "OOG2 za paczkę Large",
    carriers_surcharge_oog_on_band: "Naliczaj OOG1/OOG2 od każdej paczki Medium/Large (dosłowne odczytanie Załącznika 1; niepotwierdzone przez InPost)",
    carriers_surcharge_remote_postcodes: "Kody pocztowe obszarów odległych",
    carriers_surcharge_remote_postcodes_hint: "Wzorce: obszar HS*, dystrykt PA48 *, sektor PA48 7*. Oddzielone przecinkami.",
    carriers_surcharge_remote_published: "Opublikowana lista InPost ({n} dystryktów).",
    carriers_surcharge_remote_custom: "Zmieniona lista ({n} wzorców) zastępuje listę InPost.",
    carriers_surcharge_remote_restore: "Przywróć opublikowaną listę InPost ({n} dystryktów)",
    shipping_rules_tester_transit: "(+{days} dni)",
    shipping_rules_tester_transit_long: "+{days} dni tranzytu ({area}, {when})",
    shipping_rules_strategy: "Strategia",
    shipping_rules_strategy_fixed: "Stała usługa",
    shipping_rules_strategy_cheapest: "Najtańsza z…",
    shipping_rules_strategy_cheapest_summary: "najtańsza z {n}",
    shipping_rules_candidates: "Usługi kandydujące",
    shipping_rules_candidates_hint: "Każda przesyłka pasująca do reguły jest wyceniana na każdej z usług — APC jako przesyłka zbiorcza z dopłatami strefowymi, InPost za paczkę według rozmiaru z paliwem, dekarbonizacją, NI i obszarami odległymi — i rezerwowana najtaniej. Wybierz co najmniej dwie.",
    shipping_rules_tester_candidate_excluded: "wykluczona ({reason})",
    shipping_rules_tester_inpost_bands: "rozmiary InPost {bands}",
    carrier_generic: "Przewoźnik",
    carrier_booking_carrier_rejected: "{carrier} odrzucił dane przesyłki",
    carrier_booking_carrier_unreachable: "Brak połączenia z {carrier}",
    carrier_booking_delivery_point_required: "Zamówienie nie ma punktu odbioru InPost — usługa automat/punkt go wymaga",
    carriers_service_col_on: "Wł.",
    carriers_service_col_type: "Typ",
    carriers_service_base_cost: "Koszt £",
    carriers_service_add_parcel_cost: "Dodatkowa paczka £",
    carriers_service_included_kg: "Wliczone kg",
    carriers_service_per_kg: "£/kg powyżej",
    carriers_service_pick: "Usługa APC",
    carriers_service_pick_custom: "Usługa niestandardowa…",
    carriers_service_pick_hint: "Wypełnia kod, nazwę i opublikowane limity — wszystko edytowalne.",

    // Ustawienia > Wysyłka > Reguły wysyłki
    shipping_rules_settings: "Reguły wysyłki",
    shipping_rules_settings_hint: "Uporządkowane reguły wybierające usługę przewoźnika, gdy ostatni artykuł zamówienia zostanie zeskanowany przy wysyłce. Wygrywa pierwsza pasująca reguła; zamówienie bez dopasowania jest blokowane, dopóki reguła nie pasuje — nic nie wychodzi bez zarezerwowanej etykiety.",
    shipping_rules_warehouse: "Magazyn",
    shipping_rules_load_failed: "Nie udało się wczytać reguł wysyłki",
    shipping_rules_empty: "Brak reguł wysyłki — zamówienia w tym magazynie nie zarezerwują przewoźnika.",
    shipping_rules_no_services: "Brak włączonych usług przewoźnika dla tego magazynu — najpierw skonfiguruj konto przewoźnika w Integracje › Przewoźnicy.",
    shipping_rules_add: "Dodaj regułę",
    shipping_rules_name: "Nazwa reguły",
    shipping_rules_target_service: "Wyślij usługą",
    shipping_rules_enabled_toggle: "Reguła włączona",
    shipping_rules_conditions: "Warunki",
    shipping_rules_conditions_hint: "Wszystkie ustawione warunki muszą pasować. Puste pola pasują do wszystkiego.",
    shipping_rules_service_pallet_suffix: "· palety",
    shipping_rules_pallet_rule_hint: "Ta reguła kieruje zamówienia PALETOWE na stanowisku palet. Warunki dotyczą całego zamówienia (kraje, typ dostawy, kod pocztowy, wagi palet). Zamówienia paczkowe nigdy jej nie używają.",
    shipping_rules_cheapest_parcel_only: "Opcja najtańszej dotyczy tylko usług paczkowych — usługi paletowe nie są wyświetlane.",
    shipping_rules_pallet_intro: "Przewoźnicy paletowi (JAS, Raben, Palletways, DB Schenker) są wybierani przez reguły wskazujące ich usługę paletową. Bez reguły paletowej stanowisko palet korzysta z listy krajów przewoźnika.",
    shipping_rules_delivery_types: "Wybór wysyłki klienta",
    shipping_rules_box_names: "Dozwolone typy pudeł",
    shipping_rules_box_names_hint: "Pozostaw wszystkie niezaznaczone, aby dopuścić każde pudło. Po zaznaczeniu reguła pasuje tylko wtedy, gdy KAŻDE pudło w przesyłce jest jednym z wybranych typów — pudła o własnych wymiarach nigdy nie pasują do ograniczonej reguły.",
    shipping_rules_tester_box_type: "Typ pudła",
    shipping_rules_tester_box_custom: "Własne",
    shipping_rules_advanced_summary: "Kierowanie wg rozmiaru i wagi (opcjonalne)",
    shipping_rules_advanced_hint: "Potrzebne tylko do kierowania przesyłek między usługami — np. progi wagowe dla tańszego przewoźnika lub wysyłanie wszystkich zamówień wielopudłowych jedną usługą. To, co usługa może fizycznie przewieźć, jest już egzekwowane przez jej limity powyżej; nie powtarzaj ich tutaj.",
    shipping_rules_min_weight_kg: "Łączna waga przesyłki powyżej (kg) — >",
    shipping_rules_max_weight_kg: "Łączna waga przesyłki do (kg) — ≤",
    shipping_rules_min_boxes: "Pudeł co najmniej — ≥",
    shipping_rules_max_boxes: "Pudeł co najwyżej — ≤",
    shipping_rules_max_longest_side_cm: "Najdłuższy bok do (cm) — ≤",
    shipping_rules_max_length_cm: "Długość do (cm) — ≤",
    shipping_rules_max_width_cm: "Szerokość do (cm) — ≤",
    shipping_rules_max_height_cm: "Wysokość do (cm) — ≤",
    shipping_rules_weight_bounds_hint: "Warunki wagowe dotyczą CAŁEJ przesyłki (wszystkie pudła razem, waga rzeczywista) — limity na pudło pochodzą z usługi powyżej. Zakresy nie nakładają się: „powyżej” wyklucza wartość, „do” ją obejmuje — więc progi 0–1 kg i 1–5 kg kierują dokładnie 1 kg do pierwszego.",
    shipping_rules_service_limits: "Limity {code} (z Przewoźnicy → Usługi, stosowane automatycznie): {limits}. Przesyłki, których usługa nie może przewieźć, pomijają tę regułę i próbują następnej — nie trzeba powtarzać tych limitów w warunkach poniżej.",
    shipping_rules_limit_boxes: "≤ {n} pudeł",
    shipping_rules_limit_weight: "≤ {kg} kg na pudło",
    shipping_rules_limit_dims: "≤ {dims} cm",
    shipping_rules_dims_hint: "Limity wymiarów obowiązują dla każdego pudła/koperty niezależnie od orientacji — największy bok porównywany jest z największym limitem itd.",
    shipping_rules_uk_regions: "Regiony UK",
    shipping_rules_uk_regions_hint: "Dopasowanie według regionu docelowego (z kodu pocztowego). Pozostaw wszystkie niezaznaczone, aby dopasować wszędzie.",
    shipping_rules_countries: "Kraje",
    shipping_rules_countries_hint: "Kody ISO rozdzielone przecinkami, np. GB, IE. Pozostaw puste dla dowolnego.",
    region_england: "Anglia",
    region_wales: "Walia",
    region_scotland: "Szkocja",
    region_scottish_highlands: "Szkockie Highlandy",
    region_scottish_islands: "Wyspy szkockie",
    region_northern_ireland: "Irlandia Północna",
    region_isle_of_man: "Wyspa Man",
    region_isle_of_wight: "Wyspa Wight",
    region_isles_of_scilly: "Wyspy Scilly",
    region_channel_islands: "Wyspy Normandzkie",
    shipping_rules_postcode_includes: "Kody pocztowe uwzględnione",
    shipping_rules_postcode_excludes: "Kody pocztowe wykluczone",
    shipping_rules_postcode_hint: "Prefiksy rozdzielone przecinkami, * jako wieloznacznik — np. BT*, IM*, GY*.",
    shipping_rules_sales_channels: "Kanały sprzedaży",
    shipping_rules_sales_channels_hint: "Nazwy kanałów rozdzielone przecinkami, dokładnie jak w zamówieniach, np. Bodysocks, Bodysocks UK. Pozostaw puste dla dowolnego kanału.",
    shipping_rules_date_from: "Aktywna od",
    shipping_rules_date_to: "Aktywna do",
    shipping_rules_date_window_hint: "Dni wysyłki (włącznie), w których reguła obowiązuje. Pozostaw puste, aby obowiązywała zawsze.",
    shipping_rules_tester_channel: "Kanał sprzedaży",
    shipping_rules_tester_date: "Data wysyłki",
    shipping_rules_delete: "Usuń regułę",
    shipping_rules_delete_confirm: "Usunąć tę regułę?",
    shipping_rules_move_up: "Przesuń regułę w górę",
    shipping_rules_move_down: "Przesuń regułę w dół",
    shipping_rules_reorder_failed: "Nie udało się zmienić kolejności reguł",
    shipping_rules_tester_heading: "Tester reguł",
    shipping_rules_tester_hint: "Uruchamia dokładnie ten sam mechanizm oceny, którego używa stanowisko wysyłki, na aktywnych regułach.",
    shipping_rules_tester_weight: "Waga kg",
    shipping_rules_tester_boxes: "Pudła",
    shipping_rules_tester_postcode: "Kod pocztowy",
    shipping_rules_tester_length: "Długość cm",
    shipping_rules_tester_width: "Szerokość cm",
    shipping_rules_tester_height: "Wysokość cm",
    shipping_rules_tester_country: "Kraj",
    shipping_rules_tester_region: "Region UK",
    shipping_rules_tester_region_any: "— dowolny (lub wpisz kod pocztowy) —",
    shipping_rules_tester_box: "Pudło {n}",
    shipping_rules_tester_add_box: "Dodaj pudło",
    shipping_rules_tester_remove_box: "Usuń pudło",
    shipping_rules_tester_facts: "{boxes} pudeł · rzeczywista {actual} kg · rozliczeniowa {chargeable} kg · region: {region}",
    shipping_rules_tester_run: "Testuj",
    shipping_rules_tester_matched: "Dopasowano regułę „{rule}” → {service}",
    shipping_rules_tester_estimated_cost: "Szacowany koszt £{cost}",
    shipping_rules_tester_zone_surcharge: "zawiera dopłatę £{cost} ({zone})",
    shipping_rules_tester_consignments: "rezerwowane jako {n} przesyłki (taniej niż jedna)",
    shipping_rules_tester_no_match: "Żadna reguła nie pasuje — ta przesyłka zostałaby zablokowana przy wysyłce. (Linie „service:” oznaczają, że reguła pasowała, ale limity jej usługi nie — została pominięta.)",

    // Stanowisko wysyłki — nakładka rezerwacji przewoźnika
    carrier_booking_in_progress: "Wołamy kuriera…",
    carrier_booking_in_progress_hint: "Rezerwujemy przesyłkę i pobieramy etykietę.",
    carrier_booking_label_pending: "Rozgrzewamy drukarkę…",
    carrier_booking_label_pending_hint: "Etykieta już jedzie.",
    carrier_booking_failed: "Rezerwacja przewoźnika nie powiodła się",
    carrier_booking_no_rules: "Brak skonfigurowanych reguł wysyłki dla tego magazynu",
    carrier_booking_no_match: "Żadna reguła wysyłki nie pasuje do tej przesyłki",
    carrier_booking_service_constraints: "Reguła „{rule}” pasuje, ale paczki przekraczają limity jej usługi",
    carrier_booking_not_gb: "APC wysyła tylko na adresy GB — adres docelowy tego zamówienia nie jest w GB",
    carrier_booking_country_not_served: "{carrier} wysyła tylko do {allowed} — adres docelowy tego zamówienia to {country}",
    carrier_booking_carrier_misconfigured: "Konto {carrier} nie jest skonfigurowane dla tego magazynu — w Ustawienia › Integracje › Przewoźnicy potrzebne są dane dostępowe i adres nadawcy",
    carrier_booking_service_limits: "{carrier} nie może przewieźć tej przesyłki — przekracza limity umowne usługi",
    carrier_booking_address_unroutable: "{carrier} nie może zaadresować tej przesyłki — okręg lub miejscowość nie występuje na liście przewoźnika",
    carrier_booking_label_timeout: "Przewoźnik nie zwrócił etykiety na czas",
    carrier_booking_cancelling: "Etykieta przewoźnika dla tego zamówienia jest właśnie anulowana — nie można go przepakować, dopóki się to nie zakończy. Odczekaj minutę i ponów; jeśli nadal jest zablokowane, rezerwację musi rozwiązać przełożony.",
    carrier_booking_in_flight_elsewhere: "Inne stanowisko właśnie rezerwuje to zamówienie",
    carrier_booking_box_mismatch: "To zamówienie ma już rezerwację na {booked} paczek, a spakowano {packed}. Pudełka bez etykiety nie można wysłać. Anuluj etykietę i zarezerwuj ponownie dla pudełek na stanowisku albo wróć i popraw pudełka.",
    carrier_booking_box_contents_mismatch: "Istniejąca etykieta tego zamówienia obejmuje {booked} kg, a spakowano {packed} kg — to nie są te same pudełka. Anuluj etykietę i zarezerwuj ponownie dla pudełek na stanowisku albo wróć i popraw pudełka.",
    carrier_booking_rebook: "Anuluj etykietę i zarezerwuj ponownie na {packed} paczek",
    carrier_booking_rebook_confirm: "Obecna etykieta zostanie anulowana, a zamówienie zarezerwowane ponownie na {packed} paczek. Wydrukowane etykiety ({booked}) trzeba wyrzucić — stary list przewozowy przestanie obowiązywać.",
    carrier_booking_rebook_confirm_btn: "Tak, anuluj i zarezerwuj ponownie",
    carrier_booking_fix_boxes: "Wróć i popraw pudełka",
    carrier_booking_already_shipped: "To zamówienie zostało już wysłane, więc nie można anulować jego etykiety ze stanowiska pakowania. Przełożony otwiera je ponownie z biurka.",
    carrier_booking_shared_consignment: "Ta etykieta jest wspólna z innymi zamówieniami w tej samej przesyłce. Anulowanie jej tutaj zmieniłoby także ich etykiety — musi to rozwiązać przełożony.",
    carrier_booking_cancel_window_closed: "{carrier} nie pozwala już anulować tej etykiety: {reason}. Oflaguj zamówienie dla przełożonego.",
    carrier_booking_cancel_reason_manifested: "została ujęta w manifeście (godzina graniczna {cutoff})",
    carrier_booking_cancel_reason_scanned: "przewoźnik zeskanował już paczkę",
    carrier_booking_void_failed: "{carrier} nie potwierdził anulowania, więc nowa etykieta nie została zarezerwowana, a stara pozostaje bez zmian. Oflaguj zamówienie dla przełożonego.",
    carrier_booking_wrong_status: "Rezerwacja tego zamówienia nie jest już aktywna w APC — przełożony musi ją rozwiązać, zanim zamówienie będzie można spakować",
    carrier_booking_label_fetch_failed: "Przewoźnik odrzucił żądanie etykiety",
    carrier_booking_apc_rejected: "APC odrzuciło dane przesyłki",
    carrier_booking_apc_rejected_hint: "Zwykle wynikają one z danych dostawy zamówienia. Popraw powyższe pola w zamówieniu i naciśnij Ponów — jeśli ponowienie się powiedzie, wysyłka przebiega normalnie.",
    carrier_booking_blocked_hint: "To zamówienie nie może zostać wysłane bez zarezerwowanej etykiety. Usuń problem (lub zaktualizuj Reguły wysyłki w Ustawieniach) i spróbuj ponownie.",
    carrier_booking_retry: "Ponów rezerwację",
    carrier_said: "Przewoźnik odpowiedział: ",
    carrier_live_booking_box_warning: "Etykieta jest już zarezerwowana na {booked} paczek — na stanowisku jest {packed}. Zakończenie anuluje ją i zarezerwuje ponownie.",
    carrier_booking_edit_address: "Edytuj adres dostawy",
    carrier_booking_save_address_retry: "Zapisz adres i ponów",
    address_updated: "Adres dostawy zaktualizowany",
    reopen_carrier_cancel_queued: "Stara etykieta {carrier} została zakolejkowana do anulowania.",
    reopen_carrier_cancel_done: "Stara etykieta {carrier} została anulowana (anulowano etykiet: {n}).",
    reopen_carrier_void_local: "Stara etykieta {carrier} została unieważniona (etykiet: {n}).",
    cancel_carrier_label_done_local_reship: "Etykieta {carrier} unieważniona (etykiet: {n}). Zamówienie wróciło do wysyłki: zeskanuj na stanowisku jego etykietę wysyłkową (albo oryginalną totę / lokalizację), aby spakować ponownie.",
    cancel_carrier_label_done_local_cancelled: "Etykieta {carrier} unieważniona (etykiet: {n}). Zamówienie zostało anulowane.",
    carrier_name_unknown: "przewoźnik",
    // Arkusz skanowania przyjęcia BargainFox
    bf_mode_title: "BargainFox",
    bf_last_item_label: "Ostatni",
    bf_last_item_fnsku: "FNSKU",
    bf_last_item_asin: "ASIN",
    bf_last_item_scanned: "Zeskanowano",
    bf_last_item_untitled: "Brak opisu",
    bf_location_toggle: "BF",
    bf_location_toggle_hint: "Użyj przepływu sortowania do pojemników BargainFox w tej lokalizacji arkusza skanowania. Nie można łączyć z Info o pudełku.",
    // Flaga "Info o pudełku" biurka arkusza skanowania (getProductData w /scan/check)
    box_info_toggle: "Info o pudełku",
    box_info_toggle_hint: "Pokazuj ASIN-y znajdujące się w każdym zeskanowanym pudełku w tej lokalizacji arkusza skanowania. Nie można łączyć z BF.",
    box_info_none: "Brak informacji o pudełku",
    box_info_units: "{count} szt.",
    box_info_total_rrp: "Łączna cena RRP {value}",
    box_info_col_asin: "ASIN",
    box_info_col_title: "Tytuł",
    box_info_col_rrp: "RRP",
    box_info_col_units: "Szt.",
    box_info_more: "+{count} więcej",
    bf_hot_cover_days: "Pokrycie Hot BF (dni)",
    bf_hot_cover_days_hint: "Liczba dni sprzedaży, którą mają pokryć lokalizacje Hot, wyliczana z 30-dniowej sprzedaży w tabeli produktów BF. Puste pole oznacza domyślnie 14 dni.",
    bf_new_sku_hot_units: "Sztuki Hot dla nowych SKU BF",
    bf_new_sku_hot_units_hint: "SKU bez danych sprzedaży BF dostaje tyle sztuk do Hot, aby pierwsze zamówienia były kompletowane z niskich lokalizacji; sztuki już w lokalizacjach Hot, w pojemnikach Hot czekających na odłożenie i w otwartych pojemnikach Hot są wliczane. Po pierwszej sprzedaży obowiązuje zwykły cel Hot. Dotyczy tylko arkusza skanowania — Forecast Drop bez zmian. Puste pole oznacza domyślnie 2, 0 wyłącza.",
    bf_unit_units: "szt.",
    bf_tote_max_weight_kg: "Limit wagi pojemnika Hot/Cold BF (kg)",
    bf_tote_max_weight_kg_hint: "Na standardowym arkuszu BF pojemnik Hot lub Cold jest wymuszenie zamykany i wysyłany do odłożenia, gdy suma wag produktów z Portalu osiągnie tę wartość. Sztuki bez wagi liczą się jako 0. Arkusze Duże oraz pojemniki Czerwone i Pomiar nie mają limitu. Puste pole oznacza domyślnie 10 kg, 0 wyłącza.",
    bf_colour_hot: "Hot",
    bf_colour_cold: "Cold",
    bf_colour_red: "Czerwony",
    bf_colour_measure: "Pomiar",
    bf_colour_black: "Czarny",
    bf_colour_error: "Błąd",
    bf_scan_tote: "Zeskanuj pojemnik",
    bf_scan_replacement_tote: "Zeskanuj nowy pojemnik",
    bf_scan_edit_tote: "Zeskanuj pojemnik do edycji",
    bf_scan_unit_to_edit: "Zeskanuj sztukę do edycji",
    bf_scan_tote_to_close: "Zeskanuj pojemnik, aby go zamknąć",
    bf_scan_item: "Zeskanuj produkt",
    bf_scan_placeholder: "Zeskanuj kod produktu lub pojemnika",
    bf_setup_prompt: "Zeskanuj pojemnik {colour}",
    bf_setup_prompt_counted: "Zeskanuj pojemnik {colour} {number} z {required}",
    bf_reopen_prompt: "Pojemnik {colour} jest zamknięty — zeskanuj nowy pojemnik, aby go ponownie otworzyć",
    bf_items_blocked_missing_tote: "Skanowanie produktów jest zablokowane, dopóki każdy kolor nie ma wszystkich wymaganych pojemników.",
    bf_setup_close_sibling_hint: "…lub zeskanuj otwarty pojemnik {colour}, aby go również zamknąć",
    bf_swap_prompt: "Zeskanuj nowy pojemnik dla {colour}",
    bf_swap_close_prompt: "Zeskanuj otwarty pojemnik {colour}, aby go zamknąć",
    bf_reopen_tote_title: "Otworzyć pojemnik ponownie?",
    bf_reopen_tote_confirm: "Pojemnik {tote} zamknięto z {units} szt. ({closedBy}). Otworzyć go ponownie?",
    bf_reopen_carry_on: "Kontynuuj ({units} szt.)",
    bf_reopen_start_over: "Zacznij od nowa — pojemnik jest pusty",
    bf_reopen_start_over_confirm: "Spowoduje to usunięcie {units} szt. zapisanych dla pojemnika {tote}. Kontynuować?",
    bf_reopen_start_over_yes: "Tak — zacznij od nowa",
    bf_unknown_operator: "nieznany operator",
    bf_edit_tote_prompt: "Zeskanuj pojemnik {colour} do edycji",
    bf_edit_unit_prompt: "Zeskanuj sztukę do usunięcia z pojemnika {tote}",
    bf_close_prompt: "Zeskanuj pojemnik {colour}, aby go zamknąć",
    bf_item_close_confirm: "Zeskanuj pojemnik {tote} ponownie, aby go zamknąć — liczba sztuk: {units}",
    bf_tote_full_title: "Pojemnik pełny",
    bf_item_close_weight: "Pojemnik {tote} ma {kg} kg z limitu {limit} kg (sztuk: {units}). Zeskanuj go, aby zamknąć i wysłać do odłożenia.",
    bf_tote_weight: "{kg} kg",
    bf_tote_units_weight: "Pojemnik {tote}: {units} szt., {weight}",
    bf_verdict_hot: "Hot",
    bf_verdict_cold: "Cold",
    bf_verdict_red: "Czerwony",
    bf_verdict_measure: "Pomiar",
    bf_verdict_black: "Poza manifestem",
    bf_verdict_not_on_portal: "Brak w Portalu",
    bf_not_on_portal_detail: "FNSKU {fnsku} jest na manifeście (ASIN {asin}), ale produktu brakuje w Portalu — odłóż sztukę na bok.",
    bf_verdict_big: "BIG",
    bf_no_tote: "Brak pojemnika",
    bf_no_tote_open: "Brak pojemnika — zeskanuj, aby otworzyć",
    bf_closed_reopen: "Zamknięty — zeskanuj nowy pojemnik, aby ponownie otworzyć",
    bf_waiting: "Oczekiwanie",
    bf_swap_tote: "Zmień pojemnik",
    bf_swap_booked_success: "Pojemnik {tote} wysłano do odłożenia — {units} szt.",
    bf_swap_empty_success: "Pusty pojemnik {tote} zwolniono do ponownego użycia.",
    bf_close_booked_success: "Pojemnik {tote} wysłano do odłożenia — {units} szt. z {skus} SKU.",
    bf_close_empty_success: "Pusty pojemnik {tote} zwolniono do ponownego użycia; niczego nie zarezerwowano.",
    bf_edit_action: "Edytuj pojemnik {colour}",
    bf_edit_success: "Usunięto sztukę z pojemnika {colour} {tote}.",
    bf_leave_mode: "Opuść tryb BF",
    bf_finish_session: "Zakończ sesję",
    bf_resume_finish: "Wznów kończenie",
    bf_finish_pending_title: "Oczekująca sztuka",
    bf_finish_pending_warning: "Zeskanuj pojemnik {tote}, aby potwierdzić tę sztukę, albo jawnie ją porzuć przed zakończeniem.",
    bf_finish_abandon_pending: "Porzuć sztukę i rozpocznij kończenie",
    bf_finish_complete: "Sesja zakończona",
    bf_finish_summary_intro: "Sztuki przekazane do odłożenia",
    bf_units_booked: "zarezerwowane sztuki",
    bf_tote_units: "Pojemnik {tote}: {units} szt.",
    bf_status_active: "AKTYWNY",
    bf_status_open_count: "Otwarte: {count}",
    bf_status_free: "wolne",
    bf_swap_tote_tooltip: "Zmień pojemnik — obecny jest pełny",
    bf_remove_item_tooltip: "Usuń produkt z tego pojemnika",
    bf_verify_tote_tooltip: "Sprawdź zawartość pojemnika (wkrótce)",
    bf_done: "Gotowe",
    bf_back_to_location: "Zeskanuj inną lokalizację",
    bf_active_elsewhere_confirm: "Sesja BargainFox jest aktywna w lokalizacji {location}. Porzucić ją i rozpocząć tutaj?",
    bf_confirm_retry: "Potwierdzenie pojemnika nie dotarło do serwera. Spróbuj ponownie.",
    bf_confirmation_lost_rescan: "Potwierdzenie zostało utracone — zeskanuj ponownie produkt i pojemnik.",
    bf_session_recovery_prompt: "Uruchom ponownie BargainFox tutaj albo opuść tryb BF.",
    bf_restart_session: "Uruchom sesję ponownie",
    bf_error_unknown_location: "Nieznana lokalizacja arkusza skanowania.",
    bf_error_not_location: "Ta lokalizacja nie jest włączona dla BargainFox.",
    bf_error_active_elsewhere: "Sesja BargainFox jest aktywna w innej lokalizacji.",
    bf_error_tote_required: "Zeskanuj kod pojemnika dla tego koloru.",
    bf_error_unknown_tote: "Nieznany pojemnik",
    bf_error_tote_already_open_here: "Już otwarty w tej sesji",
    bf_error_tote_already_open: "Pojemnik jest używany gdzie indziej",
    bf_error_tote_closed: "Pojemnik oczekuje na odłożenie — wybierz inny",
    bf_error_tote_awaiting_put_away: "Pojemnik nadal zawiera towar do odłożenia — wybierz inny",
    bf_error_tote_not_reopenable: "Pojemnika nie można już ponownie otworzyć — wybierz inny",
    bf_error_tote_stored: "Ten pojemnik został już odłożony.",
    bf_error_colour_already_open: "Dla tego koloru jest już otwarty pojemnik {tote}.",
    bf_error_colour_tote_limit: "Dla tego koloru są już otwarte maksymalnie dwa pojemniki.",
    bf_error_old_tote_required: "Najpierw zeskanuj pojemnik, który chcesz wymienić.",
    bf_error_no_session: "Brak aktywnej sesji BargainFox.",
    bf_error_session_ended: "Ta sesja BargainFox została zakończona.",
    bf_error_colour_new_tote_required: "Wybierz kolor i zeskanuj nowy pojemnik.",
    bf_error_no_event: "Żaden zeskanowany produkt nie oczekuje na tę operację.",
    bf_error_missing_location_barcode: "Brakuje kodu lokalizacji sesji.",
    bf_error_no_colour_tote: "Ten kolor nie ma otwartego pojemnika.",
    bf_error_already_booked: "Ten pojemnik został już przekazany do odłożenia.",
    bf_error_all_totes_required: "Otwórz wszystkie wymagane pojemniki przed skanowaniem produktów.",
    bf_error_totes_still_open: "Zamknij wszystkie otwarte pojemniki kolorów przed zakończeniem sesji.",
    bf_error_wrong_tote: "Serwer odrzucił pojemnik. Zeskanuj pojemnik oczekiwanego koloru.",
    bf_error_tote_weight_limit: "Ten pojemnik osiągnął limit wagi. Zamknij go i wyślij do odłożenia albo użyj drugiego pojemnika.",
    bf_error_tote_weight_limit_close: "Pojemnik pełny — zeskanuj pełny pojemnik, aby go zamknąć, zanim zeskanujesz cokolwiek innego.",
    bf_error_event_not_pending: "Ten produkt nie oczekuje już na potwierdzenie.",
    bf_error_event_not_found: "Nie znaleziono zdarzenia skanowania.",
    bf_error_server: "Nie udało się wykonać operacji BargainFox. Spróbuj ponownie.",
    // Tryb BF Duże (PDBIG): trzy pojemniki, zasada długości, okno o długości
    bf_location_mode: "Tryb",
    bf_location_mode_hint: "Standard = Hot/Cold/Czerwony/Pomiar z sześcioma pojemnikami. Duże = jeden pojemnik Hot (hot i cold razem), Czerwony i Pomiar, plus zasada maksymalnej długości.",
    bf_location_mode_standard: "Standard",
    bf_location_mode_big: "Duże",
    bf_big_max_length_cm: "Maks. długość dużych produktów BF (cm)",
    bf_big_max_length_cm_hint: "Arkusze skanowania w trybie Duże wysyłają sztukę na Czerwony, gdy jej najdłuższy bok przekracza tę wartość. Puste pole oznacza domyślnie 60 cm.",
    bf_over_length_title: "Sprawdź długość",
    bf_over_length_question: "Czy ten produkt jest dłuższy niż {max} cm?",
    bf_over_length_yes: "Tak — dłuższy (Czerwony)",
    bf_over_length_no: "Nie — krótszy (Hot)",
    bf_over_length_detail: "Najdłuższy bok {longest} cm przekracza maksimum {max} cm — paleta Czerwona.",
    bf_operator_over_length_detail: "Oznaczony przez operatora jako dłuższy niż {max} cm — paleta Czerwona.",
    bf_operator_under_length_detail: "Oznaczony przez operatora jako krótszy niż {max} cm — pojemnik Hot.",
    bf_length_change_answer: "Zmień odpowiedź",
    bf_error_dims_present: "Ten produkt ma już wymiary — decyduje zmierzony rozmiar.",
    bf_length_answers_title: "Odpowiedzi o długości BF",
    bf_length_answers_hint: "Odpowiedzi udzielone w oknie „czy dłuższy niż maksimum?” w trybie Duże, zapamiętane dla SKU do czasu wpisania wymiarów produktu. Usuń, aby zapytać ponownie.",
    bf_length_answers_empty: "Brak zapamiętanych odpowiedzi.",
    bf_length_answer_over: "Dłuższy — Czerwony",
    bf_length_answer_under: "Krótszy — Hot",
    bf_length_answer_measured: "Ma już wymiary",
    bf_length_answer_remove: "Zapomnij odpowiedź",
    bf_length_answer_by: "{name} · {when}",
    bf_error_colour_not_in_mode: "Ten kolor pojemnika nie jest używany na tym stanowisku.",
    bf_error_not_big_mode: "Odpowiedzi o długości dotyczą tylko stanowiska dużych produktów.",
    picking_special_queues_title: "Kolejki specjalne",
    picking_queue_orders: "Zamówienia: {count}",
    picking_queue_items: "Sztuki: {count}",
    picking_queue_pick: "Kompletuj",
    picking_queue_start: "Rozpocznij kolejkę",
    picking_queue_not_ready: "Niegotowe — zapas nie jest jeszcze dostępny",
    picking_queue_empty: "Brak zamówień w tej kolejce.",
    picking_queue_back: "Wróć do typów kompletacji",
    orders_pick_queue_label: "Kolejka specjalna",
    orders_pick_queue_none: "Brak",
    settings_picking_queues_title: "Nazwy kolejek specjalnych",
    settings_picking_queues_hint: "Zmień nazwy trzech stałych kolejek specjalnych dla każdego magazynu. Nazwy nie mogą być puste i mogą mieć maksymalnie 40 znaków.",
    settings_picking_queue_1: "Kolejka 1",
    settings_picking_queue_2: "Kolejka 2",
    settings_picking_queue_3: "Kolejka 3",

    // Pick to Tote (kolejka specjalna 4 — zamówienia wewnętrzne
    // kompletowane do jednego pojemnika i przekazywane do odkładania)
    pick_to_tote: "Kompletacja do pojemnika",
    bulk_pick: "Kompletacja zbiorcza",
    pallet_dispatch: "Wysyłka palet",
    pallet_dispatch_order: "Zamówienie",
    pallet_dispatch_scan_prompt: "Zeskanuj paletę ze strefy odkładczej, aby otworzyć jej zamówienie",
    pallet_dispatch_not_enabled: "Palletways nie jest włączony dla tego magazynu — nie można tu jeszcze nadawać zamówień paletowych.",
    pallet_dispatch_no_carrier: "Żaden przewoźnik paletowy nie jest włączony dla tego magazynu — nie można tu jeszcze wysyłać zamówień paletowych.",
    pallet_dispatch_no_carrier_for_country: "Żaden przewoźnik paletowy nie obsługuje kraju {country} — tego zamówienia nie można stąd wysłać.",
    pallet_dispatch_no_pallet_rule: "Żadna reguła wysyłki palet nie pasuje do tego zamówienia — dodaj ją w Ustawienia › Wysyłka › Reguły wysyłki",
    pallet_dispatch_routed_by_rule: "Przewoźnik wg reguły: {rule}",
    pallet_dispatch_manual_heading: "Wysyłka ręczna",
    pallet_dispatch_carrier_line: "Przewoźnik: {carrier} (kraj dostawy {country})",
    pallet_dispatch_manual_hint: "Nadaj tę paletę na stronie przewoźnika {carrier}, dołącz tutaj etykietę i wydrukuj ją, wpisz numer {carrier} z rezerwacji, a następnie kliknij Wyślij. Kanał sprzedaży potrzebuje tego numeru, aby oznaczyć zamówienie jako wysłane.",
    pallet_dispatch_manual_fallback: "{carrier} nie jest jeszcze skonfigurowany do nadawania przez API w tym magazynie (brakuje: {missing}) — do czasu uzupełnienia Ustawienia › Przewoźnicy wysyłka ręczna.",
    pallet_dispatch_manual_fallback_hint: "Nadaj tę paletę w systemie przewoźnika {carrier}, dołącz tutaj etykietę i wydrukuj ją, wpisz numer listu przewozowego, a następnie kliknij Wyślij. Link do śledzenia zostanie dodany automatycznie.",
    pallet_dispatch_tracking_needed: "Aby wysłać, wpisz numer {carrier} z rezerwacji — jest na etykiecie PDF (np. 4121310799 lub 261028-004877).",
    pallet_dispatch_err_tracking_required: "Przed wysłaniem wpisz numer śledzenia przewoźnika",
    pallet_dispatch_attachments: "Załączniki",
    pallet_dispatch_no_attachments: "Nie dołączono jeszcze żadnych plików.",
    pallet_dispatch_kind_shipping_label: "Etykieta wysyłkowa",
    pallet_dispatch_kind_invoice: "Faktura",
    pallet_dispatch_kind_other: "Inne",
    pallet_dispatch_upload_label: "Dołącz etykietę",
    pallet_dispatch_uploaded: "Dołączono etykietę: {name}",
    pallet_dispatch_upload_failed: "Nie udało się dołączyć etykiety",
    pallet_dispatch_print: "Drukuj",
    pallet_dispatch_tracking: "Numer śledzenia",
    pallet_dispatch_tracking_url: "Link do śledzenia (opcjonalnie)",
    pallet_dispatch_ship: "Wyślij",
    pallet_dispatch_ship_confirm_text: "Wysłać {order} przez {carrier} teraz? Zamówienie zostanie oznaczone jako wysłane, a kanał sprzedaży powiadomiony.",
    pallet_dispatch_ship_confirm: "Tak, wyślij",
    pallet_dispatch_shipped_manual: "{order} wysłane przez {carrier}",
    pallet_dispatch_err_no_pallet_carrier: "Żaden przewoźnik paletowy nie obsługuje kraju dostawy tego zamówienia",
    pallet_dispatch_err_use_api_booking: "Przewoźnik tego zamówienia jest rezerwowany przez API — użyj Rezerwuj",
    pallet_dispatch_err_bad_tracking_url: "Link do śledzenia musi zaczynać się od http:// lub https://",
    pallet_dispatch_err_fulfil_failed: "Nie udało się oznaczyć zamówienia jako wysłanego",
    pallet_dispatch_ready: "Gotowe do nadania",
    pallet_dispatch_ready_manual: "Gotowe do wysyłki",
    pallet_dispatch_ready_empty: "Żadne zamówienia paletowe nie czekają na stanowisku.",
    pallet_dispatch_booked_heading: "Nadane — czekają na zwolnienie",
    pallet_dispatch_released_heading: "Zwolnione — czekają na numer śledzenia",
    pallet_dispatch_released_hint: "Zwolnione do Palletways. Zamówienie zostanie oznaczone jako wysłane, gdy Palletways nada numer śledzenia.",
    pallet_dispatch_row_meta: "Palety: {n} · {kg} kg",
    pallet_dispatch_awaiting_release: "Nadane, jeszcze niezwolnione do Palletways: {n}",
    pallet_dispatch_release: "Zwolnij dzisiejsze palety",
    pallet_dispatch_release_confirm_text: "Wysłać przesyłki ({n}) do oddziału Palletways? Tego nie można cofnąć.",
    pallet_dispatch_release_confirm: "Tak, zwolnij",
    pallet_dispatch_released: "Przesyłki zwolnione do Palletways: {n}",
    pallet_dispatch_release_failed: "{order} NIE zostało zwolnione: {error}",
    pallet_dispatch_nothing_to_release: "Nie ma nic do zwolnienia",
    pallet_dispatch_shipped: "Zamówienie {order} wysłane — śledzenie {tracking}",
    pallet_dispatch_ship_failed: "Zamówienie {order} zwolniono, ale nie udało się oznaczyć jako wysłane: {error}",
    pallet_dispatch_state_ready: "Gotowe do nadania",
    pallet_dispatch_state_ready_manual: "Gotowe do wysyłki",
    pallet_dispatch_state_booking: "Nadawanie…",
    pallet_dispatch_state_booked: "Nadane",
    pallet_dispatch_state_released: "Zwolnione",
    pallet_dispatch_state_failed: "Ostatnie nadanie nieudane",
    pallet_dispatch_col_pallet: "Paleta",
    pallet_dispatch_col_type: "Typ Palletways",
    pallet_dispatch_col_weight: "Waga (kg)",
    pallet_dispatch_col_height: "Wysokość (cm)",
    pallet_dispatch_col_volumetric: "Waga objętościowa (kg)",
    pallet_dispatch_no_height: "brak zapisanej wysokości",
    pallet_dispatch_col_scanned: "Zeskanowana",
    pallet_dispatch_scanned: "Zeskanowana",
    pallet_dispatch_choose_type: "Wybierz…",
    palletways_type_oversized: "Ponadwymiarowa — 2 palety, 1 podniesienie, bez windy",
    pallet_dispatch_weight_default: "brak zapisanej wagi — przyjęto 300 kg",
    pallet_dispatch_no_phone: "brak telefonu",
    pallet_dispatch_no_email: "brak e-maila",
    pallet_dispatch_scan_all: "Przed nadaniem zeskanuj każdą paletę tego zamówienia — zeskanowano {done} z {total}",
    pallet_dispatch_scan_all_manual: "Przed wysyłką zeskanuj każdą paletę tego zamówienia — zeskanowano {done} z {total}",
    pallet_dispatch_last_attempt: "Ostatnia próba nadania nie powiodła się: {error}",
    pallet_dispatch_book: "Nadaj i drukuj etykiety",
    pallet_dispatch_reprint: "Drukuj etykiety ponownie",
    pallet_dispatch_void: "Anuluj nadanie",
    pallet_dispatch_void_confirm: "Tak, anuluj",
    pallet_dispatch_booked: "Zamówienie {order} nadane w Palletways",
    pallet_dispatch_reprinted: "Zamówienie {order} jest już nadane — etykiety wydrukowano ponownie",
    pallet_dispatch_voided: "Nadanie dla {order} anulowane",
    pallet_dispatch_booking_line: "Przesyłka {con} · {service} · kody palet {barcodes}",
    pallet_dispatch_print_fallback: "Okno drukowania się nie otworzyło — pobrano plik PDF z etykietą",
    pallet_dispatch_err_unknown_pallet: "Tej palety nie ma na stanowisku wysyłki palet",
    pallet_dispatch_err_scan_all_pallets: "Najpierw zeskanuj każdą paletę zamówienia",
    pallet_dispatch_err_service_limits: "Tego zamówienia nie można nadać w obecnym stanie",
    pallet_dispatch_err_carrier_unavailable: "{carrier} nie jest włączony dla tego magazynu",
    pallet_dispatch_err_booking_in_progress: "To zamówienie jest właśnie nadawane",
    pallet_dispatch_err_already_released: "Ta przesyłka została już zwolniona do Palletways",
    pallet_dispatch_err_no_service: "Palletways nie oferuje usługi ekonomicznej dla tego kodu pocztowego",
    pallet_dispatch_err_carrier_rejected: "{carrier} odrzucił nadanie",
    pallet_dispatch_err_carrier_unreachable: "Brak połączenia z {carrier}",
    pallet_dispatch_err_label_fetch_failed: "Nadano, ale etykieta nie wróciła",
    pallet_dispatch_err_order_not_at_desk: "To zamówienie nie jest już na stanowisku wysyłki palet",
    pallet_dispatch_err_not_all_staged: "Nie wszystkie palety tego zamówienia są już w strefie odkładczej",
    pallet_dispatch_err_no_booking: "Brak nadania, którego to dotyczy",
    pallet_dispatch_err_carrier_refused: "Palletways odmówił — przesyłka mogła już zostać zwolniona",
    pallet_dispatch_err_generic: "Nie udało się — spróbuj ponownie",
    // Ekrany w stylu wysyłki (2026-10-21): ekran pakowania, ekran potwierdzenia.
    pallet_dispatch_view: "Podgląd",
    pallet_dispatch_all_scanned: "Wszystkie palety zeskanowane",
    pallet_dispatch_bar_progress: "Zeskanowano {done} z {total} palet",
    pallet_dispatch_print_labels: "Drukuj etykiety",
    pallet_dispatch_print_label: "Drukuj etykietę",
    pallet_dispatch_print_and_ship: "Drukuj etykietę i wyślij",
    pallet_dispatch_no_label_attached: "Nie dołączono jeszcze etykiety wysyłkowej — dołącz ją poniżej, aby wydrukować ją stąd, albo wyślij bez niej, jeśli została wydrukowana gdzie indziej.",
    pallet_dispatch_done: "Gotowe",
    pallet_dispatch_state_shipped: "Wysłane",
    pallet_dispatch_shipped_line: "Wysłane przez {carrier} · śledzenie {tracking}",
    // Przewoźnik paletowy „direct” (JAS, nadanie przez API z tego stanowiska).
    pallet_dispatch_direct_heading: "Nadaj i wyślij",
    pallet_dispatch_direct_hint: "Wyślij nadaje to zamówienie u przewoźnika {carrier} przez API: etykieta i list przewozowy wracają i drukują się tutaj, a zamówienie od razu dostaje status wysłane. {carrier} nie ma API anulowania — sprawdź palety przed wysyłką.",
    pallet_dispatch_book_and_ship: "Nadaj przez {carrier} i wyślij",
    pallet_dispatch_direct_confirm_text: "Nadać {order} przez {carrier} i wysłać teraz? Przesyłka zostanie utworzona u przewoźnika, a zamówienie oznaczone jako wysłane.",
    pallet_dispatch_shipped_direct: "{order} nadane przez {carrier} — list przewozowy {tracking}",
    pallet_dispatch_print_waybill: "Drukuj list przewozowy",
    pallet_dispatch_direct_documents_hint: "Etykieta została wydrukowana. Wydrukuj także list przewozowy dla kierowcy.",
    pallet_dispatch_err_carrier_misconfigured: "Konto przewoźnika nie jest skonfigurowane do nadawania",
    pallet_dispatch_err_carrier_not_allowed: "{carrier} nie może wysłać tego zamówienia. Dozwoleni przewoźnicy: {allowed}",
    pallet_dispatch_err_carrier_not_supported: "{carrier} nie ma listy załadunkowej",
    pallet_dispatch_choose_carrier: "Przewoźnik",
    pallet_dispatch_planned_delivery: "Planowana dostawa {from} – {to}",
    pallet_dispatch_wz_upload_failed: "Przesyłka została wysłana, ale wysłanie dokumentu eWZ się nie powiodło: {error}",
    pallet_dispatch_loading_list: "Lista załadunkowa — {carrier}",
    pallet_dispatch_loading_list_date: "Data",
    pallet_dispatch_loading_list_print: "Drukuj listę załadunkową",
    pallet_dispatch_loading_list_none: "Brak przesyłek do załadunku w dniu {date}",
    pallet_dispatch_loading_list_printed: "Lista załadunkowa {number} · przesyłek: {n}",
    pallet_dispatch_err_not_this_order: "Ta paleta nie należy do tego zamówienia — wróć do listy, aby otworzyć inne zamówienie",
    pallet_picks: "Kompletacja palet",
    pallet_picks_empty: "Brak zamówień paletowych do skompletowania.",
    pallet_picks_start_an_order: "Rozpocznij zamówienie",
    pallet_picks_start_an_order_hint: "Naciśnij Start przy zamówieniu lub zeskanuj jedną z jego palet. Wszystkie palety tego zamówienia zawozisz do wysyłki, zanim zaczniesz kolejne.",
    pallet_picks_start: "Start",
    pallet_picks_take_over: "Przejmij",
    pallet_picks_your_order: "Twoje zamówienie",
    pallet_picks_locked_by: "Kompletuje {name}",
    pallet_picks_another_picker: "inny pracownik",
    pallet_picks_next: "Następna: {sku}",
    pallet_picks_next_at: "Idź do {location} i zeskanuj etykietę palety",
    pallet_picks_nothing_pickable: "Nie można pobrać więcej palet",
    pallet_picks_nothing_pickable_hint: "Reszta tego zamówienia nie jest w lokalizacji magazynowej. Opuść zamówienie, aby można było to wyjaśnić.",
    pallet_picks_leave_order: "Opuść zamówienie",
    pallet_picks_leave_order_confirm: "Tak, opuść",
    pallet_picks_left_order: "Opuszczono zamówienie",
    pallet_picks_finish_first: "Najpierw dokończ swoje zamówienie — czeka jeszcze {n}",
    pallet_picks_take_to_holding: "Zabierz ją do strefy wysyłki palet i zeskanuj {barcode}",
    pallet_picks_put_back: "Odłóż",
    pallet_picks_put_back_confirm: "Tak, odłóż",
    pallet_picks_released: "Paleta odłożona — nie jest już pobrana",
    pallet_picks_staged: "Paleta jest w strefie wysyłki",
    pallet_picks_staged_order_ready: "Paleta jest w strefie wysyłki — zamówienie gotowe do wysyłki",
    pallet_picks_order_progress: "{done} z {total} w strefie wysyłki",
    pallet_picks_state_to_pick: "Do pobrania",
    pallet_picks_state_no_stock: "Brak w lokalizacji",
    pallet_picks_state_moving: "W drodze",
    pallet_picks_state_staged: "W strefie wysyłki",
    pallet_picks_not_enabled: "Palletways nie jest włączony dla tego magazynu, więc zamówienia paletowe nie trafiają tu automatycznie.",
    pallet_picks_err_stage_first: "Masz już paletę {sku}. Najpierw zabierz ją do strefy wysyłki palet.",
    pallet_picks_err_unknown_barcode: "Ten kod nie jest paletą",
    pallet_picks_err_not_on_order: "Żadne zamówienie paletowe nie czeka na tę paletę",
    pallet_picks_err_no_stock: "Ta paleta nie jest w lokalizacji magazynowej — nie można jej pobrać",
    pallet_picks_err_not_holding_area: "To nie jest kod strefy wysyłki palet",
    pallet_picks_err_nothing_in_hand: "Nie masz palety do odstawienia — najpierw zeskanuj paletę",
    pallet_picks_err_order_locked: "To zamówienie kompletuje {name}",
    pallet_picks_err_not_in_your_order: "Ta paleta nie należy do Twojego zamówienia {order}",
    pallet_picks_err_finish_order_first: "Najpierw dokończ zamówienie {order}",
    pallet_picks_err_order_not_available: "Tego zamówienia nie można już kompletować",
    pallet_picks_err_order_cancelled: "Zamówienie dla palety {sku} zostało anulowane — odwieź paletę i naciśnij Odłóż",
    pallet_picks_err_generic: "Nie udało się — spróbuj ponownie",
    orders_pallet_picks_hint: "Pobierane jako cała paleta bez pojemnika, potem wysyłane ze stanowiska wysyłki palet. Ustawiane automatycznie dla zamówień złożonych z produktów paletowych.",
    pick_to_tote_empty: "Brak zamówień przypisanych do kompletacji do pojemnika.",
    pick_to_tote_note_title: "Notatka zamówienia",
    orders_pick_to_tote_hint: "Kompletowane do jednego pojemnika i odkładane — zamówienie kończy się bez wysyłki. Poniższa notatka jest widoczna dla kompletującego.",
    orders_bulk_pick_hint: "Kompletowane jak zamówienie z kolejki specjalnej, ale każdy SKU pobierany jest z jak najmniejszej liczby lokalizacji — lokalizacja z całą ilością ma pierwszeństwo przed dzieleniem.",
    picking_single_tote_order: "To zamówienie mieści się w jednym pojemniku — używaj pojemnika, od którego zacząłeś",
    picking_tote_not_york: "To nie york — Pick & Sort kompletuje się tylko do yorków",
    // Singles: odmowa zmiany pojemnika, bo bieżące zamówienie jest częściowo skompletowane
    picking_part_picked_title: "Najpierw dokończyć to zamówienie?",
    picking_part_picked_body: "{picked} z {required} szt. tego zamówienia jest już w {tote}. Zmiana teraz podzieli zamówienie na dwa yorki.",
    picking_part_picked_left: "Zostało do pobrania: {count}",
    picking_part_picked_keep: "Kompletuj dalej do {tote}",
    picking_part_picked_swap: "Mimo to zmień na {tote}",
    picking_part_picked_hint: "Albo zeskanuj {tote} ponownie, aby mimo to zmienić",

    // Trofea (modal rekordów i kamieni milowych)
    trophies_title: "Moje trofea",
    trophies_close: "Zamknij",
    trophies_tab_milestones: "Kamienie milowe",
    trophies_tab_records: "Rekordy",
    trophies_best_day: "Najlepszy dzień",
    trophies_lifetime: "Łącznie",
    trophies_streak: "Seria",
    trophies_section_lifetime: "Punkty łącznie",
    trophies_section_day: "Wielkie dni",
    trophies_section_golden_hour: "Złota godzina",
    trophies_section_streak: "Seria punktowania",
    trophies_streak_days: "dni",
    trophies_streak_note: "Weekendy i święta nigdy nie przerywają serii — kalendarz brytyjski lub polski, według Twojego magazynu.",
    trophies_min: "MIN",
    trophies_hr: "GODZ",
    trophies_more: "więcej",
    trophies_worldwide: "Rekordy świata",
    trophies_worldwide_sub: "wszyscy użytkownicy · wszystkie magazyny",
    trophies_personal: "Rekordy życiowe",
    trophies_personal_sub: "Twoje najlepsze serie",
    trophies_you: "Ty",
    trophies_items: "szt.",
    trophies_items_processed: "przetworzonych sztuk",
    trophies_held: "od",
    trophies_days_short: "d",
    trophies_no_record: "Brak rekordu — ustanów pierwszy",
    trophies_no_pb: "Jeszcze bez wyniku",
    trophies_to_wr: "do rekordu",
    trophies_new_record: "NOWY REKORD ŚWIATA",
    trophies_milestone_unlocked: "KAMIEŃ MILOWY",
    trophies_previous: "Poprzedni",
    trophies_lifetime_points: "PUNKTY ŁĄCZNIE",
    trophies_in_one_day: "W JEDEN DZIEŃ",
    trophies_in_one_hour: "W GODZINĘ",
    trophies_day_streak: "DNI SERII",
    trophies_dethroned: "Twój rekord został pobity",
    trophies_also_broken: "Pobite również",
    trophies_flow_scan_sheet: "Scan Sheet",
    trophies_flow_bf_scan: "BF Scan",
    trophies_flow_book_in: "Przyjęcie",
    trophies_flow_put_away: "Odkładanie",
    trophies_flow_sorter_1: "Sorter 1",
    trophies_flow_sorter_2: "Sorter 2",
    trophies_flow_pick_and_sort: "Pick & Sort",
    trophies_flow_picking_light: "Kompletacja Single",
    trophies_flow_picking_pick_and_sort: "Kompletacja P&S",
    trophies_flow_picking_large: "Kompletacja Large",
    trophies_flow_drop_shelf: "Uzupełnianie półek",
    trophies_flow_drop_forecast: "Uzupełnianie prognozy",
    trophies_flow_dispatch_light: "Wysyłka Single",
    trophies_flow_dispatch_pick_and_sort: "Wysyłka P&S",
    trophies_flow_dispatch_large: "Wysyłka Large",
    trophies_flow_wipe: "Wipe",
    trophies_dept_goods_in: "Przyjęcie towaru",
    trophies_dept_sorting: "Sortowanie",
    trophies_dept_picking: "Kompletacja",
    trophies_dept_drops: "Uzupełnianie",
    trophies_dept_dispatch: "Wysyłka",
    trophies_dept_put_away: "Odkładanie",
    trophies_dept_wipe: "Wipe",
    trophies_sub_single: "Pojedyncze",
    trophies_sub_pas: "P&S",
    trophies_sub_large: "Duże",
    trophies_sub_shelf: "Półki",
    trophies_sub_forecast: "Prognoza",
    points_tab_records: "Rekordy",
    points_records_empty: "Brak rekordów — pierwszy wynik w każdym dziale zdobywa koronę.",
    points_col_flow: "Dział",
    points_col_window: "Okno",
    points_col_holder: "Rekordzista",
    points_col_set: "Ustanowiony",
    points_col_held: "Od",
    points_user_no_records: "Brak rekordów",
    points_user_no_milestones: "Brak kamieni milowych",
    points_tab_settings: "Ustawienia",
    points_gate_title: "Okno trofeów",
    points_gate_interval_label: "Minuty między otwarciami trofeów",
    points_gate_interval_hint: "Od pierwszego skanu dnia i po każdym otwarciu (także po celebracjach).",
    points_gate_seconds_label: "Sekundy widoczności okna",
    points_gate_seconds_hint: "Odliczanie pulsuje przez ostatnie 10 sekund, potem okno zamyka się samo.",
    points_gate_saved: "Ustawienia trofeów zapisane",
    // Zamówienia ręczne (Zamówienia → Nowe zamówienie) + edycja pozycji
    new_order: "Nowe zamówienie",
    create_order_title: "Utwórz zamówienie",
    create_order: "Utwórz zamówienie",
    order_created: "Zamówienie #{order} utworzone (wstrzymane)",
    create_order_failed: "Nie udało się utworzyć zamówienia — spróbuj ponownie",
    create_order_missing_warehouse: "Wybierz magazyn",
    create_order_missing_address: "Uzupełnij nazwę odbiorcy, adres (linia 1), miasto, kod pocztowy i kraj",
    create_order_missing_billing: "Uzupełnij dane do faktury (nazwa, adres, miasto, kod pocztowy, kraj) lub zaznacz 'Dane do faktury takie jak dostawy'",
    create_order_need_lines: "Dodaj co najmniej jeden produkt",
    create_order_bad_shipping: "Koszt wysyłki musi być liczbą 0 lub większą",
    create_order_no_lines_yet: "Brak produktów — użyj Dodaj produkt.",
    create_order_hold_note: "Zamówienie zostanie utworzone jako Wstrzymane. Zmień status na Niezrealizowane, aby przekazać je do kompletacji.",
    order_number_optional: "Numer zamówienia (opcjonalnie)",
    order_number_auto_hint: "Puste = automatyczny numer MAN",
    order_notes_optional: "Uwagi (opcjonalnie)",
    billing_same_as_delivery: "Dane do faktury takie jak dostawy",
    add_product: "Dodaj produkt",
    add_product_title: "Dodaj produkt do zamówienia",
    stock_free_n: "Wolny stan: {n}",
    stock_none_free: "Brak wolnego stanu",
    stock_only_n_free: "Tylko {n} wolnych — zmniejsz ilość",
    remove_line: "Usuń",
    order_line_remove_title: "Usunąć SKU z zamówienia?",
    order_line_remove_body: "Poniższa pozycja zostanie usunięta z zamówienia {order}. Usunięcie zostanie zapisane w logach zamówienia wraz z Twoim imieniem.",
    order_line_remove_confirm: "Usuń {n} × {sku}",
    order_line_reduce_title: "Zmniejszyć ilość?",
    order_line_reduce_body: "Ilość poniższej pozycji w zamówieniu {order} zmieni się z {from} na {to}. Zmiana zostanie zapisana w logach zamówienia wraz z Twoim imieniem.",
    order_line_added: "Produkt dodany",
    order_line_removed: "Pozycja usunięta",
    order_line_updated: "Ilość zaktualizowana",

    // Stock Control › Write Off (admin-only)
    write_off: "Spisanie",
    write_off_history: "Historia",
    write_off_search_label: "Lokalizacja",
    write_off_search_placeholder: "Zeskanuj lub wpisz kod albo nazwę lokalizacji",
    write_off_unknown_location: "Nie znaleziono lokalizacji w tym magazynie",
    write_off_sellable: "Sprzedawalne",
    write_off_unsellable: "Niesprzedawalne",
    write_off_units: "szt.",
    write_off_value: "wartość",
    write_off_empty_location: "Brak zapasów w tej lokalizacji",
    write_off_select_all: "Zaznacz wszystko",
    write_off_select: "Zaznacz",
    write_off_product: "Produkt",
    write_off_units_here: "Tutaj",
    write_off_allocated: "Zarezerwowane",
    write_off_free_stock: "Wolny stan",
    write_off_unit_cost: "Koszt jedn.",
    write_off_line_value: "Wartość",
    write_off_qty: "Ilość",
    write_off_reason: "Powód",
    write_off_reason_pick: "Wybierz powód…",
    write_off_reason_damaged: "Uszkodzone",
    write_off_reason_disposed: "Zutylizowane",
    write_off_reason_sold_offline: "Sprzedane poza systemem",
    write_off_reason_pallet_sold: "Sprzedana paleta",
    write_off_reason_unsold_grey: "Niesprzedane grey",
    write_off_reason_duplicate: "Duplikat",
    write_off_reason_stock_take: "Inwentaryzacja",
    write_off_reason_other: "Inne",
    write_off_reference: "Referencja",
    write_off_reference_placeholder: "Referencja / notatka (opcjonalnie)",
    write_off_action: "Spisz",
    write_off_problem_invalid_qty: "Wpisz liczbę całkowitą 1 lub większą",
    write_off_problem_over_writable: "Tylko {max} niezarezerwowanych tutaj — zarezerwowanych sztuk nie można spisać",
    write_off_problem_over_free_stock: "Tylko {free} wolnych dla SKU — reszta jest zarezerwowana dla zamówień",
    write_off_error_no_lines: "Zaznacz co najmniej jedną pozycję",
    write_off_error_no_reason: "Wybierz powód",
    write_off_error_invalid_qty: "Wpisz poprawną ilość dla {sku}",
    write_off_error_over_writable: "{sku}: ilość przekracza niezarezerwowane sztuki tutaj",
    write_off_error_over_free_stock: "{sku}: sprzedaż poza systemem nie może przekroczyć wolnego stanu",
    write_off_be_not_at_location: "{sku} nie znajduje się już w tej lokalizacji",
    write_off_be_exceeds_writable: "{sku}: obecnie tylko {writable} niezarezerwowanych tutaj",
    write_off_be_exceeds_free_stock: "{sku}: obecnie tylko {free} wolnych dla SKU",
    write_off_be_stock_moved: "{sku}: stan zmienił się podczas potwierdzania — nic nie spisano, sprawdź dane i spróbuj ponownie",
    write_off_confirm_title: "Spisać zapasy?",
    write_off_confirm_body: "Te sztuki zostaną usunięte z zapasów w lokalizacji {location}. Tej operacji nie można cofnąć.",
    write_off_confirm_reserved_warning: "Przekracza wolny stan — zamówienie na to SKU zostanie zablokowane przez brak zapasów",
    write_off_confirm_action: "Potwierdź spisanie",
    write_off_done: "Spisano {units} szt. ({value})",
    write_off_filter_from: "Od",
    write_off_filter_to: "Do",
    write_off_location: "Lokalizacja",
    write_off_sku: "SKU",
    write_off_date: "Data",
    write_off_who: "Kto",
    write_off_export: "Eksport XLSX",
    write_off_history_empty: "Brak pasujących spisań",
    write_off_paging: "{from}–{to} z {total}",
    write_off_prev: "Poprzednia",
    write_off_next: "Następna",
    // Wg SKU (2026-10-19): szukaj SKU/kodu, jeden wiersz na lokalizację.
    write_off_mode: "Szukaj wg",
    write_off_mode_location: "Lokalizacja",
    write_off_mode_sku: "SKU",
    write_off_search_sku_label: "SKU lub kod kreskowy",
    write_off_search_sku_placeholder: "Zeskanuj lub wpisz SKU albo kod kreskowy produktu",
    write_off_unknown_sku: "Żaden produkt ani zapas w tym magazynie nie pasuje do tego SKU lub kodu",
    write_off_empty_sku: "Brak zapasów tego SKU w żadnej lokalizacji magazynu {warehouse}",
    write_off_elsewhere: "Stan w innych magazynach: {list} — wybierz ten magazyn obok wyszukiwania, aby spisać tam",
    write_off_warehouse: "Magazyn",
    write_off_free_stock_hint: "Sztuki SKU nieobiecane żadnemu zamówieniu — maksimum do sprzedaży poza systemem",
    write_off_across_locations: "w {count} lokalizacjach",
    write_off_filter: "Pokaż",
    write_off_filter_on_hand: "Na stanie",
    write_off_filter_on_hand_hint: "Wiersze z niezarezerwowanymi sztukami, które można odpisać",
    write_off_filter_allocated: "Przydzielone",
    write_off_filter_allocated_hint: "Wiersze ze sztukami wskazanymi przez otwarty przydział — tych sztuk nie można odpisać",
    write_off_filter_reserved: "Zarezerwowane",
    write_off_filter_reserved_hint: "Wiersze z większą liczbą nieprzydzielonych sztuk niż wolny stan SKU — odpis ponad wolny stan zabiera sztuki obiecane zamówieniom",
    write_off_filter_unsellable: "Niesprzedawalne",
    write_off_filter_unsellable_hint: "Wiersze w lokalizacji niesprzedawalnej",
    write_off_filter_clear: "Wyczyść",
    write_off_filter_empty: "Żaden wiersz nie pasuje do filtra — wyczyść go, aby zobaczyć wszystko",
    write_off_put_here: "Odłożono tu",
    write_off_put_here_hint: "Kiedy te sztuki trafiły do tej lokalizacji — od najstarszego do najnowszego aktywnego wiersza stanu. Odpis nadal zdejmuje najpierw najstarsze sztuki.",
    write_off_put_here_from: "Odłożono od",
    write_off_put_here_to: "Odłożono do",
    write_off_put_here_match: "{rows} wierszy · {units} szt. w zakresie",
    write_off_put_here_in_range: "{units} w zakresie",
    write_off_total_over_free_stock: "Zaznaczona suma {total} przekracza wolny stan {free} — reszta jest zarezerwowana dla zamówień",
    write_off_error_total_over_free_stock: "Sprzedaż poza systemem nie może przekroczyć wolnego stanu ({free}) w zaznaczonych lokalizacjach",
    write_off_confirm_body_sku: "Te sztuki {sku} zostaną usunięte z zapasów w {count} lokalizacjach. Tej operacji nie można cofnąć.",
    write_off_be_not_at_location_sku: "{sku} nie znajduje się już w {location}",
    write_off_be_exceeds_writable_sku: "{location}: obecnie tylko {writable} niezarezerwowanych",
    write_off_be_stock_moved_sku: "{location}: stan zmienił się podczas potwierdzania — nic nie spisano, sprawdź dane i spróbuj ponownie",
    warehouse_tile_write_off_desc: "Usuń zapasy z lokalizacji albo SKU ze wszystkich jego lokalizacji z podaniem powodu — uszkodzone, zutylizowane, sprzedane poza systemem, inwentaryzacja — i przeglądaj historię spisań",
    warehouse_tile_write_off_short: "Usuń zapasy z podaniem powodu; historia",
    // ---- Admin › Magazyn › Raporty ----
    reports_title: "Raporty",
    warehouse_tile_reports_desc: "Wybierz eksport i pobierz go",
    reports_hint: "Wybierz magazyn i raport, a następnie Pobierz. Każdy raport jest tworzony z bieżących danych w chwili pobrania.",
    reports_none: "Nie masz jeszcze dostępu do żadnych raportów.",
    reports_load_failed: "Nie udało się wczytać raportów — spróbuj ponownie",
    reports_pick_one: "Wybierz raport",
    reports_download: "Pobierz",
    reports_downloading: "Tworzenie…",
    reports_download_failed: "Nie udało się pobrać raportu",
    reports_from: "Od",
    reports_to: "Do",
    reports_sort_day: "Dzień sortowania",
    reports_batch: "Partia",
    reports_batch_n: "Partia {batch}",
    reports_batches_loading: "Ładowanie…",
    reports_batches_none: "Brak partii w tym dniu",
    reports_batches_load_failed: "Nie udało się wczytać partii — spróbuj ponownie",
    reports_trailer: "Naczepa",
    reports_category_inventory: "Zapasy",
    report_inventory_stock_title: "Zapasy - stan wg SKU",
    report_inventory_stock_desc: "Jeden wiersz na SKU: na stanie, przydzielone, zarezerwowane, niesprzedawalne, na palecie, koszt jednostkowy i całkowity.",
    report_inventory_detail_title: "Zapasy - szczegóły",
    report_inventory_detail_desc: "Każda bieżąca pozycja zapasu z lokalizacją, pojemnikiem, PO, datą przyjęcia i kosztem (eksport szczegółów na koniec miesiąca).",
    report_inventory_locations_title: "Zapasy - wg lokalizacji",
    report_inventory_locations_desc: "Dostępne zapasy zsumowane wg SKU i lokalizacji.",
    report_mcl_po_export_title: "MCL PO Export",
    report_mcl_po_export_desc: "Plik CSV zamówienia zakupu MCL dla jednej naczepy: jeden wiersz na SKU palety na stanie w MCL_TRAILER_1, MCL_TRAILER_2 lub MCL_TRAILER_3 (Newport), ilość 1 każda. Zapisywany jako MCL_T1_RRRRMMDD, MCL_T2_RRRRMMDD lub MCL_T3_RRRRMMDD.",
    report_wipe_logs_title: "Logi Wipe",
    report_wipe_logs_desc: "Każdy kod kreskowy zeskanowany na stanowisku Wipe w ostatnich 60 dniach, najnowsze na górze: kiedy, kto, kod, wynik (znaleziono, trasa kartonu, nie znaleziono), SKU, ASIN i koszt.",
    reports_category_orders: "Zamówienia",
    report_orders_dispatched_title: "Zamówienia wysłane",
    report_orders_dispatched_desc: "Jeden wiersz na paczkę wysłaną w zakresie dat: numer zamówienia, kanał, data i godzina złożenia i wysyłki, kto wysłał, stanowisko, kurier, usługa, numer śledzenia, rozmiar i waga kartonu, sztuki, adres dostawy, wartość zamówienia i status śledzenia. Zamówienia skonsolidowane mają numer CON, a obok numery zamówień oryginalnych.",
    report_mcl_unfulfilled_orders_title: "MCL - zamówienia niezrealizowane",
    report_mcl_unfulfilled_orders_desc: "Plik CSV importu zamówień MCL: jeden wiersz na linię SKU każdego zamówienia w magazynie, które wciąż czeka na wysyłkę (nie zrealizowane, zwrócone, anulowane ani wstrzymane), z numerem zamówienia, tytułem produktu, SKU, ilością, adresem dostawy, e-mailem i telefonem. Zamówienie z kilkoma SKU to kilka wierszy z tym samym numerem. Uruchom dla magazynu MCL. Zapisywany jako MCL_Orders_RRRRMMDD.",
    reports_category_presort: "Presort",
    report_presort_stock_title: "Plik zapasów presort",
    report_presort_stock_desc: "Każde SKU ze strony szczegółów zapasów dla magazynu (każdy status, sprzedawalne lub nie, łącznie z przydzielonymi), jeden raz, z wagą jednostkową.",
    report_presort_sales_title: "Plik sprzedaży presort",
    report_presort_sales_desc: "Jeden wiersz na pozycję zamówienia złożonego w zakresie dat: SKU, numer zamówienia, sztuki, typ dostawy i waga jednostkowa. Zamówienia skonsolidowane mają numer CON, a obok numery zamówień oryginalnych. Anulowane zamówienia są pomijane.",
    reports_category_bargainfox: "BargainFox",
    report_bf_price_file_title: "Plik cen BargainFox",
    report_bf_price_file_desc: "Jeden wiersz na SKU: stan, sprzedaż BargainFox (7 / 30 / 90 dni), pierwsze przyjęcie, ostatnie przyjęcie, ostatnia sprzedaż i dni bez sprzedaży - plik wejściowy Price Updatera (stan + sprzedaż). Wyprzedane SKU ze sprzedażą w ostatnich 7 dniach są uwzględnione.",
    reports_category_sorter: "Sorter",
    report_sorter_missing_items_title: "Brakujące pozycje sortera",
    report_sorter_missing_items_desc: "Każda pozycja z dnia sortowania i partii, której Sorter 1 lub Sorter 2 nigdy nie zeskanował: zamówienie, SKU, który sorter ją pominął, linia, zsyp i miejsce Sortera 2.",
    reports_nightly_title: "Nocne szczegóły zapasów",
    reports_nightly_hint: "Tworzone co noc o północy czasu brytyjskiego dla każdego magazynu z zapasem: eksport szczegółów zapasów na koniec dnia. Przechowywane 35 dni; pliki z końca miesiąca są przechowywane na stałe.",
    reports_nightly_none: "Brak jeszcze nocnych plików dla {warehouse}.",
    reports_nightly_load_failed: "Nie udało się wczytać nocnych plików — spróbuj ponownie",
    reports_nightly_col_stock_at: "Stan na",
    reports_nightly_col_lines: "Wiersze",
    reports_nightly_col_size: "Rozmiar",
    reports_nightly_col_built: "Utworzono",
    reports_nightly_col_status: "Status",
    reports_nightly_end_of: "Koniec dnia {date}",
    reports_nightly_month_end: "Koniec miesiąca",
    reports_nightly_ready: "Gotowy",
    reports_nightly_building: "W trakcie",
    reports_nightly_failed: "Błąd",
    reports_nightly_downloading: "Pobieranie…",
    reports_queued_title: "Eksporty w kolejce",
    reports_queued_hint: "Pliki zamówione z tabel Wipe i Produkty ręczne (Zleć eksport Jobalots). Kolumna tytułów wielojęzycznych jest wypełniana z pamięci tłumaczeń i AI, dlatego każdy plik powstaje w tle i pojawia się tutaj, gdy jest gotowy. Przechowywane 7 dni.",
    reports_queued_none: "Brak eksportów w kolejce z ostatnich 7 dni.",
    reports_queued_load_failed: "Nie udało się wczytać eksportów w kolejce — spróbuj ponownie",
    reports_queued_col_report: "Eksport",
    reports_queued_col_warehouse: "Magazyn",
    reports_queued_col_requested_by: "Zlecił(a)",
    reports_queued_col_requested: "Zlecono",
    reports_queued_all_warehouses: "Wszystkie",
    reports_queued_status_queued: "W kolejce",
    reports_queued_report_jobalots_wipe: "Import Jobalots — Wipe",
    reports_queued_report_jobalots_manual_products: "Import Jobalots — Produkty ręczne",
    reports_queued_untranslated: "{count} tytułów nie udało się przetłumaczyć — komórki pozostawiono puste",

    // Goods In > Pallets (desktop + printer): build a sale pallet label
    pallets: "Palety",
    pallets_hint: "Wybierz kolor, typ i rozmiar, wskaż dostawcę i dodaj ewentualne uwagi. Wydrukuje się kolejna etykieta dla tego magazynu, a jej lokalizacja i produkt zostaną utworzone, aby SKU z pojemnika można było odłożyć na paletę.",
    pallets_step_colour: "Kolor",
    pallets_step_type: "Typ",
    pallets_step_size: "Rozmiar",
    pallets_step_supplier: "Dostawca",
    pallets_step_notes: "Uwagi",
    pallets_supplier: "Dostawca",
    pallets_supplier_hint: "Lista zawiera wszystkich aktywnych dostawców; na początku wybrany jest {supplier}.",
    pallets_notes: "Uwagi",
    pallets_notes_placeholder: "Opcjonalnie — wszystko, co warto wiedzieć o tej palecie",
    pallets_notes_hint: "Opcjonalnie. Widoczne w Admin › Magazyn › Utworzone palety oraz w eksporcie.",
    pallets_notes_none: "Brak",
    pallets_step_hazards: "Ostrzeżenie o zawartości",
    pallets_hazards: "Ostrzeżenie",
    pallets_hazard_liquids: "Płyny",
    pallets_hazard_glass: "Szkło",
    pallets_hazards_hint: "Opcjonalnie. Zaznacz, co zawiera paleta; każda pozycja drukuje się jako trójkąt ostrzegawczy na etykiecie. Nie jest zapisywane ani eksportowane.",
    pallets_hazards_none: "Brak",
    pallets_err_supplier_required: "Wybierz dostawcę",
    pallets_colour_black_hint: "Towar bez manifestu",
    pallets_colour_dsd: "Nośniki danych",
    pallets_colour_dsd_hint: "Magazyn przed wymazaniem – nigdy nie wystawiana",
    pallets_admin_dsd_hint: "Paleta magazynowa nośników danych: od utworzenia ma status Wystawiona i nie można go zmienić",
    pallets_size_fixed: "Stały rozmiar",
    pallets_size_height: "Według wysokości",
    pallets_height_placeholder: "np. 180",
    pallets_height_unit: "cm",
    pallets_summary: "Etykieta do druku",
    pallets_print: "Drukuj etykietę",
    pallets_printing: "Drukowanie…",
    pallets_created_toast: "{sku} utworzono i wydrukowano",
    pallets_print_failed_created: "{sku} utworzono, ale etykieta się nie wydrukowała — użyj Drukuj ponownie",
    pallets_reprint: "Drukuj ponownie",
    pallets_new: "Nowa paleta",
    pallets_recent: "Ostatnie etykiety",
    pallets_recent_none: "Nie wydrukowano jeszcze żadnej palety",
    pallets_no_printer: "Brak drukarki",
    pallets_printer_connected: "Drukarka gotowa",
    pallets_printer: "Drukarka",
    pallets_put_away_hint: "Następnie: na skanerze otwórz Odkładanie, zeskanuj zamknięty pojemnik, a potem tę etykietę, aby przenieść SKU na paletę.",
    pallets_colour: "Kolor",
    pallets_type: "Typ",
    pallets_size: "Rozmiar",
    pallets_not_chosen: "Nie wybrano",
    pallets_err_colour_invalid: "Wybierz kolor",
    pallets_err_type_required: "Wybierz typ palety",
    pallets_err_size_required: "Wybierz rozmiar lub wpisz wysokość",
    pallets_err_size_invalid: "Ten rozmiar nie jest już skonfigurowany — odśwież stronę",
    pallets_err_height_invalid: "Wpisz wysokość od 1 do 300 cm",
    pallets_err_height_not_allowed: "Wpisywanie wysokości jest wyłączone dla tego magazynu",
    pallets_err_location_exists: "Lokalizacja {sku} już istnieje — zwiększ numer początkowy w Ustawienia › Goods In › Palety",
    pallets_err_product_exists: "Produkt {sku} już istnieje — zwiększ numer początkowy w Ustawienia › Goods In › Palety",
    pallets_err_seq_taken: "Kolizja numeru z innym stanowiskiem — spróbuj ponownie",

    // Admin > Warehouse > Pallets Created
    pallets_admin_title: "Utworzone palety",
    pallets_admin_hint: "Każda etykieta palety sprzedażowej wydrukowana w Goods In › Palety, per magazyn: kto wydrukował, kiedy, rozmiar, gdzie stoi, co na nią odłożono i czy jest już wystawiona.",
    warehouse_tile_pallets_desc: "Palety sprzedażowe — etykiety, zawartość",
    pallets_admin_tile_total: "Palety",
    pallets_admin_tile_not_listed: "Gotowe do wystawienia",
    pallets_admin_tile_listed: "Wystawione",
    pallets_admin_tile_needs_resolving: "Do wyjaśnienia",
    pallets_admin_tile_needs_resolving_hint: "Palety z błędem, mieszanym dostawcą, innym dostawcą, puste oraz ze zduplikowanym SKU",
    pallets_admin_tile_today: "Utworzone dziś",
    pallets_admin_col_sku: "SKU palety",
    pallets_admin_col_colour: "Kolor",
    pallets_admin_col_type: "Typ",
    pallets_admin_col_size: "Rozmiar",
    pallets_admin_col_supplier: "Dostawca",
    pallets_admin_col_location: "Lokalizacja",
    pallets_admin_col_notes: "Uwagi",
    pallets_admin_col_by: "Wydrukował(a)",
    pallets_admin_col_date: "Data utworzenia",
    pallets_admin_col_units: "Sztuki",
    pallets_admin_col_skus: "SKU",
    pallets_admin_col_value: "Wartość kosztowa",
    pallets_admin_col_rrp: "Wartość RRP",
    pallets_admin_col_status: "Status",
    pallets_status_not_listed: "Gotowa do wystawienia",
    pallets_status_listed: "Wystawiona",
    pallets_status_error: "Błąd - do wyjaśnienia",
    pallets_status_mixed_supplier: "Mieszany dostawca",
    pallets_status_different_supplier: "Inny dostawca",
    pallets_status_empty: "Pusta",
    pallets_status_duplicate_sku: "Zduplikowany SKU",
    pallets_status_needs_resolving: "Do wyjaśnienia",
    pallets_status_voided: "Anulowana",
    pallets_status_listing: "W wystawianiu",
    pallets_status_listing_mine: "Moje wystawianie",
    pallets_admin_tile_listing: "W wystawianiu",
    pallets_admin_tile_listing_hint: "Palety, które ktoś właśnie wystawia — każda partia jest zablokowana dla osoby, która ją wystawia",
    pallets_admin_col_listed_by: "Wystawił(a)",
    pallets_admin_listing_by: "W partii wystawiania: {name}",
    pallets_admin_listing_locked: "W partii wystawiania: {name} — zmienić może tylko ta osoba lub Admin",
    pallets_admin_listing_locked_toast: "{sku} jest w partii wystawiania: {name}",
    pallets_admin_listing_not_ready: "{sku} musi być „Gotowa do wystawienia”, zanim trafi do wystawiania",
    pallets_admin_bulk_not_ready: "Pominięto {n} palet — do wystawiania trafiają tylko palety „Gotowe do wystawienia”",
    pallets_admin_supplier_mismatch: "Produkty na tej palecie pochodzą od: {suppliers} — to nie dostawca z etykiety. Ustawia Portal; znika, gdy stan zostanie poprawiony lub dostawca zostanie tu zmieniony",
    pallets_admin_empty_hint: "Na tę paletę nic jeszcze nie odłożono. Ustawia Portal; wybierz „Gotowa do wystawienia”, aby wyczyścić ręcznie",
    pallets_admin_duplicate_hint: "SKU z tej palety znajduje się także na innej palecie (SKU w formacie ASIN i kończące się na /1 nie są sprawdzane). Ustawia Portal; znika, gdy SKU jest tylko na jednej palecie, lub wybierz status ręcznie, aby to odrzucić",
    pallets_admin_duplicate_sku_line: "{sku} jest także na: {pallets}",
    pallets_admin_duplicate_also_on: "Także na: {pallets}",
    pallets_admin_change_supplier: "Zmień dostawcę",
    pallets_admin_change_supplier_hint: "Kliknij, aby zmienić dostawcę tej palety",
    pallets_admin_supplier_on_label: "Na etykiecie: {supplier}",
    pallets_admin_supplier_on_pallet: "Odłożone na paletę: {suppliers}",
    pallets_admin_supplier_on_pallet_none: "Na paletę nic jeszcze nie odłożono",
    pallets_admin_supplier_saved: "{sku}: dostawca zmieniony na {supplier}",
    pallets_admin_edit_notes: "Edytuj uwagę",
    pallets_admin_notes_placeholder: "Dodaj uwagę…",
    pallets_admin_notes_edited_by: "Ostatnio edytował(a): {name} · {when}",
    pallets_admin_notes_saved: "{sku}: uwaga zapisana",
    pallets_admin_stock_export: "Eksport stanów",
    pallets_admin_stock_export_hint: "Palety z tej listy wraz ze wszystkimi SKU na nich: jeden wiersz na paletę, potem jeden wiersz na produkt",
    pallets_admin_select: "Zaznacz",
    pallets_admin_select_all: "Zaznacz wszystkie palety na liście",
    pallets_admin_bulk_saved: "Oznaczono {n} palet: {status}",
    pallets_admin_bulk_skipped: "{n} palet nie zmieniono (w cudzej partii wystawiania, nie gotowe do wystawienia, anulowane lub usunięte) — lista odświeżona",
    pallets_admin_search_hint: "Szukaj SKU palety, dostawcy lub osoby",
    pallets_admin_none: "Brak palet dla tego magazynu",
    pallets_admin_export: "Eksport XLSX",
    pallets_admin_reprinted: "Etykieta wysłana do drukarki",
    pallets_admin_void: "Anuluj",
    pallets_admin_void_confirm: "Anulować {sku}? Numer nie zostanie użyty ponownie; lokalizacja i produkt zostaną usunięte.",
    pallets_admin_voided: "{sku} anulowano",
    pallets_admin_void_has_stock: "{sku} ma {units} szt. — przenieś je przed anulowaniem",
    pallets_admin_status_saved: "{sku} oznaczono: {status}",
    pallets_admin_from: "Od",
    pallets_admin_to: "Do",
    pallets_admin_col_weight: "Waga (kg)",
    pallets_admin_weight_hint: "Wyliczana z produktów na palecie: liczba sztuk × waga każdego produktu",
    pallets_admin_weight_partial: "{n} szt. na tej palecie nie ma wagi produktu, więc rzeczywista waga jest większa",
    pallets_admin_weight_over_limit: "{weight} kg przekracza limit Palletways dla {type} ({limit} kg) — tę paletę być może trzeba będzie nadać jako następny, większy rozmiar",
    pallets_admin_locked: "Sztuki, SKU, wartości i waga zostały zablokowane w chwili wystawienia tej palety ({date}) — nie zmieniają się już wraz ze stanem w jej lokalizacji",
    pallets_admin_weight_volumetric: "Waga objętościowa dla tego magazynu: {formula} g",

    // Settings > Goods In > Pallets
    pallets_settings: "Palety",
    pallets_settings_hint: "Jak Goods In › Palety tworzy etykietę palety sprzedażowej dla każdego magazynu. Etykiety mają format KOD-KOLOR+numer (PD-RED1, NP-YELLOW3); każda kombinacja magazynu, koloru i numeru jest użyta raz. Wydruk etykiety tworzy lokalizację i produkt o tym SKU.",
    pallets_settings_types: "Typy palet",
    pallets_settings_types_hint: "Opcjonalne. Jeśli ustawione, operator musi wybrać jeden, np. Mix, Zabawki, Dom. Bez typów krok jest pomijany.",
    pallets_settings_types_none: "Brak typów — krok typu jest pomijany",
    pallets_settings_sizes: "Stałe rozmiary",
    pallets_settings_sizes_hint: "Oferowane rozmiary, np. Ćwierć, Pół, Pełna.",
    pallets_settings_sizes_none: "Brak stałych rozmiarów",
    pallets_settings_allow_height: "Zezwól na rozmiar według wysokości (cm)",
    pallets_settings_hazard_flags: "Ostrzeżenia o zawartości",
    pallets_settings_hazard_flags_hint: "Dodaje krok w Goods In › Palety, między Dostawcą a Uwagami, z pytaniem, czy paleta zawiera płyny lub szkło. Każda zaznaczona pozycja drukuje się jako trójkąt ostrzegawczy na etykiecie. Nic nie jest zapisywane na palecie ani eksportowane.",
    pallets_settings_hazard_flags_on: "Pytaj o płyny / szkło i drukuj trójkąty ostrzegawcze na etykiecie",
    pallets_settings_palletways: "Typ Palletways",
    pallets_settings_palletways_hint: "Typ palety Palletways dla każdego rozmiaru (QP ćwierć, HP pół, LP lekka, FP pełna, MQP mini ćwierć; OS ponadwymiarowa — nadawana jako 2 palety na 1 podniesienie z 1 etykietą, w cenie dwóch LP, bez windy). Jest kopiowany na paletę przy wydruku etykiety; zmiana tutaj nie zmienia już istniejących palet.",
    pallets_settings_palletways_none: "Nie ustawiono",
    pallets_settings_next_seq: "Następny numer etykiety",
    pallets_settings_next_seq_hint: "Od jakiego numeru zaczyna się numeracja dla każdego koloru — ustaw przy starcie, aby nowe etykiety kontynuowały po istniejących paletach. Wydane numery nigdy się nie powtarzają, niezależnie od wpisu.",
    pallets_settings_add: "Dodaj",
    pallets_settings_remove: "Usuń {name}",
    pallets_settings_name_placeholder: "Nazwa",
    pallets_settings_saved: "Zapisano",
    pallets_settings_last_printed: "ostatni {n}",
    pallets_settings_seq_too_low: "{colour}: następny numer musi być większy niż {last}, ostatni wydrukowany",
    pallets_settings_volumetric: "Waga objętościowa",
    pallets_settings_volumetric_hint: "Magazyny rozliczane według objętości, a nie masy (Polska). Po włączeniu wagą palety jest jej podstawa × wysokość ÷ dzielnik, w kg, zamiast wagi tego, co na niej leży. Wysokość pochodzi z palety, gdy jest wymiarowana wysokością, w przeciwnym razie z wysokości ustawionej poniżej dla jej stałego rozmiaru.",
    pallets_settings_volumetric_on: "Używaj wagi objętościowej dla palet",
    pallets_settings_volumetric_length_cm: "Długość (cm)",
    pallets_settings_volumetric_width_cm: "Szerokość (cm)",
    pallets_settings_volumetric_divisor: "Dzielnik",
    pallets_settings_volumetric_formula: "Waga (g) = ({l} × {w} × wysokość cm ÷ {d}) × 1000",
    pallets_settings_volumetric_invalid: "Długość, szerokość i dzielnik muszą być liczbami większymi od 0",
    pallets_settings_size_height: "Wysokość dla rozmiaru (cm)",
    pallets_settings_size_height_hint: "Wysokość, której używa obliczenie objętościowe dla palety każdego stałego rozmiaru. Rozmiar bez wysokości wraca do wagi tego, co leży na palecie.",
    pallets_settings_size_height_invalid: "{name}: wysokość musi mieścić się między 1 a 300 cm",
    inventory_col_on_pallet: "Na palecie",
    inventory_on_pallet_hint: "Sztuki w lokalizacjach palet sprzedażowych — sprzedawalne jako paleta, nigdy nie pobierane ani nie wysyłane do kanałów jako to SKU",
    tote_status_retired: "Ten pojemnik palety został już odłożony — nie można go użyć ponownie",

    // ---- Dispatch desk session (desk saved on the account) ----
    desk_order_claimed: "{name} pakuje to zamówienie na stanowisku {desk} od {time}. Poproś kierownika zmiany o jego zwolnienie.",
    desk_order_claimed_no_desk: "{name} pakuje to zamówienie od {time}. Poproś kierownika zmiany o jego zwolnienie.",
    desk_claim_unknown_packer: "Inny pakujący",
    desk_claim_lost: "Kierownik zmiany zwolnił to zamówienie",
    desk_pack_state_changed_elsewhere: "To zamówienie zostało zmienione na innym ekranie — wyświetlono najnowszy stan.",
    desk_order_released_not_dispatch: "Zamówienie otwarte na Twoim stanowisku ma teraz status {status} i zostało z niego zdjęte.",
    desk_order_released_generic: "Zamówienie otwarte na Twoim stanowisku zostało z niego zdjęte.",
    desk_order_already_open: "Masz już otwarte inne zamówienie — zostało przywrócone.",
    reset_order: "Zresetuj zamówienie",
    reset_order_confirm_one: "Usunąć pudełko i wszystkie skany z tego zamówienia? Rozpakuj pudełko, zanim przejdziesz dalej.",
    reset_order_confirm: "Usunąć wszystkie pudełka ({count}) i wszystkie skany z tego zamówienia? Rozpakuj pudełka, zanim przejdziesz dalej.",
    packing_now_title: "Teraz pakowane",
    packing_now_hint: "Zamówienia przetrzymywane przez pakujących na stanowiskach. Zwolnienie zamówienia pozwala każdemu otworzyć je z pojemnika; spakowane już pudełka i skany zostają zachowane.",
    packing_now_empty: "Nikt teraz nie pakuje zamówienia.",
    packing_now_col_packer: "Pakujący",
    packing_now_col_desk: "Stanowisko",
    packing_now_col_order: "Zamówienie",
    packing_now_col_since: "Od",
    packing_now_col_units: "Sztuki",
    packing_now_col_boxes: "Pudełka",
    packing_now_release: "Zwolnij",
    packing_now_release_title: "Zwolnij zamówienie",
    packing_now_release_confirm: "Zwolnić zamówienie #{order} od {name}? Każdy będzie mógł je wtedy otworzyć z pojemnika, razem z już spakowanymi pudełkami i skanami.",
    packing_now_released: "Zamówienie zwolnione",
    packing_now_release_failed: "Nie udało się zwolnić zamówienia",
    order_being_packed: "Pakuje: {name}, stanowisko {desk}, od {time}",
    order_being_packed_no_desk: "Pakuje: {name}, od {time}",
    // Zwroty (portal zwrotów BargainFox: Admin › Zwroty, panel w Zamówieniach, Ustawienia › Zwroty)
    rt_title: "Zwroty",
    tile_returns_desc: "Zwroty BargainFox: weryfikacja, etykiety, kontrola i zwroty pieniędzy",
    rt_intro: "Zgłoszenia ze strony zwrotów BargainFox. Zatwierdź lub odrzuć te czekające na weryfikację, zamów etykiety i sprawdź zwroty, gdy dotrą.",
    rt_tab_review: "Weryfikacja",
    rt_tab_label: "Etykieta do zamówienia",
    rt_tab_awaiting: "Czeka na zwrot",
    rt_tab_transit: "W drodze",
    rt_tab_received: "Do sprawdzenia",
    rt_tab_done: "Zakończone",
    rt_tab_all: "Wszystkie",
    rt_empty_review: "Nic nie czeka na weryfikację.",
    rt_empty_label: "Brak etykiet do zamówienia.",
    rt_empty_awaiting: "Brak zwrotów czekających na nadanie.",
    rt_empty_transit: "Brak zwrotów w drodze.",
    rt_empty_received: "Nic do sprawdzenia.",
    rt_empty_done: "Brak zakończonych zgłoszeń.",
    rt_empty_all: "Brak zgłoszeń zwrotu.",
    rt_empty_search: "Brak zgłoszeń pasujących do wyszukiwania.",
    // Admin › Zwroty › Błędy (co nie zadziałało w portalu zwrotów; ReturnErrors.tsx)
    rt_tab_errors: "Błędy",
    rt_err_badge_title: "Błędy jeszcze nieprzejrzane (ostatnie 7 dni)",
    rt_err_load_failed: "Nie udało się wczytać błędów. Spróbuj ponownie.",
    rt_err_area: "Obszar",
    rt_err_area_all: "Wszystkie obszary",
    rt_err_period: "Okres",
    rt_err_period_1: "Ostatnie 24 godziny",
    rt_err_period_7: "Ostatnie 7 dni",
    rt_err_period_30: "Ostatnie 30 dni",
    rt_err_in_1: "Błędów: {n} w ciągu ostatnich 24 godzin",
    rt_err_in_7: "Błędów: {n} w ciągu ostatnich 7 dni",
    rt_err_in_30: "Błędów: {n} w ciągu ostatnich 30 dni",
    rt_err_env: "Tylko błędy ze środowiska {env}.",
    rt_err_alerts_to: "Powiadomienia o błędach trafiają na {email}, najwyżej jedno na godzinę.",
    rt_err_alerts_change: "Zmień w Ustawienia › Zwroty",
    rt_err_no_alerts: "Nie ustawiono adresu do powiadomień o błędach.",
    rt_err_alerts_add: "Dodaj go w Ustawienia › Zwroty",
    rt_err_col_time: "Kiedy",
    rt_err_col_message: "Co się stało",
    rt_err_action: "Do zrobienia: {action}",
    rt_err_repeats_title: "Wystąpiło {n} razy",
    rt_err_show_details: "Pokaż szczegóły",
    rt_err_hide_details: "Ukryj szczegóły",
    rt_err_empty: "Brak błędów w tym okresie.",
    rt_err_new_in_1: "Nowych błędów: {n} w ciągu ostatnich 24 godzin",
    rt_err_new_in_7: "Nowych błędów: {n} w ciągu ostatnich 7 dni",
    rt_err_new_in_30: "Nowych błędów: {n} w ciągu ostatnich 30 dni",
    rt_err_show_seen: "Pokaż przejrzane",
    rt_err_mark_seen: "Przejrzane",
    rt_err_mark_seen_title: "Oznacz jako przejrzane: zniknie z listy nowych błędów",
    rt_err_mark_unseen: "Oznacz jako nowe",
    rt_err_mark_all_seen: "Oznacz wszystkie jako przejrzane",
    rt_err_mark_all_title: "Oznacz jako przejrzane wszystkie nowe błędy z wybranego okresu i obszaru",
    rt_err_mark_failed: "Nie udało się oznaczyć błędów. Spróbuj ponownie.",
    rt_err_seen_by: "Przejrzane: {name} · {time}",
    rt_err_seen_at: "Przejrzane · {time}",
    rt_err_empty_new: "Brak nowych błędów w tym okresie.",
    rt_err_empty_seen_hidden: "Błędy oznaczone jako przejrzane są ukryte.",
    rt_err_area_site: "Strona dla klientów",
    rt_err_area_api: "API zwrotów",
    rt_err_area_labels: "Etykiety",
    rt_err_area_payments: "Płatności",
    rt_err_area_tracking: "Śledzenie przesyłek",
    rt_err_area_emails: "E-maile do klientów",
    rt_err_area_exchange: "Wymiany",
    rt_err_area_contact: "Formularz kontaktowy",
    rt_err_area_staff: "Działania personelu",
    rt_err_area_jobs: "Zadania w tle",
    rt_err_area_config: "Konfiguracja",
    rt_err_detail_kind: "Rodzaj",
    rt_err_detail_code: "Kod",
    rt_err_detail_status: "Status HTTP",
    rt_err_detail_api_path: "Ścieżka API",
    rt_err_detail_page: "Strona",
    rt_err_detail_build: "Wersja",
    rt_err_detail_instance: "Serwer",
    rt_err_detail_user_agent: "Przeglądarka",
    rt_err_detail_stack: "Ślad stosu",
    rt_status_review: "Weryfikacja",
    rt_status_label_pending: "Etykieta do zamówienia",
    rt_status_awaiting_return: "Czeka na zwrot",
    rt_status_in_transit: "W drodze",
    rt_status_received: "Odebrany",
    rt_status_refund_pending: "Oczekuje na zwrot pieniędzy",
    rt_status_replacement_sent: "Wysłano zamiennik",
    rt_status_exchange_booked: "Wymiana zarezerwowana",
    rt_status_completed: "Zakończony",
    rt_status_cancelled: "Anulowany",
    rt_problem_return: "Zwrot",
    rt_problem_damaged: "Uszkodzony lub wadliwy",
    rt_problem_missing: "Brakujący produkt",
    rt_problem_wrong: "Zły produkt",
    rt_problem_notarrived: "Nie dotarło",
    rt_res_refund: "Zwrot pieniędzy",
    rt_res_replacement: "Zamiennik",
    rt_res_exchange: "Wymiana",
    rt_search_placeholder: "Numer zgłoszenia, zamówienia, przesyłki lub e-mail",
    rt_from: "Od",
    rt_to: "Do",
    rt_clear: "Wyczyść",
    rt_refresh: "Odśwież",
    rt_col_request: "Zgłoszenie",
    rt_col_customer: "Klient",
    rt_col_items: "Produkty",
    rt_col_outcome: "Problem",
    rt_col_refund: "Zwrot",
    rt_col_status: "Status",
    rt_units: "Sztuk: {n}",
    rt_more_lines: "+{n} więcej",
    rt_has_photos: "Zdjęcia",
    rt_showing: "{from}-{to} z {total}",
    rt_page_of: "Strona {page} z {pages}",
    rt_prev: "Poprzednia",
    rt_next: "Następna",
    rt_load_failed: "Nie udało się wczytać zwrotów. Spróbuj ponownie.",
    rt_not_found: "Nie ma takiego zgłoszenia zwrotu.",
    rt_started: "Utworzono {when} · {channel}",
    rt_flag_claim: "Przewoźnik: doręczono",
    rt_flag_shortfall: "Brak kredytu: {short}",
    rt_exchange_shortfall: "Przyjęte produkty (kredyt {credit}) nie pokrywają już nowych produktów ({basket}): brakuje {short}. Niczego nie pobrano - zdecyduj ręcznie.",
    rt_flag_keep: "Klient zatrzymuje produkt",
    rt_auto_failed: "Krok automatyczny się nie powiódł, więc zgłoszenie trafiło do weryfikacji: {why}",
    rt_approve: "Zatwierdź",
    rt_decline: "Odrzuć",
    rt_book_label: "Zamów etykietę",
    rt_manual_label: "Dodaj etykietę ręcznie",
    rt_mark_received: "Oznacz jako odebrany",
    rt_complete: "Sprawdź i zakończ",
    rt_release_exchange: "Zwolnij teraz",
    rt_release_exchange_confirm: "Zwolnić zamówienie wymiany teraz, bez czekania na zwrot? Przejdzie ze statusu Wymiana do Niezrealizowanych, a nowe produkty zostaną wysłane, zanim zwrot do nas wróci.",
    rt_release_replacement: "Wyślij zamiennik teraz",
    rt_release_replacement_confirm: "Wysłać zamiennik teraz? Przestanie być wstrzymany i trafi do puli kompletacji, zanim przewoźnik zeskanuje zwrot.",
    rt_refund_payment: "Zwróć płatność kartą",
    rt_cancel: "Anuluj zgłoszenie",
    rt_not_available: "Jeszcze niedostępne: ta część portalu zwrotów nie została wydana.",
    rt_action_failed: "Nie udało się. Spróbuj ponownie.",
    rt_already_done: "Już zrobione.",
    rt_file_failed: "Nie udało się otworzyć pliku.",
    rt_approved: "Zgłoszenie zatwierdzone",
    rt_declined: "Zgłoszenie odrzucone. Klient otrzymał e-mail.",
    rt_completed: "Zwrot sprawdzony i zakończony",
    rt_cancelled: "Zgłoszenie anulowane",
    rt_label_booked: "Etykieta zamówiona",
    rt_label_added: "Etykieta zapisana",
    rt_label_voided: "Etykieta unieważniona",
    rt_marked_received: "Oznaczono jako odebrany",
    rt_exchange_released: "Zwolniono zamówienie wymiany",
    rt_replacement_released: "Zwolniono zamówienie zamienne",
    rt_payment_refunded: "Płatność kartą zwrócona",
    rt_note_added: "Notatka dodana",
    rt_void_reminder: "Zamówione paczki są wciąż aktywne u przewoźnika. Unieważnij je: {parcels}",
    rt_items: "Produkty",
    rt_order_photos: "Zdjęcia całego zamówienia",
    rt_timeline: "Historia",
    rt_add_note: "Dodaj notatkę",
    rt_note_placeholder: "Notatki widzą tylko pracownicy",
    rt_save_note: "Zapisz notatkę",
    rt_customer: "Klient",
    rt_name: "Imię i nazwisko",
    rt_email: "E-mail",
    rt_address: "Adres",
    rt_phone: "Telefon",
    rt_entry: "Wejście przez",
    rt_entry_link: "Link z BargainFox",
    rt_entry_direct: "Wyszukanie zamówienia na stronie",
    rt_return_rate: "Wskaźnik zwrotów",
    rt_ip: "Adres IP",
    rt_orders: "Zamówienia",
    rt_delivered_on: "Doręczono {date}",
    rt_not_delivered: "Brak skanu doręczenia",
    rt_return_by: "zwrot do {date}",
    rt_replacement_orders: "Zamówienia zamienne",
    rt_exchange_orders: "Zamówienia wymiany",
    rt_on_hold: "wstrzymane",
    rt_rep_held: "Wstrzymane, aż zwrot będzie w drodze. Wysyłka po pierwszym skanie przewoźnika.",
    rt_rep_released: "Zwolniono {date} ({how}).",
    rt_rep_released_plain: "Zwolniono {date}.",
    rt_rep_via_staff: "ręcznie przez pracownika",
    rt_rep_cancelled: "Anulowano {date}: zwrot nie został nadany.",
    rt_exc_title: "Wymiana",
    rt_exc_held: "Zamówienie wymiany czeka w statusie Wymiana (towar zarezerwowany), aż zwrot {when}. Potem przechodzi do Niezrealizowanych.",
    rt_exc_when_shipped: "będzie w drodze",
    rt_exc_when_delivered: "do nas dotrze",
    rt_exc_when_received: "zostanie sprawdzony",
    rt_exc_when_booked: "zostanie zamówiony",
    rt_exc_released: "Zwolniono do Niezrealizowanych {date} - {how}.",
    rt_exc_released_plain: "Zwolniono do Niezrealizowanych {date}.",
    rt_exc_via_shipped: "gdy zwrot był w drodze",
    rt_exc_via_delivered: "gdy zwrot do nas dotarł",
    rt_exc_via_received: "gdy zwrot został sprawdzony",
    rt_exc_via_booked: "gdy zwrot został zamówiony",
    rt_exc_via_staff: "ręcznie przez pracownika (Zwolnij teraz)",
    rt_exc_cancelled: "Wymianę anulowano {date}: {why}.",
    rt_exc_cancelled_plain: "Wymianę anulowano {date}.",
    rt_exc_test_hold: "Test na stagingu: po zwolnieniu zamówienie wymiany zostaje ręcznie wstrzymane zamiast trafić do Niezrealizowanych, więc nigdy nie zostanie skompletowane ani wysłane.",
    rt_exc_each: "{price} / szt.",
    rt_exc_total: "Suma koszyka",
    rt_exc_express: "Dostawa ekspresowa",
    rt_exc_express_fastfox: "Bezpłatnie z FastFox",
    rt_exc_stock_short: "Za mało towaru, by utworzyć zamówienie wymiany (sprawdzono {when}). Nie utworzono zamówienia.",
    rt_exc_short_line: "potrzeba {needed}, dostępne {available}",
    rt_exc_stock_short_help: "Po uzupełnieniu towaru kliknij ponownie \"Zwolnij teraz\". Albo anuluj zgłoszenie i zwróć klientowi pieniądze.",
    rt_money: "Kwoty",
    rt_items_value: "Produkty",
    rt_vat_incl: "w tym VAT",
    rt_delivery_refund: "Zwrot za dostawę",
    rt_postage: "Opłata za odesłanie",
    rt_payable: "Klient płaci",
    rt_refund_quoted: "Zwrot wyliczony",
    rt_refund_now: "Zwrot teraz",
    rt_service: "Usługa {service} · etykiety: {labels}",
    rt_parcels: "Paczki",
    rt_no_parcels: "Etykieta jeszcze nie zamówiona.",
    rt_nothing_back: "Nic nie wraca.",
    rt_parcel_n: "Paczka {n}",
    rt_label_pdf: "Etykieta PDF",
    rt_void: "Unieważnij",
    rt_payments: "Płatności i faktury",
    rt_payment_line: "Płatność {amount}",
    rt_refund_line: "Zwrot pieniędzy {amount}",
    rt_sales_invoice: "Faktura sprzedaży {number}",
    rt_credit_invoice: "Faktura korygująca {number}",
    rt_card: "{scheme} kończąca się na {last4}",
    rt_qty: "Ilość {n}",
    rt_fault_ours: "Nasza wina",
    rt_fault_customer: "Powód klienta",
    rt_line_replaced: "Wymieniono: {n}",
    rt_line_pended: "Oczekuje na zwrot: {n}",
    rt_line_checked: "Sprawdzono: przyjęto {a}, odrzucono {r}",
    rt_delivery_short: "dostawa",
    rt_approve_title: "Zatwierdź zgłoszenie",
    rt_approve_intro: "Klient prosił o: {asked}. Wybierz, co robimy.",
    rt_approve_replacement_hint: "Wysyłamy zamówienie zamienne. Czego brak na stanie, trafia do zwrotu pieniędzy.",
    rt_approve_replacement_no: "Tylko gdy każdy produkt to nasza wina.",
    rt_approve_refund_now: "Od razu trafia do zwrotu pieniędzy. Nic nie wraca.",
    rt_approve_refund_back: "Najpierw produkt wraca: zwrot pieniędzy po sprawdzeniu.",
    rt_message_optional: "Wiadomość do klienta (opcjonalnie)",
    rt_message_customer: "Wiadomość do klienta",
    rt_message_required: "Napisz wiadomość do klienta.",
    rt_message_required_reject: "Napisz klientowi, dlaczego część produktów nie została przyjęta.",
    rt_decline_title: "Odrzuć zgłoszenie",
    rt_decline_intro: "Zgłoszenie zostanie anulowane, a klient dostanie e-mail z Twoją wiadomością.",
    rt_cancel_title: "Anuluj zgłoszenie",
    rt_cancel_intro: "Klient dostanie e-mail o anulowaniu. Produkty będzie można zwrócić w nowym zgłoszeniu. Zamówioną etykietę trzeba unieważnić osobno.",
    rt_cancel_reason: "Powód (tylko dla pracowników)",
    rt_cancel_message: "Wiadomość do klienta (opcjonalnie)",
    rt_cancel_message_hint: "Trafia do e-maila o anulowaniu i na stronę statusu zgłoszenia. Powód powyżej nigdy.",
    rt_keep: "Nie zmieniaj",
    rt_complete_title: "Sprawdź zwrot",
    rt_complete_intro_refund: "Przyjęte sztuki trafiają do zwrotu pieniędzy. Nieprzyjęte są odrzucane, a klient dowiaduje się dlaczego.",
    rt_complete_intro_other: "Zapisz, co wróciło. Tu nie ruszamy pieniędzy.",
    rt_item: "Produkt",
    rt_came_back: "Do sprawdzenia",
    rt_accept: "Przyjmij",
    rt_accept_qty_for: "Przyjęte sztuki: {item}",
    rt_rejecting: "Sztuk do odrzucenia: {n}.",
    rt_charge_postage: "Nalicz opłatę za odesłanie ({amount})",
    rt_charge_postage_hint: "Gdy produkt jednak nie był uszkodzony, wadliwy ani niewłaściwy. Opłata zostanie potrącona ze zwrotu pieniędzy albo z kredytu pozostałego z wymiany. Przy zamienniku zapisujemy ją jako należną.",
    rt_charge_postage_placeholder: "Dlaczego naliczasz opłatę za odesłanie, np. produkt nie jest uszkodzony.",
    rt_charge_postage_message_required: "Napisz klientowi, dlaczego naliczasz opłatę za odesłanie.",
    rt_manual_intro: "Dla etykiety zamówionej poza Portalem (Royal Mail, InPost lub inny).",
    rt_carrier: "Przewoźnik",
    rt_carrier_royalmail: "Royal Mail",
    rt_carrier_inpost: "InPost",
    rt_carrier_apc: "APC",
    rt_carrier_other: "Inny",
    rt_tracking_number: "Numer przesyłki",
    rt_tracking_required: "Wpisz numer przesyłki.",
    rt_track_title: "Śledź przesyłkę na stronie {carrier}",
    rt_label_file: "Etykieta PDF (opcjonalnie)",
    rt_save_label: "Zapisz etykietę",
    rt_refund_payment_confirm: "Zwrócić {amount} na kartę klienta?",
    rt_event_request_submitted: "Zgłoszenie wysłane",
    rt_event_refund_pending: "Dodano zwrot pieniędzy",
    rt_event_replacement_created: "Utworzono zamówienie zamienne",
    rt_event_staff_approved: "Zatwierdzone",
    rt_event_staff_declined: "Odrzucone",
    rt_event_staff_completed: "Sprawdzone i zakończone",
    rt_event_staff_cancelled: "Anulowane",
    rt_event_staff_note: "Notatka",
    rt_event_customer_cancelled: "Anulowane przez klienta",
    rt_event_customer_cancelled_labels: "Etykiety do unieważnienia: {n}",
    rt_event_label_void_failed: "Etykieta NIE unieważniona - unieważnij ręcznie",
    rt_event_exchange_shortfall: "Brak kredytu na wymianę - niczego nie pobrano",
    rt_event_apc_voided: "Przesyłka APC unieważniona",
    rt_event_apc_void_manifested: "Przesyłka APC już zmanifestowana - poproś APC o korektę",
    rt_event_apc_void_failed: "Unieważnienie w APC nie powiodło się - ponawiane codziennie",
    rt_event_labels_voided: "Niewykorzystane etykiety unieważnione",
    rt_event_labels_voided_parcels: "Anulowano paczki: {n}",
    rt_event_pool_label_issued: "Wydano etykietę Royal Mail",
    rt_event_pool_label_specimen: "WZÓR etykiety Royal Mail (nie produkcja)",
    rt_event_pool_label_downloaded: "Pobrano etykietę Royal Mail",
    rt_event_pool_label_released: "Etykieta Royal Mail wróciła do puli",
    rt_event_pool_label_kept: "Etykieta Royal Mail zachowana (już pobrana)",
    rt_event_replacement_held: "Zamiennik wstrzymany, aż zwrot będzie w drodze",
    rt_event_replacement_released: "Zamiennik zwolniony",
    rt_event_replacement_cancelled: "Wstrzymany zamiennik anulowany",
    rt_event_postage_charged: "Naliczono opłatę za odesłanie",
    rt_event_refund_issued: "Zwrot pieniędzy wykonany w BargainFox",
    rt_event_refund_declined: "BargainFox odrzucił zwrot pieniędzy",
    rt_labels_voided: "Unieważniono w APC: {waybills}",
    rt_labels_void_failed: "APC nie unieważnił {waybills}: oznaczono przy paczce, ponawiane codziennie. Sprawdź portal APC.",
    rt_drop_off_code: "Kod nadania (InPost, opcjonalnie)",
    rt_drop_off_code_hint: "Kod, który klient wpisuje w paczkomacie, jeśli InPost go podał.",
    rt_drop_off_code_invalid: "4-32 litery lub cyfry",
    rs_max_dims: "Maks. paczka cm",
    rs_max_kg_for: "Maks. kg dla {name}",
    rs_max_len_for: "Maks. długość cm dla {name}",
    rs_max_dims_for: "Największa paczka dla {name} (cm)",
    rs_from_carrier: "Z ustawień przewoźnika",
    rs_no_box_limit: "Bez limitu paczki",
    rs_limits_hint: "Puste limity pochodzą z ustawień przewoźnika (Integracje › Przewoźnicy); wartość tutaj może je tylko zaostrzyć. Rozmiar paczki to długość × szerokość × wysokość w cm, w dowolnym ułożeniu.",
    rs_inpost_apc: "InPost i APC",
    rs_inpost_account: "Konto zwrotów InPost",
    rs_inpost_account_hint: "Konto w magazynie zwrotów, na którym nadawane są zwroty (Integracje › Przewoźnicy).",
    rs_inpost_returns_only: "{label} - tylko zwroty (wyłączone dla etykiet wysyłkowych)",
    rs_inpost_not_at: "{label} nie jest kontem InPost w magazynie {warehouse}. Wybierz jedno z jego kont.",
    rs_inpost_none_at: "Magazyn {warehouse} nie ma konta InPost (Integracje › Przewoźnicy).",
    rs_pick_one: "Wybierz z listy.",
    rs_not_listed: "{value} (niedostępne)",
    rs_warehouse_unknown: "{value} nie jest magazynem w Portalu. Wybierz magazyn z listy.",
    rs_inpost_drop_off_days: "Dni na nadanie w InPost",
    rs_inpost_drop_off_days_hint: "Jak długo ważny jest kod nadania klienta. Puste = domyślnie InPost.",
    rs_inpost_default: "Domyślnie InPost",
    rs_inpost_radius: "Promień wyszukiwania paczkomatów (km)",
    rs_inpost_radius_hint: "Jak daleko od klienta szukać paczkomatów i punktów.",
    rs_inpost_lockers_shown: "Liczba pokazanych paczkomatów",
    rs_depot_grace: "Dni karencji nadania w oddziale APC",
    rs_depot_grace_hint: "Dni po zarezerwowanym dniu nadania, po których niewykorzystany zwrot do oddziału uznaje się za przegapiony.",
    rt_event_approved_as: "Jako: {resolution}",
    rm_title: "Etykiety Royal Mail",
    rm_hint: "Wygenerowane wcześniej etykiety zwrotne Royal Mail Tracked 48. Wgraj je tu hurtowo; każdy zwrot dostaje najstarszą nieużytą. Prawdziwe etykiety wydaje tylko produkcja; staging i maszyny testowe wydają wzory.",
    rm_low_stock_setting: "Ostrzegaj poniżej",
    rm_low_stock_setting_hint: "Liczba użytecznych etykiet, poniżej której pojawia się ostrzeżenie (tutaj i na stronie Zwroty).",
    rm_max_age: "Maksymalny wiek etykiety (dni)",
    rm_max_age_hint: "Nie wydawaj etykiety wgranej dawniej niż tyle dni. Puste = bez limitu (Royal Mail nie potwierdził terminu ważności).",
    rm_no_limit: "Bez limitu",
    rm_oba: "Konto Royal Mail (OBA)",
    rm_oba_hint: "Wgrane etykiety innego konta są odrzucane.",
    rm_limits_note: "Waga, rozmiar i opłata klienta za zwrot Royal Mail są w wierszu Royal Mail w sekcji Usługi zwrotu. Potwierdź limity z Royal Mail.",
    rm_low_stock: "Kończą się etykiety zwrotne Royal Mail: zostało {n} (ostrzeżenie poniżej {min}). Wgraj więcej w Ustawienia › Zwroty.",
    rm_specimen_note: "Ten serwer wydaje tylko WZORY etykiet (nie produkcja); liczby dotyczą wspólnej puli.",
    rm_status_available: "Dostępne",
    rm_status_issued: "Wydane, niepobrane",
    rm_status_downloaded: "Pobrane",
    rm_status_received: "Przyjęte",
    rm_status_void: "Unieważnione",
    rm_drop_here: "Upuść tu pliki PDF z etykietami albo",
    rm_choose_files: "Wybierz pliki",
    rm_uploading: "Wgrywanie i sprawdzanie każdej strony…",
    rm_pdf_only: "Można wgrywać tylko pliki PDF.",
    rm_upload_failed: "Wgrywanie się nie udało.",
    rm_result: "{pages} stron: {added} dodano, {dup} już w puli, {bad} odrzucono",
    rm_page: "Strona {n}",
    rm_more_rejected: "…i jeszcze {n} odrzuconych stron",
    rm_search: "Szukaj po numerze przesyłki lub zwrocie",
    rm_status_filter: "Status",
    rm_all_statuses: "Wszystkie statusy",
    rm_tracking: "Numer przesyłki",
    rm_status: "Status",
    rm_return: "Zwrot",
    rm_issued: "Wydano",
    rm_downloaded: "Pobrano",
    rm_received: "Przyjęto",
    rm_none: "Brak pasujących etykiet.",
    rm_open_pdf: "Otwórz etykietę {tracking}",
    rm_void_label: "Unieważnij etykietę {tracking}",
    rm_void_reason: "Dlaczego jest unieważniona?",
    rm_void: "Unieważnij",
    rm_voided: "Etykieta unieważniona",
    rm_not_ready: "Pula etykiet Royal Mail nie jest jeszcze skonfigurowana w tej bazie.",
    rt_contacts_title: "Wiadomości klienta po terminie zwrotu",
    rt_contacts_hint: "Wysłane z formularza kontaktowego na stronie zwrotów. Odpowiadaj ze skrzynki obsługi klienta.",
    rt_contact_reason_faulty: "Wadliwy lub uszkodzony",
    rt_contact_reason_missing: "Brakujący produkt",
    rt_contact_reason_notarrived: "Nie dotarło",
    rt_contact_reason_other: "Coś innego",
    rt_contact_delivery_gorgias: "Zgłoszenie w Gorgias",
    rt_contact_delivery_email: "Wysłano do skrzynki",
    rt_contact_delivery_pending: "Czeka na wysłanie",
    rt_contact_delivery_failed: "Nie dostarczono",
    rt_contact_view_gorgias: "Zobacz w Gorgias",
    rt_contact_order: "Zamówienie {ref}",
    rt_event_auto_failed: "Do weryfikacji: {why}",
    rt_photo_open: "Otwórz zdjęcie {n}",
    rt_photo_title: "Zdjęcie od klienta",
    rt_photo_of: "Zdjęcie {n} z {total}",
    rt_photo_prev: "Poprzednie zdjęcie",
    rt_photo_next: "Następne zdjęcie",
    rt_photo_download: "Pobierz",
    rt_photo_failed: "Nie udało się wczytać zdjęcia.",
    rt_photo_heic: "To zdjęcie HEIC, którego przeglądarka nie wyświetli. Pobierz je, aby obejrzeć.",
    rt_panel_title: "Zwroty",
    rt_relation_original: "Zwrot z tego zamówienia",
    rt_relation_replacement: "Zamiennik do zwrotu",
    rt_relation_exchange: "Wymiana do zwrotu",
    rt_refund_amount: "zwrot {amount}",
    rt_paid_amount: "zapłacono {amount}",
    // Returns page: a parcel returned to sender, scanned into the search (ReturnedParcelPanel.tsx).
    rt_rts_title: "Zwrócona przesyłka",
    rt_rts_returned: "Zwrot do nadawcy",
    rt_rts_tracking: "Śledzenie: {status}",
    rt_rts_superseded: "Tej etykiety nie ma już przy zamówieniu (nadano nową). Oto obecne przesyłki zamówienia.",
    rt_rts_matches: "Przesyłki pasujące do tego kodu ({n}):",
    rt_rts_order: "Zamówienie",
    rt_rts_parts: "Zamówienia klienta: {orders}",
    rt_rts_customer: "Klient",
    rt_rts_parcel: "Przesyłka",
    rt_rts_box_of: "Pudełko {n} z {total}",
    rt_rts_shipped: "wysłano {date}",
    rt_rts_not_channel: "To nie jest zamówienie BargainFox ani Jobalots ({channel}). Zwróć pieniądze tam, gdzie zostało sprzedane.",
    rt_rts_replacement: "To zamiennik do zamówienia #{order}, więc nic za niego nie zapłacono. Jeśli należy się zwrot, użyj pierwotnego zamówienia.",
    rt_rts_label_voided: "Ta etykieta została anulowana, więc przesyłka nie wyszła na niej. Sprawdź zamówienie na stronie Zamówienia.",
    rt_rts_order_status: "Status zamówienia: {status}. Najpierw rozlicz je na stronie Zamówienia.",
    rt_rts_nothing_left: "W tej przesyłce nie zostało nic do zwrotu.",
    rt_rts_contents_not_recorded: "Nie zapisano, co trafiło do tego pudełka, więc widać wszystkie pozycje zamówienia. Sprawdź pudełko i ustaw ilości.",
    rt_rts_history: "Już w „Oczekuje na zwrot” z tej przesyłki: {amount} (sztuk: {n}), {when}, {by}",
    rt_rts_in_box: "W pudełku: {n}",
    rt_rts_each: "{price} za sztukę",
    rt_rts_refunded_pending: "Zwrócono: {refunded} · Oczekuje: {pending}",
    rt_rts_qty_label: "Sztuki {sku} do zwrotu",
    rt_rts_of: "z {n}",
    rt_rts_none_left: "Nic nie zostało",
    rt_rts_delivery: "Dostawa opłacona w tym zamówieniu: {amount}. Nie jest wliczona: notatka w zamówieniu informuje osobę obsługującą zwroty.",
    rt_rts_total: "Razem",
    rt_rts_put: "Przenieś {amount} do „Oczekuje na zwrot”",
    rt_rts_process: "Przetwórz zwrot pieniędzy",
    rt_rts_why: "Dlaczego zwracamy pieniądze?",
    rt_rts_reason_rts: "Zwrot do nadawcy",
    rt_rts_reason_label: "Powód",
    rt_rts_reason_placeholder: "Albo wpisz powód",
    rt_rts_reason_needed: "Najpierw wybierz „Zwrot do nadawcy” albo wpisz powód",
    rt_rts_reason_hint: "Teraz nic nie jest wypłacane. Klient dostanie e-mail, gdy osoba obsługująca zwroty oznaczy zwrot jako wystawiony w „Oczekuje na zwrot”.",
    rt_rts_contents_not_recorded_many: "Nie zapisano, co trafiło do tego pudełka, a zamówienie wysłano w {n} pudełkach, więc nic nie jest wypełnione. Sprawdź pudełko i ustaw ilości.",
    rt_rts_failed: "Nie udało się przenieść zwrotu do „Oczekuje na zwrot”. Spróbuj ponownie.",
    rt_rts_done: "{amount} (sztuk: {n}) przeniesiono do „Oczekuje na zwrot” dla zamówienia #{order}.",
    rt_rts_open_order: "Otwórz zamówienie",
    rt_rts_already: "Już w „Oczekuje na zwrot”: w tej przesyłce nie zostało nic więcej do zwrotu.",
    rt_rts_no_parcels: "Ta etykieta należy do zamówienia #{order}, które nie ma teraz wysłanych przesyłek.",
    rp_pay_title: "Płatność w portalu zwrotów BargainFox",
    rp_pay_paid_full: "Zapłacono {amount} ({method}), {date}",
    rp_pay_paid_method: "Zapłacono {amount} ({method})",
    rp_pay_paid_date: "Zapłacono {amount}, {date}",
    rp_pay_paid: "Zapłacono {amount}",
    rp_pay_refunded: "Zwrócono {amount}",
    rp_pay_pending: "Zwrot oczekuje: {amount}",
    rp_pay_left: "Pozostało do zwrotu {amount}",
    rp_pay_fully_refunded: "Zwrócono w całości",
    rp_pay_invoice: "Faktura sprzedaży {number}",
    rp_pay_credit_note: "Faktura korygująca {number} · {amount}",
    rp_pay_open_credit_note: "Otwórz fakturę korygującą {number}",
    rp_pay_history: "Zwroty pieniędzy",
    rp_pay_status_refunded: "Zwrócono",
    rp_pay_status_waiting: "Czeka na Checkout.com",
    rp_pay_status_declined: "Odrzucono",
    rp_pay_status_failed: "Nie powiodło się",
    rp_pay_emailed: "Klient otrzymał e-mail",
    rp_pay_source_staff: "Pracownik",
    rp_pay_source_returns_page: "Strona Zwroty",
    rp_pay_source_exchange_cancelled: "Anulowana wymiana",
    rp_pay_source_dashboard: "Panel Checkout.com",
    rp_pay_source_earlier: "Wcześniejszy zwrot",
    rp_pay_refund: "Zwróć pieniądze",
    rp_pay_amount: "Kwota (£)",
    rp_pay_full_amount: "Cała kwota",
    rp_pay_up_to: "Maksymalnie {amount}",
    rp_pay_amount_invalid: "Podaj kwotę w funtach, np. 5.00",
    rp_pay_amount_min: "Najmniejszy zwrot to £0.01",
    rp_pay_amount_max: "Maksymalnie {amount}: tyle zostało do zwrotu",
    rp_pay_reason: "Powód (klient zobaczy go na fakturze korygującej, wpisz po angielsku)",
    rp_pay_reason_placeholder: "Item arrived damaged",
    rp_pay_reason_short: "Co najmniej 3 znaki",
    rp_pay_notify: "Wyślij klientowi fakturę korygującą e-mailem",
    rp_pay_confirm: "Zwróć {amount} na {method}",
    rp_pay_confirm_plain: "Zwróć {amount}",
    rp_pay_sending: "Zwracanie…",
    rp_pay_done: "Zwrot {amount} wystawiony",
    rp_pay_sent: "Zwrot {amount} wysłany do Checkout.com, czeka na potwierdzenie",
    rp_pay_failed: "Nie udało się potwierdzić zwrotu. Sprawdź listę zwrotów, zanim spróbujesz ponownie.",
    ocd_title: "Dokumenty {channel}",
    ocd_title_generic: "Dokumenty kanału sprzedaży",
    ocd_invoice: "Faktura sprzedaży {number}",
    ocd_credit_note: "Faktura korygująca {number}",
    ocd_corrects: "Koryguje fakturę {number}",
    ocd_error: "W tej chwili nie udało się pobrać z {channel} dokumentów zamówienia #{reference}.",
    ocd_error_generic: "W tej chwili nie udało się pobrać z kanału sprzedaży dokumentów zamówienia #{reference}.",
    ocd_not_available: "Ten dokument jest teraz niedostępny.",
    ocd_file_failed: "Nie udało się otworzyć dokumentu: kanał sprzedaży mógł nie odpowiedzieć. Spróbuj ponownie za chwilę.",
    returns_settings: "Zwroty",
    returns_settings_hint: "Portal zwrotów BargainFox: terminy, zwroty pieniędzy, zamienniki, wymiany, powody i usługi zwrotne. Zmienia tylko Admin.",
    rs_no_access: "Nie masz dostępu do ustawień zwrotów.",
    rs_load_failed: "Nie udało się wczytać ustawień zwrotów.",
    rs_read_only: "Tylko do odczytu: te ustawienia zmienia tylko Admin.",
    rs_last_saved: "Ostatnio zapisał(a) {who}, {when}",
    rs_portal: "Portal zwrotów",
    rs_enabled: "Przyjmuj nowe zgłoszenia",
    rs_return_warehouse: "Magazyn zwrotów",
    rs_return_warehouse_hint: "Magazyn, do którego przyjmowane są zwroty.",
    rs_terms_url: "Link do regulaminu",
    rs_help_url: "Link do centrum pomocy",
    rs_url_hint: "Link https albo puste pole.",
    rs_return_address: "Adres zwrotu",
    rs_return_address_hint: "Na ten adres wystawiana jest każda etykieta zwrotna.",
    rs_addr_company: "Firma",
    rs_addr_name: "Nazwa",
    rs_addr_line_1: "Adres, linia 1",
    rs_addr_line_2: "Adres, linia 2",
    rs_addr_city: "Miasto",
    rs_addr_postcode: "Kod pocztowy",
    rs_addr_country: "Kraj",
    rs_addr_vat_number: "Numer VAT",
    rs_window: "Termin zwrotu",
    rs_window_days: "Dni od doręczenia",
    rs_window_days_hint: "Pokazywane klientowi.",
    rs_problem_window_days: "Termin dla uszkodzonych, wadliwych, błędnych lub brakujących produktów (dni od doręczenia)",
    rs_problem_window_days_hint: "Zwykle taki sam jak termin zwrotu. Zostaw puste, aby go użyć ({days} dni). Zamówienie jest otwarte, dopóki trwa którykolwiek z terminów.",
    rs_same_as_window: "Tak samo ({days})",
    rs_grace_days: "Dni karencji",
    rs_grace_days_hint: "Dodatkowe dni, niepokazywane.",
    rs_no_scan_days: "Brak skanu doręczenia: dni od daty zamówienia",
    rs_no_scan_days_hint: "Gdy nie ma skanu doręczenia.",
    rs_not_arrived: "Reklamacje braku dostawy po",
    rs_not_arrived_hint: "Dni robocze po spodziewanej dostawie.",
    rs_refunds: "Zwroty pieniędzy i zwroty bez odsyłania",
    rs_returnless_damaged: "Bez odsyłania do: uszkodzone lub wadliwe (ze zdjęciami)",
    rs_returnless_damaged_hint: "Wartość produktów (z VAT) do tej kwoty: bez etykiety, klient zatrzymuje produkt. Powód uszkodzenia lub wady wymagający zdjęć. £0 = zawsze wraca.",
    rs_returnless_wrong: "Bez odsyłania do: zły produkt lub niezgodny z opisem",
    rs_returnless_wrong_hint: "Wysłany zły produkt oraz powody uszkodzenia bez zdjęć (np. niezgodny z opisem). £0 = zawsze wraca.",
    rs_returnless_mind: "Bez odsyłania do: zmiana zdania",
    rs_returnless_mind_hint: "Każdy powód „Chcę coś zwrócić”. £0 = zawsze wraca.",
    rs_returnless_rate: "Maks. wskaźnik zwrotów (%)",
    rs_returnless_rate_hint: "Od podanej wyżej liczby zamówień: powyżej tej wartości produkty zawsze muszą wrócić.",
    rs_return_rate_explained: "Wskaźnik zwrotów = zamówienia klienta w BargainFox z danego okresu ze zwrotem lub zwrotem pieniędzy ÷ wszystkie jego zamówienia w BargainFox z tego okresu, po adresie e-mail. Zgłoszenie bez odsyłania odrzucone przez pracownika się nie liczy. Bieżące zgłoszenie się nie liczy.",
    rs_standing: "Kto może zatrzymać produkty",
    rs_standing_days: "Okres (dni)",
    rs_standing_days_hint: "Liczą się zamówienia i zgłoszenia bez odsyłania z tylu ostatnich dni. 365 = kroczące 12 miesięcy.",
    rs_standing_min_orders: "Wskaźnik zwrotów od (zamówień)",
    rs_standing_min_orders_hint: "Klienta z mniejszą liczbą zamówień w tym okresie ocenia się według limitu poniżej.",
    rs_standing_allowance: "Limit zgłoszeń bez odsyłania poniżej tej liczby",
    rs_standing_allowance_hint: "Ile zgłoszeń bez odsyłania taki klient ma w tym okresie. Potem produkty muszą wrócić.",
    rs_returnless_refunds: "Bez odsyłania dla zwrotów pieniędzy",
    rs_returnless_refunds_hint: "Od razu tworzy zwrot pieniędzy w Zamówieniach.",
    rs_returnless_replacements: "Bez odsyłania dla zamienników",
    rs_returnless_replacements_hint: "Uszkodzone lub złe produkty w ramach limitu nie wracają.",
    rs_refund_delivery: "Zwracaj koszt dostawy, gdy to nasza wina",
    rs_refund_delivery_hint: "Całe zamówienie: w całości. Część: proporcjonalnie do wartości produktów.",
    rs_deduct_postage: "Potrącaj opłatę za odesłanie, gdy to powód klienta",
    rs_deduct_postage_hint: "Opłatę ustawia się w usługach zwrotnych.",
    rs_replacements: "Zamienniki",
    rs_replacements_hint: "Zamówienie zamienne (klon REP) w kanale BargainFox Returns. Natychmiastowe od razu trafiają do kompletacji. Przy włączonym automatycznym zatwierdzaniu droższe, których towar wraca, czekają, aż zwrot będzie w drodze; pozostałe czekają na weryfikację w Zwrotach.",
    rs_instant_limit: "Wysyłaj od razu, gdy wartość poniżej",
    rs_instant_limit_hint: "Wartość wysyłanych ponownie produktów, z VAT.",
    rs_auto_approve_returns: "Automatycznie zatwierdzaj zwroty",
    rs_auto_approve_returns_hint: "Zamiennik o wartości równej limitowi natychmiastowej wysyłki lub wyższej, którego produkt do nas wraca, nie trafia do weryfikacji. Etykieta zwrotna jest zamawiana od razu, a zamiennik wysyłany, gdy tylko przewoźnik zeskanuje zwrot. Bez skanu w terminie anulowania wymiany zamiennik zostaje anulowany.",
    rs_catalogue_refresh: "Odświeżaj sklep co (minut)",
    rs_catalogue_refresh_hint: "Jak często ceny, stany i oferty sklepu wymiany są odświeżane z BargainFox (od 5 do 60). Kolejność bestsellerów jest ustalana raz dziennie. 0 = wyłączone: sklep jest budowany, gdy klient go otwiera, co trwa dłużej.",
    rs_missing: "Brakujące i niedoręczone",
    rs_missing_allowance: "Dozwolone poniżej liczby zamówień",
    rs_missing_allowance_hint: "Ile zgłoszeń braku lub niedoręczenia może złożyć w danym okresie klient z mniejszą liczbą zamówień niż próg, zanim każde trafi do weryfikacji. Od tej liczby zamówień decyduje wskaźnik zwrotów.",
    rs_review_missing: "Weryfikuj każde zgłoszenie braku i niedoręczenia",
    rs_review_missing_hint: "Wyłączone: poniżej powyższych limitów zamiennik lub zwrot pieniędzy idzie od razu, dopóki klient ma dobrą historię, a po jej przekroczeniu każde zgłoszenie jest weryfikowane bez względu na wartość. Włączone: każde sprawdza pracownik.",
    rs_refund_review_limit: "Sprawdzaj zwroty pieniędzy bez odsyłki od",
    rs_refund_review_limit_hint: "Brakujące, niedostarczone lub zatrzymane produkty: zwrot od tej kwoty czeka tu na weryfikację. Z VAT; 0 = sprawdzaj każdy.",
    rs_exchanges: "Wymiany",
    rs_exchanges_enabled: "Oferuj wymiany",
    rs_min_stock: "Pokazuj tylko produkty z co najmniej",
    rs_min_stock_hint: "Sztuk dostępnych do sprzedaży.",
    rs_cancel_days: "Anuluj, jeśli zwrot nie zostanie nadany w ciągu (dni)",
    rs_cancel_days_hint: "Zamówienie wymiany czeka w statusie Wymiana i rezerwuje towar. Bez skanu przewoźnika w tym czasie: zostaje anulowane, towar zwolniony, dopłata zwrócona, a klient dostaje e-mail.",
    rs_express_fee: "Opłata za dostawę ekspresową",
    rs_express_fee_hint: "Tyle klient płaci za ekspresową dostawę nowych produktów, bez względu na ich liczbę i wagę. Dostawa standardowa jest bezpłatna. Członkowie FastFox mają dostawę ekspresową za darmo.",
    rs_tiers: "Kiedy zamówienie wymiany przechodzi do Niezrealizowanych",
    rs_tiers_hint: "Według wartości nowych produktów. Zamówienie powstaje przy rezerwacji wymiany i czeka w statusie Wymiana (z zarezerwowanym towarem), aż zwrot osiągnie wybrany etap - potem magazyn je kompletuje.",
    rs_tier_value: "Wartość wymiany",
    rs_tier_when: "Wyślij, gdy",
    rs_tier_under: "Poniżej",
    rs_tier_and_over: "£{amount} i więcej",
    rs_tier_limit: "Próg {n}",
    rs_tier_trigger: "Wyzwalacz {n}",
    rs_when_booked: "Zwrot jest zamówiony (już niedozwolone)",
    rs_tier_when_retired: "Próg {n}: ten wyzwalacz nie jest już dozwolony. Zamówienie wymiany przechodzi do Niezrealizowanych dopiero, gdy klient nada zwrot - wybierz, kiedy.",
    rs_when_shipped: "Zwrot jest nadany (pierwszy skan)",
    rs_when_delivered: "Zwrot dotarł do naszego magazynu",
    rs_when_received: "Magazyn oznaczy go jako odebrany",
    rs_ranking: "Ranking na stronie wymiany",
    rs_ranking_hint: "Wynik = sztuki zamówione w okresie × (cena ÷ mediana ceny) ^ waga ceny.",
    rs_ranking_days: "Okres rankingu (dni)",
    rs_price_weight: "Waga ceny",
    rs_price_weight_hint: "0 = tylko sprzedaż · 0,5 = lekkie wsparcie · 1 = mocne wsparcie.",
    rs_min_units: "Minimum zamówionych sztuk w okresie",
    rs_top_badges: "Odznaka \"Bestseller\" dla pierwszych",
    rs_top_badges_hint: "Produktów. 0 ukrywa odznakę.",
    rs_invoices: "Płatności i faktury",
    rs_invoices_hint: "Sprzedawca na fakturach za wymiany.",
    rs_emails: "E-maile do klientów",
    rs_emails_hint: "Wysyłane z adresu poniżej i zapisywane w zakładce Logi zamówienia.",
    rs_from_address: "Adres nadawcy",
    rs_from_address_hint: "Z tego adresu portal zwrotów wysyła e-maile do klientów. Musi być w domenie, z której może wysyłać nasza usługa pocztowa (bargainfox.com).",
    rs_reply_to: "Adres do odpowiedzi",
    rs_reply_to_hint: "Tu trafiają odpowiedzi klientów.",
    rs_support_inbox: "Skrzynka obsługi klienta",
    rs_contact_gorgias: "Wysyłaj wiadomości z formularza do Gorgias",
    rs_contact_gorgias_hint: "Tworzy zgłoszenie w Gorgias na skrzynce BargainFox (wymaga kluczy Gorgias na serwerze). Wyłączone: wiadomości trafiają e-mailem do skrzynki powyżej.",
    rs_shipping_link: "Przycisk zwrotu w e-mailach o wysyłce BargainFox",
    rs_shipping_link_hint: "Dodaje \"Return or report a problem\" do e-maila o wysyłce wysyłanego przez Portal: link tylko do tego zamówienia, ważny przez liczbę dni linku z sekcji Dostęp i bezpieczeństwo.",
    rs_support_inbox_hint: "Wiadomości z formularza kontaktowego po terminie zwrotu. Na produkcji stają się zgłoszeniami w Gorgias dla tej skrzynki; gdzie indziej trafiają tu e-mailem.",
    rs_error_alert_email: "Adres do powiadomień o błędach",
    rs_error_alert_email_hint: "Wysyłamy tu e-mail, gdy w portalu zwrotów wystąpią błędy, najwyżej raz na godzinę. Zostaw puste, aby nie wysyłać e-maili.",
    rs_reasons: "Powody",
    rs_reasons_hint: "Od winy zależy darmowe odesłanie, zwrot za dostawę i dostępne rozwiązania. Zmiany zapisują się od razu.",
    rs_on: "Wł.",
    rs_problem: "Problem",
    rs_reason_label: "Powód widoczny dla klienta",
    rs_fault: "Wina",
    rs_needs_detail: "Wymaga opisu",
    rs_needs_photo: "Wymaga zdjęcia",
    rs_actions: "Akcje",
    rs_reason_on: "Oferuj: {label}",
    rs_reason_fixed: "Stały powód tego problemu: można zmienić nazwę, nie można wyłączyć.",
    rs_reason_delete: "Usuń powód {code}",
    rs_reason_delete_confirm: "Usunąć powód {code}? Powód użyty w zgłoszeniu można tylko wyłączyć.",
    rs_add_reason: "Dodaj powód",
    rs_reason_code: "Kod",
    rs_services: "Usługi zwrotne",
    rs_services_hint: "Wzorce kodów pocztowych jak na liście obszarów oddalonych: obszar HS*, dzielnica PA48 *, sektor PA48 7*. Oddzielaj przecinkami.",
    rs_service: "Usługa",
    rs_service_on: "Oferuj {name}",
    rs_fee: "Opłata klienta",
    rs_fee_for: "Opłata klienta za {name}",
    rs_max_kg: "Maks. kg",
    rs_max_len: "Maks. długość cm",
    rs_pc_only: "Kody: tylko",
    rs_pc_never: "Kody: nigdy",
    rs_pc_only_for: "Tylko te kody dla {name}",
    rs_pc_never_for: "Nigdy te kody dla {name}",
    rs_pc_all: "Wszystkie",
    rs_pc_none: "Brak",
    rs_max_labels: "Maks. etykiet na zwrot",
    rs_max_labels_hint: "Nigdy więcej niż paczek, w których wysłano zamówienie.",
    rs_security: "Dostęp i bezpieczeństwo",
    rs_token_account: "Link z konta BargainFox (minuty)",
    rs_token_account_hint: "Jednorazowy.",
    rs_token_email: "Link w e-mailu (dni)",
    rs_token_email_hint: "Wielokrotny do wygaśnięcia.",
    rs_session_idle: "Sesja wygasa po (minuty bezczynności)",
    rs_ip_failures: "Nieudane wyszukania na IP (15 minut)",
    rs_ip_failures_hint: "Potem blokada czasowa.",
    rs_order_failures: "Nieudane wyszukania na numer zamówienia (1 godzina)",
    rs_order_failures_hint: "Potem blokada czasowa.",
    rs_captcha_after: "Pokaż weryfikację po (nieudanych wyszukaniach)",
    rs_mask: "Maskuj dane osobowe w sesjach z wyszukania zamówienia",
    rs_mask_hint: "Na przykład \"S. M***\" i \"CF14 ***\". Produkty widać w całości.",
    rs_other: "Inne ustawienia",
    rs_other_hint: "Ustawienia, których ten ekran jeszcze nie układa.",
    rs_unsaved: "Niezapisane zmiany: {n}",
    rs_no_changes: "Brak niezapisanych zmian",
    rs_discard: "Odrzuć zmiany",
    rs_save: "Zapisz ustawienia zwrotów",
    rs_saved: "Ustawienia zwrotów zapisane",
    rs_save_failed: "Nie udało się zapisać. Spróbuj ponownie.",
    rs_fix_fields: "Niektóre ustawienia są nieprawidłowe. Sprawdź zaznaczone pola.",
    rs_admin_only: "Ustawienia zwrotów zmienia tylko Admin.",
};

export default pl;
